"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[1014],{

/***/ 68881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IH": () => (/* binding */ add),
  "yV": () => (/* binding */ identify),
  "S1": () => (/* binding */ init),
  "Kz": () => (/* binding */ logEvent),
  "Iv": () => (/* binding */ setUserId)
});

// UNUSED EXPORTS: Identify, Revenue, Types, createInstance, extendSession, flush, getDeviceId, getSessionId, getUserId, groupIdentify, remove, reset, revenue, runQueuedFunctions, setDeviceId, setGroup, setOptOut, setSessionId, setTransport, track

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/debug.js
var debug = __webpack_require__(39625);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(80187);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/return-wrapper.js
var return_wrapper = __webpack_require__(46190);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/status.js
var esm_status = __webpack_require__(91669);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/messages.js
var SUCCESS_MESSAGE = 'Event tracked successfully';
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
var OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
var MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
var INVALID_API_KEY = 'Invalid API key';
var CLIENT_NOT_INITIALIZED = 'Client not initialized'; //# sourceMappingURL=messages.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/constants.js
var constants = __webpack_require__(36095);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/chunk.js
// Creates an array of elements split into groups the length of size.
// If array can't be split evenly, the final chunk will be the remaining elements.
// Works similary as https://lodash.com/docs/4.17.15#chunk
var chunk = function(arr, size) {
    var chunkSize = Math.max(size, 1);
    return arr.reduce(function(chunks, element, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) {
            chunks[chunkIndex] = [];
        }
        chunks[chunkIndex].push(element);
        return chunks;
    }, []);
}; //# sourceMappingURL=chunk.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/result-builder.js

var buildResult = function(event, code, message) {
    if (code === void 0) {
        code = 0;
    }
    if (message === void 0) {
        message = esm_status/* Status.Unknown */.q.Unknown;
    }
    return {
        event: event,
        code: code,
        message: message
    };
}; //# sourceMappingURL=result-builder.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/config.js
var config = __webpack_require__(74408);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/uuid.js
/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */ var UUID = function(a) {
    return a // if the placeholder was passed, return
     ? (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
     : (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11) // -100000000000,
    ).replace(// replacing
    /[018]/g, UUID);
}; //# sourceMappingURL=uuid.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/plugins/destination.js








function getErrorMessage(error) {
    if (error instanceof Error) return error.message;
    return String(error);
}
function getResponseBodyString(res) {
    var responseBodyString = '';
    try {
        if ('body' in res) {
            responseBodyString = JSON.stringify(res.body, null, 2);
        }
    } catch (_a) {
    // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
    }
    return responseBodyString;
}
var Destination = /** @class */ function() {
    function Destination() {
        this.name = 'amplitude';
        this.type = 'destination';
        this.retryTimeout = 1000;
        this.throttleTimeout = 30000;
        this.storageKey = '';
        this.scheduled = null;
        this.queue = [];
    }
    Destination.prototype.setup = function(config) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var unsent;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.config = config;
                        this.storageKey = "".concat(constants/* STORAGE_PREFIX */.f1, "_").concat(this.config.apiKey.substring(0, 10));
                        return [
                            4 /*yield*/ ,
                            (_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey)
                        ];
                    case 1:
                        unsent = _b.sent();
                        if (unsent && unsent.length > 0) {
                            void Promise.all(unsent.map(function(event) {
                                return _this.execute(event);
                            })).catch();
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(undefined)
                        ];
                }
            });
        });
    };
    Destination.prototype.execute = function(event) {
        var _this = this;
        // Assign insert_id for dropping invalid event later
        if (!event.insert_id) {
            event.insert_id = UUID();
        }
        return new Promise(function(resolve) {
            var context = {
                event: event,
                attempts: 0,
                callback: function(result) {
                    return resolve(result);
                },
                timeout: 0
            };
            void _this.addToQueue(context);
        });
    };
    Destination.prototype.getTryableList = function(list) {
        var _this = this;
        return list.filter(function(context) {
            if (context.attempts < _this.config.flushMaxRetries) {
                context.attempts += 1;
                return true;
            }
            void _this.fulfillRequest([
                context
            ], 500, MAX_RETRIES_EXCEEDED_MESSAGE);
            return false;
        });
    };
    Destination.prototype.scheduleTryable = function(list, shouldAddToQueue) {
        var _this = this;
        if (shouldAddToQueue === void 0) {
            shouldAddToQueue = false;
        }
        list.forEach(function(context) {
            // Only need to concat the queue for the first time
            if (shouldAddToQueue) {
                _this.queue = _this.queue.concat(context);
            }
            if (context.timeout === 0) {
                _this.schedule(_this.config.flushIntervalMillis);
                return;
            }
            setTimeout(function() {
                context.timeout = 0;
                _this.schedule(0);
            }, context.timeout);
        });
    };
    Destination.prototype.addToQueue = function() {
        var list = [];
        for(var _i = 0; _i < arguments.length; _i++){
            list[_i] = arguments[_i];
        }
        var tryable = this.getTryableList(list);
        this.scheduleTryable(tryable, true);
        this.saveEvents();
    };
    Destination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.scheduled || this.config.offline) {
            return;
        }
        this.scheduled = setTimeout(function() {
            void _this.flush(true).then(function() {
                if (_this.queue.length > 0) {
                    _this.schedule(timeout);
                }
            });
        }, timeout);
    };
    Destination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) {
            useRetry = false;
        }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var list, later, batches;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Skip flush if offline
                        if (this.config.offline) {
                            this.config.loggerProvider.debug('Skipping flush while offline.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        if (this.scheduled) {
                            clearTimeout(this.scheduled);
                            this.scheduled = null;
                        }
                        batches = chunk(list, this.config.flushQueueSize);
                        return [
                            4 /*yield*/ ,
                            Promise.all(batches.map(function(batch) {
                                return _this.send(batch, useRetry);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        this.scheduleTryable(later);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.send = function(list, useRetry) {
        if (useRetry === void 0) {
            useRetry = true;
        }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var payload, serverUrl, res, e_1, errorMessage;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.config.apiKey) {
                            return [
                                2 /*return*/ ,
                                this.fulfillRequest(list, 400, MISSING_API_KEY_MESSAGE)
                            ];
                        }
                        payload = {
                            api_key: this.config.apiKey,
                            events: list.map(function(context) {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                var _a = context.event, extra = _a.extra, eventWithoutExtra = (0,tslib_es6/* __rest */._T)(_a, [
                                    "extra"
                                ]);
                                return eventWithoutExtra;
                            }),
                            options: {
                                min_id_length: this.config.minIdLength
                            },
                            client_upload_time: new Date().toISOString(),
                            request_metadata: this.config.requestMetadata
                        };
                        this.config.requestMetadata = new config/* RequestMetadata */.Dg();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        serverUrl = (0,config/* createServerConfig */.RG)(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                        return [
                            4 /*yield*/ ,
                            this.config.transportProvider.send(serverUrl, payload)
                        ];
                    case 2:
                        res = _a.sent();
                        if (res === null) {
                            this.fulfillRequest(list, 0, UNEXPECTED_ERROR_MESSAGE);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            if ('body' in res) {
                                this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat(getResponseBodyString(res)));
                            } else {
                                this.fulfillRequest(list, res.statusCode, res.status);
                            }
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.handleResponse(res, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        errorMessage = getErrorMessage(e_1);
                        this.config.loggerProvider.error(errorMessage);
                        this.handleResponse({
                            status: esm_status/* Status.Failed */.q.Failed,
                            statusCode: 0
                        }, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.handleResponse = function(res, list) {
        var status = res.status;
        switch(status){
            case esm_status/* Status.Success */.q.Success:
                {
                    this.handleSuccessResponse(res, list);
                    break;
                }
            case esm_status/* Status.Invalid */.q.Invalid:
                {
                    this.handleInvalidResponse(res, list);
                    break;
                }
            case esm_status/* Status.PayloadTooLarge */.q.PayloadTooLarge:
                {
                    this.handlePayloadTooLargeResponse(res, list);
                    break;
                }
            case esm_status/* Status.RateLimit */.q.RateLimit:
                {
                    this.handleRateLimitResponse(res, list);
                    break;
                }
            default:
                {
                    // log intermediate event status before retry
                    this.config.loggerProvider.warn("{code: 0, error: \"Status '".concat(status, "' provided for ").concat(list.length, " events\"}"));
                    this.handleOtherResponse(list);
                    break;
                }
        }
    };
    Destination.prototype.handleSuccessResponse = function(res, list) {
        this.fulfillRequest(list, res.statusCode, SUCCESS_MESSAGE);
    };
    Destination.prototype.handleInvalidResponse = function(res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith(INVALID_API_KEY)) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        var dropIndex = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(Object.values(res.body.eventsWithInvalidFields)), false), (0,tslib_es6/* __read */.CR)(Object.values(res.body.eventsWithMissingFields)), false), (0,tslib_es6/* __read */.CR)(Object.values(res.body.eventsWithInvalidIdLengths)), false), (0,tslib_es6/* __read */.CR)(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function(context, index) {
            if (dropIndexSet.has(index)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            return true;
        });
        if (retry.length > 0) {
            // log intermediate event status before retry
            this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        var tryable = this.getTryableList(retry);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handlePayloadTooLargeResponse = function(res, list) {
        if (list.length === 1) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        // log intermediate event status before retry
        this.config.loggerProvider.warn(getResponseBodyString(res));
        this.config.flushQueueSize /= 2;
        var tryable = this.getTryableList(list);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handleRateLimitResponse = function(res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function(context, index) {
            if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            if (throttledIndexSet.has(index)) {
                context.timeout = _this.throttleTimeout;
            }
            return true;
        });
        if (retry.length > 0) {
            // log intermediate event status before retry
            this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        var tryable = this.getTryableList(retry);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handleOtherResponse = function(list) {
        var _this = this;
        var later = list.map(function(context) {
            context.timeout = context.attempts * _this.retryTimeout;
            return context;
        });
        var tryable = this.getTryableList(later);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.fulfillRequest = function(list, code, message) {
        this.removeEvents(list);
        list.forEach(function(context) {
            return context.callback(buildResult(context.event, code, message));
        });
    };
    /**
     * This is called on
     * 1) new events are added to queue; or
     * 2) response comes back for a request
     *
     * Update the event storage based on the queue
     */ Destination.prototype.saveEvents = function() {
        if (!this.config.storageProvider) {
            return;
        }
        var updatedEvents = this.queue.map(function(context) {
            return context.event;
        });
        void this.config.storageProvider.set(this.storageKey, updatedEvents);
    };
    /**
     * This is called on response comes back for a request
     */ Destination.prototype.removeEvents = function(eventsToRemove) {
        this.queue = this.queue.filter(function(queuedContext) {
            return !eventsToRemove.some(function(context) {
                return context.event.insert_id === queuedContext.event.insert_id;
            });
        });
        this.saveEvents();
    };
    return Destination;
}();
 //# sourceMappingURL=destination.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/identify.js
var esm_identify = __webpack_require__(7848);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/event.js
var esm_event = __webpack_require__(10261);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/valid-properties.js
var valid_properties = __webpack_require__(4041);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/revenue.js



var Revenue = /** @class */ function() {
    function Revenue() {
        this.productId = '';
        this.quantity = 1;
        this.price = 0.0;
    }
    Revenue.prototype.setProductId = function(productId) {
        this.productId = productId;
        return this;
    };
    Revenue.prototype.setQuantity = function(quantity) {
        if (quantity > 0) {
            this.quantity = quantity;
        }
        return this;
    };
    Revenue.prototype.setPrice = function(price) {
        this.price = price;
        return this;
    };
    Revenue.prototype.setRevenueType = function(revenueType) {
        this.revenueType = revenueType;
        return this;
    };
    Revenue.prototype.setRevenue = function(revenue) {
        this.revenue = revenue;
        return this;
    };
    Revenue.prototype.setEventProperties = function(properties) {
        if ((0,valid_properties/* isValidObject */.L)(properties)) {
            this.properties = properties;
        }
        return this;
    };
    Revenue.prototype.getEventProperties = function() {
        var eventProperties = this.properties ? (0,tslib_es6/* __assign */.pi)({}, this.properties) : {};
        eventProperties[esm_event/* RevenueProperty.REVENUE_PRODUCT_ID */.al.REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[esm_event/* RevenueProperty.REVENUE_QUANTITY */.al.REVENUE_QUANTITY] = this.quantity;
        eventProperties[esm_event/* RevenueProperty.REVENUE_PRICE */.al.REVENUE_PRICE] = this.price;
        eventProperties[esm_event/* RevenueProperty.REVENUE_TYPE */.al.REVENUE_TYPE] = this.revenueType;
        eventProperties[esm_event/* RevenueProperty.REVENUE */.al.REVENUE] = this.revenue;
        return eventProperties;
    };
    return Revenue;
}();
 //# sourceMappingURL=revenue.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/timeline.js



var Timeline = /** @class */ function() {
    function Timeline(client) {
        this.client = client;
        this.queue = [];
        // Flag to guarantee one schedule apply is running
        this.applying = false;
        // Flag indicates whether timeline is ready to process event
        // Events collected before timeline is ready will stay in the queue to be processed later
        this.plugins = [];
    }
    Timeline.prototype.register = function(plugin, config) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.plugins.some(function(existingPlugin) {
                            return existingPlugin.name === plugin.name;
                        })) {
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            config.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (plugin.name === undefined) {
                            plugin.name = UUID();
                            config.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
                        }
                        plugin.type = (_a = plugin.type) !== null && _a !== void 0 ? _a : 'enrichment';
                        return [
                            4 /*yield*/ ,
                            (_b = plugin.setup) === null || _b === void 0 ? void 0 : _b.call(plugin, config, this.client)
                        ];
                    case 1:
                        _c.sent();
                        this.plugins.push(plugin);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.deregister = function(pluginName) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var index, plugin;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        index = this.plugins.findIndex(function(plugin) {
                            return plugin.name === pluginName;
                        });
                        plugin = this.plugins[index];
                        this.plugins.splice(index, 1);
                        return [
                            4 /*yield*/ ,
                            (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.reset = function(client) {
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function(plugin) {
            var _a;
            return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin);
        });
        this.plugins = [];
        this.client = client;
    };
    Timeline.prototype.push = function(event) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.queue.push([
                event,
                resolve
            ]);
            _this.scheduleApply(0);
        });
    };
    Timeline.prototype.scheduleApply = function(timeout) {
        var _this = this;
        if (this.applying) return;
        this.applying = true;
        setTimeout(function() {
            void _this.apply(_this.queue.shift()).then(function() {
                _this.applying = false;
                if (_this.queue.length > 0) {
                    _this.scheduleApply(0);
                }
            });
        }, timeout);
    };
    Timeline.prototype.apply = function(item) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
            var e_1, _c, e_2, _d;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!item) {
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _a = (0,tslib_es6/* __read */.CR)(item, 1), event = _a[0];
                        _b = (0,tslib_es6/* __read */.CR)(item, 2), resolve = _b[1];
                        before = this.plugins.filter(function(plugin) {
                            return plugin.type === 'before';
                        });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        before_1 = (0,tslib_es6/* __values */.XA)(before), before_1_1 = before_1.next();
                        _e.label = 2;
                    case 2:
                        if (!!before_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        plugin = before_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) {
                            // do nothing
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0,tslib_es6/* __assign */.pi)({}, event))
                        ];
                    case 3:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else {
                            event = e;
                        }
                        _e.label = 4;
                    case 4:
                        before_1_1 = before_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        enrichment = this.plugins.filter(function(plugin) {
                            return plugin.type === 'enrichment' || plugin.type === undefined;
                        });
                        _e.label = 9;
                    case 9:
                        _e.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        enrichment_1 = (0,tslib_es6/* __values */.XA)(enrichment), enrichment_1_1 = enrichment_1.next();
                        _e.label = 10;
                    case 10:
                        if (!!enrichment_1_1.done) return [
                            3 /*break*/ ,
                            13
                        ];
                        plugin = enrichment_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) {
                            // do nothing
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0,tslib_es6/* __assign */.pi)({}, event))
                        ];
                    case 11:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else {
                            event = e;
                        }
                        _e.label = 12;
                    case 12:
                        enrichment_1_1 = enrichment_1.next();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        e_2_1 = _e.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        try {
                            if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            var eventClone = (0,tslib_es6/* __assign */.pi)({}, event);
                            return plugin.execute(eventClone).catch(function(e) {
                                return buildResult(eventClone, 0, String(e));
                            });
                        });
                        void Promise.all(executeDestinations).then(function(_a) {
                            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), result = _b[0];
                            var resolveResult = result || buildResult(event, 100, 'Event not tracked, no destination plugins on the instance');
                            resolve(resolveResult);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.flush = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var queue, destination, executeDestinations;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        queue = this.queue;
                        this.queue = [];
                        return [
                            4 /*yield*/ ,
                            Promise.all(queue.map(function(item) {
                                return _this.apply(item);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            return plugin.flush && plugin.flush();
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(executeDestinations)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return Timeline;
}();
 //# sourceMappingURL=timeline.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/event-builder.js



var createTrackEvent = function(eventInput, eventProperties, eventOptions) {
    var baseEvent = typeof eventInput === 'string' ? {
        event_type: eventInput
    } : eventInput;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, baseEvent), eventOptions), eventProperties && {
        event_properties: eventProperties
    });
};
var createIdentifyEvent = function(identify, eventOptions) {
    var identifyEvent = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, eventOptions), {
        event_type: esm_event/* SpecialEventType.IDENTIFY */.JU.IDENTIFY,
        user_properties: identify.getUserProperties()
    });
    return identifyEvent;
};
var createGroupIdentifyEvent = function(groupType, groupName, identify, eventOptions) {
    var _a;
    var groupIdentify = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, eventOptions), {
        event_type: esm_event/* SpecialEventType.GROUP_IDENTIFY */.JU.GROUP_IDENTIFY,
        group_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupIdentify;
};
var createGroupEvent = function(groupType, groupName, eventOptions) {
    var _a;
    var identify = new esm_identify/* Identify */.h();
    identify.set(groupType, groupName);
    var groupEvent = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, eventOptions), {
        event_type: esm_event/* SpecialEventType.IDENTIFY */.JU.IDENTIFY,
        user_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupEvent;
};
var createRevenueEvent = function(revenue, eventOptions) {
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, eventOptions), {
        event_type: esm_event/* SpecialEventType.REVENUE */.JU.REVENUE,
        event_properties: revenue.getEventProperties()
    });
}; //# sourceMappingURL=event-builder.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/core-client.js






var AmplitudeCore = /** @class */ function() {
    function AmplitudeCore(name) {
        if (name === void 0) {
            name = '$default';
        }
        this.initializing = false;
        this.isReady = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new Timeline(this);
        this.name = name;
    }
    AmplitudeCore.prototype._init = function(config) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.config = config;
                        this.timeline.reset(this);
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('q')
                        ];
                    case 1:
                        _a.sent();
                        this.isReady = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.runQueuedFunctions = function(queueName) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
            var e_1, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        queuedFunctions = this[queueName];
                        this[queueName] = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        queuedFunctions_1 = (0,tslib_es6/* __values */.XA)(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queuedFunctions_1_1.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        queuedFunction = queuedFunctions_1_1.value;
                        val = queuedFunction();
                        if (!(val && 'promise' in val)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            val.promise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            val
                        ];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        queuedFunctions_1_1 = queuedFunctions_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        if (!this[queueName].length) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions(queueName)
                        ];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.track = function(eventInput, eventProperties, eventOptions) {
        var event = createTrackEvent(eventInput, eventProperties, eventOptions);
        return (0,return_wrapper/* returnWrapper */.S)(this.dispatch(event));
    };
    AmplitudeCore.prototype.identify = function(identify, eventOptions) {
        var event = createIdentifyEvent(identify, eventOptions);
        return (0,return_wrapper/* returnWrapper */.S)(this.dispatch(event));
    };
    AmplitudeCore.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        var event = createGroupIdentifyEvent(groupType, groupName, identify, eventOptions);
        return (0,return_wrapper/* returnWrapper */.S)(this.dispatch(event));
    };
    AmplitudeCore.prototype.setGroup = function(groupType, groupName, eventOptions) {
        var event = createGroupEvent(groupType, groupName, eventOptions);
        return (0,return_wrapper/* returnWrapper */.S)(this.dispatch(event));
    };
    AmplitudeCore.prototype.revenue = function(revenue, eventOptions) {
        var event = createRevenueEvent(revenue, eventOptions);
        return (0,return_wrapper/* returnWrapper */.S)(this.dispatch(event));
    };
    AmplitudeCore.prototype.add = function(plugin) {
        if (!this.isReady) {
            this.q.push(this._addPlugin.bind(this, plugin));
            return (0,return_wrapper/* returnWrapper */.S)();
        }
        return this._addPlugin(plugin);
    };
    AmplitudeCore.prototype._addPlugin = function(plugin) {
        return (0,return_wrapper/* returnWrapper */.S)(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore.prototype.remove = function(pluginName) {
        if (!this.isReady) {
            this.q.push(this._removePlugin.bind(this, pluginName));
            return (0,return_wrapper/* returnWrapper */.S)();
        }
        return this._removePlugin(pluginName);
    };
    AmplitudeCore.prototype._removePlugin = function(pluginName) {
        return (0,return_wrapper/* returnWrapper */.S)(this.timeline.deregister(pluginName));
    };
    AmplitudeCore.prototype.dispatchWithCallback = function(event, callback) {
        if (!this.isReady) {
            return callback(buildResult(event, 0, CLIENT_NOT_INITIALIZED));
        }
        void this.process(event).then(callback);
    };
    AmplitudeCore.prototype.dispatch = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (!this.isReady) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve) {
                            _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
                        })
                    ];
                }
                return [
                    2 /*return*/ ,
                    this.process(event)
                ];
            });
        });
    };
    AmplitudeCore.prototype.process = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var result, e_2, message, result;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // skip event processing if opt out
                        if (this.config.optOut) {
                            return [
                                2 /*return*/ ,
                                buildResult(event, 0, OPT_OUT_MESSAGE)
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.timeline.push(event)
                        ];
                    case 1:
                        result = _a.sent();
                        result.code === 200 ? this.config.loggerProvider.log(result.message) : result.code === 100 ? this.config.loggerProvider.warn(result.message) : this.config.loggerProvider.error(result.message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 2:
                        e_2 = _a.sent();
                        message = String(e_2);
                        this.config.loggerProvider.error(message);
                        result = buildResult(event, 0, message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function(optOut) {
        if (!this.isReady) {
            this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
            return;
        }
        this._setOptOut(optOut);
    };
    AmplitudeCore.prototype._setOptOut = function(optOut) {
        this.config.optOut = Boolean(optOut);
    };
    AmplitudeCore.prototype.flush = function() {
        return (0,return_wrapper/* returnWrapper */.S)(this.timeline.flush());
    };
    return AmplitudeCore;
}();
 //# sourceMappingURL=core-client.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/default-tracking.js

/**
 * Returns false if autocapture === false or if autocapture[event],
 * otherwise returns true
 */ var isTrackingEnabled = function(autocapture, event) {
    if (typeof autocapture === 'boolean') {
        return autocapture;
    }
    if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) {
        return false;
    }
    return true;
};
var isAttributionTrackingEnabled = function(autocapture) {
    return isTrackingEnabled(autocapture, 'attribution');
};
var isFileDownloadTrackingEnabled = function(autocapture) {
    return isTrackingEnabled(autocapture, 'fileDownloads');
};
var isFormInteractionTrackingEnabled = function(autocapture) {
    return isTrackingEnabled(autocapture, 'formInteractions');
};
var isPageViewTrackingEnabled = function(autocapture) {
    return isTrackingEnabled(autocapture, 'pageViews');
};
var isSessionTrackingEnabled = function(autocapture) {
    return isTrackingEnabled(autocapture, 'sessions');
};
/**
 * Returns true if
 * 1. autocapture === true
 * 2. if autocapture.elementInteractions === true
 * 3. if autocapture.elementInteractions === object
 * otherwise returns false
 */ var isElementInteractionsEnabled = function(autocapture) {
    if (typeof autocapture === 'boolean') {
        return autocapture;
    }
    if (typeof autocapture === 'object' && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === 'object')) {
        return true;
    }
    return false;
};
var getElementInteractionsConfig = function(config) {
    if (isElementInteractionsEnabled(config.autocapture) && typeof config.autocapture === 'object' && typeof config.autocapture.elementInteractions === 'object') {
        return config.autocapture.elementInteractions;
    }
    return undefined;
};
var getPageViewTrackingConfig = function(config) {
    var trackOn = function() {
        return false;
    };
    var trackHistoryChanges = undefined;
    var eventType;
    var pageCounter = config.pageCounter;
    var isDefaultPageViewTrackingEnabled = isPageViewTrackingEnabled(config.defaultTracking);
    if (isDefaultPageViewTrackingEnabled) {
        trackOn = undefined;
        eventType = undefined;
        if (config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.pageViews && typeof config.defaultTracking.pageViews === 'object') {
            if ('trackOn' in config.defaultTracking.pageViews) {
                trackOn = config.defaultTracking.pageViews.trackOn;
            }
            if ('trackHistoryChanges' in config.defaultTracking.pageViews) {
                trackHistoryChanges = config.defaultTracking.pageViews.trackHistoryChanges;
            }
            if ('eventType' in config.defaultTracking.pageViews && config.defaultTracking.pageViews.eventType) {
                eventType = config.defaultTracking.pageViews.eventType;
            }
        }
    }
    return {
        trackOn: trackOn,
        trackHistoryChanges: trackHistoryChanges,
        eventType: eventType,
        pageCounter: pageCounter
    };
};
var getAttributionTrackingConfig = function(config) {
    if (isAttributionTrackingEnabled(config.defaultTracking) && config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.attribution && typeof config.defaultTracking.attribution === 'object') {
        return (0,tslib_es6/* __assign */.pi)({}, config.defaultTracking.attribution);
    }
    return {};
}; //# sourceMappingURL=default-tracking.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/attribution/constants.js
var UTM_CAMPAIGN = 'utm_campaign';
var UTM_CONTENT = 'utm_content';
var UTM_ID = 'utm_id';
var UTM_MEDIUM = 'utm_medium';
var UTM_SOURCE = 'utm_source';
var UTM_TERM = 'utm_term';
var DCLID = 'dclid';
var FBCLID = 'fbclid';
var GBRAID = 'gbraid';
var GCLID = 'gclid';
var KO_CLICK_ID = 'ko_click_id';
var LI_FAT_ID = 'li_fat_id';
var MSCLKID = 'msclkid';
var RDT_CID = 'rtd_cid';
var TTCLID = 'ttclid';
var TWCLID = 'twclid';
var WBRAID = 'wbraid';
var EMPTY_VALUE = 'EMPTY';
var BASE_CAMPAIGN = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rtd_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var MKTG = 'MKTG'; //# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/attribution/helpers.js



var domainWithoutSubdomain = function(domain) {
    var parts = domain.split('.');
    if (parts.length <= 2) {
        return domain;
    }
    return parts.slice(parts.length - 2, parts.length).join('.');
};
//Direct traffic mean no external referral, no UTMs, no click-ids, and no other customer identified marketing campaign url params.
var isDirectTraffic = function(current) {
    return Object.values(current).every(function(value) {
        return !value;
    });
};
var isNewCampaign = function(current, previous, options, isNewSession) {
    if (isNewSession === void 0) {
        isNewSession = true;
    }
    var referrer = current.referrer, referring_domain = current.referring_domain, currentCampaign = (0,tslib_es6/* __rest */._T)(current, [
        "referrer",
        "referring_domain"
    ]);
    var _a = previous || {}, _previous_referrer = _a.referrer, prevReferringDomain = _a.referring_domain, previousCampaign = (0,tslib_es6/* __rest */._T)(_a, [
        "referrer",
        "referring_domain"
    ]);
    if (isExcludedReferrer(options.excludeReferrers, current.referring_domain)) {
        return false;
    }
    //In the same session, direct traffic should not override or unset any persisting query params
    if (!isNewSession && isDirectTraffic(current) && previous) {
        return false;
    }
    var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
    var hasNewDomain = domainWithoutSubdomain(referring_domain || '') !== domainWithoutSubdomain(prevReferringDomain || '');
    return !previous || hasNewCampaign || hasNewDomain;
};
var isExcludedReferrer = function(excludeReferrers, referringDomain) {
    if (excludeReferrers === void 0) {
        excludeReferrers = [];
    }
    if (referringDomain === void 0) {
        referringDomain = '';
    }
    return excludeReferrers.some(function(value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
    });
};
var createCampaignEvent = function(campaign, options) {
    var campaignParameters = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, BASE_CAMPAIGN), campaign);
    var identifyEvent = Object.entries(campaignParameters).reduce(function(identify, _a) {
        var _b;
        var _c = (0,tslib_es6/* __read */.CR)(_a, 2), key = _c[0], value = _c[1];
        identify.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : 'EMPTY');
        if (value) {
            return identify.set(key, value);
        }
        return identify.unset(key);
    }, new esm_identify/* Identify */.h());
    return createIdentifyEvent(identifyEvent);
};
var getDefaultExcludedReferrers = function(cookieDomain) {
    var domain = cookieDomain;
    if (domain) {
        if (domain.startsWith('.')) {
            domain = domain.substring(1);
        }
        return [
            new RegExp("".concat(domain.replace('.', '\\.'), "$"))
        ];
    }
    return [];
}; //# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/storage/helpers.js

var getStorageKey = function(apiKey, postKey, limit) {
    if (postKey === void 0) {
        postKey = '';
    }
    if (limit === void 0) {
        limit = 10;
    }
    return [
        constants/* AMPLITUDE_PREFIX */.xp,
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
}; //# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/global-scope.js
var global_scope = __webpack_require__(96276);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/query-params.js

var getQueryParams = function() {
    var _a;
    var globalScope = (0,global_scope/* getGlobalScope */.l)();
    /* istanbul ignore if */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) {
        return {};
    }
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function(acc, curr) {
        var query = curr.split('=', 2);
        var key = tryDecodeURIComponent(query[0]);
        var value = tryDecodeURIComponent(query[1]);
        if (!value) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var tryDecodeURIComponent = function(value) {
    if (value === void 0) {
        value = '';
    }
    try {
        return decodeURIComponent(value);
    } catch (_a) {
        return '';
    }
}; //# sourceMappingURL=query-params.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/attribution/campaign-parser.js



var CampaignParser = /** @class */ function() {
    function CampaignParser() {}
    CampaignParser.prototype.parse = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, BASE_CAMPAIGN), this.getUtmParam()), this.getReferrer()), this.getClickIds())
                ];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function() {
        var params = getQueryParams();
        var utmCampaign = params[UTM_CAMPAIGN];
        var utmContent = params[UTM_CONTENT];
        var utmId = params[UTM_ID];
        var utmMedium = params[UTM_MEDIUM];
        var utmSource = params[UTM_SOURCE];
        var utmTerm = params[UTM_TERM];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm
        };
    };
    CampaignParser.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        } catch (_c) {
        // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function() {
        var _a;
        var params = getQueryParams();
        return _a = {}, _a[DCLID] = params[DCLID], _a[FBCLID] = params[FBCLID], _a[GBRAID] = params[GBRAID], _a[GCLID] = params[GCLID], _a[KO_CLICK_ID] = params[KO_CLICK_ID], _a[LI_FAT_ID] = params[LI_FAT_ID], _a[MSCLKID] = params[MSCLKID], _a[RDT_CID] = params[RDT_CID], _a[TTCLID] = params[TTCLID], _a[TWCLID] = params[TWCLID], _a[WBRAID] = params[WBRAID], _a;
    };
    return CampaignParser;
}();
 //# sourceMappingURL=campaign-parser.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/session.js
var isNewSession = function(sessionTimeout, lastEventTime) {
    if (lastEventTime === void 0) {
        lastEventTime = Date.now();
    }
    var currentTime = Date.now();
    var timeSinceLastEvent = currentTime - lastEventTime;
    return timeSinceLastEvent > sessionTimeout;
}; //# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/attribution/web-attribution.js






var WebAttribution = /** @class */ function() {
    function WebAttribution(options, config) {
        var _a;
        this.shouldTrackNewCampaign = false;
        this.options = (0,tslib_es6/* __assign */.pi)({
            initialEmptyValue: 'EMPTY',
            resetSessionOnNewCampaign: false,
            excludeReferrers: getDefaultExcludedReferrers((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain)
        }, options);
        this.storage = config.cookieStorage;
        this.storageKey = getStorageKey(config.apiKey, 'MKTG');
        this.currentCampaign = BASE_CAMPAIGN;
        this.sessionTimeout = config.sessionTimeout;
        this.lastEventTime = config.lastEventTime;
        config.loggerProvider.log('Installing web attribution tracking.');
    }
    WebAttribution.prototype.init = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var isEventInNewSession;
            var _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchCampaign()
                        ];
                    case 1:
                        _a = tslib_es6/* __read.apply */.CR.apply(void 0, [
                            _b.sent(),
                            2
                        ]), this.currentCampaign = _a[0], this.previousCampaign = _a[1];
                        isEventInNewSession = !this.lastEventTime ? true : isNewSession(this.sessionTimeout, this.lastEventTime);
                        if (!isNewCampaign(this.currentCampaign, this.previousCampaign, this.options, isEventInNewSession)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.shouldTrackNewCampaign = true;
                        return [
                            4 /*yield*/ ,
                            this.storage.set(this.storageKey, this.currentCampaign)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAttribution.prototype.fetchCampaign = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                new CampaignParser().parse(),
                                this.storage.get(this.storageKey)
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * This can be called when enable web attribution and either
     * 1. set a new session
     * 2. has new campaign and enable resetSessionOnNewCampaign
     */ WebAttribution.prototype.generateCampaignEvent = function(event_id) {
        // Mark this campaign has been tracked
        this.shouldTrackNewCampaign = false;
        var campaignEvent = createCampaignEvent(this.currentCampaign, this.options);
        if (event_id) {
            campaignEvent.event_id = event_id;
        }
        return campaignEvent;
    };
    WebAttribution.prototype.shouldSetSessionIdOnNewCampaign = function() {
        return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    };
    return WebAttribution;
}();
 //# sourceMappingURL=web-attribution.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/analytics-connector.js + 1 modules
var analytics_connector = __webpack_require__(64505);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/plugins/identity.js


var IdentityEventSender = /** @class */ function() {
    function IdentityEventSender() {
        this.name = 'identity';
        this.type = 'before';
        this.identityStore = (0,analytics_connector/* getAnalyticsConnector */.bM)().identityStore;
    }
    IdentityEventSender.prototype.execute = function(context) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var userProperties;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                userProperties = context.user_properties;
                if (userProperties) {
                    this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
                }
                return [
                    2 /*return*/ ,
                    context
                ];
            });
        });
    };
    IdentityEventSender.prototype.setup = function(config) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (config.instanceName) {
                    this.identityStore = (0,analytics_connector/* getAnalyticsConnector */.bM)(config.instanceName).identityStore;
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return IdentityEventSender;
}();
 //# sourceMappingURL=identity.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/offline.js
var OfflineDisabled = null; //# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/utils/snippet-helper.js
/**
 * Applies the proxied functions on the proxied amplitude snippet to an instance of the real object.
 * @ignore
 */ var runQueuedFunctions = function(instance, queue) {
    convertProxyObjectToRealObject(instance, queue);
};
/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 */ var convertProxyObjectToRealObject = function(instance, queue) {
    for(var i = 0; i < queue.length; i++){
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === 'function') {
            var result = fn.apply(instance, args);
            if (typeof resolve === 'function') {
                resolve(result === null || result === void 0 ? void 0 : result.promise);
            }
        }
    }
    return instance;
};
/**
 * Check if the param is snippet proxy
 */ var isInstanceProxy = function(instance) {
    var instanceProxy = instance;
    return instanceProxy && instanceProxy._q !== undefined;
}; //# sourceMappingURL=snippet-helper.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/language.js
var getLanguage = function() {
    var _a, _b, _c, _d;
    if (typeof navigator === 'undefined') return '';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var userLanguage = navigator.userLanguage;
    return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : '';
}; //# sourceMappingURL=language.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/version.js
var VERSION = '2.11.9'; //# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/plugins/context.js




var BROWSER_PLATFORM = 'Web';
var IP_ADDRESS = '$remote';
var Context = /** @class */ function() {
    function Context() {
        this.name = '@amplitude/plugin-context-browser';
        this.type = 'before';
        this.library = "amplitude-ts/".concat(VERSION);
        /* istanbul ignore else */ if (typeof navigator !== 'undefined') {
            this.userAgent = navigator.userAgent;
        }
    }
    Context.prototype.setup = function(config) {
        this.config = config;
        return Promise.resolve(undefined);
    };
    Context.prototype.execute = function(context) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var time, lastEventId, nextEventId, event;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                time = new Date().getTime();
                lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
                nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
                this.config.lastEventId = nextEventId;
                if (!context.time) {
                    this.config.lastEventTime = time;
                }
                event = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({
                    user_id: this.config.userId,
                    device_id: this.config.deviceId,
                    session_id: this.config.sessionId,
                    time: time
                }, this.config.appVersion && {
                    app_version: this.config.appVersion
                }), this.config.trackingOptions.platform && {
                    platform: BROWSER_PLATFORM
                }), this.config.trackingOptions.language && {
                    language: getLanguage()
                }), this.config.trackingOptions.ipAddress && {
                    ip: IP_ADDRESS
                }), {
                    insert_id: UUID(),
                    partner_id: this.config.partnerId,
                    plan: this.config.plan
                }), this.config.ingestionMetadata && {
                    ingestion_metadata: {
                        source_name: this.config.ingestionMetadata.sourceName,
                        source_version: this.config.ingestionMetadata.sourceVersion
                    }
                }), context), {
                    event_id: nextEventId,
                    library: this.library,
                    user_agent: this.userAgent
                });
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    return Context;
}();
 //# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/logger.js
var logger = __webpack_require__(36652);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/storage/memory.js

var MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        this.memoryStorage = new Map();
    }
    MemoryStorage.prototype.isEnabled = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    MemoryStorage.prototype.get = function(key) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.memoryStorage.get(key)
                ];
            });
        });
    };
    MemoryStorage.prototype.getRaw = function(key) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var value;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.get(key)
                        ];
                    case 1:
                        value = _a.sent();
                        return [
                            2 /*return*/ ,
                            value ? JSON.stringify(value) : undefined
                        ];
                }
            });
        });
    };
    MemoryStorage.prototype.set = function(key, value) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                this.memoryStorage.set(key, value);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.remove = function(key) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                this.memoryStorage.delete(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.reset = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                this.memoryStorage.clear();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return MemoryStorage;
}();
 //# sourceMappingURL=memory.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/logger.js
var esm_logger = __webpack_require__(70268);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/cookie-name.js

var getCookieName = function(apiKey, postKey, limit) {
    if (postKey === void 0) {
        postKey = '';
    }
    if (limit === void 0) {
        limit = 10;
    }
    return [
        constants/* AMPLITUDE_PREFIX */.xp,
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};
var getOldCookieName = function(apiKey) {
    return "".concat(constants/* AMPLITUDE_PREFIX.toLowerCase */.xp.toLowerCase(), "_").concat(apiKey.substring(0, 6));
}; //# sourceMappingURL=cookie-name.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/storage/cookie.js


var CookieStorage = /** @class */ function() {
    function CookieStorage(options) {
        this.options = (0,tslib_es6/* __assign */.pi)({}, options);
    }
    CookieStorage.prototype.isEnabled = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var testStrorage, testKey, value, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!(0,global_scope/* getGlobalScope */.l)()) {
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        CookieStorage.testValue = String(Date.now());
                        testStrorage = new CookieStorage(this.options);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStrorage.set(testKey, CookieStorage.testValue)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStrorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === CookieStorage.testValue
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStrorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.get = function(key) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var value, decodedValue;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) {
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        try {
                            decodedValue = (_a = decodeCookiesAsDefault(value)) !== null && _a !== void 0 ? _a : decodeCookiesWithDoubleUrlEncoding(value);
                            if (decodedValue === undefined) {
                                console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                            return [
                                2 /*return*/ ,
                                JSON.parse(decodedValue)
                            ];
                        } catch (_c) {
                            console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.getRaw = function(key) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var globalScope, cookie, match;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                globalScope = (0,global_scope/* getGlobalScope */.l)();
                cookie = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split('; ')) !== null && _b !== void 0 ? _b : [];
                match = cookie.find(function(c) {
                    return c.indexOf(key + '=') === 0;
                });
                if (!match) {
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                }
                return [
                    2 /*return*/ ,
                    match.substring(key.length + 1)
                ];
            });
        });
    };
    CookieStorage.prototype.set = function(key, value) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var expirationDays, expires, expireDate, date, str, globalScope, errorMessage;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                try {
                    expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
                    expires = value !== null ? expirationDays : -1;
                    expireDate = undefined;
                    if (expires) {
                        date = new Date();
                        date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
                        expireDate = date;
                    }
                    str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
                    if (expireDate) {
                        str += "; expires=".concat(expireDate.toUTCString());
                    }
                    str += '; path=/';
                    if (this.options.domain) {
                        str += "; domain=".concat(this.options.domain);
                    }
                    if (this.options.secure) {
                        str += '; Secure';
                    }
                    if (this.options.sameSite) {
                        str += "; SameSite=".concat(this.options.sameSite);
                    }
                    globalScope = (0,global_scope/* getGlobalScope */.l)();
                    if (globalScope) {
                        globalScope.document.cookie = str;
                    }
                } catch (error) {
                    errorMessage = error instanceof Error ? error.message : String(error);
                    console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CookieStorage.prototype.remove = function(key) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.set(key, null)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.reset = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return CookieStorage;
}();

var decodeCookiesAsDefault = function(value) {
    try {
        return decodeURIComponent(atob(value));
    } catch (_a) {
        return undefined;
    }
};
var decodeCookiesWithDoubleUrlEncoding = function(value) {
    // Modern Ruby (v7+) automatically encodes cookies with URL encoding by
    // https://api.rubyonrails.org/classes/ActionDispatch/Cookies.html
    try {
        return decodeURIComponent(atob(decodeURIComponent(value)));
    } catch (_a) {
        return undefined;
    }
}; //# sourceMappingURL=cookie.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/transports/fetch.js
var transports_fetch = __webpack_require__(22798);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/storage/browser-storage.js

var BrowserStorage = /** @class */ function() {
    function BrowserStorage(storage) {
        this.storage = storage;
    }
    BrowserStorage.prototype.isEnabled = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var random, testStorage, testKey, value, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!this.storage) {
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        random = String(Date.now());
                        testStorage = new BrowserStorage(this.storage);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStorage.set(testKey, random)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === random
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.get = function(key) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var value, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) {
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [
                            2 /*return*/ ,
                            JSON.parse(value)
                        ];
                    case 2:
                        _a = _b.sent();
                        console.error("[Amplitude] Error: Could not get value from storage");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.getRaw = function(key) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || undefined
                ];
            });
        });
    };
    BrowserStorage.prototype.set = function(key, value) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.remove = function(key) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.reset = function() {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.clear();
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return BrowserStorage;
}();
 //# sourceMappingURL=browser-storage.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/storage/local-storage.js



var MAX_ARRAY_LENGTH = 1000;
var LocalStorage = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(LocalStorage, _super);
    function LocalStorage(config) {
        var _this = this;
        var _a;
        _this = _super.call(this, (_a = (0,global_scope/* getGlobalScope */.l)()) === null || _a === void 0 ? void 0 : _a.localStorage) || this;
        _this.loggerProvider = config === null || config === void 0 ? void 0 : config.loggerProvider;
        return _this;
    }
    LocalStorage.prototype.set = function(key, value) {
        var _a;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var droppedEventsCount;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(Array.isArray(value) && value.length > MAX_ARRAY_LENGTH)) return [
                            3 /*break*/ ,
                            2
                        ];
                        droppedEventsCount = value.length - MAX_ARRAY_LENGTH;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value.slice(0, MAX_ARRAY_LENGTH))
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.loggerProvider) === null || _a === void 0 ? void 0 : _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, "."));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value)
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return LocalStorage;
}(BrowserStorage);
 //# sourceMappingURL=local-storage.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/storage/session-storage.js



var SessionStorage = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(SessionStorage, _super);
    function SessionStorage() {
        var _a;
        return _super.call(this, (_a = (0,global_scope/* getGlobalScope */.l)()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
    }
    return SessionStorage;
}(BrowserStorage);
 //# sourceMappingURL=session-storage.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/transports/base.js
var base = __webpack_require__(21143);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/transports/xhr.js


var XHRTransport = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            done: 4
        };
        return _this;
    }
    XHRTransport.prototype.send = function(serverUrl, payload) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        /* istanbul ignore if */ if (typeof XMLHttpRequest === 'undefined') {
                            reject(new Error('XHRTransport is not supported.'));
                        }
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', serverUrl, true);
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === _this.state.done) {
                                var responseText = xhr.responseText;
                                try {
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                                    resolve(_this.buildResponse(JSON.parse(responseText)));
                                } catch (_a) {
                                    resolve(_this.buildResponse({
                                        code: xhr.status
                                    }));
                                }
                            }
                        };
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.setRequestHeader('Accept', '*/*');
                        xhr.send(JSON.stringify(payload));
                    })
                ];
            });
        });
    };
    return XHRTransport;
}(base/* BaseTransport */.d);
 //# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/transports/send-beacon.js



var SendBeaconTransport = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(SendBeaconTransport, _super);
    function SendBeaconTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendBeaconTransport.prototype.send = function(serverUrl, payload) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var globalScope = (0,global_scope/* getGlobalScope */.l)();
                        /* istanbul ignore if */ if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) {
                            throw new Error('SendBeaconTransport is not supported');
                        }
                        try {
                            var data = JSON.stringify(payload);
                            var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
                            if (success) {
                                return resolve(_this.buildResponse({
                                    code: 200,
                                    events_ingested: payload.events.length,
                                    payload_size_bytes: data.length,
                                    server_upload_time: Date.now()
                                }));
                            }
                            return resolve(_this.buildResponse({
                                code: 500
                            }));
                        } catch (e) {
                            reject(e);
                        }
                    })
                ];
            });
        });
    };
    return SendBeaconTransport;
}(base/* BaseTransport */.d);
 //# sourceMappingURL=send-beacon.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/cookie-migration/index.js


var parseLegacyCookies = function(apiKey, cookieStorage, deleteLegacyCookies) {
    if (deleteLegacyCookies === void 0) {
        deleteLegacyCookies = true;
    }
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            switch(_b.label){
                case 0:
                    cookieName = getOldCookieName(apiKey);
                    return [
                        4 /*yield*/ ,
                        cookieStorage.getRaw(cookieName)
                    ];
                case 1:
                    cookies = _b.sent();
                    if (!cookies) {
                        return [
                            2 /*return*/ ,
                            {
                                optOut: false
                            }
                        ];
                    }
                    if (!deleteLegacyCookies) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        cookieStorage.remove(cookieName)
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = (0,tslib_es6/* __read */.CR)(cookies.split('.'), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
                    return [
                        2 /*return*/ ,
                        {
                            deviceId: deviceId,
                            userId: decode(userId),
                            sessionId: parseTime(sessionId),
                            lastEventId: parseTime(lastEventId),
                            lastEventTime: parseTime(lastEventTime),
                            optOut: Boolean(optOut)
                        }
                    ];
            }
        });
    });
};
var parseTime = function(num) {
    var integer = parseInt(num, 32);
    if (isNaN(integer)) {
        return undefined;
    }
    return integer;
};
var decode = function(value) {
    if (!atob || !escape || !value) {
        return undefined;
    }
    try {
        return decodeURIComponent(escape(atob(value)));
    } catch (_a) {
        return undefined;
    }
}; //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/constants.js
var DEFAULT_EVENT_PREFIX = '[Amplitude]';
var DEFAULT_PAGE_VIEW_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Page Viewed");
var DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started");
var DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted");
var DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded");
var DEFAULT_SESSION_START_EVENT = 'session_start';
var DEFAULT_SESSION_END_EVENT = 'session_end';
var FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension");
var FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name");
var LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID");
var LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text");
var LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL");
var FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID");
var FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name");
var FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination");
var DEFAULT_IDENTITY_STORAGE = 'cookie';
var DEFAULT_SERVER_ZONE = 'US'; //# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/config.js










// Exported for testing purposes only. Do not expose to public interface.
var BrowserConfig = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserConfig, _super);
    function BrowserConfig(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled) {
        if (cookieStorage === void 0) {
            cookieStorage = new MemoryStorage();
        }
        if (cookieOptions === void 0) {
            cookieOptions = {
                domain: '',
                expiration: 365,
                sameSite: 'Lax',
                secure: false,
                upgrade: true
            };
        }
        if (flushIntervalMillis === void 0) {
            flushIntervalMillis = 1000;
        }
        if (flushMaxRetries === void 0) {
            flushMaxRetries = 5;
        }
        if (flushQueueSize === void 0) {
            flushQueueSize = 30;
        }
        if (identityStorage === void 0) {
            identityStorage = DEFAULT_IDENTITY_STORAGE;
        }
        if (loggerProvider === void 0) {
            loggerProvider = new esm_logger/* Logger */.Y();
        }
        if (logLevel === void 0) {
            logLevel = logger/* LogLevel.Warn */.i.Warn;
        }
        if (offline === void 0) {
            offline = false;
        }
        if (optOut === void 0) {
            optOut = false;
        }
        if (serverUrl === void 0) {
            serverUrl = '';
        }
        if (serverZone === void 0) {
            serverZone = DEFAULT_SERVER_ZONE;
        }
        if (sessionTimeout === void 0) {
            sessionTimeout = 30 * 60 * 1000;
        }
        if (storageProvider === void 0) {
            storageProvider = new LocalStorage({
                loggerProvider: loggerProvider
            });
        }
        if (trackingOptions === void 0) {
            trackingOptions = {
                ipAddress: true,
                language: true,
                platform: true
            };
        }
        if (transport === void 0) {
            transport = 'fetch';
        }
        if (useBatch === void 0) {
            useBatch = false;
        }
        if (fetchRemoteConfig === void 0) {
            fetchRemoteConfig = false;
        }
        var _this = _super.call(this, {
            apiKey: apiKey,
            storageProvider: storageProvider,
            transportProvider: createTransport(transport)
        }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.autocapture = autocapture;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this.fetchRemoteConfig = fetchRemoteConfig;
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.debugLogsEnabled = debugLogsEnabled;
        _this.loggerProvider.enable(debugLogsEnabled ? logger/* LogLevel.Debug */.i.Debug : _this.logLevel);
        return _this;
    }
    Object.defineProperty(BrowserConfig.prototype, "cookieStorage", {
        get: function() {
            return this._cookieStorage;
        },
        set: function(cookieStorage) {
            if (this._cookieStorage !== cookieStorage) {
                this._cookieStorage = cookieStorage;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deviceId", {
        get: function() {
            return this._deviceId;
        },
        set: function(deviceId) {
            if (this._deviceId !== deviceId) {
                this._deviceId = deviceId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "userId", {
        get: function() {
            return this._userId;
        },
        set: function(userId) {
            if (this._userId !== userId) {
                this._userId = userId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "sessionId", {
        get: function() {
            return this._sessionId;
        },
        set: function(sessionId) {
            if (this._sessionId !== sessionId) {
                this._sessionId = sessionId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            if (this._optOut !== optOut) {
                this._optOut = optOut;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventTime", {
        get: function() {
            return this._lastEventTime;
        },
        set: function(lastEventTime) {
            if (this._lastEventTime !== lastEventTime) {
                this._lastEventTime = lastEventTime;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventId", {
        get: function() {
            return this._lastEventId;
        },
        set: function(lastEventId) {
            if (this._lastEventId !== lastEventId) {
                this._lastEventId = lastEventId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "pageCounter", {
        get: function() {
            return this._pageCounter;
        },
        set: function(pageCounter) {
            if (this._pageCounter !== pageCounter) {
                this._pageCounter = pageCounter;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "debugLogsEnabled", {
        set: function(debugLogsEnabled) {
            if (this._debugLogsEnabled !== debugLogsEnabled) {
                this._debugLogsEnabled = debugLogsEnabled;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    BrowserConfig.prototype.updateStorage = function() {
        var cache = {
            deviceId: this._deviceId,
            userId: this._userId,
            sessionId: this._sessionId,
            optOut: this._optOut,
            lastEventTime: this._lastEventTime,
            lastEventId: this._lastEventId,
            pageCounter: this._pageCounter,
            debugLogsEnabled: this._debugLogsEnabled
        };
        void this.cookieStorage.set(getCookieName(this.apiKey), cache);
    };
    return BrowserConfig;
}(config/* Config */.De);

var useBrowserConfig = function(apiKey, options, amplitudeInstance) {
    if (options === void 0) {
        options = {};
    }
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var identityStorage, cookieOptions, _a, _b, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_3) {
            switch(_3.label){
                case 0:
                    identityStorage = options.identityStorage || DEFAULT_IDENTITY_STORAGE;
                    _c = {};
                    if (!(identityStorage !== DEFAULT_IDENTITY_STORAGE)) return [
                        3 /*break*/ ,
                        1
                    ];
                    _a = '';
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 1:
                    if (!((_e = (_d = options.cookieOptions) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = _e;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        getTopLevelDomain()
                    ];
                case 3:
                    _b = _3.sent();
                    _3.label = 4;
                case 4:
                    _a = _b;
                    _3.label = 5;
                case 5:
                    cookieOptions = tslib_es6/* __assign.apply */.pi.apply(void 0, [
                        (_c.domain = _a, _c.expiration = 365, _c.sameSite = 'Lax', _c.secure = false, _c.upgrade = true, _c),
                        options.cookieOptions
                    ]);
                    cookieStorage = createCookieStorage(options.identityStorage, cookieOptions);
                    return [
                        4 /*yield*/ ,
                        parseLegacyCookies(apiKey, cookieStorage, (_g = (_f = options.cookieOptions) === null || _f === void 0 ? void 0 : _f.upgrade) !== null && _g !== void 0 ? _g : true)
                    ];
                case 6:
                    legacyCookies = _3.sent();
                    return [
                        4 /*yield*/ ,
                        cookieStorage.get(getCookieName(apiKey))
                    ];
                case 7:
                    previousCookies = _3.sent();
                    queryParams = getQueryParams();
                    deviceId = (_m = (_l = (_k = (_j = (_h = options.deviceId) !== null && _h !== void 0 ? _h : queryParams.ampDeviceId) !== null && _j !== void 0 ? _j : queryParams.deviceId) !== null && _k !== void 0 ? _k : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _l !== void 0 ? _l : legacyCookies.deviceId) !== null && _m !== void 0 ? _m : UUID();
                    lastEventId = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _o !== void 0 ? _o : legacyCookies.lastEventId;
                    lastEventTime = (_p = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _p !== void 0 ? _p : legacyCookies.lastEventTime;
                    optOut = (_r = (_q = options.optOut) !== null && _q !== void 0 ? _q : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _r !== void 0 ? _r : legacyCookies.optOut;
                    sessionId = (_s = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _s !== void 0 ? _s : legacyCookies.sessionId;
                    userId = (_u = (_t = options.userId) !== null && _t !== void 0 ? _t : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _u !== void 0 ? _u : legacyCookies.userId;
                    amplitudeInstance.previousSessionDeviceId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _v !== void 0 ? _v : legacyCookies.deviceId;
                    amplitudeInstance.previousSessionUserId = (_w = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _w !== void 0 ? _w : legacyCookies.userId;
                    trackingOptions = {
                        ipAddress: (_y = (_x = options.trackingOptions) === null || _x === void 0 ? void 0 : _x.ipAddress) !== null && _y !== void 0 ? _y : true,
                        language: (_0 = (_z = options.trackingOptions) === null || _z === void 0 ? void 0 : _z.language) !== null && _0 !== void 0 ? _0 : true,
                        platform: (_2 = (_1 = options.trackingOptions) === null || _1 === void 0 ? void 0 : _1.platform) !== null && _2 !== void 0 ? _2 : true
                    };
                    pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
                    debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
                    // Override default tracking options if autocapture is set
                    if (options.autocapture !== undefined) {
                        options.defaultTracking = options.autocapture;
                    }
                    browserConfig = new BrowserConfig(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled);
                    return [
                        4 /*yield*/ ,
                        browserConfig.storageProvider.isEnabled()
                    ];
                case 8:
                    if (!_3.sent()) {
                        browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
                        browserConfig.storageProvider = new MemoryStorage();
                    }
                    return [
                        2 /*return*/ ,
                        browserConfig
                    ];
            }
        });
    });
};
var createCookieStorage = function(identityStorage, cookieOptions) {
    if (identityStorage === void 0) {
        identityStorage = DEFAULT_IDENTITY_STORAGE;
    }
    if (cookieOptions === void 0) {
        cookieOptions = {};
    }
    switch(identityStorage){
        case 'localStorage':
            return new LocalStorage();
        case 'sessionStorage':
            return new SessionStorage();
        case 'none':
            return new MemoryStorage();
        case 'cookie':
        default:
            return new CookieStorage((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, cookieOptions), {
                expirationDays: cookieOptions.expiration
            }));
    }
};
var createTransport = function(transport) {
    if (transport === 'xhr') {
        return new XHRTransport();
    }
    if (transport === 'beacon') {
        return new SendBeaconTransport();
    }
    return new transports_fetch/* FetchTransport */.V();
};
var getTopLevelDomain = function(url) {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var host, parts, levels, storageKey, i, i, domain, options, storage, value;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new CookieStorage().isEnabled()
                    ];
                case 1:
                    if (!_a.sent() || !url && (typeof location === 'undefined' || !location.hostname)) {
                        return [
                            2 /*return*/ ,
                            ''
                        ];
                    }
                    host = url !== null && url !== void 0 ? url : location.hostname;
                    parts = host.split('.');
                    levels = [];
                    storageKey = 'AMP_TLDTEST';
                    for(i = parts.length - 2; i >= 0; --i){
                        levels.push(parts.slice(i).join('.'));
                    }
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < levels.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    domain = levels[i];
                    options = {
                        domain: '.' + domain
                    };
                    storage = new CookieStorage(options);
                    return [
                        4 /*yield*/ ,
                        storage.set(storageKey, 1)
                    ];
                case 3:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        storage.get(storageKey)
                    ];
                case 4:
                    value = _a.sent();
                    if (!value) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        storage.remove(storageKey)
                    ];
                case 5:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        '.' + domain
                    ];
                case 6:
                    i++;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        ''
                    ];
            }
        });
    });
}; //# sourceMappingURL=config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-page-view-tracking-browser@2.3.5/node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/utils.js
var omitUndefined = function(input) {
    var obj = {};
    for(var key in input){
        var val = input[key];
        if (val) {
            obj[key] = val;
        }
    }
    return obj;
}; //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-page-view-tracking-browser@2.3.5/node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/page-view-tracking.js





var defaultPageViewEvent = '[Amplitude] Page Viewed';
var pageViewTrackingPlugin = function(options) {
    if (options === void 0) {
        options = {};
    }
    var amplitude;
    var globalScope = (0,global_scope/* getGlobalScope */.l)();
    var loggerProvider = undefined;
    var pushState;
    var localConfig;
    var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a = options.eventType, eventType = _a === void 0 ? defaultPageViewEvent : _a;
    var getDecodeURI = function(locationStr) {
        var decodedLocationStr = locationStr;
        try {
            decodedLocationStr = decodeURI(locationStr);
        } catch (e) {
            /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.error('Malformed URI sequence: ', e);
        }
        return decodedLocationStr;
    };
    var createPageViewEvent = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var locationHREF, _a;
            var _b;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        locationHREF = getDecodeURI(typeof location !== 'undefined' && location.href || '');
                        _b = {
                            event_type: eventType
                        };
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            getCampaignParams()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (_b.event_properties = tslib_es6/* __assign.apply */.pi.apply(void 0, [
                                tslib_es6/* __assign.apply */.pi.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    '[Amplitude] Page Domain': /* istanbul ignore next */ typeof location !== 'undefined' && location.hostname || '',
                                    '[Amplitude] Page Location': locationHREF,
                                    '[Amplitude] Page Path': /* istanbul ignore next */ typeof location !== 'undefined' && getDecodeURI(location.pathname) || '',
                                    '[Amplitude] Page Title': /* istanbul ignore next */ typeof document !== 'undefined' && document.title || '',
                                    '[Amplitude] Page URL': locationHREF.split('?')[0]
                                }
                            ]), _b)
                        ];
                }
            });
        });
    };
    var shouldTrackOnPageLoad = function() {
        return typeof trackOn === 'undefined' || typeof trackOn === 'function' && trackOn();
    };
    /* istanbul ignore next */ var previousURL = typeof location !== 'undefined' ? location.href : null;
    var trackHistoryPageView = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var newURL, shouldTrackPageView, _a, _b, _c;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        newURL = location.href;
                        shouldTrackPageView = shouldTrackHistoryPageView(trackHistoryChanges, newURL, previousURL || '') && shouldTrackOnPageLoad();
                        // Note: Update `previousURL` in the same clock tick as `shouldTrackHistoryPageView()`
                        // This was previously done after `amplitude?.track(await createPageViewEvent());` and
                        // causes a concurrency issue where app triggers `pushState` twice with the same URL target
                        // but `previousURL` is only updated after the second `pushState` producing two page viewed events
                        previousURL = newURL;
                        if (!shouldTrackPageView) return [
                            3 /*break*/ ,
                            4
                        ];
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log('Tracking page view event');
                        if (!(amplitude === null || amplitude === void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = void 0;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        _c = (_b = amplitude).track;
                        return [
                            4 /*yield*/ ,
                            createPageViewEvent()
                        ];
                    case 2:
                        _a = _c.apply(_b, [
                            _d.sent()
                        ]);
                        _d.label = 3;
                    case 3:
                        _a;
                        _d.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /* istanbul ignore next */ var trackHistoryPageViewWrapper = function() {
        void trackHistoryPageView();
    };
    var plugin = {
        name: '@amplitude/plugin-page-view-tracking-browser',
        type: 'enrichment',
        setup: function(config, client) {
            return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                var _a, _b;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            amplitude = client;
                            localConfig = config;
                            loggerProvider = config.loggerProvider;
                            loggerProvider.log('Installing @amplitude/plugin-page-view-tracking-browser');
                            if (globalScope) {
                                globalScope.addEventListener('popstate', trackHistoryPageViewWrapper);
                                // Save reference to original push state, to be used in teardown
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                pushState = globalScope.history.pushState;
                                /* istanbul ignore next */ // There is no global browser listener for changes to history, so we have
                                // to modify pushState directly.
                                // https://stackoverflow.com/a/64927639
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                    apply: function(target, thisArg, _a) {
                                        var _b = (0,tslib_es6/* __read */.CR)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        void trackHistoryPageView();
                                    }
                                });
                            }
                            if (!shouldTrackOnPageLoad()) return [
                                3 /*break*/ ,
                                2
                            ];
                            loggerProvider.log('Tracking page view event');
                            _b = (_a = amplitude).track;
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            _b.apply(_a, [
                                _c.sent()
                            ]);
                            _c.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function(event) {
            return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                var pageViewEvent;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(trackOn === 'attribution' && isCampaignEvent(event))) return [
                                3 /*break*/ ,
                                2
                            ];
                            /* istanbul ignore next */ // loggerProvider should be defined by the time execute is invoked
                            loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log('Enriching campaign event to page view event with campaign parameters');
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            pageViewEvent = _a.sent();
                            event.event_type = pageViewEvent.event_type;
                            event.event_properties = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.event_properties), pageViewEvent.event_properties);
                            _a.label = 2;
                        case 2:
                            // Update the pageCounter for the page view event
                            if (localConfig && event.event_type === eventType) {
                                localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                                event.event_properties = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.event_properties), {
                                    '[Amplitude] Page Counter': localConfig.pageCounter
                                });
                            }
                            return [
                                2 /*return*/ ,
                                event
                            ];
                    }
                });
            });
        },
        teardown: function() {
            return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    if (globalScope) {
                        globalScope.removeEventListener('popstate', trackHistoryPageViewWrapper);
                        if (pushState) {
                            globalScope.history.pushState = pushState;
                        }
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }
    };
    return plugin;
};
var getCampaignParams = function() {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var _a;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = omitUndefined;
                    return [
                        4 /*yield*/ ,
                        new CampaignParser().parse()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ])
                    ];
            }
        });
    });
};
var isCampaignEvent = function(event) {
    if (event.event_type === '$identify' && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[esm_event/* IdentifyOperation.SET */.h9.SET] || {};
        var $unset = properties[esm_event/* IdentifyOperation.UNSET */.h9.UNSET] || {};
        var userProperties_1 = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(Object.keys($set)), false), (0,tslib_es6/* __read */.CR)(Object.keys($unset)), false);
        return Object.keys(BASE_CAMPAIGN).every(function(value) {
            return userProperties_1.includes(value);
        });
    }
    return false;
};
var shouldTrackHistoryPageView = function(trackingOption, newURLStr, oldURLStr) {
    switch(trackingOption){
        case 'pathOnly':
            {
                if (oldURLStr == '') return true;
                var newURL = new URL(newURLStr);
                var oldURL = new URL(oldURLStr);
                var newBaseStr = newURL.origin + newURL.pathname;
                var oldBaseStr = oldURL.origin + oldURL.pathname;
                return newBaseStr !== oldBaseStr;
            }
        default:
            return newURLStr !== oldURLStr;
    }
}; //# sourceMappingURL=page-view-tracking.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/plugins/form-interaction-tracking.js



var formInteractionTracking = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 ? void 0 : element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-form-interaction-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                // The form interaction plugin observes changes in the dom. For this to work correctly, the observer can only be setup
                // after the body is built. When Amplitud gets initialized in a script tag, the body tag is still unavailable. So register this
                // only after the window is loaded
                /* istanbul ignore next */ (_a = (0,global_scope/* getGlobalScope */.l)()) === null || _a === void 0 ? void 0 : _a.addEventListener('load', function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') {
                        return;
                    }
                    var addFormInteractionListener = function(form) {
                        var hasFormChanged = false;
                        addEventListener(form, 'change', function() {
                            var _a;
                            if (!hasFormChanged) {
                                amplitude.track(DEFAULT_FORM_START_EVENT, (_a = {}, _a[FORM_ID] = stringOrUndefined(form.id), _a[FORM_NAME] = stringOrUndefined(form.name), _a[FORM_DESTINATION] = form.action, _a));
                            }
                            hasFormChanged = true;
                        });
                        addEventListener(form, 'submit', function() {
                            var _a, _b;
                            if (!hasFormChanged) {
                                amplitude.track(DEFAULT_FORM_START_EVENT, (_a = {}, _a[FORM_ID] = stringOrUndefined(form.id), _a[FORM_NAME] = stringOrUndefined(form.name), _a[FORM_DESTINATION] = form.action, _a));
                            }
                            amplitude.track(DEFAULT_FORM_SUBMIT_EVENT, (_b = {}, _b[FORM_ID] = stringOrUndefined(form.id), _b[FORM_NAME] = stringOrUndefined(form.name), _b[FORM_DESTINATION] = form.action, _b));
                            hasFormChanged = false;
                        });
                    };
                    // Adds listener to existing anchor tags
                    var forms = Array.from(document.getElementsByTagName('form'));
                    forms.forEach(addFormInteractionListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'FORM') {
                                        addFormInteractionListener(node);
                                    }
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                        Array.from(node.querySelectorAll('form')).map(addFormInteractionListener);
                                    }
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};
var stringOrUndefined = function(name) {
    /* istanbul ignore if */ if (typeof name !== 'string') {
        // We found instances where the value of `name` is an Element and not a string.
        // Elements may have circular references and would throw an error when passed to `JSON.stringify(...)`.
        // If a non-string value is seen, assume there is no value.
        return undefined;
    }
    return name;
}; //# sourceMappingURL=form-interaction-tracking.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/plugins/file-download-tracking.js



var fileDownloadTracking = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 ? void 0 : element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-file-download-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                // The form interaction plugin observes changes in the dom. For this to work correctly, the observer can only be setup
                // after the body is built. When Amplitud gets initialized in a script tag, the body tag is still unavailable. So register this
                // only after the window is loaded
                /* istanbul ignore next */ (_a = (0,global_scope/* getGlobalScope */.l)()) === null || _a === void 0 ? void 0 : _a.addEventListener('load', function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') {
                        return;
                    }
                    var addFileDownloadListener = function(a) {
                        var url;
                        try {
                            // eslint-disable-next-line no-restricted-globals
                            url = new URL(a.href, window.location.href);
                        } catch (_a) {
                            /* istanbul ignore next */ return;
                        }
                        var result = ext.exec(url.href);
                        var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                        if (fileExtension) {
                            addEventListener(a, 'click', function() {
                                var _a;
                                if (fileExtension) {
                                    amplitude.track(DEFAULT_FILE_DOWNLOAD_EVENT, (_a = {}, _a[FILE_EXTENSION] = fileExtension, _a[FILE_NAME] = url.pathname, _a[LINK_ID] = a.id, _a[LINK_TEXT] = a.text, _a[LINK_URL] = a.href, _a));
                                }
                            });
                        }
                    };
                    var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
                    // Adds listener to existing anchor tags
                    var links = Array.from(document.getElementsByTagName('a'));
                    links.forEach(addFileDownloadListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'A') {
                                        addFileDownloadListener(node);
                                    }
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                        Array.from(node.querySelectorAll('a')).map(addFileDownloadListener);
                                    }
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
}; //# sourceMappingURL=file-download-tracking.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/det-notification.js
var notified = false;
var detNotify = function(config) {
    if (notified || config.defaultTracking !== undefined) {
        return;
    }
    var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
    config.loggerProvider.warn(message);
    notified = true;
};
/**
 * @private
 * This function is meant for testing purposes only
 */ var resetNotify = function() {
    notified = false;
}; //# sourceMappingURL=det-notification.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/plugins/network-connectivity-checker.js


var networkConnectivityCheckerPlugin = function() {
    var name = '@amplitude/plugin-network-checker-browser';
    var type = 'before';
    var globalScope = (0,global_scope/* getGlobalScope */.l)();
    var eventListeners = [];
    var addNetworkListener = function(type, handler) {
        if (globalScope) {
            globalScope.addEventListener(type, handler);
            eventListeners.push({
                type: type,
                handler: handler
            });
        }
    };
    var removeNetworkListeners = function() {
        eventListeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            if (globalScope) {
                globalScope.removeEventListener(type, handler);
            }
        });
        eventListeners = [];
    };
    var setup = function(config, amplitude) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (typeof navigator === 'undefined') {
                    config.loggerProvider.debug('Network connectivity checker plugin is disabled because navigator is not available.');
                    config.offline = false;
                    return [
                        2 /*return*/ 
                    ];
                }
                config.offline = !navigator.onLine;
                addNetworkListener('online', function() {
                    config.loggerProvider.debug('Network connectivity changed to online.');
                    config.offline = false;
                    // Flush immediately will cause ERR_NETWORK_CHANGED
                    setTimeout(function() {
                        amplitude.flush();
                    }, config.flushIntervalMillis);
                });
                addNetworkListener('offline', function() {
                    config.loggerProvider.debug('Network connectivity changed to offline.');
                    config.offline = true;
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var teardown = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                removeNetworkListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        teardown: teardown
    };
}; //# sourceMappingURL=network-connectivity-checker.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/server-zone.js
var server_zone = __webpack_require__(59207);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-remote-config@0.4.1/node_modules/@amplitude/analytics-remote-config/lib/esm/remote-config.js



var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, remote config fetch failed';
var SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var remote_config_MAX_RETRIES_EXCEEDED_MESSAGE = 'Remote config fetch rejected due to exceeded retry count';
var TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var remote_config_UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var REMOTE_CONFIG_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_STAGING = 'https://sr-client-cfg.stag2.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_EU = 'https://sr-client-cfg.eu.amplitude.com/config';
var RemoteConfigFetch = /** @class */ function() {
    function RemoteConfigFetch(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1000;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var fetchStartTime, configAPIResponse, remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fetchStartTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                this.fetchWithTimeout(sessionId)
                            ];
                        case 1:
                            configAPIResponse = _a.sent();
                            if (configAPIResponse) {
                                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                                if (remoteConfig) {
                                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                                    return [
                                        2 /*return*/ ,
                                        remoteConfig[key]
                                    ];
                                }
                            }
                            this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        this.fetchWithTimeout = function(sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var controller, timeoutId, remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            controller = new AbortController();
                            timeoutId = setTimeout(function() {
                                return controller.abort();
                            }, 5000);
                            return [
                                4 /*yield*/ ,
                                this.fetchRemoteConfig(controller.signal, sessionId)
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            clearTimeout(timeoutId);
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var urlParams, _a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
                var e_2, _c;
                var _d;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: remote_config_MAX_RETRIES_EXCEEDED_MESSAGE
                                    })
                                ];
                            } else if (signal.aborted) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: TIMEOUT_MESSAGE
                                    })
                                ];
                            } else if (sessionId !== this.lastFetchedSessionId) {
                                this.lastFetchedSessionId = sessionId;
                                this.attempts = 0;
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            urlParams = new URLSearchParams({
                                api_key: this.localConfig.apiKey
                            });
                            try {
                                for(_a = (0,tslib_es6/* __values */.XA)(this.configKeys), _b = _a.next(); !_b.done; _b = _a.next()){
                                    configKey = _b.value;
                                    urlParams.append('config_keys', configKey);
                                }
                            } catch (e_2_1) {
                                e_2 = {
                                    error: e_2_1
                                };
                            } finally{
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                } finally{
                                    if (e_2) throw e_2.error;
                                }
                            }
                            if (sessionId) {
                                urlParams.set('session_id', String(sessionId));
                            }
                            options = {
                                headers: {
                                    Accept: '*/*'
                                },
                                method: 'GET'
                            };
                            serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                            this.attempts += 1;
                            return [
                                4 /*yield*/ ,
                                fetch(serverUrl, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), {
                                    signal: signal
                                }))
                            ];
                        case 2:
                            res = _e.sent();
                            if (res === null) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: remote_config_UNEXPECTED_ERROR_MESSAGE
                                    })
                                ];
                            }
                            parsedStatus = new base/* BaseTransport */.d().buildStatus(res.status);
                            switch(parsedStatus){
                                case esm_status/* Status.Success */.q.Success:
                                    this.attempts = 0;
                                    return [
                                        2 /*return*/ ,
                                        this.parseAndStoreConfig(res)
                                    ];
                                case esm_status/* Status.Failed */.q.Failed:
                                    return [
                                        2 /*return*/ ,
                                        this.retryFetch(signal, sessionId)
                                    ];
                                default:
                                    return [
                                        2 /*return*/ ,
                                        this.completeRequest({
                                            err: UNEXPECTED_NETWORK_ERROR_MESSAGE
                                        })
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _e.sent();
                            knownError = e_1;
                            if (signal.aborted) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: TIMEOUT_MESSAGE
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: (_d = knownError.message) !== null && _d !== void 0 ? _d : remote_config_UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.retryFetch = function(signal, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var _this = this;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, _this.attempts * _this.retryTimeout);
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.fetchRemoteConfig(signal, sessionId)
                            ];
                    }
                });
            });
        };
        this.parseAndStoreConfig = function(res) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                res.json()
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            this.completeRequest({
                                success: SUCCESS_REMOTE_CONFIG
                            });
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
    }
    RemoteConfigFetch.prototype.getServerUrl = function() {
        if (this.localConfig.serverZone === server_zone/* ServerZone.STAGING */.J.STAGING) {
            return REMOTE_CONFIG_SERVER_URL_STAGING;
        }
        if (this.localConfig.serverZone === server_zone/* ServerZone.EU */.J.EU) {
            return REMOTE_CONFIG_SERVER_URL_EU;
        }
        return REMOTE_CONFIG_SERVER_URL;
    };
    RemoteConfigFetch.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) {
            throw new Error(err);
        } else if (success) {
            this.localConfig.loggerProvider.log(success);
        }
    };
    return RemoteConfigFetch;
}();

var createRemoteConfigFetch = function(_a) {
    var localConfig = _a.localConfig, configKeys = _a.configKeys;
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            return [
                2 /*return*/ ,
                new RemoteConfigFetch({
                    localConfig: localConfig,
                    configKeys: configKeys
                })
            ];
        });
    });
}; //# sourceMappingURL=remote-config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-remote-config@0.4.1/node_modules/@amplitude/analytics-remote-config/lib/esm/index.js

var esm_createRemoteConfigFetch = createRemoteConfigFetch; //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/config/joined-config.js



var BrowserJoinedConfigGenerator = /** @class */ function() {
    function BrowserJoinedConfigGenerator(localConfig) {
        this.config = localConfig;
        this.config.loggerProvider.debug('Local configuration before merging with remote config', JSON.stringify(this.config, null, 2));
    }
    BrowserJoinedConfigGenerator.prototype.initialize = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            esm_createRemoteConfigFetch({
                                localConfig: this.config,
                                configKeys: [
                                    'analyticsSDK'
                                ]
                            })
                        ];
                    case 1:
                        _a.remoteConfigFetch = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserJoinedConfigGenerator.prototype.generateJoinedConfig = function() {
        var _a, _b, _c;
        var _d;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var remoteConfig, _e, e_1;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _f.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _e = this.remoteConfigFetch;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('analyticsSDK', 'browserSDK', this.config.sessionId)
                        ];
                    case 1:
                        _e = _f.sent();
                        _f.label = 2;
                    case 2:
                        remoteConfig = _e;
                        this.config.loggerProvider.debug('Remote configuration:', JSON.stringify(remoteConfig, null, 2));
                        // merge remoteConfig.autocapture and this.config.autocapture
                        // if a field is in remoteConfig.autocapture, use that value
                        // if a field is not in remoteConfig.autocapture, use the value from this.config.autocapture
                        if (remoteConfig && 'autocapture' in remoteConfig) {
                            if (typeof remoteConfig.autocapture === 'boolean') {
                                this.config.autocapture = remoteConfig.autocapture;
                            }
                            if (typeof remoteConfig.autocapture === 'object') {
                                if (this.config.autocapture === undefined) {
                                    this.config.autocapture = remoteConfig.autocapture;
                                }
                                if (typeof this.config.autocapture === 'boolean') {
                                    this.config.autocapture = (0,tslib_es6/* __assign */.pi)({
                                        attribution: this.config.autocapture,
                                        fileDownloads: this.config.autocapture,
                                        formInteractions: this.config.autocapture,
                                        pageViews: this.config.autocapture,
                                        sessions: this.config.autocapture,
                                        elementInteractions: this.config.autocapture
                                    }, remoteConfig.autocapture);
                                }
                                if (typeof this.config.autocapture === 'object') {
                                    this.config.autocapture = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.config.autocapture), remoteConfig.autocapture);
                                }
                            }
                            // Override default tracking options if autocapture is updated by remote config
                            this.config.defaultTracking = this.config.autocapture;
                        }
                        this.config.loggerProvider.debug('Joined configuration: ', JSON.stringify(this.config, null, 2));
                        (_a = (_d = this.config).requestMetadata) !== null && _a !== void 0 ? _a : _d.requestMetadata = new config/* RequestMetadata */.Dg();
                        if ((_b = this.remoteConfigFetch) === null || _b === void 0 ? void 0 : _b.metrics.fetchTimeAPISuccess) {
                            this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_success', this.remoteConfigFetch.metrics.fetchTimeAPISuccess);
                        }
                        if ((_c = this.remoteConfigFetch) === null || _c === void 0 ? void 0 : _c.metrics.fetchTimeAPIFail) {
                            this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_fail', this.remoteConfigFetch.metrics.fetchTimeAPIFail);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _f.sent();
                        this.config.loggerProvider.error('Failed to fetch remote configuration because of error: ', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.config
                        ];
                }
            });
        });
    };
    return BrowserJoinedConfigGenerator;
}();

var createBrowserJoinedConfigGenerator = function(localConfig) {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var joinedConfigGenerator;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
            switch(_a.label){
                case 0:
                    joinedConfigGenerator = new BrowserJoinedConfigGenerator(localConfig);
                    return [
                        4 /*yield*/ ,
                        joinedConfigGenerator.initialize()
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        joinedConfigGenerator
                    ];
            }
        });
    });
}; //# sourceMappingURL=joined-config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/element-interactions.js
/**
 * Default CSS selectors to define which elements on the page to track.
 * Extend this list to include additional elements to track. For example:
 * ```
 * autocapturePlugin({
 *    cssSelectorAllowlist: [...DEFAULT_CSS_SELECTOR_ALLOWLIST, ".my-class"],
 * })
 * ```
 */ var DEFAULT_CSS_SELECTOR_ALLOWLIST = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'video',
    'audio',
    '[contenteditable="true" i]',
    '[data-amp-default-track]',
    '.amp-default-track'
];
/**
 * Default prefix to allow the plugin to capture data attributes as an event property.
 */ var DEFAULT_DATA_ATTRIBUTE_PREFIX = 'data-amp-track-';
/**
 * Default list of elements on the page should be tracked when the page changes.
 */ var DEFAULT_ACTION_CLICK_ALLOWLIST = [
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
]; //# sourceMappingURL=element-interactions.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/constants.js
var PLUGIN_NAME = '@amplitude/plugin-autocapture-browser';
var AMPLITUDE_ELEMENT_CLICKED_EVENT = '[Amplitude] Element Clicked';
var AMPLITUDE_ELEMENT_CHANGED_EVENT = '[Amplitude] Element Changed';
var AMPLITUDE_EVENT_PROP_ELEMENT_ID = '[Amplitude] Element ID';
var AMPLITUDE_EVENT_PROP_ELEMENT_CLASS = '[Amplitude] Element Class';
var AMPLITUDE_EVENT_PROP_ELEMENT_TAG = '[Amplitude] Element Tag';
var AMPLITUDE_EVENT_PROP_ELEMENT_TEXT = '[Amplitude] Element Text';
var AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY = '[Amplitude] Element Hierarchy';
var AMPLITUDE_EVENT_PROP_ELEMENT_HREF = '[Amplitude] Element Href';
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT = '[Amplitude] Element Position Left';
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP = '[Amplitude] Element Position Top';
var AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL = '[Amplitude] Element Aria Label';
var AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES = '[Amplitude] Element Attributes';
// Deprecated in favor of AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY. Keeping for backwards compatibility.
var AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR = '[Amplitude] Element Selector';
var AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL = '[Amplitude] Element Parent Label';
var AMPLITUDE_EVENT_PROP_PAGE_URL = '[Amplitude] Page URL';
var AMPLITUDE_EVENT_PROP_PAGE_TITLE = '[Amplitude] Page Title';
var AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = '[Amplitude] Viewport Height';
var AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = '[Amplitude] Viewport Width';
// Visual Tagging related constants
var AMPLITUDE_ORIGIN = 'https://app.amplitude.com';
var AMPLITUDE_ORIGIN_EU = 'https://app.eu.amplitude.com';
var AMPLITUDE_ORIGIN_STAGING = 'https://apps.stag2.amplitude.com';
var AMPLITUDE_ORIGINS_MAP = {
    US: AMPLITUDE_ORIGIN,
    EU: AMPLITUDE_ORIGIN_EU,
    STAGING: AMPLITUDE_ORIGIN_STAGING
};
var AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL = 'https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz';
// This is the class name used by the visual tagging selector to highlight the selected element.
// Should not use this class in the selector.
var AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS = 'amp-visual-tagging-selector-highlight'; //# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isArrayLike.js
var isArrayLike = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
}; //# sourceMappingURL=isArrayLike.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
function isFunction_isFunction(value) {
    return typeof value === 'function';
} //# sourceMappingURL=isFunction.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isPromise.js

function isPromise(value) {
    return isFunction_isFunction(value === null || value === void 0 ? void 0 : value.then);
} //# sourceMappingURL=isPromise.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
function createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
} //# sourceMappingURL=createErrorClass.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/UnsubscriptionError.js

var UnsubscriptionError = createErrorClass(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
}); //# sourceMappingURL=UnsubscriptionError.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
} //# sourceMappingURL=arrRemove.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/Subscription.js




var Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for(var _parentage_1 = (0,tslib_es6/* __values */.XA)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                } else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction_isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                } catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [
                        e
                    ];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0,tslib_es6/* __values */.XA)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(errors)), (0,tslib_es6/* __read */.CR)(err.errors));
                            } else {
                                errors.push(err);
                            }
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            } else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        } else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();

var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return value instanceof Subscription || value && 'closed' in value && isFunction_isFunction(value.remove) && isFunction_isFunction(value.add) && isFunction_isFunction(value.unsubscribe);
}
function execFinalizer(finalizer) {
    if (isFunction_isFunction(finalizer)) {
        finalizer();
    } else {
        finalizer.unsubscribe();
    }
} //# sourceMappingURL=Subscription.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/config.js
var config_config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
}; //# sourceMappingURL=config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/timeoutProvider.js

var timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++){
            args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, (0,tslib_es6/* __spreadArray */.ev)([
                handler,
                timeout
            ], (0,tslib_es6/* __read */.CR)(args)));
        }
        return setTimeout.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([
            handler,
            timeout
        ], (0,tslib_es6/* __read */.CR)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
}; //# sourceMappingURL=timeoutProvider.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js


function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function() {
        var onUnhandledError = config_config.onUnhandledError;
        if (onUnhandledError) {
            onUnhandledError(err);
        } else {
            throw err;
        }
    });
} //# sourceMappingURL=reportUnhandledError.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/noop.js
function noop() {} //# sourceMappingURL=noop.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/NotificationFactories.js
var COMPLETE_NOTIFICATION = function() {
    return createNotification('C', undefined, undefined);
}();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
} //# sourceMappingURL=NotificationFactories.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/errorContext.js

var context = null;
function errorContext(cb) {
    if (config_config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
            context = {
                errorThrown: false,
                error: null
            };
        }
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) {
                throw error;
            }
        }
    } else {
        cb();
    }
}
function captureError(err) {
    if (config_config.useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
} //# sourceMappingURL=errorContext.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/Subscriber.js









var Subscriber = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(_this);
            }
        } else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) {
            handleStoppedNotification(nextNotification(value), this);
        } else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) {
            handleStoppedNotification(errorNotification(err), this);
        } else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) {
            handleStoppedNotification(COMPLETE_NOTIFICATION, this);
        } else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription);

var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            } catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            } catch (error) {
                handleUnhandledError(error);
            }
        } else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            } catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}();
var SafeSubscriber = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction_isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined
            };
        } else {
            var context_1;
            if (_this && config_config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
                };
            } else {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber);

function handleUnhandledError(error) {
    if (config_config.useDeprecatedSynchronousErrorHandling) {
        captureError(error);
    } else {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = config_config.onStoppedNotification;
    onStoppedNotification && timeoutProvider.setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop
}; //# sourceMappingURL=Subscriber.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/symbol/observable.js
var observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); //# sourceMappingURL=observable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/identity.js
function identity(x) {
    return x;
} //# sourceMappingURL=identity.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/pipe.js

function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++){
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
} //# sourceMappingURL=pipe.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/Observable.js







var Observable_Observable = function() {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new SafeSubscriber({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++){
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();

function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config_config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction_isFunction(value.next) && isFunction_isFunction(value.error) && isFunction_isFunction(value.complete);
}
function isSubscriber(value) {
    return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
} //# sourceMappingURL=Observable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isInteropObservable.js


function isInteropObservable(input) {
    return isFunction_isFunction(input[observable]);
} //# sourceMappingURL=isInteropObservable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isAsyncIterable.js

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction_isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
} //# sourceMappingURL=isAsyncIterable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/throwUnobservableError.js
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
} //# sourceMappingURL=throwUnobservableError.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/symbol/iterator.js
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator_iterator = getSymbolIterator(); //# sourceMappingURL=iterator.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isIterable.js


function isIterable(input) {
    return isFunction_isFunction(input === null || input === void 0 ? void 0 : input[iterator_iterator]);
} //# sourceMappingURL=isIterable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isReadableStreamLike.js


function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0,tslib_es6/* __asyncGenerator */.FC)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    if (false) {}
                    return [
                        4,
                        (0,tslib_es6/* __await */.qq)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,tslib_es6/* __await */.qq)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0,tslib_es6/* __await */.qq)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return isFunction_isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
} //# sourceMappingURL=isReadableStreamLike.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/innerFrom.js












function innerFrom(input) {
    if (input instanceof Observable_Observable) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike(input)) {
            return fromArrayLike(input);
        }
        if (isPromise(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
    return new Observable_Observable(function(subscriber) {
        var obs = obj[observable]();
        if (isFunction_isFunction(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new Observable_Observable(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++){
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new Observable_Observable(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, reportUnhandledError);
    });
}
function fromIterable(iterable) {
    return new Observable_Observable(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0,tslib_es6/* __values */.XA)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new Observable_Observable(function(subscriber) {
        process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0,tslib_es6/* __asyncValues */.KL)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [
                            2
                        ];
                    }
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
} //# sourceMappingURL=innerFrom.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/lift.js

function hasLift(source) {
    return isFunction_isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function(source) {
        if (hasLift(source)) {
            return source.lift(function(liftedSource) {
                try {
                    return init(liftedSource, this);
                } catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
} //# sourceMappingURL=lift.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/OperatorSubscriber.js


function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber);
 //# sourceMappingURL=OperatorSubscriber.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/map.js


function map(project, thisArg) {
    return operate(function(source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
} //# sourceMappingURL=map.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/executeSchedule.js
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) {
        delay = 0;
    }
    if (repeat === void 0) {
        repeat = false;
    }
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        } else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
} //# sourceMappingURL=executeSchedule.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/mergeInternals.js



function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            } else {
                subscriber.next(innerValue);
            }
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function() {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) {
                            executeSchedule(subscriber, innerSubScheduler, function() {
                                return doInnerSub(bufferedValue);
                            });
                        } else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while(buffer.length && active < concurrent){
                        _loop_1();
                    }
                    checkComplete();
                } catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
} //# sourceMappingURL=mergeInternals.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/mergeMap.js





function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Infinity;
    }
    if (isFunction_isFunction(resultSelector)) {
        return mergeMap(function(a, i) {
            return map(function(b, ii) {
                return resultSelector(a, b, i, ii);
            })(innerFrom(project(a, i)));
        }, concurrent);
    } else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return operate(function(source, subscriber) {
        return mergeInternals(source, subscriber, project, concurrent);
    });
} //# sourceMappingURL=mergeMap.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/mapOneOrManyArgs.js


var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return map(function(args) {
        return callOrApply(fn, args);
    });
} //# sourceMappingURL=mapOneOrManyArgs.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/fromEvent.js







var nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var jqueryMethods = [
    'on',
    'off'
];
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction_isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
    }
    var _a = (0,tslib_es6/* __read */.CR)(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if (isArrayLike(target)) {
            return mergeMap(function(subTarget) {
                return fromEvent(subTarget, eventName, options);
            })(innerFrom(target));
        }
    }
    if (!add) {
        throw new TypeError('Invalid event target');
    }
    return new Observable_Observable(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++){
                args[_i] = arguments[_i];
            }
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function isNodeStyleEventEmitter(target) {
    return isFunction_isFunction(target.addListener) && isFunction_isFunction(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return isFunction_isFunction(target.on) && isFunction_isFunction(target.off);
}
function isEventTarget(target) {
    return isFunction_isFunction(target.addEventListener) && isFunction_isFunction(target.removeEventListener);
} //# sourceMappingURL=fromEvent.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/finder.js
/* istanbul ignore file */ 
var finder_config;
var rootDocument;
function finder(input, options) {
    if (input.nodeType !== Node.ELEMENT_NODE) {
        throw new Error("Can't generate CSS selector for non-element node type.");
    }
    if ('html' === input.tagName.toLowerCase()) {
        return 'html';
    }
    var defaults = {
        root: document.body,
        idName: function(_name) {
            return true;
        },
        className: function(_name) {
            return true;
        },
        tagName: function(_name) {
            return true;
        },
        attr: function(_name, _value) {
            return false;
        },
        seedMinLength: 1,
        optimizedMinLength: 2,
        threshold: 1000,
        maxNumberOfTries: 10000
    };
    finder_config = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaults), options);
    rootDocument = findRootDocument(finder_config.root, defaults);
    var path = bottomUpSearch(input, 'all', function() {
        return bottomUpSearch(input, 'two', function() {
            return bottomUpSearch(input, 'one', function() {
                return bottomUpSearch(input, 'none');
            });
        });
    });
    if (path) {
        var optimized = sort(optimize(path, input));
        if (optimized.length > 0) {
            path = optimized[0];
        }
        return selector(path);
    } else {
        throw new Error("Selector was not found.");
    }
}
function findRootDocument(rootNode, defaults) {
    if (rootNode.nodeType === Node.DOCUMENT_NODE) {
        return rootNode;
    }
    if (rootNode === defaults.root) {
        return rootNode.ownerDocument;
    }
    return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
    var path = null;
    var stack = [];
    var current = input;
    var i = 0;
    var _loop_1 = function() {
        var e_1, _a;
        var level = maybe(id(current)) || maybe.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(attr(current)), false)) || maybe.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(classNames(current)), false)) || maybe(tagName(current)) || [
            any()
        ];
        var nth = index(current);
        if (limit == 'all') {
            if (nth) {
                level = level.concat(level.filter(dispensableNth).map(function(node) {
                    return nthChild(node, nth);
                }));
            }
        } else if (limit == 'two') {
            level = level.slice(0, 1);
            if (nth) {
                level = level.concat(level.filter(dispensableNth).map(function(node) {
                    return nthChild(node, nth);
                }));
            }
        } else if (limit == 'one') {
            var _b = (0,tslib_es6/* __read */.CR)(level = level.slice(0, 1), 1), node = _b[0];
            if (nth && dispensableNth(node)) {
                level = [
                    nthChild(node, nth)
                ];
            }
        } else if (limit == 'none') {
            level = [
                any()
            ];
            if (nth) {
                level = [
                    nthChild(level[0], nth)
                ];
            }
        }
        try {
            for(var level_1 = (e_1 = void 0, (0,tslib_es6/* __values */.XA)(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()){
                var node = level_1_1.value;
                node.level = i;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        stack.push(level);
        if (stack.length >= finder_config.seedMinLength) {
            path = findUniquePath(stack, fallback);
            if (path) {
                return "break";
            }
        }
        current = current.parentElement;
        i++;
    };
    while(current){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    if (!path) {
        path = findUniquePath(stack, fallback);
    }
    if (!path && fallback) {
        return fallback();
    }
    return path;
}
function findUniquePath(stack, fallback) {
    var e_2, _a;
    // Check first the total number of combinations first since generating the combinations can cause memory exhaustion
    var numCombinations = stack.reduce(function(acc, i) {
        return acc * i.length;
    }, 1);
    if (numCombinations > finder_config.threshold) {
        return fallback ? fallback() : null;
    }
    var paths = sort(combinations(stack));
    try {
        for(var paths_1 = (0,tslib_es6/* __values */.XA)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var candidate = paths_1_1.value;
            if (unique(candidate)) {
                return candidate;
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return null;
}
function selector(path) {
    var node = path[0];
    var query = node.name;
    for(var i = 1; i < path.length; i++){
        var level = path[i].level || 0;
        if (node.level === level - 1) {
            query = "".concat(path[i].name, " > ").concat(query);
        } else {
            query = "".concat(path[i].name, " ").concat(query);
        }
        node = path[i];
    }
    return query;
}
function penalty(path) {
    return path.map(function(node) {
        return node.penalty;
    }).reduce(function(acc, i) {
        return acc + i;
    }, 0);
}
function unique(path) {
    var css = selector(path);
    switch(rootDocument.querySelectorAll(css).length){
        case 0:
            throw new Error("Can't select any node with this selector: ".concat(css));
        case 1:
            return true;
        default:
            return false;
    }
}
function id(input) {
    var elementId = input.getAttribute('id');
    if (elementId && finder_config.idName(elementId)) {
        return {
            name: '#' + CSS.escape(elementId),
            penalty: 0
        };
    }
    return null;
}
function attr(input) {
    var attrs = Array.from(input.attributes).filter(function(attr) {
        return finder_config.attr(attr.name, attr.value);
    });
    return attrs.map(function(attr) {
        return {
            name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
            penalty: 0.5
        };
    });
}
function classNames(input) {
    var names = Array.from(input.classList).filter(finder_config.className);
    return names.map(function(name) {
        return {
            name: '.' + CSS.escape(name),
            penalty: 1
        };
    });
}
function tagName(input) {
    var name = input.tagName.toLowerCase();
    if (finder_config.tagName(name)) {
        return {
            name: name,
            penalty: 2
        };
    }
    return null;
}
function any() {
    return {
        name: '*',
        penalty: 3
    };
}
function index(input) {
    var parent = input.parentNode;
    if (!parent) {
        return null;
    }
    var child = parent.firstChild;
    if (!child) {
        return null;
    }
    var i = 0;
    while(child){
        if (child.nodeType === Node.ELEMENT_NODE) {
            i++;
        }
        if (child === input) {
            break;
        }
        child = child.nextSibling;
    }
    return i;
}
function nthChild(node, i) {
    return {
        name: node.name + ":nth-child(".concat(i, ")"),
        penalty: node.penalty + 1
    };
}
function dispensableNth(node) {
    return node.name !== 'html' && !node.name.startsWith('#');
}
function maybe() {
    var level = [];
    for(var _i = 0; _i < arguments.length; _i++){
        level[_i] = arguments[_i];
    }
    var list = level.filter(notEmpty);
    if (list.length > 0) {
        return list;
    }
    return null;
}
function notEmpty(value) {
    return value !== null && value !== undefined;
}
function combinations(stack, path) {
    var _a, _b, node, e_3_1;
    var e_3, _c;
    if (path === void 0) {
        path = [];
    }
    return (0,tslib_es6/* __generator */.Jh)(this, function(_d) {
        switch(_d.label){
            case 0:
                if (!(stack.length > 0)) return [
                    3 /*break*/ ,
                    9
                ];
                _d.label = 1;
            case 1:
                _d.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _a = (0,tslib_es6/* __values */.XA)(stack[0]), _b = _a.next();
                _d.label = 2;
            case 2:
                if (!!_b.done) return [
                    3 /*break*/ ,
                    5
                ];
                node = _b.value;
                return [
                    5 /*yield**/ ,
                    (0,tslib_es6/* __values */.XA)(combinations(stack.slice(1, stack.length), path.concat(node)))
                ];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4:
                _b = _a.next();
                return [
                    3 /*break*/ ,
                    2
                ];
            case 5:
                return [
                    3 /*break*/ ,
                    8
                ];
            case 6:
                e_3_1 = _d.sent();
                e_3 = {
                    error: e_3_1
                };
                return [
                    3 /*break*/ ,
                    8
                ];
            case 7:
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                } finally{
                    if (e_3) throw e_3.error;
                }
                return [
                    7 /*endfinally*/ 
                ];
            case 8:
                return [
                    3 /*break*/ ,
                    11
                ];
            case 9:
                return [
                    4 /*yield*/ ,
                    path
                ];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function sort(paths) {
    return (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(paths), false).sort(function(a, b) {
        return penalty(a) - penalty(b);
    });
}
function optimize(path, input, scope) {
    var i, newPath, newPathKey;
    if (scope === void 0) {
        scope = {
            counter: 0,
            visited: new Map()
        };
    }
    return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
        switch(_a.label){
            case 0:
                if (!(path.length > 2 && path.length > finder_config.optimizedMinLength)) return [
                    3 /*break*/ ,
                    5
                ];
                i = 1;
                _a.label = 1;
            case 1:
                if (!(i < path.length - 1)) return [
                    3 /*break*/ ,
                    5
                ];
                if (scope.counter > finder_config.maxNumberOfTries) {
                    return [
                        2 /*return*/ 
                    ]; // Okay At least I tried!
                }
                scope.counter += 1;
                newPath = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(path), false);
                newPath.splice(i, 1);
                newPathKey = selector(newPath);
                if (scope.visited.has(newPathKey)) {
                    return [
                        2 /*return*/ 
                    ];
                }
                if (!(unique(newPath) && same(newPath, input))) return [
                    3 /*break*/ ,
                    4
                ];
                return [
                    4 /*yield*/ ,
                    newPath
                ];
            case 2:
                _a.sent();
                scope.visited.set(newPathKey, true);
                return [
                    5 /*yield**/ ,
                    (0,tslib_es6/* __values */.XA)(optimize(newPath, input, scope))
                ];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [
                    3 /*break*/ ,
                    1
                ];
            case 5:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function same(path, input) {
    return rootDocument.querySelector(selector(path)) === input;
} //# sourceMappingURL=finder.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/helpers.js
/* eslint-disable no-restricted-globals */ 

var SENSITIVE_TAGS = [
    'input',
    'select',
    'textarea'
];
var createShouldTrackEvent = function(autocaptureOptions, allowlist) {
    return function(actionType, element) {
        var _a, _b, _c;
        var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
        /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        // window, document, and Text nodes have no tag
        if (!tag) {
            return false;
        }
        if (shouldTrackEventResolver) {
            return shouldTrackEventResolver(actionType, element);
        }
        if (!isPageUrlAllowed(window.location.href, pageUrlAllowlist)) {
            return false;
        }
        /* istanbul ignore next */ var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute('type')) || '';
        if (typeof elementType === 'string') {
            switch(elementType.toLowerCase()){
                case 'hidden':
                    return false;
                case 'password':
                    return false;
            }
        }
        /* istanbul ignore if */ if (allowlist) {
            var hasMatchAnyAllowedSelector = allowlist.some(function(selector) {
                var _a;
                return !!((_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector));
            });
            if (!hasMatchAnyAllowedSelector) {
                return false;
            }
        }
        switch(tag){
            case 'input':
            case 'select':
            case 'textarea':
                return actionType === 'change' || actionType === 'click';
            default:
                {
                    /* istanbul ignore next */ var computedStyle = (_c = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _c === void 0 ? void 0 : _c.call(window, element);
                    /* istanbul ignore next */ if (computedStyle && computedStyle.getPropertyValue('cursor') === 'pointer' && actionType === 'click') {
                        return true;
                    }
                    return actionType === 'click';
                }
        }
    };
};
var isNonSensitiveString = function(text) {
    if (text == null) {
        return false;
    }
    if (typeof text === 'string') {
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((text || '').replace(/[- ]/g, ''))) {
            return false;
        }
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(text)) {
            return false;
        }
    }
    return true;
};
var isTextNode = function(node) {
    return !!node && node.nodeType === 3;
};
var isNonSensitiveElement = function(element) {
    var _a, _b, _c;
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    var isContentEditable = element instanceof HTMLElement ? ((_c = element.getAttribute('contenteditable')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true' : false;
    return !SENSITIVE_TAGS.includes(tag) && !isContentEditable;
};
// Maybe this can be simplified with element.innerText, keep and manual concatenating for now, more research needed.
var getText = function(element) {
    var text = '';
    if (isNonSensitiveElement(element) && element.childNodes && element.childNodes.length) {
        element.childNodes.forEach(function(child) {
            var childText = '';
            if (isTextNode(child)) {
                if (child.textContent) {
                    childText = child.textContent;
                }
            } else {
                childText = getText(child);
            }
            text += childText.split(/(\s+)/).filter(isNonSensitiveString).join('').replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ').substring(0, 255);
        });
    }
    return text;
};
var getSelector = function(element, logger) {
    var _a, _b;
    var selector = '';
    try {
        selector = finder(element, {
            className: function(name) {
                return name !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
            },
            maxNumberOfTries: 1000
        });
        return selector;
    } catch (error) {
        if (logger) {
            var typedError = error;
            logger.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(typedError.toString()));
        }
    }
    // Fall back to use tag, id, and class name, if finder fails.
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (tag) {
        selector = tag;
    }
    var id = element.getAttribute('id');
    var className = element.getAttribute('class');
    if (id) {
        selector = "#".concat(id);
    } else if (className) {
        var classes = className.split(' ').filter(function(name) {
            return name !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
        }).join('.');
        if (classes) {
            selector = "".concat(selector, ".").concat(classes);
        }
    }
    return selector;
};
var isPageUrlAllowed = function(url, pageUrlAllowlist) {
    if (!pageUrlAllowlist || !pageUrlAllowlist.length) {
        return true;
    }
    return pageUrlAllowlist.some(function(allowedUrl) {
        if (typeof allowedUrl === 'string') {
            return url === allowedUrl;
        }
        return url.match(allowedUrl);
    });
};
var getAttributesWithPrefix = function(element, prefix) {
    return element.getAttributeNames().reduce(function(attributes, attributeName) {
        if (attributeName.startsWith(prefix)) {
            var attributeKey = attributeName.replace(prefix, '');
            var attributeValue = element.getAttribute(attributeName);
            if (attributeKey) {
                attributes[attributeKey] = attributeValue || '';
            }
        }
        return attributes;
    }, {});
};
var isEmpty = function(value) {
    return value === undefined || value === null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};
var removeEmptyProperties = function(properties) {
    return Object.keys(properties).reduce(function(filteredProperties, key) {
        var value = properties[key];
        if (!isEmpty(value)) {
            filteredProperties[key] = value;
        }
        return filteredProperties;
    }, {});
};
var getNearestLabel = function(element) {
    var parent = element.parentElement;
    if (!parent) {
        return '';
    }
    var labelElement;
    try {
        labelElement = parent.querySelector(':scope>span,h1,h2,h3,h4,h5,h6');
    } catch (error) {
        labelElement = null;
    }
    if (labelElement) {
        /* istanbul ignore next */ var labelText = labelElement.textContent || '';
        return isNonSensitiveString(labelText) ? labelText : '';
    }
    return getNearestLabel(parent);
};
var querySelectUniqueElements = function(root, selectors) {
    if (root && 'querySelectorAll' in root && typeof root.querySelectorAll === 'function') {
        var elementSet = selectors.reduce(function(elements, selector) {
            if (selector) {
                var selectedElements = Array.from(root.querySelectorAll(selector));
                selectedElements.forEach(function(element) {
                    elements.add(element);
                });
            }
            return elements;
        }, new Set());
        return Array.from(elementSet);
    }
    return [];
};
// Similar as element.closest, but works with multiple selectors
var getClosestElement = function(element, selectors) {
    if (!element) {
        return null;
    }
    /* istanbul ignore next */ if (selectors.some(function(selector) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector);
    })) {
        return element;
    }
    /* istanbul ignore next */ return getClosestElement(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
};
// Returns the element properties for the given element in Visual Labeling.
var getEventTagProps = function(element, logger) {
    var _a;
    var _b, _c;
    if (!element) {
        return {};
    }
    /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
    var selector = getSelector(element, logger);
    var properties = (_a = {}, _a[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector, _a[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a);
    return removeEmptyProperties(properties);
};
var asyncLoadScript = function(url) {
    return new Promise(function(resolve, reject) {
        var _a;
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = url;
            scriptElement.addEventListener('load', function() {
                resolve({
                    status: true
                });
            }, {
                once: true
            });
            scriptElement.addEventListener('error', function() {
                reject({
                    status: false,
                    message: "Failed to load the script ".concat(url)
                });
            });
            /* istanbul ignore next */ (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(scriptElement);
        } catch (error) {
            /* istanbul ignore next */ reject(error);
        }
    });
};
function generateUniqueId() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var filterOutNonTrackableEvents = function(event) {
    // Filter out changeEvent events with no target
    // This could happen when change events are triggered programmatically
    if (event.event.target === null || !event.closestTrackedAncestor) {
        return false;
    }
    return true;
}; //# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/messenger.js
/* istanbul ignore file */ /* eslint-disable no-restricted-globals */ 

// TODO: use MessageChannel instead of window.postMessage
var WindowMessenger = /** @class */ function() {
    function WindowMessenger(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.origin, origin = _c === void 0 ? AMPLITUDE_ORIGIN : _c;
        var _this = this;
        this.endpoint = AMPLITUDE_ORIGIN;
        this.requestCallbacks = {};
        this.onSelect = function(data) {
            _this.notify({
                action: 'element-selected',
                data: data
            });
        };
        this.onTrack = function(type, properties) {
            if (type === 'selector-mode-changed') {
                _this.notify({
                    action: 'track-selector-mode-changed',
                    data: properties
                });
            } else if (type === 'selector-moved') {
                _this.notify({
                    action: 'track-selector-moved',
                    data: properties
                });
            }
        };
        this.endpoint = origin;
    }
    WindowMessenger.prototype.notify = function(message) {
        var _a, _b, _c, _d;
        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.call(_a, 'Message sent: ', JSON.stringify(message));
        (_d = (_c = window.opener) === null || _c === void 0 ? void 0 : _c.postMessage) === null || _d === void 0 ? void 0 : _d.call(_c, message, this.endpoint);
    };
    // Send an async request to the parent window
    WindowMessenger.prototype.sendRequest = function(action, args, options) {
        var _this = this;
        if (options === void 0) {
            options = {
                timeout: 15000
            };
        }
        // Create Request ID
        var id = generateUniqueId();
        var request = {
            id: id,
            action: action,
            args: args
        };
        // Create a Promise that will be resolved when the response is received
        var promise = new Promise(function(resolve, reject) {
            _this.requestCallbacks[id] = {
                resolve: resolve,
                reject: reject
            };
            // Send the request
            _this.notify(request);
            // Handle request timeouts
            if ((options === null || options === void 0 ? void 0 : options.timeout) > 0) {
                setTimeout(function() {
                    reject(new Error("".concat(action, " timed out (id: ").concat(id, ")")));
                    delete _this.requestCallbacks[id];
                }, options.timeout);
            }
        });
        return promise;
    };
    // Handle messages from the parent window
    WindowMessenger.prototype.handleResponse = function(response) {
        var _a;
        if (!this.requestCallbacks[response.id]) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn("No callback found for request id: ".concat(response.id));
            return;
        }
        this.requestCallbacks[response.id].resolve(response.responseData);
        delete this.requestCallbacks[response.id];
    };
    WindowMessenger.prototype.setup = function(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, logger = _b.logger, endpoint = _b.endpoint, isElementSelectable = _b.isElementSelectable, cssSelectorAllowlist = _b.cssSelectorAllowlist, actionClickAllowlist = _b.actionClickAllowlist;
        this.logger = logger;
        // If endpoint is customized, don't override it.
        if (endpoint && this.endpoint === AMPLITUDE_ORIGIN) {
            this.endpoint = endpoint;
        }
        var amplitudeVisualTaggingSelectorInstance = null;
        // Attach Event Listener to listen for messages from the parent window
        window.addEventListener('message', function(event) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.call(_a, 'Message received: ', JSON.stringify(event));
            // Only accept messages from the specified origin
            if (_this.endpoint !== event.origin) {
                return;
            }
            var eventData = event === null || event === void 0 ? void 0 : event.data;
            var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
            // Ignore messages without action
            if (!action) {
                return;
            }
            // If id exists, handle responses to previous requests
            if ('id' in eventData) {
                (_d = (_c = _this.logger) === null || _c === void 0 ? void 0 : _c.debug) === null || _d === void 0 ? void 0 : _d.call(_c, 'Received Response to previous request: ', JSON.stringify(event));
                _this.handleResponse(eventData);
            // If action exists, handle the action using existing handlers
            } else {
                if (action === 'ping') {
                    _this.notify({
                        action: 'pong'
                    });
                } else if (action === 'initialize-visual-tagging-selector') {
                    var actionData_1 = eventData === null || eventData === void 0 ? void 0 : eventData.data;
                    asyncLoadScript(AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL).then(function() {
                        var _a;
                        // eslint-disable-next-line
                        amplitudeVisualTaggingSelectorInstance = (_a = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _a === void 0 ? void 0 : _a.call(window, {
                            getEventTagProps: getEventTagProps,
                            isElementSelectable: function(element) {
                                if (isElementSelectable) {
                                    return isElementSelectable((actionData_1 === null || actionData_1 === void 0 ? void 0 : actionData_1.actionType) || 'click', element);
                                }
                                return true;
                            },
                            onTrack: _this.onTrack,
                            onSelect: _this.onSelect,
                            visualHighlightClass: AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS,
                            messenger: _this,
                            cssSelectorAllowlist: cssSelectorAllowlist,
                            actionClickAllowlist: actionClickAllowlist
                        });
                        _this.notify({
                            action: 'selector-loaded'
                        });
                    }).catch(function() {
                        var _a;
                        (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.warn('Failed to initialize visual tagging selector');
                    });
                } else if (action === 'close-visual-tagging-selector') {
                    // eslint-disable-next-line
                    (_e = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _e === void 0 ? void 0 : _e.call(amplitudeVisualTaggingSelectorInstance);
                }
            }
        });
        // Notify the parent window that the page has loaded
        this.notify({
            action: 'page-loaded'
        });
    };
    return WindowMessenger;
}();
 //# sourceMappingURL=messenger.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/hierarchy.js


var BLOCKED_ATTRIBUTES = [
    // Already captured elsewhere in the hierarchy object
    'id',
    'class',
    // non-useful and potentially large attribute
    'style',
    // sensitive as prefilled form data may populate this attribute
    'value',
    // DOM events
    'onclick',
    'onchange',
    'oninput',
    'onblur',
    'onsubmit',
    'onfocus',
    'onkeydown',
    'onkeyup',
    'onkeypress',
    // React specific
    'data-reactid',
    'data-react-checksum',
    'data-reactroot'
];
var SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = [
    'type'
];
var SVG_TAGS = [
    'svg',
    'path',
    'g'
];
var HIGHLY_SENSITIVE_INPUT_TYPES = [
    'password',
    'hidden'
];
var MAX_ATTRIBUTE_LENGTH = 128;
var MAX_HIERARCHY_LENGTH = 1024;
function getElementProperties(element) {
    var e_1, _a;
    var _b, _c, _d, _e;
    if (element === null) {
        return null;
    }
    var tagName = String(element.tagName).toLowerCase();
    var properties = {
        tag: tagName
    };
    var siblings = Array.from((_c = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
    if (siblings.length) {
        properties.index = siblings.indexOf(element);
        properties.indexOfType = siblings.filter(function(el) {
            return el.tagName === element.tagName;
        }).indexOf(element);
    }
    var prevSiblingTag = (_e = (_d = element.previousElementSibling) === null || _d === void 0 ? void 0 : _d.tagName) === null || _e === void 0 ? void 0 : _e.toLowerCase();
    if (prevSiblingTag) {
        properties.prevSib = String(prevSiblingTag);
    }
    var id = element.getAttribute('id');
    if (id) {
        properties.id = String(id);
    }
    var classes = Array.from(element.classList);
    if (classes.length) {
        properties.classes = classes;
    }
    var attributes = {};
    var attributesArray = Array.from(element.attributes);
    var filteredAttributes = attributesArray.filter(function(attr) {
        return !BLOCKED_ATTRIBUTES.includes(attr.name);
    });
    var isSensitiveElement = !isNonSensitiveElement(element);
    // if input is hidden or password or for SVGs, skip attribute collection entirely
    if (!HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute('type'))) && !SVG_TAGS.includes(tagName)) {
        try {
            for(var filteredAttributes_1 = (0,tslib_es6/* __values */.XA)(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()){
                var attr = filteredAttributes_1_1.value;
                // If sensitive element, only allow certain attributes
                if (isSensitiveElement && !SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr.name)) {
                    continue;
                }
                // Finally cast attribute value to string and limit attribute value length
                attributes[attr.name] = String(attr.value).substring(0, MAX_ATTRIBUTE_LENGTH);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a = filteredAttributes_1.return)) _a.call(filteredAttributes_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    if (Object.keys(attributes).length) {
        properties.attrs = attributes;
    }
    return properties;
}
function getAncestors(targetEl) {
    var ancestors = [];
    if (!targetEl) {
        return ancestors;
    }
    // Add self to the list of ancestors
    ancestors.push(targetEl);
    var current = targetEl.parentElement;
    while(current && current.tagName !== 'HTML'){
        ancestors.push(current);
        current = current.parentElement;
    }
    return ancestors;
}
// Get the DOM hierarchy of the element, starting from the target element to the root element.
var getHierarchy = function(element) {
    var hierarchy = [];
    if (!element) {
        return [];
    }
    // Get list of ancestors including itself and get properties at each level in the hierarchy
    var ancestors = getAncestors(element);
    hierarchy = ensureListUnderLimit(ancestors.map(function(el) {
        return getElementProperties(el);
    }), MAX_HIERARCHY_LENGTH);
    return hierarchy;
};
function ensureListUnderLimit(list, bytesLimit) {
    var numChars = 0;
    for(var i = 0; i < list.length; i++){
        var node = list[i];
        if (node === null) {
            // simulate 'None' in python
            numChars += 4;
        } else {
            var value = ensureUnicodePythonCompatible(node);
            // Using Array.from(string).length instead of string.length
            // to correctly count Unicode characters (including emojis)
            numChars += value ? Array.from(value).length : 4;
        }
        if (numChars > bytesLimit) {
            return list.slice(0, i);
        }
    }
    return list;
}
/**
 * Converts a JSON-compatible value to a Python-compatible string representation.
 * This function handles various data types and ensures proper escaping and formatting.
 *
 * @param value - The value to be converted (can be any JSON-compatible type)
 * @param nested - Indicates if the value is nested within another structure (default: false)
 * @returns A string representation of the value compatible with Python, or null if conversion fails
 */ function ensureUnicodePythonCompatible(value, nested) {
    if (nested === void 0) {
        nested = false;
    }
    try {
        if (value == null) {
            // Handle null values
            if (nested) {
                return 'None'; // Represent null as 'None' in Python when nested
            }
            return null; // Return null for top-level null values
        } else if (typeof value === 'string') {
            if (nested) {
                // Escape special characters in nested strings
                value = value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r');
                // Handle quotes in the string
                if (value.includes('"')) {
                    return "'".concat(value, "'"); // Wrap in single quotes if it contains double quotes
                }
                if (value.includes("'")) {
                    return "\"".concat(value.replace(/'/g, "\\'"), "\""); // Wrap in double quotes and escape single quotes
                }
                return "'".concat(value, "'"); // Default to wrapping in single quotes
            }
            return value; // Return non-nested strings as-is
        } else if (typeof value === 'boolean') {
            // Convert boolean to Python-style capitalized string
            return value ? 'True' : 'False';
        } else if (Array.isArray(value)) {
            // Handle arrays by recursively converting each element
            var elements = value.map(function(o) {
                return ensureUnicodePythonCompatible(o, true);
            });
            return "[".concat(elements.join(', '), "]");
        } else if (typeof value === 'object') {
            // Handle objects (dictionaries in Python)
            var entries = Object.entries(value).filter(function(_a) {
                var _b = (0,tslib_es6/* __read */.CR)(_a, 1), key = _b[0];
                return key != null;
            }) // Filter out null keys
            .map(function(_a) {
                var _b = (0,tslib_es6/* __read */.CR)(_a, 2), key = _b[0], val = _b[1];
                return "".concat(String(ensureUnicodePythonCompatible(key, true)), ": ").concat(String(ensureUnicodePythonCompatible(val, true)));
            });
            var result = "{".concat(entries.join(', '), "}");
            // Handle single quotes in the resulting string
            if (result.includes("\\'")) {
                result = result.replace(/'/g, "'").replace(/'/g, "\\'");
            }
            return result;
        }
        // For any other types, return their string representation;
        return value.toString();
    } catch (e) {
        // Return null if any error occurs during the conversion
        return null;
    }
} //# sourceMappingURL=hierarchy.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/pairwise.js


function pairwise() {
    return operate(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
} //# sourceMappingURL=pairwise.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/filter.js


function filter(predicate, thisArg) {
    return operate(function(source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
} //# sourceMappingURL=filter.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/Action.js


var Action = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(Subscription);
 //# sourceMappingURL=Action.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/intervalProvider.js

var intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++){
            args[_i - 2] = arguments[_i];
        }
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
            return delegate.setInterval.apply(delegate, (0,tslib_es6/* __spreadArray */.ev)([
                handler,
                timeout
            ], (0,tslib_es6/* __read */.CR)(args)));
        }
        return setInterval.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([
            handler,
            timeout
        ], (0,tslib_es6/* __read */.CR)(args)));
    },
    clearInterval: function(handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
}; //# sourceMappingURL=intervalProvider.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/AsyncAction.js




var AsyncAction = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        if (id != null) {
            intervalProvider.clearInterval(id);
        }
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        } else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            arrRemove(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(Action);
 //# sourceMappingURL=AsyncAction.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/dateTimestampProvider.js
var dateTimestampProvider = {
    now: function() {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
}; //# sourceMappingURL=dateTimestampProvider.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/Scheduler.js

var Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
}();
 //# sourceMappingURL=Scheduler.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/AsyncScheduler.js


var AsyncScheduler = function(_super) {
    (0,tslib_es6/* __extends */.ZT)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }while (action = actions.shift())
        this._active = false;
        if (error) {
            while(action = actions.shift()){
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler);
 //# sourceMappingURL=AsyncScheduler.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduler/async.js


var asyncScheduler = new AsyncScheduler(AsyncAction);
var async_async = asyncScheduler; //# sourceMappingURL=async.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/debounceTime.js



function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = asyncScheduler;
    }
    return operate(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
} //# sourceMappingURL=debounceTime.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/mergeAll.js


function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Infinity;
    }
    return mergeMap(identity, concurrent);
} //# sourceMappingURL=mergeAll.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/empty.js

var EMPTY = new Observable_Observable(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
} //# sourceMappingURL=empty.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isScheduler.js

function isScheduler(value) {
    return value && isFunction_isFunction(value.schedule);
} //# sourceMappingURL=isScheduler.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/args.js


function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return isFunction(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return isScheduler(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
} //# sourceMappingURL=args.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/observeOn.js



function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return operate(function(source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            return executeSchedule(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return executeSchedule(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return executeSchedule(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
} //# sourceMappingURL=observeOn.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/subscribeOn.js

function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return operate(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
} //# sourceMappingURL=subscribeOn.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleObservable.js



function scheduleObservable(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
} //# sourceMappingURL=scheduleObservable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/schedulePromise.js



function schedulePromise(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
} //# sourceMappingURL=schedulePromise.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleArray.js

function scheduleArray(input, scheduler) {
    return new Observable_Observable(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
            } else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
} //# sourceMappingURL=scheduleArray.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleIterable.js




function scheduleIterable(input, scheduler) {
    return new Observable_Observable(function(subscriber) {
        var iterator;
        executeSchedule(subscriber, scheduler, function() {
            iterator = input[iterator_iterator]();
            executeSchedule(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                } else {
                    subscriber.next(value);
                }
            }, 0, true);
        });
        return function() {
            return isFunction_isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
} //# sourceMappingURL=scheduleIterable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleAsyncIterable.js


function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable_Observable(function(subscriber) {
        executeSchedule(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            executeSchedule(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) {
                        subscriber.complete();
                    } else {
                        subscriber.next(result.value);
                    }
                });
            }, 0, true);
        });
    });
} //# sourceMappingURL=scheduleAsyncIterable.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleReadableStreamLike.js


function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
} //# sourceMappingURL=scheduleReadableStreamLike.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/scheduled/scheduled.js













function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        if (isAsyncIterable(input)) {
            return scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable(input)) {
            return scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike(input)) {
            return scheduleReadableStreamLike(input, scheduler);
        }
    }
    throw createInvalidObservableTypeError(input);
} //# sourceMappingURL=scheduled.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/from.js


function from(input, scheduler) {
    return scheduler ? scheduled(input, scheduler) : innerFrom(input);
} //# sourceMappingURL=from.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/merge.js





function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++){
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    var sources = args;
    return !sources.length ? EMPTY : sources.length === 1 ? innerFrom(sources[0]) : mergeAll(concurrent)(from(sources, scheduler));
} //# sourceMappingURL=merge.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/concatAll.js

function concatAll() {
    return mergeAll(1);
} //# sourceMappingURL=concatAll.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/concat.js



function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++){
        args[_i] = arguments[_i];
    }
    return concatAll()(from(args, popScheduler(args)));
} //# sourceMappingURL=concat.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/take.js



function take(count) {
    return count <= 0 ? function() {
        return EMPTY;
    } : operate(function(source, subscriber) {
        var seen = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) {
                    subscriber.complete();
                }
            }
        }));
    });
} //# sourceMappingURL=take.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/ignoreElements.js



function ignoreElements() {
    return operate(function(source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, noop));
    });
} //# sourceMappingURL=ignoreElements.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/mapTo.js

function mapTo(value) {
    return map(function() {
        return value;
    });
} //# sourceMappingURL=mapTo.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/delayWhen.js






function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function(source) {
            return concat(subscriptionDelay.pipe(take(1), ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
        };
    }
    return mergeMap(function(value, index) {
        return innerFrom(delayDurationSelector(value, index)).pipe(take(1), mapTo(value));
    });
} //# sourceMappingURL=delayWhen.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/util/isDate.js
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
} //# sourceMappingURL=isDate.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/observable/timer.js




function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    if (scheduler === void 0) {
        scheduler = async_async;
    }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if (isScheduler(intervalOrScheduler)) {
            scheduler = intervalOrScheduler;
        } else {
            intervalDuration = intervalOrScheduler;
        }
    }
    return new Observable_Observable(function(subscriber) {
        var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
            due = 0;
        }
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) {
                    this.schedule(undefined, intervalDuration);
                } else {
                    subscriber.complete();
                }
            }
        }, due);
    });
} //# sourceMappingURL=timer.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/delay.js



function delay(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = asyncScheduler;
    }
    var duration = timer(due, scheduler);
    return delayWhen(function() {
        return duration;
    });
} //# sourceMappingURL=delay.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/buffer.js




function buffer(closingNotifier) {
    return operate(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        innerFrom(closingNotifier).subscribe(createOperatorSubscriber(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, noop));
        return function() {
            currentBuffer = null;
        };
    });
} //# sourceMappingURL=buffer.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-click.js




var RAGE_CLICK_THRESHOLD = 5;
function trackClicks(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, shouldTrackEvent = _a.shouldTrackEvent;
    var clickObservable = allObservables.clickObservable;
    // Trigger if the target of the click event has changed and position is different
    // Keeping track of position is important to avoid false positives when the user clicks on the same
    // element where certain frameworks could replace the element instance between rerenders
    var comparisonTrigger = clickObservable.pipe(pairwise(), filter(function(_a) {
        var _b = (0,tslib_es6/* __read */.CR)(_a, 2), prev = _b[0], current = _b[1];
        var targetChanged = prev.event.target !== current.event.target;
        /* istanbul ignore next */ var samePos = Math.abs(current.event.screenX - prev.event.screenX) <= 20 && Math.abs(current.event.screenY - prev.event.screenY) <= 20;
        return targetChanged && !samePos;
    }));
    // Trigger if there is no click event within 1 second
    var timeoutTrigger = clickObservable.pipe(debounceTime(options.debounceTime), map(function() {
        return 'timeout';
    }));
    var triggers = merge(comparisonTrigger, timeoutTrigger);
    // Get buffers of clicks, if the buffer length is over 5, it is rage click
    var bufferedClicks = clickObservable.pipe(delay(0), filter(filterOutNonTrackableEvents), filter(function(click) {
        // Only track clicks on elements that should be tracked,
        return shouldTrackEvent('click', click.closestTrackedAncestor);
    }), buffer(triggers));
    return bufferedClicks.subscribe(function(clicks) {
        var e_1, _a;
        // TODO: update this when rage clicks are added
        var clickType = clicks.length >= RAGE_CLICK_THRESHOLD ? AMPLITUDE_ELEMENT_CLICKED_EVENT : AMPLITUDE_ELEMENT_CLICKED_EVENT;
        try {
            for(var clicks_1 = (0,tslib_es6/* __values */.XA)(clicks), clicks_1_1 = clicks_1.next(); !clicks_1_1.done; clicks_1_1 = clicks_1.next()){
                var click = clicks_1_1.value;
                /* istanbul ignore next */ amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(clickType, click.targetElementProperties, {
                    time: click.timestamp
                });
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (clicks_1_1 && !clicks_1_1.done && (_a = clicks_1.return)) _a.call(clicks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    });
} //# sourceMappingURL=track-click.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-change.js



function trackChange(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent;
    var changeObservable = allObservables.changeObservable;
    var filteredChangeObservable = changeObservable.pipe(filter(filterOutNonTrackableEvents), filter(function(changeEvent) {
        // Only track change on elements that should be tracked,
        return shouldTrackEvent('change', changeEvent.closestTrackedAncestor);
    }));
    return filteredChangeObservable.subscribe(function(changeEvent) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CHANGED_EVENT, getEventProperties('change', changeEvent.closestTrackedAncestor));
    });
} //# sourceMappingURL=track-change.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/switchMap.js



function switchMap(project, resultSelector) {
    return operate(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = createOperatorSubscriber(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
} //# sourceMappingURL=switchMap.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/rxjs@7.8.1/node_modules/rxjs/dist/esm5/internal/operators/timeout.js







var TimeoutError = createErrorClass(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) {
            info = null;
        }
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = isValidDate(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return operate(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = executeSchedule(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    innerFrom(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe(createOperatorSubscriber(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            }
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
} //# sourceMappingURL=timeout.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-action-click.js




function trackActionClick(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, shouldTrackActionClick = _a.shouldTrackActionClick;
    var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
    var filteredClickObservable = clickObservable.pipe(filter(function(click) {
        // Filter out regularly tracked click events that are already handled in trackClicks
        return !shouldTrackEvent('click', click.closestTrackedAncestor);
    }), map(function(click) {
        // overwrite the closestTrackedAncestor with the closest element that is on the actionClickAllowlist
        var closestActionClickEl = getClosestElement(click.event.target, options.actionClickAllowlist);
        click.closestTrackedAncestor = closestActionClickEl;
        // overwrite the targetElementProperties with the properties of the closestActionClickEl
        if (click.closestTrackedAncestor !== null) {
            click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
        }
        return click;
    }), filter(filterOutNonTrackableEvents), filter(function(clickEvent) {
        // Only track change on elements that should be tracked
        return shouldTrackActionClick('click', clickEvent.closestTrackedAncestor);
    }));
    var changeObservables = [
        mutationObservable
    ];
    /* istanbul ignore next */ if (navigateObservable) {
        changeObservables.push(navigateObservable);
    }
    var mutationOrNavigate = merge.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(changeObservables), false));
    var actionClicks = filteredClickObservable.pipe(// If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    switchMap(function(click) {
        return mutationOrNavigate.pipe(take(1), timeout({
            first: 500,
            with: function() {
                return EMPTY;
            }
        }), map(function() {
            return click;
        }));
    }));
    return actionClicks.subscribe(function(actionClick) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CLICKED_EVENT, getEventProperties('click', actionClick.closestTrackedAncestor), {
            time: actionClick.timestamp
        });
    });
} //# sourceMappingURL=track-action-click.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-autocapture-browser@1.0.4/node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture-plugin.js

/* eslint-disable no-restricted-globals */ 








var ObservablesEnum;
(function(ObservablesEnum) {
    ObservablesEnum["ClickObservable"] = "clickObservable";
    ObservablesEnum["ChangeObservable"] = "changeObservable";
    // ErrorObservable = 'errorObservable',
    ObservablesEnum["NavigateObservable"] = "navigateObservable";
    ObservablesEnum["MutationObservable"] = "mutationObservable";
})(ObservablesEnum || (ObservablesEnum = {}));
// Type predicate
function isElementBasedEvent(event) {
    return event.type === 'click' || event.type === 'change';
}
var autocapturePlugin = function(options) {
    var _a, _b, _c;
    if (options === void 0) {
        options = {};
    }
    var _d = options.dataAttributePrefix, dataAttributePrefix = _d === void 0 ? DEFAULT_DATA_ATTRIBUTE_PREFIX : _d, _e = options.visualTaggingOptions, visualTaggingOptions = _e === void 0 ? {
        enabled: true,
        messenger: new WindowMessenger()
    } : _e;
    options.cssSelectorAllowlist = (_a = options.cssSelectorAllowlist) !== null && _a !== void 0 ? _a : DEFAULT_CSS_SELECTOR_ALLOWLIST;
    options.actionClickAllowlist = (_b = options.actionClickAllowlist) !== null && _b !== void 0 ? _b : DEFAULT_ACTION_CLICK_ALLOWLIST;
    options.debounceTime = (_c = options.debounceTime) !== null && _c !== void 0 ? _c : 0; // TODO: update this when rage clicks are added to 1000ms
    var name = PLUGIN_NAME;
    var type = 'enrichment';
    var subscriptions = [];
    var logger = undefined;
    // Create observables on events on the window
    var createObservables = function() {
        var _a;
        // Create Observables from direct user events
        var clickObservable = fromEvent(document, 'click', {
            capture: true
        }).pipe(map(function(click) {
            return addAdditionalEventProperties(click, 'click');
        }));
        var changeObservable = fromEvent(document, 'change', {
            capture: true
        }).pipe(map(function(change) {
            return addAdditionalEventProperties(change, 'change');
        }));
        // Create Observable from unhandled errors
        // const errorObservable = fromEvent<ErrorEvent>(window, 'error').pipe(
        //   map((error) => addAdditionalEventProperties(error, 'error')),
        // );
        // Create observable for URL changes
        var navigateObservable;
        /* istanbul ignore next */ if (window.navigation) {
            navigateObservable = fromEvent(window.navigation, 'navigate').pipe(map(function(navigate) {
                return addAdditionalEventProperties(navigate, 'navigate');
            }));
        }
        // Track DOM Mutations
        var mutationObservable = new Observable_Observable(function(observer) {
            var mutationObserver = new MutationObserver(function(mutations) {
                observer.next(mutations);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true
            });
            return function() {
                return mutationObserver.disconnect();
            };
        }).pipe(map(function(mutation) {
            return addAdditionalEventProperties(mutation, 'mutation');
        }));
        return _a = {}, _a[ObservablesEnum.ClickObservable] = clickObservable, _a[ObservablesEnum.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
        _a[ObservablesEnum.NavigateObservable] = navigateObservable, _a[ObservablesEnum.MutationObservable] = mutationObservable, _a;
    };
    // Returns the Amplitude event properties for the given element.
    var getEventProperties = function(actionType, element) {
        var _a;
        var _b, _c;
        /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
        /* istanbul ignore next */ var rect = typeof element.getBoundingClientRect === 'function' ? element.getBoundingClientRect() : {
            left: null,
            top: null
        };
        var ariaLabel = element.getAttribute('aria-label');
        var attributes = getAttributesWithPrefix(element, dataAttributePrefix);
        var nearestLabel = getNearestLabel(element);
        var selector = getSelector(element, logger);
        /* istanbul ignore next */ var properties = (_a = {}, _a[AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.getAttribute('id') || '', _a[AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.getAttribute('class'), _a[AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = getHierarchy(element), _a[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left), _a[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = rect.top == null ? null : Math.round(rect.top), _a[AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel, _a[AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes, _a[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector, _a[AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel, _a[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a[AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document !== 'undefined' && document.title || '', _a[AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, _a[AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, _a);
        if (tag === 'a' && actionType === 'click' && element instanceof HTMLAnchorElement) {
            properties[AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
        }
        return removeEmptyProperties(properties);
    };
    var addAdditionalEventProperties = function(event, type) {
        var baseEvent = {
            event: event,
            timestamp: Date.now(),
            type: type
        };
        if (isElementBasedEvent(baseEvent) && baseEvent.event.target !== null) {
            // Retrieve additional event properties from the target element
            var closestTrackedAncestor = getClosestElement(baseEvent.event.target, options.cssSelectorAllowlist);
            if (closestTrackedAncestor) {
                baseEvent.closestTrackedAncestor = closestTrackedAncestor;
                baseEvent.targetElementProperties = getEventProperties(baseEvent.type, closestTrackedAncestor);
            }
            return baseEvent;
        }
        return baseEvent;
    };
    var setup = function(config, amplitude) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, allowlist, actionClickAllowlist;
            var _a, _b;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                logger = config.loggerProvider;
                /* istanbul ignore if */ if (typeof document === 'undefined') {
                    return [
                        2 /*return*/ 
                    ];
                }
                shouldTrackEvent = createShouldTrackEvent(options, options.cssSelectorAllowlist);
                shouldTrackActionClick = createShouldTrackEvent(options, options.actionClickAllowlist);
                allObservables = createObservables();
                clickTrackingSubscription = trackClicks({
                    allObservables: allObservables,
                    options: options,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(clickTrackingSubscription);
                changeSubscription = trackChange({
                    allObservables: allObservables,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(changeSubscription);
                actionClickSubscription = trackActionClick({
                    allObservables: allObservables,
                    options: options,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    shouldTrackActionClick: shouldTrackActionClick
                });
                subscriptions.push(actionClickSubscription);
                /* istanbul ignore next */ (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 ? void 0 : _a.log("".concat(name, " has been successfully added."));
                // Setup visual tagging selector
                if (window.opener && visualTaggingOptions.enabled) {
                    allowlist = options.cssSelectorAllowlist;
                    actionClickAllowlist = options.actionClickAllowlist;
                    /* istanbul ignore next */ (_b = visualTaggingOptions.messenger) === null || _b === void 0 ? void 0 : _b.setup((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({
                        logger: config === null || config === void 0 ? void 0 : config.loggerProvider
                    }, (config === null || config === void 0 ? void 0 : config.serverZone) && {
                        endpoint: AMPLITUDE_ORIGINS_MAP[config.serverZone]
                    }), {
                        isElementSelectable: createShouldTrackEvent(options, (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(allowlist), false), (0,tslib_es6/* __read */.CR)(actionClickAllowlist), false)),
                        cssSelectorAllowlist: allowlist,
                        actionClickAllowlist: actionClickAllowlist
                    }));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
            var subscriptions_1, subscriptions_1_1, subscription;
            var e_1, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                try {
                    for(subscriptions_1 = (0,tslib_es6/* __values */.XA)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                        subscription = subscriptions_1_1.value;
                        subscription.unsubscribe();
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
}; //# sourceMappingURL=autocapture-plugin.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/browser-client.js















var AmplitudeBrowser = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(AmplitudeBrowser, _super);
    function AmplitudeBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmplitudeBrowser.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) {
            apiKey = '';
        }
        var userId;
        var options;
        if (arguments.length > 2) {
            userId = userIdOrOptions;
            options = maybeOptions;
        } else {
            if (typeof userIdOrOptions === 'string') {
                userId = userIdOrOptions;
                options = undefined;
            } else {
                userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
                options = userIdOrOptions;
            }
        }
        return (0,return_wrapper/* returnWrapper */.S)(this._init((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), {
            userId: userId,
            apiKey: apiKey
        })));
    };
    AmplitudeBrowser.prototype._init = function(options) {
        var _a, _b, _c;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var browserOptions, joinedConfigGenerator, attributionTrackingOptions, queryParams, querySessionId, connector;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        // Step 1: Block concurrent initialization
                        if (this.initializing) {
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.initializing = true;
                        return [
                            4 /*yield*/ ,
                            useBrowserConfig(options.apiKey, options, this)
                        ];
                    case 1:
                        browserOptions = _d.sent();
                        if (!options.fetchRemoteConfig) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            createBrowserJoinedConfigGenerator(browserOptions)
                        ];
                    case 2:
                        joinedConfigGenerator = _d.sent();
                        return [
                            4 /*yield*/ ,
                            joinedConfigGenerator.generateJoinedConfig()
                        ];
                    case 3:
                        browserOptions = _d.sent();
                        _d.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _super.prototype._init.call(this, browserOptions)
                        ];
                    case 5:
                        _d.sent();
                        this.logBrowserOptions(browserOptions);
                        if (!isAttributionTrackingEnabled(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            7
                        ];
                        attributionTrackingOptions = getAttributionTrackingConfig(this.config);
                        this.webAttribution = new WebAttribution(attributionTrackingOptions, this.config);
                        // Fetch the current campaign, check if need to track web attribution later
                        return [
                            4 /*yield*/ ,
                            this.webAttribution.init()
                        ];
                    case 6:
                        // Fetch the current campaign, check if need to track web attribution later
                        _d.sent();
                        _d.label = 7;
                    case 7:
                        queryParams = getQueryParams();
                        querySessionId = Number.isNaN(Number(queryParams.ampSessionId)) ? undefined : Number(queryParams.ampSessionId);
                        this.setSessionId((_c = (_b = (_a = options.sessionId) !== null && _a !== void 0 ? _a : querySessionId) !== null && _b !== void 0 ? _b : this.config.sessionId) !== null && _c !== void 0 ? _c : Date.now());
                        connector = (0,analytics_connector/* getAnalyticsConnector */.bM)(options.instanceName);
                        connector.identityStore.setIdentity({
                            userId: this.config.userId,
                            deviceId: this.config.deviceId
                        });
                        if (!(this.config.offline !== OfflineDisabled)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.add(networkConnectivityCheckerPlugin()).promise
                        ];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9:
                        return [
                            4 /*yield*/ ,
                            this.add(new Destination()).promise
                        ];
                    case 10:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new Context()).promise
                        ];
                    case 11:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new IdentityEventSender()).promise
                        ];
                    case 12:
                        _d.sent();
                        // Notify if DET is enabled
                        detNotify(this.config);
                        if (!isFileDownloadTrackingEnabled(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            14
                        ];
                        this.config.loggerProvider.debug('Adding file download tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add(fileDownloadTracking()).promise
                        ];
                    case 13:
                        _d.sent();
                        _d.label = 14;
                    case 14:
                        if (!isFormInteractionTrackingEnabled(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            16
                        ];
                        this.config.loggerProvider.debug('Adding form interaction plugin');
                        return [
                            4 /*yield*/ ,
                            this.add(formInteractionTracking()).promise
                        ];
                    case 15:
                        _d.sent();
                        _d.label = 16;
                    case 16:
                        if (!isPageViewTrackingEnabled(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            18
                        ];
                        this.config.loggerProvider.debug('Adding page view tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add(pageViewTrackingPlugin(getPageViewTrackingConfig(this.config))).promise
                        ];
                    case 17:
                        _d.sent();
                        _d.label = 18;
                    case 18:
                        if (!isElementInteractionsEnabled(this.config.autocapture)) return [
                            3 /*break*/ ,
                            20
                        ];
                        this.config.loggerProvider.debug('Adding user interactions plugin (autocapture plugin)');
                        return [
                            4 /*yield*/ ,
                            this.add(autocapturePlugin(getElementInteractionsConfig(this.config))).promise
                        ];
                    case 19:
                        _d.sent();
                        _d.label = 20;
                    case 20:
                        this.initializing = false;
                        // Step 6: Run queued dispatch functions
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('dispatchQ')
                        ];
                    case 21:
                        // Step 6: Run queued dispatch functions
                        _d.sent();
                        // Step 7: Add the event receiver after running remaining queued functions.
                        connector.eventBridge.setEventReceiver(function(event) {
                            void _this.track(event.eventType, event.eventProperties);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeBrowser.prototype.getUserId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
    };
    AmplitudeBrowser.prototype.setUserId = function(userId) {
        if (!this.config) {
            this.q.push(this.setUserId.bind(this, userId));
            return;
        }
        this.config.loggerProvider.debug('function setUserId: ', userId);
        if (userId !== this.config.userId || userId === undefined) {
            this.config.userId = userId;
            (0,analytics_connector/* setConnectorUserId */.x)(userId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    AmplitudeBrowser.prototype.setDeviceId = function(deviceId) {
        if (!this.config) {
            this.q.push(this.setDeviceId.bind(this, deviceId));
            return;
        }
        this.config.loggerProvider.debug('function setDeviceId: ', deviceId);
        this.config.deviceId = deviceId;
        (0,analytics_connector/* setConnectorDeviceId */.Sb)(deviceId, this.config.instanceName);
    };
    AmplitudeBrowser.prototype.reset = function() {
        this.setDeviceId(UUID());
        this.setUserId(undefined);
    };
    AmplitudeBrowser.prototype.getSessionId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    AmplitudeBrowser.prototype.setSessionId = function(sessionId) {
        var _a;
        var promises = [];
        if (!this.config) {
            this.q.push(this.setSessionId.bind(this, sessionId));
            return (0,return_wrapper/* returnWrapper */.S)(Promise.resolve());
        }
        // Prevents starting a new session with the same session ID
        if (sessionId === this.config.sessionId) {
            return (0,return_wrapper/* returnWrapper */.S)(Promise.resolve());
        }
        this.config.loggerProvider.debug('function setSessionId: ', sessionId);
        var previousSessionId = this.getSessionId();
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = undefined;
        this.config.pageCounter = 0;
        if (isSessionTrackingEnabled(this.config.defaultTracking)) {
            if (previousSessionId && lastEventTime) {
                promises.push(this.track(DEFAULT_SESSION_END_EVENT, undefined, {
                    device_id: this.previousSessionDeviceId,
                    event_id: ++lastEventId,
                    session_id: previousSessionId,
                    time: lastEventTime + 1,
                    user_id: this.previousSessionUserId
                }).promise);
            }
            this.config.lastEventTime = this.config.sessionId;
        }
        // Fire web attribution event when enable webAttribution tracking
        // 1. has new campaign (call setSessionId from init function)
        // 2. or shouldTrackNewCampaign (call setSessionId from async process(event) when there has new campaign and resetSessionOnNewCampaign = true )
        var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
        if (isSessionTrackingEnabled(this.config.defaultTracking)) {
            promises.push(this.track(DEFAULT_SESSION_START_EVENT, undefined, {
                event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
                session_id: this.config.sessionId,
                time: this.config.lastEventTime
            }).promise);
        }
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
        return (0,return_wrapper/* returnWrapper */.S)(Promise.all(promises));
    };
    AmplitudeBrowser.prototype.extendSession = function() {
        if (!this.config) {
            this.q.push(this.extendSession.bind(this));
            return;
        }
        this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser.prototype.setTransport = function(transport) {
        if (!this.config) {
            this.q.push(this.setTransport.bind(this, transport));
            return;
        }
        this.config.transportProvider = createTransport(transport);
    };
    AmplitudeBrowser.prototype.identify = function(identify, eventOptions) {
        if (isInstanceProxy(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = convertProxyObjectToRealObject(new esm_identify/* Identify */.h(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) {
            this.setUserId(eventOptions.user_id);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) {
            this.setDeviceId(eventOptions.device_id);
        }
        return _super.prototype.identify.call(this, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        if (isInstanceProxy(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = convertProxyObjectToRealObject(new esm_identify/* Identify */.h(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.revenue = function(revenue, eventOptions) {
        if (isInstanceProxy(revenue)) {
            var queue = revenue._q;
            revenue._q = [];
            revenue = convertProxyObjectToRealObject(new Revenue(), queue);
        }
        return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
        if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) {
            return false;
        }
        var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
        if (promises) {
            promises.push(this.track(campaignEvent).promise);
        } else {
            this.track(campaignEvent);
        }
        this.config.loggerProvider.log('Tracking attribution.');
        return true;
    };
    AmplitudeBrowser.prototype.process = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                currentTime = Date.now();
                isEventInNewSession = isNewSession(this.config.sessionTimeout, this.config.lastEventTime);
                shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
                if (event.event_type !== DEFAULT_SESSION_START_EVENT && event.event_type !== DEFAULT_SESSION_END_EVENT && (!event.session_id || event.session_id === this.getSessionId())) {
                    if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
                        this.setSessionId(currentTime);
                        if (shouldSetSessionIdOnNewCampaign) {
                            this.config.loggerProvider.log('Created a new session for new campaign.');
                        }
                    } else if (!isEventInNewSession) {
                        // Web attribution should be tracked during the middle of a session
                        // if there has been a chance in the campaign information.
                        this.trackCampaignEventIfNeeded();
                    }
                }
                return [
                    2 /*return*/ ,
                    _super.prototype.process.call(this, event)
                ];
            });
        });
    };
    AmplitudeBrowser.prototype.logBrowserOptions = function(browserConfig) {
        try {
            var browserConfigCopy = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, browserConfig), {
                apiKey: browserConfig.apiKey.substring(0, 10) + '********'
            });
            this.config.loggerProvider.debug('Initialized Amplitude with BrowserConfig:', JSON.stringify(browserConfigCopy));
        } catch (e) {
            /* istanbul ignore next */ this.config.loggerProvider.error('Error logging browser config', e);
        }
    };
    return AmplitudeBrowser;
}(AmplitudeCore);
 //# sourceMappingURL=browser-client.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/browser-client-factory.js


var createInstance = function() {
    var client = new AmplitudeBrowser();
    return {
        init: (0,debug/* debugWrapper */.w_)(client.init.bind(client), 'init', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ])),
        add: (0,debug/* debugWrapper */.w_)(client.add.bind(client), 'add', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        remove: (0,debug/* debugWrapper */.w_)(client.remove.bind(client), 'remove', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        track: (0,debug/* debugWrapper */.w_)(client.track.bind(client), 'track', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        logEvent: (0,debug/* debugWrapper */.w_)(client.logEvent.bind(client), 'logEvent', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        identify: (0,debug/* debugWrapper */.w_)(client.identify.bind(client), 'identify', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        groupIdentify: (0,debug/* debugWrapper */.w_)(client.groupIdentify.bind(client), 'groupIdentify', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        setGroup: (0,debug/* debugWrapper */.w_)(client.setGroup.bind(client), 'setGroup', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        revenue: (0,debug/* debugWrapper */.w_)(client.revenue.bind(client), 'revenue', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        flush: (0,debug/* debugWrapper */.w_)(client.flush.bind(client), 'flush', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        getUserId: (0,debug/* debugWrapper */.w_)(client.getUserId.bind(client), 'getUserId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config',
            'config.userId'
        ])),
        setUserId: (0,debug/* debugWrapper */.w_)(client.setUserId.bind(client), 'setUserId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config',
            'config.userId'
        ])),
        getDeviceId: (0,debug/* debugWrapper */.w_)(client.getDeviceId.bind(client), 'getDeviceId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config',
            'config.deviceId'
        ])),
        setDeviceId: (0,debug/* debugWrapper */.w_)(client.setDeviceId.bind(client), 'setDeviceId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config',
            'config.deviceId'
        ])),
        reset: (0,debug/* debugWrapper */.w_)(client.reset.bind(client), 'reset', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config',
            'config.userId',
            'config.deviceId'
        ])),
        getSessionId: (0,debug/* debugWrapper */.w_)(client.getSessionId.bind(client), 'getSessionId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ])),
        setSessionId: (0,debug/* debugWrapper */.w_)(client.setSessionId.bind(client), 'setSessionId', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ])),
        extendSession: (0,debug/* debugWrapper */.w_)(client.extendSession.bind(client), 'extendSession', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ])),
        setOptOut: (0,debug/* debugWrapper */.w_)(client.setOptOut.bind(client), 'setOptOut', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ])),
        setTransport: (0,debug/* debugWrapper */.w_)(client.setTransport.bind(client), 'setTransport', (0,debug/* getClientLogConfig */.yh)(client), (0,debug/* getClientStates */.zn)(client, [
            'config'
        ]))
    };
};
/* harmony default export */ const browser_client_factory = (createInstance()); //# sourceMappingURL=browser-client-factory.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-browser@2.11.9/node_modules/@amplitude/analytics-browser/lib/esm/index.js
/* eslint-disable @typescript-eslint/unbound-method */ 

var add = browser_client_factory.add, extendSession = browser_client_factory.extendSession, flush = browser_client_factory.flush, getDeviceId = browser_client_factory.getDeviceId, getSessionId = browser_client_factory.getSessionId, getUserId = browser_client_factory.getUserId, groupIdentify = browser_client_factory.groupIdentify, identify = browser_client_factory.identify, init = browser_client_factory.init, logEvent = browser_client_factory.logEvent, remove = browser_client_factory.remove, esm_reset = browser_client_factory.reset, revenue = browser_client_factory.revenue, setDeviceId = browser_client_factory.setDeviceId, setGroup = browser_client_factory.setGroup, setOptOut = browser_client_factory.setOptOut, setSessionId = browser_client_factory.setSessionId, setTransport = browser_client_factory.setTransport, setUserId = browser_client_factory.setUserId, track = browser_client_factory.track;



 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 64505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bM": () => (/* binding */ getAnalyticsConnector),
  "Sb": () => (/* binding */ setConnectorDeviceId),
  "x": () => (/* binding */ setConnectorUserId)
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-connector@1.6.2/node_modules/@amplitude/analytics-connector/dist/analytics-connector.esm.js
var ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var getLanguage = function() {
    return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) {
                this.queue.push(event);
            }
        } else {
            this.receiver(event);
        }
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function(obj1, obj2) {
    var e_1, _a;
    var primitive = [
        'string',
        'number',
        'boolean',
        'undefined'
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) {
        return false;
    }
    try {
        for(var primitive_1 = __values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()){
            var p = primitive_1_1.value;
            if (p === typeA) {
                return obj1 === obj2;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) {
        return true;
    } else if (obj1 == null || obj2 == null) {
        return false;
    }
    // if got here - objects
    if (obj1.length !== obj2.length) {
        return false;
    }
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) {
        return false;
    }
    if (isArrayA && isArrayB) {
        //arrays
        for(var i = 0; i < obj1.length; i++){
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
    } else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!isEqual(sorted1, sorted2)) {
            return false;
        }
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!isEqual(obj1[key], obj2[key])) {
                result_1 = false;
            }
        });
        return result_1;
    }
    return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
    Object.entries = function(obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while(i--){
            resArray[i] = [
                ownProps[i],
                obj[ownProps[i]]
            ];
        }
        return resArray;
    };
}
var IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self1 = this;
        var actingUserProperties = __assign({}, this.identity.userProperties);
        var actingIdentity = __assign(__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function(optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function(actions) {
                var e_1, _a, e_2, _b, e_3, _c;
                var actingProperties = actingIdentity.userProperties || {};
                try {
                    for(var _d = __values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()){
                        var _f = __read(_e.value, 2), action = _f[0], properties = _f[1];
                        switch(action){
                            case ID_OP_SET:
                                try {
                                    for(var _g = (e_2 = void 0, __values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var _j = __read(_h.value, 2), key = _j[0], value = _j[1];
                                        actingProperties[key] = value;
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                break;
                            case ID_OP_UNSET:
                                try {
                                    for(var _k = (e_3 = void 0, __values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()){
                                        var key = _l.value;
                                        delete actingProperties[key];
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                break;
                            case ID_OP_CLEAR_ALL:
                                actingProperties = {};
                                break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function() {
                self1.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return __assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = __assign({}, this.identity);
        this.identity = __assign({}, identity);
        if (!isEqual(originalIdentity, this.identity)) {
            this.listeners.forEach(function(listener) {
                listener(identity);
            });
        }
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof (self || window) !== 'undefined' ? (self || window) : self;
var AnalyticsConnector = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new IdentityStoreImpl();
        this.eventBridge = new EventBridgeImpl();
        this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!safeGlobal['analyticsConnectorInstances']) {
            safeGlobal['analyticsConnectorInstances'] = {};
        }
        if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
            safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
        }
        return safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}();


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/analytics-connector.js

var getAnalyticsConnector = function(instanceName) {
    if (instanceName === void 0) {
        instanceName = '$default_instance';
    }
    return AnalyticsConnector.getInstance(instanceName);
};
var setConnectorUserId = function(userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var setConnectorDeviceId = function(deviceId, instanceName) {
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
}; //# sourceMappingURL=analytics-connector.js.map


/***/ }),

/***/ 96276:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ getGlobalScope)
/* harmony export */ });
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var getGlobalScope = function() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') {
        return globalThis[ampIntegrationContextName];
    }
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof (self || window) !== 'undefined') {
        return (self || window);
    }
    return undefined;
}; //# sourceMappingURL=global-scope.js.map


/***/ }),

/***/ 22798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ FetchTransport)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80187);
/* harmony import */ var _amplitude_analytics_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21143);


var FetchTransport = /** @class */ function(_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport.prototype.send = function(serverUrl, payload) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function() {
            var options, response, responseText;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        /* istanbul ignore if */ if (typeof fetch === 'undefined') {
                            throw new Error('FetchTransport is not supported');
                        }
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*'
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        responseText = _a.sent();
                        try {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            return [
                                2 /*return*/ ,
                                this.buildResponse(JSON.parse(responseText))
                            ];
                        } catch (_b) {
                            return [
                                2 /*return*/ ,
                                this.buildResponse({
                                    code: response.status
                                })
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FetchTransport;
}(_amplitude_analytics_core__WEBPACK_IMPORTED_MODULE_1__/* .BaseTransport */ .d);
 //# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 74408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": () => (/* binding */ Config),
/* harmony export */   "RG": () => (/* binding */ createServerConfig),
/* harmony export */   "Dg": () => (/* binding */ RequestMetadata)
/* harmony export */ });
/* unused harmony exports getDefaultConfig, getServerUrl */
/* harmony import */ var _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36652);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36095);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70268);



var getDefaultConfig = function() {
    return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 10000,
        instanceName: '$default_instance',
        logLevel: _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Warn */ .i.Warn,
        loggerProvider: new _logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Y(),
        offline: false,
        optOut: false,
        serverUrl: _constants__WEBPACK_IMPORTED_MODULE_2__/* .AMPLITUDE_SERVER_URL */ .EG,
        serverZone: 'US',
        useBatch: false
    };
};
var Config = /** @class */ function() {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = getDefaultConfig();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();

var getServerUrl = function(serverZone, useBatch) {
    if (serverZone === 'EU') {
        return useBatch ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .EU_AMPLITUDE_BATCH_SERVER_URL */ .RE : _constants__WEBPACK_IMPORTED_MODULE_2__/* .EU_AMPLITUDE_SERVER_URL */ .y_;
    }
    return useBatch ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .AMPLITUDE_BATCH_SERVER_URL */ .h8 : _constants__WEBPACK_IMPORTED_MODULE_2__/* .AMPLITUDE_SERVER_URL */ .EG;
};
var createServerConfig = function(serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) {
        serverUrl = '';
    }
    if (serverZone === void 0) {
        serverZone = getDefaultConfig().serverZone;
    }
    if (useBatch === void 0) {
        useBatch = getDefaultConfig().useBatch;
    }
    if (serverUrl) {
        return {
            serverUrl: serverUrl,
            serverZone: undefined
        };
    }
    var _serverZone = [
        'US',
        'EU'
    ].includes(serverZone) ? serverZone : getDefaultConfig().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: getServerUrl(_serverZone, useBatch)
    };
};
var RequestMetadata = /** @class */ function() {
    function RequestMetadata() {
        this.sdk = {
            metrics: {
                histogram: {}
            }
        };
    }
    RequestMetadata.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata;
}();

var HistogramOptions = /** @class */ function() {
    function HistogramOptions() {}
    return HistogramOptions;
}(); //# sourceMappingURL=config.js.map


/***/ }),

/***/ 36095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q$": () => (/* binding */ UNSET_VALUE),
/* harmony export */   "xp": () => (/* binding */ AMPLITUDE_PREFIX),
/* harmony export */   "f1": () => (/* binding */ STORAGE_PREFIX),
/* harmony export */   "EG": () => (/* binding */ AMPLITUDE_SERVER_URL),
/* harmony export */   "y_": () => (/* binding */ EU_AMPLITUDE_SERVER_URL),
/* harmony export */   "h8": () => (/* binding */ AMPLITUDE_BATCH_SERVER_URL),
/* harmony export */   "RE": () => (/* binding */ EU_AMPLITUDE_BATCH_SERVER_URL)
/* harmony export */ });
var UNSET_VALUE = '-';
var AMPLITUDE_PREFIX = 'AMP';
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch'; //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 7848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": () => (/* binding */ Identify)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80187);
/* harmony import */ var _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10261);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36095);
/* harmony import */ var _utils_valid_properties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4041);




var Identify = /** @class */ function() {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function() {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._properties);
    };
    Identify.prototype.set = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.SET */ .h9.SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.SET_ONCE */ .h9.SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.APPEND */ .h9.APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.PREPEND */ .h9.PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.POSTINSERT */ .h9.POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.PREINSERT */ .h9.PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.REMOVE */ .h9.REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function(property, value) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.ADD */ .h9.ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function(property) {
        this._safeSet(_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.UNSET */ .h9.UNSET, property, _constants__WEBPACK_IMPORTED_MODULE_2__/* .UNSET_VALUE */ .q$);
        return this;
    };
    Identify.prototype.clearAll = function() {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.CLEAR_ALL */ .h9.CLEAR_ALL] = _constants__WEBPACK_IMPORTED_MODULE_2__/* .UNSET_VALUE */ .q$;
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function(operation, property, value) {
        if (this._properties[_amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.CLEAR_ALL */ .h9.CLEAR_ALL] !== undefined) {
            // clear all already set. Skipping operation;
            return false;
        }
        if (this._propertySet.has(property)) {
            // Property already used. Skipping operation
            return false;
        }
        if (operation === _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.ADD */ .h9.ADD) {
            return typeof value === 'number';
        }
        if (operation !== _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.UNSET */ .h9.UNSET && operation !== _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .IdentifyOperation.REMOVE */ .h9.REMOVE) {
            return (0,_utils_valid_properties__WEBPACK_IMPORTED_MODULE_3__/* .isValidProperties */ .T)(property, value);
        }
        return true;
    };
    return Identify;
}();
 //# sourceMappingURL=identify.js.map


/***/ }),

/***/ 70268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ Logger)
/* harmony export */ });
/* harmony import */ var _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36652);

var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */ function() {
    function Logger() {
        this.logLevel = _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.None */ .i.None;
    }
    Logger.prototype.disable = function() {
        this.logLevel = _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.None */ .i.None;
    };
    Logger.prototype.enable = function(logLevel) {
        if (logLevel === void 0) {
            logLevel = _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Warn */ .i.Warn;
        }
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (this.logLevel < _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Verbose */ .i.Verbose) {
            return;
        }
        console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (this.logLevel < _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Warn */ .i.Warn) {
            return;
        }
        console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (this.logLevel < _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Error */ .i.Error) {
            return;
        }
        console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        if (this.logLevel < _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .LogLevel.Debug */ .i.Debug) {
            return;
        }
        // console.debug output is hidden by default in chrome
        console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}();
 //# sourceMappingURL=logger.js.map


/***/ }),

/***/ 21143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ BaseTransport)
/* harmony export */ });
/* harmony import */ var _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91669);
/* eslint-disable @typescript-eslint/no-unsafe-argument */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-call */ 
var BaseTransport = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') {
            return null;
        }
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Success */ .q.Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Invalid */ .q.Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.PayloadTooLarge */ .q.PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.RateLimit */ .q.RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Timeout */ .q.Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Success */ .q.Success;
        }
        if (code === 429) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.RateLimit */ .q.RateLimit;
        }
        if (code === 413) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.PayloadTooLarge */ .q.PayloadTooLarge;
        }
        if (code === 408) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Timeout */ .q.Timeout;
        }
        if (code >= 400 && code < 500) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Invalid */ .q.Invalid;
        }
        if (code >= 500) {
            return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Failed */ .q.Failed;
        }
        return _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_0__/* .Status.Unknown */ .q.Unknown;
    };
    return BaseTransport;
}();
 //# sourceMappingURL=base.js.map


/***/ }),

/***/ 39625:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yh": () => (/* binding */ getClientLogConfig),
/* harmony export */   "zn": () => (/* binding */ getClientStates),
/* harmony export */   "w_": () => (/* binding */ debugWrapper)
/* harmony export */ });
/* unused harmony exports getStacktrace, getValueByStringPath */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80187);
/* harmony import */ var _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36652);

/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var getStacktrace = function(ignoreDepth) {
    if (ignoreDepth === void 0) {
        ignoreDepth = 0;
    }
    var trace = new Error().stack || '';
    return trace.split('\n').slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
    });
};
// This hook makes sure we always get the latest logger and logLevel.
var getClientLogConfig = function(client) {
    return function() {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
// This is a convenient function to get the attribute from object with string path, similar to lodash '#get'.
var getValueByStringPath = function(obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for(var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()){
            var attr = _c.value;
            if (attr in obj) {
                obj = obj[attr];
            } else {
                return;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return obj;
};
var getClientStates = function(client, paths) {
    return function() {
        var e_2, _a;
        var res = {};
        try {
            for(var paths_1 = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var path = paths_1_1.value;
                res[path] = getValueByStringPath(client, path);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return res;
    };
};
var debugWrapper = function(fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) {
        fnContext = null;
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if (logLevel && logLevel < _amplitude_analytics_types__WEBPACK_IMPORTED_MODULE_1__/* .LogLevel.Debug */ .i.Debug || !logLevel || !logger) {
            return fn.apply(fnContext, args);
        }
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: getStacktrace(1),
            time: {
                start: new Date().toISOString()
            },
            states: {}
        };
        if (getStates && debugContext.states) {
            debugContext.states.before = getStates();
        }
        var result = fn.apply(fnContext, args);
        if (result && result.promise) {
            // if result is a promise, add the callback
            result.promise.then(function() {
                if (getStates && debugContext.states) {
                    debugContext.states.after = getStates();
                }
                if (debugContext.time) {
                    debugContext.time.end = new Date().toISOString();
                }
                logger.debug(JSON.stringify(debugContext, null, 2));
            });
        } else {
            if (getStates && debugContext.states) {
                debugContext.states.after = getStates();
            }
            if (debugContext.time) {
                debugContext.time.end = new Date().toISOString();
            }
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
}; //# sourceMappingURL=debug.js.map


/***/ }),

/***/ 46190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ returnWrapper)
/* harmony export */ });
var returnWrapper = function(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
}; //# sourceMappingURL=return-wrapper.js.map


/***/ }),

/***/ 4041:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ isValidObject),
/* harmony export */   "T": () => (/* binding */ isValidProperties)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80187);

var MAX_PROPERTY_KEYS = 1000;
var isValidObject = function(properties) {
    if (Object.keys(properties).length > MAX_PROPERTY_KEYS) {
        return false;
    }
    for(var key in properties){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!isValidProperties(key, value)) return false;
    }
    return true;
};
var isValidProperties = function(property, value) {
    var e_1, _a;
    if (typeof property !== 'string') return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for(var value_1 = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()){
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) {
                    return false;
                } else if (typeof valueElement === 'object') {
                    isValid = isValid && isValidObject(valueElement);
                } else if (![
                    'number',
                    'string'
                ].includes(typeof valueElement)) {
                    return false;
                }
                if (!isValid) {
                    return false;
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    } else if (value === null || value === undefined) {
        return false;
    } else if (typeof value === 'object') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return isValidObject(value);
    } else if (![
        'number',
        'string',
        'boolean'
    ].includes(typeof value)) {
        return false;
    }
    return true;
}; //# sourceMappingURL=valid-properties.js.map


/***/ }),

/***/ 10261:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h9": () => (/* binding */ IdentifyOperation),
/* harmony export */   "al": () => (/* binding */ RevenueProperty),
/* harmony export */   "JU": () => (/* binding */ SpecialEventType)
/* harmony export */ });
var IdentifyOperation;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var RevenueProperty;
(function(RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE"] = "$revenue";
})(RevenueProperty || (RevenueProperty = {}));
/**
 * Strings that have special meaning when used as an event's type
 * and have different specifications.
 */ var SpecialEventType;
(function(SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {})); //# sourceMappingURL=event.js.map


/***/ }),

/***/ 36652:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ LogLevel)
/* harmony export */ });
var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {})); //# sourceMappingURL=logger.js.map


/***/ }),

/***/ 59207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ ServerZone)
/* harmony export */ });
/**
 * @deprecated use ServerZoneType instead
 */ var ServerZone;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
})(ServerZone || (ServerZone = {})); //# sourceMappingURL=server-zone.js.map


/***/ }),

/***/ 91669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ Status)
/* harmony export */ });
/** The status of an event. */ var Status;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})(Status || (Status = {})); //# sourceMappingURL=status.js.map


/***/ }),

/***/ 55599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": () => (/* binding */ sessionReplayPlugin)
});

// UNUSED EXPORTS: SessionReplayPlugin

// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(80187);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/debug.js
var debug = __webpack_require__(39625);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/transports/fetch.js
var transports_fetch = __webpack_require__(22798);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/logger.js
var logger = __webpack_require__(70268);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/config.js
var config = __webpack_require__(74408);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/logger.js
var esm_logger = __webpack_require__(36652);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/constants.js
var constants = __webpack_require__(36095);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/server-zone.js
var server_zone = __webpack_require__(59207);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/constants.js


var DEFAULT_EVENT_PROPERTY_PREFIX = '[Amplitude]';
var DEFAULT_SESSION_REPLAY_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay ID");
var DEFAULT_SESSION_START_EVENT = 'session_start';
var DEFAULT_SESSION_END_EVENT = 'session_end';
var DEFAULT_SAMPLE_RATE = 0;
var DEFAULT_SERVER_ZONE = server_zone/* ServerZone.US */.J.US;
var SESSION_REPLAY_DEBUG_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay Debug");
var BLOCK_CLASS = 'amp-block';
var MASK_TEXT_CLASS = 'amp-mask';
var UNMASK_TEXT_CLASS = 'amp-unmask';
var SESSION_REPLAY_SERVER_URL = 'https://api-sr.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_EU_URL = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_STAGING_URL = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
var STORAGE_PREFIX = "".concat(constants/* AMPLITUDE_PREFIX */.xp, "_replay_unsent");
var MAX_EVENT_LIST_SIZE_IN_BYTES = 1 * 1000000; // 1 MB
var INTERACTION_MIN_INTERVAL = 30000; // 30 seconds
var INTERACTION_MAX_INTERVAL = 60000; // 1 minute
var MIN_INTERVAL = 500; // 500 ms
var MAX_INTERVAL = 10 * 1000; // 10 seconds
var MAX_IDB_STORAGE_LENGTH = (/* unused pure expression or super */ null && (1000 * 60 * 60 * 24 * 3)); // 3 days
var KB_SIZE = 1024;
var CustomRRwebEvent;
(function(CustomRRwebEvent) {
    CustomRRwebEvent["GET_SR_PROPS"] = "get-sr-props";
    CustomRRwebEvent["DEBUG_INFO"] = "debug-info";
})(CustomRRwebEvent || (CustomRRwebEvent = {})); //# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/config/local-config.js





var getDefaultConfig = function() {
    return {
        flushMaxRetries: 2,
        logLevel: esm_logger/* LogLevel.Warn */.i.Warn,
        loggerProvider: new logger/* Logger */.Y(),
        transportProvider: new transports_fetch/* FetchTransport */.V()
    };
};
var SessionReplayLocalConfig = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(SessionReplayLocalConfig, _super);
    function SessionReplayLocalConfig(apiKey, options) {
        var _this = this;
        var _a;
        var defaultConfig = getDefaultConfig();
        _this = _super.call(this, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({
            transportProvider: defaultConfig.transportProvider
        }, options), {
            apiKey: apiKey
        })) || this;
        _this.flushMaxRetries = options.flushMaxRetries !== undefined && options.flushMaxRetries <= defaultConfig.flushMaxRetries ? options.flushMaxRetries : defaultConfig.flushMaxRetries;
        _this.apiKey = apiKey;
        _this.sampleRate = options.sampleRate || DEFAULT_SAMPLE_RATE;
        _this.serverZone = options.serverZone || DEFAULT_SERVER_ZONE;
        _this.configEndpointUrl = options.configEndpointUrl;
        _this.shouldInlineStylesheet = options.shouldInlineStylesheet;
        _this.version = options.version;
        _this.performanceConfig = options.performanceConfig;
        _this.storeType = (_a = options.storeType) !== null && _a !== void 0 ? _a : 'idb';
        if (options.privacyConfig) {
            _this.privacyConfig = options.privacyConfig;
        }
        if (options.debugMode) {
            _this.debugMode = options.debugMode;
        }
        return _this;
    }
    return SessionReplayLocalConfig;
}(config/* Config */.De);
 //# sourceMappingURL=local-config.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/global-scope.js
var global_scope = __webpack_require__(96276);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-client-common@2.3.5/node_modules/@amplitude/analytics-client-common/lib/esm/analytics-connector.js + 1 modules
var analytics_connector = __webpack_require__(64505);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/utils/return-wrapper.js
var return_wrapper = __webpack_require__(46190);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb@2.0.0-alpha.26/node_modules/@amplitude/rrweb/dist/rrweb.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value)=>key in obj ? __defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField$1 = (obj, key, value)=>__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var NodeType$2 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})(NodeType$2 || {});
const testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const untaintedBasePrototype$1 = {};
function getUntaintedPrototype$1(key) {
    if (untaintedBasePrototype$1[key]) return untaintedBasePrototype$1[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in testableAccessors$1 ? testableAccessors$1[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in testableMethods$1 ? testableMethods$1[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods) {
        untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
const untaintedAccessorCache$1 = {};
function getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    const cacheKey = `${key}.${String(accessor)}`;
    if (untaintedAccessorCache$1[cacheKey]) return untaintedAccessorCache$1[cacheKey].call(instance);
    const untaintedPrototype = getUntaintedPrototype$1(key);
    const untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const untaintedMethodCache$1 = {};
function getUntaintedMethod$1(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if (untaintedMethodCache$1[cacheKey]) return untaintedMethodCache$1[cacheKey].bind(instance);
    const untaintedPrototype = getUntaintedPrototype$1(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function childNodes$1(n2) {
    return getUntaintedAccessor$1("Node", n2, "childNodes");
}
function parentNode$1(n2) {
    return getUntaintedAccessor$1("Node", n2, "parentNode");
}
function parentElement$1(n2) {
    return getUntaintedAccessor$1("Node", n2, "parentElement");
}
function textContent$1(n2) {
    return getUntaintedAccessor$1("Node", n2, "textContent");
}
function contains$1(n2, other) {
    return getUntaintedMethod$1("Node", n2, "contains")(other);
}
function getRootNode$1(n2) {
    return getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function styleSheets$1(n2) {
    return n2.styleSheets;
}
function shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function querySelector$1(n2, selectors) {
    return getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function querySelectorAll$1(n2, selectors) {
    return getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function mutationObserverCtor$1() {
    return getUntaintedPrototype$1("MutationObserver").constructor;
}
const index$1 = {
    childNodes: childNodes$1,
    parentNode: parentNode$1,
    parentElement: parentElement$1,
    textContent: textContent$1,
    contains: contains$1,
    getRootNode: getRootNode$1,
    host: host$1,
    styleSheets: styleSheets$1,
    shadowRoot: shadowRoot$1,
    querySelector: querySelector$1,
    querySelectorAll: querySelectorAll$1,
    mutationObserver: mutationObserverCtor$1
};
function isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function isShadowRoot(n2) {
    const hostEl = // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && index$1.shadowRoot(hostEl) === n2);
}
function isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) {
        cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    }
    return cssText;
}
function escapeImportStatement(rule2) {
    const { cssText } = rule2;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule2.href)})`
    ];
    if (rule2.layerName === "") {
        statement.push(`layer`);
    } else if (rule2.layerName) {
        statement.push(`layer(${rule2.layerName})`);
    }
    if (rule2.supportsText) {
        statement.push(`supports(${rule2.supportsText})`);
    }
    if (rule2.media.length) {
        statement.push(rule2.media.mediaText);
    }
    return statement.join(" ") + ";";
}
function stringifyStylesheet(s2) {
    try {
        const rules2 = s2.rules || s2.cssRules;
        if (!rules2) {
            return null;
        }
        const stringifiedRules = Array.from(rules2, (rule2)=>stringifyRule(rule2, s2.href)).join("");
        return fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function stringifyRule(rule2, sheetHref) {
    if (isCSSImportRule(rule2)) {
        let importStringified;
        try {
            importStringified = // we can access the imported stylesheet rules directly
            stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) {
            return absolutifyURLs(importStringified, rule2.styleSheet.href);
        }
        return importStringified;
    } else {
        let ruleStringified = rule2.cssText;
        if (isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) {
            ruleStringified = fixSafariColons(ruleStringified);
        }
        if (sheetHref) {
            return absolutifyURLs(ruleStringified, sheetHref);
        }
        return ruleStringified;
    }
}
function fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
class Mirror {
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) {
            n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
        }
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
    constructor(){
        __publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        __publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
}
function createMirror$2() {
    return new Mirror();
}
function maskInputValue({ element, maskInputOptions, tagName, type, value, maskInputFn }) {
    let text = value || "";
    const actualType = type && toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) {
            text = maskInputFn(text, element);
        } else {
            text = "*".repeat(text.length);
        }
    }
    return text;
}
function toLowerCase(str) {
    return str.toLowerCase();
}
const ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x2 = 0; x2 < canvas.width; x2 += chunkSize){
        for(let y = 0; y < canvas.height; y += chunkSize){
            const getImageData = ctx.getImageData;
            const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
            const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
        }
    }
    return true;
}
function isNodeMetaEqual(a2, b) {
    if (!a2 || !b || a2.type !== b.type) return false;
    if (a2.type === NodeType$2.Document) return a2.compatMode === b.compatMode;
    else if (a2.type === NodeType$2.DocumentType) return a2.name === b.name && a2.publicId === b.publicId && a2.systemId === b.systemId;
    else if (a2.type === NodeType$2.Comment || a2.type === NodeType$2.Text || a2.type === NodeType$2.CDATA) return a2.textContent === b.textContent;
    else if (a2.type === NodeType$2.Element) return a2.tagName === b.tagName && JSON.stringify(a2.attributes) === JSON.stringify(b.attributes) && a2.isSVG === b.isSVG && a2.needBlock === b.needBlock;
    return false;
}
function getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    toLowerCase(type) : null;
}
function extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) {
        origin = url.split("/").slice(0, 3).join("/");
    } else {
        origin = url.split("/")[0];
    }
    origin = origin.split("?")[0];
    return origin;
}
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absolutifyURLs(cssText, href) {
    return (cssText || "").replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) {
            return origin;
        }
        if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (DATA_URI.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (filePath[0] === "/") {
            return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        }
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") {
                continue;
            } else if (part === "..") {
                stack.pop();
            } else {
                stack.push(part);
            }
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
let _id = 1;
const tagNameRegex = new RegExp("[^a-z0-9-_:]");
const IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName$1(element) {
    if (element instanceof HTMLFormElement) {
        return "form";
    }
    const processedTagName = toLowerCase(element.tagName);
    if (tagNameRegex.test(processedTagName)) {
        return "div";
    }
    return processedTagName;
}
let canvasService;
let canvasCtx;
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") {
        return attributeValue;
    }
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        let url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") {
                        inParens = true;
                    }
                } else {
                    if (c2 === ")") {
                        inParens = false;
                    }
                }
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const cachedDocument = /* @__PURE__ */ new WeakMap();
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") {
        return attributeValue;
    }
    return getHref(doc, attributeValue);
}
function isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function getHref(doc, customHref) {
    let a2 = cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        cachedDocument.set(doc, a2);
    }
    if (!customHref) {
        customHref = "";
    } else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) {
        return customHref;
    }
    a2.setAttribute("href", customHref);
    return a2.href;
}
function transformAttribute(doc, tagName, name, value) {
    if (!value) {
        return value;
    }
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) {
        return absoluteToDoc(doc, value);
    } else if (name === "xlink:href" && value[0] !== "#") {
        return absoluteToDoc(doc, value);
    } else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) {
        return absoluteToDoc(doc, value);
    } else if (name === "srcset") {
        return getAbsoluteSrcsetString(doc, value);
    } else if (name === "style") {
        return absolutifyURLs(value, getHref(doc));
    } else if (tagName === "object" && name === "data") {
        return absoluteToDoc(doc, value);
    }
    return value;
}
function ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function _isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) {
                return true;
            }
        } else {
            for(let eIndex = element.classList.length; eIndex--;){
                const className = element.classList[eIndex];
                if (blockClass.test(className)) {
                    return true;
                }
            }
        }
        if (blockSelector) {
            return element.matches(blockSelector);
        }
    } catch (e2) {}
    return false;
}
function classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return classMatchesRegex(index$1.parentNode(node2), regex, checkAncestors);
    }
    for(let eIndex = node2.classList.length; eIndex--;){
        const className = node2.classList[eIndex];
        if (regex.test(className)) {
            return true;
        }
    }
    if (!checkAncestors) return false;
    return classMatchesRegex(index$1.parentNode(node2), regex, checkAncestors);
}
function needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    let el;
    if (isElement(node2)) {
        el = node2;
        if (!index$1.childNodes(el).length) {
            return false;
        }
    } else if (index$1.parentElement(node2) === null) {
        return false;
    } else {
        el = index$1.parentElement(node2);
    }
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if (classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function serializeNode(n2, options) {
    const { doc, mirror: mirror2, blockClass, blockSelector, needsMask, inlineStylesheet, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false } = options;
    const rootId = getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") {
                return {
                    type: NodeType$2.Document,
                    childNodes: [],
                    compatMode: n2.compatMode
                };
            } else {
                return {
                    type: NodeType$2.Document,
                    childNodes: []
                };
            }
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$2.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId
            };
        case n2.ELEMENT_NODE:
            return serializeElementNode(n2, {
                doc,
                blockClass,
                blockSelector,
                inlineStylesheet,
                maskInputOptions,
                maskInputFn,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                keepIframeSrcFn,
                newlyAddedElement,
                rootId
            });
        case n2.TEXT_NODE:
            return serializeTextNode(n2, {
                doc,
                needsMask,
                maskTextFn,
                rootId
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: NodeType$2.CDATA,
                textContent: "",
                rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: NodeType$2.Comment,
                textContent: index$1.textContent(n2) || "",
                rootId
            };
        default:
            return false;
    }
}
function getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    const docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function serializeTextNode(n2, options) {
    var _a2;
    const { needsMask, maskTextFn, rootId } = options;
    const parent = index$1.parentNode(n2);
    const parentTagName = parent && parent.tagName;
    let text = index$1.textContent(n2);
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isStyle && text) {
        try {
            if (n2.nextSibling || n2.previousSibling) {} else if ((_a2 = parent.sheet) == null ? void 0 : _a2.cssRules) {
                text = stringifyStylesheet(parent.sheet);
            }
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n2);
        }
        text = absolutifyURLs(text, getHref(options.doc));
    }
    if (isScript) {
        text = "SCRIPT_PLACEHOLDER";
    }
    if (!isStyle && !isScript && text && needsMask) {
        text = maskTextFn ? maskTextFn(text, index$1.parentElement(n2)) : text.replace(/[\S]/g, "*");
    }
    return {
        type: NodeType$2.Text,
        textContent: text || "",
        isStyle,
        rootId
    };
}
function serializeElementNode(n2, options) {
    const { doc, blockClass, blockSelector, inlineStylesheet, maskInputOptions = {}, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false, rootId } = options;
    const needBlock = _isBlockedElement(n2, blockClass, blockSelector);
    const tagName = getValidTagName$1(n2);
    let attributes = {};
    const len = n2.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n2.attributes[i2];
        if (!ignoreAttribute(tagName, attr.name, attr.value)) {
            attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value);
        }
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s2)=>{
            return s2.href === n2.href;
        });
        let cssText = null;
        if (stylesheet) {
            cssText = stringifyStylesheet(stylesheet);
        }
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n2.innerText || index$1.textContent(n2) || "").trim().length) {
        const cssText = stringifyStylesheet(n2.sheet);
        if (cssText) {
            attributes._cssText = cssText;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        const value = n2.value;
        const checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) {
            attributes.value = maskInputValue({
                element: n2,
                type: getInputType(n2),
                tagName,
                value,
                maskInputOptions,
                maskInputFn
            });
        } else if (checked) {
            attributes.checked = checked;
        }
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) {
            attributes.selected = true;
        } else {
            delete attributes.selected;
        }
    }
    if (tagName === "dialog" && n2.open) {
        attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!is2DCanvasBlank(n2)) {
                attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            }
        } else if (!("__context" in n2)) {
            const canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) {
                attributes.rr_dataURL = canvasDataURL;
            }
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!canvasService) {
            canvasService = doc.createElement("canvas");
            canvasCtx = canvasService.getContext("2d");
        }
        const image = n2;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                canvasService.width = image.naturalWidth;
                canvasService.height = image.naturalHeight;
                canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else {
                    console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
                }
            }
            if (image.crossOrigin === "anonymous") {
                priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
            }
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) {
            attributes.rr_scrollLeft = n2.scrollLeft;
        }
        if (n2.scrollTop) {
            attributes.rr_scrollTop = n2.scrollTop;
        }
    }
    if (needBlock) {
        const { width, height } = n2.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) {
            attributes.rr_src = attributes.src;
        }
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: NodeType$2.Element,
        tagName,
        attributes,
        childNodes: [],
        isSVG: isSVGElement(n2) || void 0,
        needBlock,
        rootId,
        isCustom: isCustomElement
    };
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) {
        return "";
    } else {
        return maybeAttr.toLowerCase();
    }
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$2.Comment) {
        return true;
    } else if (sn.type === NodeType$2.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && extractFileExtension(sn.attributes.href) === "js")) {
            return true;
        } else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) {
            return true;
        } else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) {
                return true;
            } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) {
                return true;
            } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) {
                return true;
            } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) {
                return true;
            }
        }
    }
    return false;
}
function serializeNodeWithId(n2, options) {
    const { doc, mirror: mirror2, blockClass, blockSelector, maskTextClass, maskTextSelector, skipChild = false, inlineStylesheet = true, maskInputOptions = {}, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5e3, onStylesheetLoad, stylesheetLoadTimeout = 5e3, keepIframeSrcFn = ()=>false, newlyAddedElement = false } = options;
    let { needsMask } = options;
    let { preserveWhiteSpace = true } = options;
    if (!needsMask) {
        const checkAncestors = needsMask === void 0;
        needsMask = needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = serializeNode(n2, {
        doc,
        mirror: mirror2,
        blockClass,
        blockSelector,
        needsMask,
        inlineStylesheet,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    let id;
    if (mirror2.hasNode(n2)) {
        id = mirror2.getId(n2);
    } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$2.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) {
        id = IGNORED_NODE;
    } else {
        id = genId();
    }
    const serializedNode = Object.assign(_serializedNode, {
        id
    });
    mirror2.add(n2, serializedNode);
    if (id === IGNORED_NODE) {
        return null;
    }
    if (onSerialize) {
        onSerialize(n2);
    }
    let recordChild = !skipChild;
    if (serializedNode.type === NodeType$2.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRootEl = index$1.shadowRoot(n2);
        if (shadowRootEl && isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$2.Document || serializedNode.type === NodeType$2.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$2.Element && serializedNode.tagName === "head") {
            preserveWhiteSpace = false;
        }
        const bypassOptions = {
            doc,
            mirror: mirror2,
            blockClass,
            blockSelector,
            needsMask,
            maskTextClass,
            maskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn
        };
        if (serializedNode.type === NodeType$2.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            for (const childN of Array.from(index$1.childNodes(n2))){
                const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
        let shadowRootEl = null;
        if (isElement(n2) && (shadowRootEl = index$1.shadowRoot(n2))) {
            for (const childN of Array.from(index$1.childNodes(shadowRootEl))){
                const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    isNativeShadowDom(shadowRootEl) && (serializedChildNode.isShadow = true);
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    const parent = index$1.parentNode(n2);
    if (parent && isShadowRoot(parent) && isNativeShadowDom(parent)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === NodeType$2.Element && serializedNode.tagName === "iframe") {
        onceIframeLoaded(n2, ()=>{
            const iframeDoc = n2.contentDocument;
            if (iframeDoc && onIframeLoad) {
                const serializedIframeNode = serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    mirror: mirror2,
                    blockClass,
                    blockSelector,
                    needsMask,
                    maskTextClass,
                    maskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn
                });
                if (serializedIframeNode) {
                    onIframeLoad(n2, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    if (serializedNode.type === NodeType$2.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && extractFileExtension(serializedNode.attributes.href) === "css")) {
        onceStylesheetLoaded(n2, ()=>{
            if (onStylesheetLoad) {
                const serializedLinkNode = serializeNodeWithId(n2, {
                    doc,
                    mirror: mirror2,
                    blockClass,
                    blockSelector,
                    needsMask,
                    maskTextClass,
                    maskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn
                });
                if (serializedLinkNode) {
                    onStylesheetLoad(n2, serializedLinkNode);
                }
            }
        }, stylesheetLoadTimeout);
    }
    return serializedNode;
}
function snapshot(n2, options) {
    const { mirror: mirror2 = new Mirror(), blockClass = "rr-block", blockSelector = null, maskTextClass = "rr-mask", maskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskAllInputs = false, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, onStylesheetLoad, stylesheetLoadTimeout, keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass,
        blockSelector,
        maskTextClass,
        maskTextSelector,
        skipChild: false,
        inlineStylesheet,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        slimDOMOptions,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        preserveWhiteSpace,
        onSerialize,
        onIframeLoad,
        iframeLoadTimeout,
        onStylesheetLoad,
        stylesheetLoadTimeout,
        keepIframeSrcFn,
        newlyAddedElement: false
    });
}
const MEDIA_SELECTOR = /(max|min)-device-(width|height)/;
const MEDIA_SELECTOR_GLOBAL = new RegExp(MEDIA_SELECTOR.source, "g");
const mediaSelectorPlugin = {
    postcssPlugin: "postcss-custom-selectors",
    prepare () {
        return {
            postcssPlugin: "postcss-custom-selectors",
            AtRule: function(atrule) {
                if (atrule.params.match(MEDIA_SELECTOR_GLOBAL)) {
                    atrule.params = atrule.params.replace(MEDIA_SELECTOR_GLOBAL, "$1-$2");
                }
            }
        };
    }
};
const pseudoClassPlugin = {
    postcssPlugin: "postcss-hover-classes",
    prepare: function() {
        const fixed = [];
        return {
            Rule: function(rule2) {
                if (fixed.indexOf(rule2) !== -1) {
                    return;
                }
                fixed.push(rule2);
                rule2.selectors.forEach(function(selector) {
                    if (!selector.includes(":")) {
                        return;
                    }
                    const selectorParts = selector.replace(/\n/g, " ").split(" ");
                    const pseudoedSelectorParts = [];
                    selectorParts.forEach(function(selectorPart) {
                        const pseudos = selectorPart.match(/::?([^:]+)/g);
                        if (!pseudos) {
                            pseudoedSelectorParts.push(selectorPart);
                            return;
                        }
                        const baseSelector = selectorPart.substr(0, selectorPart.length - pseudos.join("").length);
                        const classPseudos = pseudos.map(function(pseudo) {
                            const pseudoToCheck = pseudo.replace(/\(.*/g, "");
                            if (pseudoToCheck !== ":hover") {
                                return pseudo;
                            }
                            if (pseudo.match(/^::/)) {
                                return pseudo;
                            }
                            pseudo = pseudo.substr(1);
                            pseudo = pseudo.replace(/\(/g, "\\(");
                            pseudo = pseudo.replace(/\)/g, "\\)");
                            return ".\\:" + pseudo;
                        });
                        pseudoedSelectorParts.push(baseSelector + classPseudos.join(""));
                    });
                    addSelector(pseudoedSelectorParts.join(" "));
                    function addSelector(newSelector) {
                        if (newSelector && newSelector !== selector) {
                            rule2.selector += ",\n" + newSelector;
                        }
                    }
                });
            }
        };
    }
};
function getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if (this instanceof a22) {
                return Reflect.construct(f2, arguments, this.constructor);
            }
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n2[k];
            }
        });
    });
    return a2;
}
var picocolors_browser$1 = {
    exports: {}
};
var x$1 = String;
var create$1 = function() {
    return {
        isColorSupported: false,
        reset: x$1,
        bold: x$1,
        dim: x$1,
        italic: x$1,
        underline: x$1,
        inverse: x$1,
        hidden: x$1,
        strikethrough: x$1,
        black: x$1,
        red: x$1,
        green: x$1,
        yellow: x$1,
        blue: x$1,
        magenta: x$1,
        cyan: x$1,
        white: x$1,
        gray: x$1,
        bgBlack: x$1,
        bgRed: x$1,
        bgGreen: x$1,
        bgYellow: x$1,
        bgBlue: x$1,
        bgMagenta: x$1,
        bgCyan: x$1,
        bgWhite: x$1
    };
};
picocolors_browser$1.exports = create$1();
picocolors_browser$1.exports.createColors = create$1;
var picocolors_browserExports$1 = picocolors_browser$1.exports;
const __viteBrowserExternal$2 = {};
const __viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: __viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$2$1 = /* @__PURE__ */ getAugmentedNamespace$1(__viteBrowserExternal$1$1);
let pico$1 = picocolors_browserExports$1;
let terminalHighlight$1$1 = require$$2$1;
let CssSyntaxError$3$1 = class CssSyntaxError extends Error {
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") {
            this.message += ":" + this.line + ":" + this.column;
        }
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = pico$1.isColorSupported;
        if (terminalHighlight$1$1) {
            if (color) css = terminalHighlight$1$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold, gray, red } = pico$1.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else {
            mark = aside = (str)=>str;
        }
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) {
            code = "\n\n" + code + "\n";
        }
        return this.name + ": " + this.message + code;
    }
    constructor(message, line, column, source, file, plugin22){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) {
            this.file = file;
        }
        if (source) {
            this.source = source;
        }
        if (plugin22) {
            this.plugin = plugin22;
        }
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CssSyntaxError);
        }
    }
};
var cssSyntaxError$1 = CssSyntaxError$3$1;
CssSyntaxError$3$1.default = CssSyntaxError$3$1;
var symbols$1 = {};
symbols$1.isClean = Symbol("isClean");
symbols$1.my = Symbol("my");
const DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let Stringifier$2$1 = class Stringifier {
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") {
            name += node2.raws.afterName;
        } else if (params) {
            name += " ";
        }
        if (node2.nodes) {
            this.block(node2, name + params);
        } else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (node2.type === "comment") {
            value = this.raw(node2, null, "beforeComment");
        } else if (detect === "before") {
            value = this.raw(node2, null, "beforeRule");
        } else {
            value = this.raw(node2, null, "beforeClose");
        }
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) {
                for(let step = 0; step < depth; step++)value += indent;
            }
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else {
            after = this.raw(node2, "after", "emptyBody");
        }
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i2 = 0; i2 < node2.nodes.length; i2++){
            let child = node2.nodes[i2];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) {
            string += node2.raws.important || " !important";
        }
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) {
                return "";
            }
            if (parent && parent.type === "document") {
                return "";
            }
        }
        if (!parent) return DEFAULT_RAW$1[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") {
            return root2.rawCache[detect];
        }
        if (detect === "before" || detect === "after") {
            return this.beforeAfter(node2, detect);
        } else {
            let method = "raw" + capitalize$1(detect);
            if (this[method]) {
                value = this[method](root2, node2);
            } else {
                root2.walk((i2)=>{
                    value = i2.raws[own];
                    if (typeof value !== "undefined") return false;
                });
            }
        }
        if (typeof value === "undefined") value = DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeRule");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i2)=>{
            let p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    let parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) {
            return raw.raw;
        }
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) {
            this.builder(node2.raws.ownSemicolon, node2, "end");
        }
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) {
            throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        }
        this[node2.type](node2, semicolon);
    }
    constructor(builder){
        this.builder = builder;
    }
};
var stringifier$1 = Stringifier$2$1;
Stringifier$2$1.default = Stringifier$2$1;
let Stringifier$1$1 = stringifier$1;
function stringify$4$1(node2, builder) {
    let str = new Stringifier$1$1(builder);
    str.stringify(node2);
}
var stringify_1$1 = stringify$4$1;
stringify$4$1.default = stringify$4$1;
let { isClean: isClean$2$1, my: my$2$1 } = symbols$1;
let CssSyntaxError$2$1 = cssSyntaxError$1;
let Stringifier2$1 = stringifier$1;
let stringify$3$1 = stringify_1$1;
function cloneNode$1(obj, parent) {
    let cloned = new obj.constructor();
    for(let i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
            continue;
        }
        if (i2 === "proxyCache") continue;
        let value = obj[i2];
        let type = typeof value;
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") {
            cloned[i2] = value;
        } else if (Array.isArray(value)) {
            cloned[i2] = value.map((j)=>cloneNode$1(j, cloned));
        } else {
            if (type === "object" && value !== null) value = cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
let Node$4$1 = class Node2 {
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides){
            this[name] = overrides[name];
        }
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = cloneNode$1(this);
        for(let name in overrides){
            cloned[name] = overrides[name];
        }
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end, start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new CssSyntaxError$2$1(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    markDirty() {
        if (this[isClean$2$1]) {
            this[isClean$2$1] = false;
            let next = this;
            while(next = next.parent){
                next[isClean$2$1] = false;
            }
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) {
            pos = this.positionInside(opts.index, stringRepresentation);
        } else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i2 = 0; i2 < index2; i2++){
            if (string[i2] === "\n") {
                column = 1;
                line += 1;
            } else {
                column += 1;
            }
        }
        return {
            column,
            line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) {
                start = {
                    column: opts.start.column,
                    line: opts.start.line
                };
            } else if (opts.index) {
                start = this.positionInside(opts.index);
            }
            if (opts.end) {
                end = {
                    column: opts.end.column,
                    line: opts.end.line
                };
            } else if (typeof opts.endIndex === "number") {
                end = this.positionInside(opts.endIndex);
            } else if (opts.index) {
                end = this.positionInside(opts.index + 1);
            }
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) {
            end = {
                column: start.column + 1,
                line: start.line
            };
        }
        return {
            end,
            start
        };
    }
    raw(prop, defaultType) {
        let str = new Stringifier2$1();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) {
                    foundSelf = true;
                } else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else {
                    this.parent.insertBefore(bookmark, node2);
                }
            }
            if (!foundSelf) {
                this.remove();
            }
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document"){
            result2 = result2.parent;
        }
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) {
                continue;
            }
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) {
                fixed[name] = value.map((i2)=>{
                    if (typeof i2 === "object" && i2.toJSON) {
                        return i2.toJSON(null, inputs);
                    } else {
                        return i2;
                    }
                });
            } else if (typeof value === "object" && value.toJSON) {
                fixed[name] = value.toJSON(null, inputs);
            } else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId,
                    start: value.start
                };
            } else {
                fixed[name] = value;
            }
        }
        if (emitInputs) {
            fixed.inputs = [
                ...inputs.keys()
            ].map((input2)=>input2.toJSON());
        }
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) {
            this.proxyCache = new Proxy(this, this.getProxyProcessor());
        }
        return this.proxyCache;
    }
    toString(stringifier2 = stringify$3$1) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i2)=>{
            result2 += i2;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
    constructor(defaults = {}){
        this.raws = {};
        this[isClean$2$1] = false;
        this[my$2$1] = true;
        for(let name in defaults){
            if (name === "nodes") {
                this.nodes = [];
                for (let node2 of defaults[name]){
                    if (typeof node2.clone === "function") {
                        this.append(node2.clone());
                    } else {
                        this.append(node2);
                    }
                }
            } else {
                this[name] = defaults[name];
            }
        }
    }
};
var node$1 = Node$4$1;
Node$4$1.default = Node$4$1;
let Node$3$1 = node$1;
let Declaration$4$1 = class Declaration extends Node$3$1 {
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
            defaults = _extends({}, defaults, {
                value: String(defaults.value)
            });
        }
        super(defaults);
        this.type = "decl";
    }
};
var declaration$1 = Declaration$4$1;
Declaration$4$1.default = Declaration$4$1;
let urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let customAlphabet$1 = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i2 = size;
        while(i2--){
            id += alphabet[Math.random() * alphabet.length | 0];
        }
        return id;
    };
};
let nanoid$1$1 = (size = 21)=>{
    let id = "";
    let i2 = size;
    while(i2--){
        id += urlAlphabet$1[Math.random() * 64 | 0];
    }
    return id;
};
var nonSecure$1 = {
    nanoid: nanoid$1$1,
    customAlphabet: customAlphabet$1
};
let { SourceMapConsumer: SourceMapConsumer$2$1, SourceMapGenerator: SourceMapGenerator$2$1 } = require$$2$1;
let { existsSync: existsSync$1, readFileSync: readFileSync$1 } = require$$2$1;
let { dirname: dirname$1$1, join: join$1 } = require$$2$1;
function fromBase64$1(str) {
    if (Buffer) {
        return Buffer.from(str, "base64").toString();
    } else {
        return window.atob(str);
    }
}
let PreviousMap$2$1 = class PreviousMap {
    consumer() {
        if (!this.consumerCache) {
            this.consumerCache = new SourceMapConsumer$2$1(this.text);
        }
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) {
            return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        }
        if (baseCharsetUri.test(text) || baseUri.test(text)) {
            return fromBase64$1(text.substr(RegExp.lastMatch.length));
        }
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) {
            this.annotation = this.getAnnotationURL(css.substring(start, end));
        }
    }
    loadFile(path) {
        this.root = dirname$1$1(path);
        if (existsSync$1(path)) {
            this.mapFile = path;
            return readFileSync$1(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") {
                return prev;
            } else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) {
                        throw new Error("Unable to load previous source map: " + prevPath.toString());
                    }
                    return map;
                }
            } else if (prev instanceof SourceMapConsumer$2$1) {
                return SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            } else if (prev instanceof SourceMapGenerator$2$1) {
                return prev.toString();
            } else if (this.isMap(prev)) {
                return JSON.stringify(prev);
            } else {
                throw new Error("Unsupported previous source map format: " + prev.toString());
            }
        } else if (this.inline) {
            return this.decodeInline(this.annotation);
        } else if (this.annotation) {
            let map = this.annotation;
            if (file) map = join$1(dirname$1$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) {
            this.mapFile = opts.from;
        }
        if (this.mapFile) this.root = dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
};
var previousMap$1 = PreviousMap$2$1;
PreviousMap$2$1.default = PreviousMap$2$1;
let { SourceMapConsumer: SourceMapConsumer$1$1, SourceMapGenerator: SourceMapGenerator$1$1 } = require$$2$1;
let { fileURLToPath: fileURLToPath$1, pathToFileURL: pathToFileURL$1$1 } = require$$2$1;
let { isAbsolute: isAbsolute$1, resolve: resolve$1$1 } = require$$2$1;
let { nanoid: nanoid$2 } = nonSecure$1;
let terminalHighlight$2 = require$$2$1;
let CssSyntaxError$1$1 = cssSyntaxError$1;
let PreviousMap$1$1 = previousMap$1;
let fromOffsetCache$1 = Symbol("fromOffsetCache");
let sourceMapAvailable$1$1 = Boolean(SourceMapConsumer$1$1 && SourceMapGenerator$1$1);
let pathAvailable$1$1 = Boolean(resolve$1$1 && isAbsolute$1);
let Input$4$1 = class Input {
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) {
            result2 = new CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
                column: origin.column,
                line: origin.line
            }, origin.endLine === void 0 ? origin.column : {
                column: origin.endColumn,
                line: origin.endLine
            }, origin.source, origin.file, opts.plugin);
        } else {
            result2 = new CssSyntaxError$1$1(message, endLine === void 0 ? line : {
                column,
                line
            }, endLine === void 0 ? column : {
                column: endColumn,
                line: endLine
            }, this.css, this.file, opts.plugin);
        }
        result2.input = {
            column,
            endColumn,
            endLine,
            line,
            source: this.css
        };
        if (this.file) {
            if (pathToFileURL$1$1) {
                result2.input.url = pathToFileURL$1$1(this.file).toString();
            }
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[fromOffsetCache$1]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[fromOffsetCache$1] = lineToIndex;
        } else {
            lineToIndex = this[fromOffsetCache$1];
        }
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) {
            min = lineToIndex.length - 1;
        } else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) {
                    max = mid - 1;
                } else if (offset >= lineToIndex[mid + 1]) {
                    min = mid + 1;
                } else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) {
            return file;
        }
        return resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column,
            line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") {
            to = consumer.originalPositionFor({
                column: endColumn,
                line: endLine
            });
        }
        let fromUrl;
        if (isAbsolute$1(from.source)) {
            fromUrl = pathToFileURL$1$1(from.source);
        } else {
            fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL$1$1(this.map.mapFile));
        }
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if (fileURLToPath$1) {
                result2.file = fileURLToPath$1(fromUrl);
            } else {
                throw new Error(`file: protocol is not available in this PostCSS build`);
            }
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ]){
            if (this[name] != null) {
                json[name] = this[name];
            }
        }
        if (this.map) {
            json.map = _extends({}, this.map);
            if (json.map.consumerCache) {
                json.map.consumerCache = void 0;
            }
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
            throw new Error(`PostCSS received ${css} instead of CSS string`);
        }
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else {
            this.hasBOM = false;
        }
        if (opts.from) {
            if (!pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || isAbsolute$1(opts.from)) {
                this.file = opts.from;
            } else {
                this.file = resolve$1$1(opts.from);
            }
        }
        if (pathAvailable$1$1 && sourceMapAvailable$1$1) {
            let map = new PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) {
            this.id = "<input css " + nanoid$2(6) + ">";
        }
        if (this.map) this.map.file = this.from;
    }
};
var input$1 = Input$4$1;
Input$4$1.default = Input$4$1;
if (terminalHighlight$2 && terminalHighlight$2.registerInput) {
    terminalHighlight$2.registerInput(Input$4$1);
}
let { SourceMapConsumer: SourceMapConsumer$3, SourceMapGenerator: SourceMapGenerator$3 } = require$$2$1;
let { dirname: dirname$2, relative: relative$1, resolve: resolve$2, sep: sep$1 } = require$$2$1;
let { pathToFileURL: pathToFileURL$2 } = require$$2$1;
let Input$3$1 = input$1;
let sourceMapAvailable$2 = Boolean(SourceMapConsumer$3 && SourceMapGenerator$3);
let pathAvailable$2 = Boolean(dirname$2 && resolve$2 && relative$1 && sep$1);
let MapGenerator$2$1 = class MapGenerator {
    addAnnotation() {
        let content;
        if (this.isInline()) {
            content = "data:application/json;base64," + this.toBase64(this.map.toString());
        } else if (typeof this.mapOpts.annotation === "string") {
            content = this.mapOpts.annotation;
        } else if (typeof this.mapOpts.annotation === "function") {
            content = this.mapOpts.annotation(this.opts.to, this.root);
        } else {
            content = this.outputFile() + ".map";
        }
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || dirname$2(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) {
                    map.sourcesContent = null;
                }
            } else {
                map = prev.consumer();
            }
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) {
                    this.root.removeChild(i2);
                }
            }
        } else if (this.css) {
            this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
        }
    }
    generate() {
        this.clearAnnotation();
        if (pathAvailable$2 && sourceMapAvailable$2 && this.isMap()) {
            return this.generateMap();
        } else {
            let result2 = "";
            this.stringify(this.root, (i2)=>{
                result2 += i2;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) {
            this.generateString();
        } else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) {
            return [
                this.css
            ];
        } else {
            return [
                this.css,
                this.map
            ];
        }
    }
    generateString() {
        this.css = "";
        this.map = new SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else {
                column += str.length;
            }
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) {
            return true;
        }
        if (typeof this.mapOpts.annotation !== "undefined") {
            return this.mapOpts.annotation;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.annotation);
        }
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") {
            return this.mapOpts.inline;
        }
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) {
            return false;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.inline);
        }
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") {
            return !!this.opts.map;
        }
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") {
            return this.mapOpts.sourcesContent;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.withContent());
        }
        return true;
    }
    outputFile() {
        if (this.opts.to) {
            return this.path(this.opts.to);
        } else if (this.opts.from) {
            return this.path(this.opts.from);
        } else {
            return "to.css";
        }
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") {
            from = dirname$2(resolve$2(from, this.mapOpts.annotation));
        }
        let path = relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) {
                this.root.walk((node2)=>{
                    if (node2.source && node2.source.input.map) {
                        let map = node2.source.input.map;
                        if (!this.previousMaps.includes(map)) {
                            this.previousMaps.push(map);
                        }
                    }
                });
            } else {
                let input2 = new Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) {
            this.root.walk((node2)=>{
                if (node2.source) {
                    let from = node2.source.input.from;
                    if (from && !already[from]) {
                        already[from] = true;
                        let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                        this.map.setSourceContent(fromUrl, node2.source.input.css);
                    }
                }
            });
        } else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) {
            return this.toUrl(this.mapOpts.from);
        } else if (this.usesFileUrls) {
            return this.toFileUrl(node2.source.input.from);
        } else {
            return this.toUrl(this.path(node2.source.input.from));
        }
    }
    toBase64(str) {
        if (Buffer) {
            return Buffer.from(str).toString("base64");
        } else {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if (pathToFileURL$2) {
            let fileURL = pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else {
            throw new Error("`map.absolute` option is not available in this PostCSS build");
        }
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if (sep$1 === "\\") {
            path = path.replace(/\\/g, "/");
        }
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
};
var mapGenerator$1 = MapGenerator$2$1;
let Node$2$1 = node$1;
let Comment$4$1 = class Comment extends Node$2$1 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var comment$1 = Comment$4$1;
Comment$4$1.default = Comment$4$1;
let { isClean: isClean$1$1, my: my$1$1 } = symbols$1;
let Declaration$3$1 = declaration$1;
let Comment$3$1 = comment$1;
let Node$1$1 = node$1;
let parse$4$1, Rule$4$1, AtRule$4$1, Root$6$1;
function cleanSource$1(nodes) {
    return nodes.map((i2)=>{
        if (i2.nodes) i2.nodes = cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function markDirtyUp$1(node2) {
    node2[isClean$1$1] = false;
    if (node2.proxyOf.nodes) {
        for (let i2 of node2.proxyOf.nodes){
            markDirtyUp$1(i2);
        }
    }
}
let Container$7$1 = class Container extends Node$1$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) {
            for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
        }
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (!node2[prop]) {
                    return node2[prop];
                } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
                    return (...args)=>{
                        return node2[prop](...args.map((i2)=>{
                            if (typeof i2 === "function") {
                                return (child, index2)=>i2(child.toProxy(), index2);
                            } else {
                                return i2;
                            }
                        }));
                    };
                } else if (prop === "every" || prop === "some") {
                    return (cb)=>{
                        return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                    };
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else if (prop === "nodes") {
                    return node2.nodes.map((i2)=>i2.toProxy());
                } else if (prop === "first" || prop === "last") {
                    return node2[prop].toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") {
            nodes = cleanSource$1(parse$4$1(nodes).nodes);
        } else if (typeof nodes === "undefined") {
            nodes = [];
        } else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i2 of nodes){
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i2 of nodes){
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type) {
            nodes = [
                nodes
            ];
        } else if (nodes.prop) {
            if (typeof nodes.value === "undefined") {
                throw new Error("Value field is missed in node creation");
            } else if (typeof nodes.value !== "string") {
                nodes.value = String(nodes.value);
            }
            nodes = [
                new Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) {
            nodes = [
                new Rule$4$1(nodes)
            ];
        } else if (nodes.name) {
            nodes = [
                new AtRule$4$1(nodes)
            ];
        } else if (nodes.text) {
            nodes = [
                new Comment$3$1(nodes)
            ];
        } else {
            throw new Error("Unknown node type in node creation");
        }
        let processed = nodes.map((i2)=>{
            if (!i2[my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[isClean$1$1]) markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") {
                    i2.raws.before = sample.raws.before.replace(/\S/g, "");
                }
            }
            i2.parent = this.proxyOf;
            return i2;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes){
                this.indexes[id] = this.indexes[id] + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) {
                this.indexes[id] = index2 - 1;
            }
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i2)=>{
            let result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) {
                result2 = child.walk(callback);
            }
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i2)=>{
                if (child.type === "atrule") {
                    return callback(child, i2);
                }
            });
        }
        if (name instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "atrule" && name.test(child.name)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "atrule" && child.name === name) {
                return callback(child, i2);
            }
        });
    }
    walkComments(callback) {
        return this.walk((child, i2)=>{
            if (child.type === "comment") {
                return callback(child, i2);
            }
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i2)=>{
                if (child.type === "decl") {
                    return callback(child, i2);
                }
            });
        }
        if (prop instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "decl" && prop.test(child.prop)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "decl" && child.prop === prop) {
                return callback(child, i2);
            }
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i2)=>{
                if (child.type === "rule") {
                    return callback(child, i2);
                }
            });
        }
        if (selector instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "rule" && selector.test(child.selector)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "rule" && child.selector === selector) {
                return callback(child, i2);
            }
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
Container$7$1.registerParse = (dependant)=>{
    parse$4$1 = dependant;
};
Container$7$1.registerRule = (dependant)=>{
    Rule$4$1 = dependant;
};
Container$7$1.registerAtRule = (dependant)=>{
    AtRule$4$1 = dependant;
};
Container$7$1.registerRoot = (dependant)=>{
    Root$6$1 = dependant;
};
var container$1 = Container$7$1;
Container$7$1.default = Container$7$1;
Container$7$1.rebuild = (node2)=>{
    if (node2.type === "atrule") {
        Object.setPrototypeOf(node2, AtRule$4$1.prototype);
    } else if (node2.type === "rule") {
        Object.setPrototypeOf(node2, Rule$4$1.prototype);
    } else if (node2.type === "decl") {
        Object.setPrototypeOf(node2, Declaration$3$1.prototype);
    } else if (node2.type === "comment") {
        Object.setPrototypeOf(node2, Comment$3$1.prototype);
    } else if (node2.type === "root") {
        Object.setPrototypeOf(node2, Root$6$1.prototype);
    }
    node2[my$1$1] = true;
    if (node2.nodes) {
        node2.nodes.forEach((child)=>{
            Container$7$1.rebuild(child);
        });
    }
};
let Container$6$1 = container$1;
let LazyResult$4$1, Processor$3$1;
let Document$3$1 = class Document2 extends Container$6$1 {
    toResult(opts = {}) {
        let lazy = new LazyResult$4$1(new Processor$3$1(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(_extends({
            type: "document"
        }, defaults));
        if (!this.nodes) {
            this.nodes = [];
        }
    }
};
Document$3$1.registerLazyResult = (dependant)=>{
    LazyResult$4$1 = dependant;
};
Document$3$1.registerProcessor = (dependant)=>{
    Processor$3$1 = dependant;
};
var document$1$1 = Document$3$1;
Document$3$1.default = Document$3$1;
let printed$1 = {};
var warnOnce$2$1 = function warnOnce(message) {
    if (printed$1[message]) return;
    printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) {
        console.warn(message);
    }
};
let Warning$2$1 = class Warning {
    toString() {
        if (this.node) {
            return this.node.error(this.text, {
                index: this.index,
                plugin: this.plugin,
                word: this.word
            }).message;
        }
        if (this.plugin) {
            return this.plugin + ": " + this.text;
        }
        return this.text;
    }
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
};
var warning$1 = Warning$2$1;
Warning$2$1.default = Warning$2$1;
let Warning$1$1 = warning$1;
let Result$3$1 = class Result {
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
                opts.plugin = this.lastPlugin.postcssPlugin;
            }
        }
        let warning2 = new Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i2)=>i2.type === "warning");
    }
    get content() {
        return this.css;
    }
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
};
var result$1 = Result$3$1;
Result$3$1.default = Result$3$1;
const SINGLE_QUOTE$1 = "'".charCodeAt(0);
const DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
const BACKSLASH$1 = "\\".charCodeAt(0);
const SLASH$1 = "/".charCodeAt(0);
const NEWLINE$1 = "\n".charCodeAt(0);
const SPACE$1 = " ".charCodeAt(0);
const FEED$1 = "\f".charCodeAt(0);
const TAB$1 = "	".charCodeAt(0);
const CR$1 = "\r".charCodeAt(0);
const OPEN_SQUARE$1 = "[".charCodeAt(0);
const CLOSE_SQUARE$1 = "]".charCodeAt(0);
const OPEN_PARENTHESES$1 = "(".charCodeAt(0);
const CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
const OPEN_CURLY$1 = "{".charCodeAt(0);
const CLOSE_CURLY$1 = "}".charCodeAt(0);
const SEMICOLON$1 = ";".charCodeAt(0);
const ASTERISK$1 = "*".charCodeAt(0);
const COLON$1 = ":".charCodeAt(0);
const AT$1 = "@".charCodeAt(0);
const RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
const RE_HEX_ESCAPE$1 = /[\da-f]/i;
var tokenize$1 = function tokenizer(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n2, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case NEWLINE$1:
            case SPACE$1:
            case TAB$1:
            case CR$1:
            case FEED$1:
                {
                    next = pos;
                    do {
                        next += 1;
                        code = css.charCodeAt(next);
                    }while (code === SPACE$1 || code === NEWLINE$1 || code === TAB$1 || code === CR$1 || code === FEED$1)
                    currentToken = [
                        "space",
                        css.slice(pos, next)
                    ];
                    pos = next - 1;
                    break;
                }
            case OPEN_SQUARE$1:
            case CLOSE_SQUARE$1:
            case OPEN_CURLY$1:
            case CLOSE_CURLY$1:
            case COLON$1:
            case SEMICOLON$1:
            case CLOSE_PARENTHESES$1:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case OPEN_PARENTHESES$1:
                {
                    prev = buffer.length ? buffer.pop()[1] : "";
                    n2 = css.charCodeAt(pos + 1);
                    if (prev === "url" && n2 !== SINGLE_QUOTE$1 && n2 !== DOUBLE_QUOTE$1 && n2 !== SPACE$1 && n2 !== NEWLINE$1 && n2 !== TAB$1 && n2 !== FEED$1 && n2 !== CR$1) {
                        next = pos;
                        do {
                            escaped = false;
                            next = css.indexOf(")", next + 1);
                            if (next === -1) {
                                if (ignore || ignoreUnclosed) {
                                    next = pos;
                                    break;
                                } else {
                                    unclosed("bracket");
                                }
                            }
                            escapePos = next;
                            while(css.charCodeAt(escapePos - 1) === BACKSLASH$1){
                                escapePos -= 1;
                                escaped = !escaped;
                            }
                        }while (escaped)
                        currentToken = [
                            "brackets",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        next = css.indexOf(")", pos + 1);
                        content = css.slice(pos, next + 1);
                        if (next === -1 || RE_BAD_BRACKET$1.test(content)) {
                            currentToken = [
                                "(",
                                "(",
                                pos
                            ];
                        } else {
                            currentToken = [
                                "brackets",
                                content,
                                pos,
                                next
                            ];
                            pos = next;
                        }
                    }
                    break;
                }
            case SINGLE_QUOTE$1:
            case DOUBLE_QUOTE$1:
                {
                    quote = code === SINGLE_QUOTE$1 ? "'" : '"';
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(quote, next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos + 1;
                                break;
                            } else {
                                unclosed("string");
                            }
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped)
                    currentToken = [
                        "string",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case AT$1:
                {
                    RE_AT_END$1.lastIndex = pos + 1;
                    RE_AT_END$1.test(css);
                    if (RE_AT_END$1.lastIndex === 0) {
                        next = css.length - 1;
                    } else {
                        next = RE_AT_END$1.lastIndex - 2;
                    }
                    currentToken = [
                        "at-word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case BACKSLASH$1:
                {
                    next = pos;
                    escape = true;
                    while(css.charCodeAt(next + 1) === BACKSLASH$1){
                        next += 1;
                        escape = !escape;
                    }
                    code = css.charCodeAt(next + 1);
                    if (escape && code !== SLASH$1 && code !== SPACE$1 && code !== NEWLINE$1 && code !== TAB$1 && code !== CR$1 && code !== FEED$1) {
                        next += 1;
                        if (RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                            while(RE_HEX_ESCAPE$1.test(css.charAt(next + 1))){
                                next += 1;
                            }
                            if (css.charCodeAt(next + 1) === SPACE$1) {
                                next += 1;
                            }
                        }
                    }
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            default:
                {
                    if (code === SLASH$1 && css.charCodeAt(pos + 1) === ASTERISK$1) {
                        next = css.indexOf("*/", pos + 2) + 1;
                        if (next === 0) {
                            if (ignore || ignoreUnclosed) {
                                next = css.length;
                            } else {
                                unclosed("comment");
                            }
                        }
                        currentToken = [
                            "comment",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        RE_WORD_END$1.lastIndex = pos + 1;
                        RE_WORD_END$1.test(css);
                        if (RE_WORD_END$1.lastIndex === 0) {
                            next = css.length - 1;
                        } else {
                            next = RE_WORD_END$1.lastIndex - 2;
                        }
                        currentToken = [
                            "word",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        buffer.push(currentToken);
                        pos = next;
                    }
                    break;
                }
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back,
        endOfFile,
        nextToken,
        position
    };
};
let Container$5$1 = container$1;
let AtRule$3$1 = class AtRule extends Container$5$1 {
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
};
var atRule$1 = AtRule$3$1;
AtRule$3$1.default = AtRule$3$1;
Container$5$1.registerAtRule(AtRule$3$1);
let Container$4$1 = container$1;
let LazyResult$3$1, Processor$2$1;
let Root$5$1 = class Root extends Container$4$1 {
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) {
                    sample.raws.before = this.nodes[1].raws.before;
                } else {
                    delete sample.raws.before;
                }
            } else if (this.first !== sample) {
                for (let node2 of nodes){
                    node2.raws.before = sample.raws.before;
                }
            }
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) {
            this.nodes[1].raws.before = this.nodes[index2].raws.before;
        }
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new LazyResult$3$1(new Processor$2$1(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
};
Root$5$1.registerLazyResult = (dependant)=>{
    LazyResult$3$1 = dependant;
};
Root$5$1.registerProcessor = (dependant)=>{
    Processor$2$1 = dependant;
};
var root$1 = Root$5$1;
Root$5$1.default = Root$5$1;
Container$4$1.registerRoot(Root$5$1);
let list$2$1 = {
    comma (string) {
        return list$2$1.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return list$2$1.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) {
                escape = false;
            } else if (letter === "\\") {
                escape = true;
            } else if (inQuote) {
                if (letter === prevQuote) {
                    inQuote = false;
                }
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") {
                func += 1;
            } else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else {
                current += letter;
            }
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var list_1$1 = list$2$1;
list$2$1.default = list$2$1;
let Container$3$1 = container$1;
let list$1$1 = list_1$1;
let Rule$3$1 = class Rule extends Container$3$1 {
    get selectors() {
        return list$1$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
};
var rule$1 = Rule$3$1;
Rule$3$1.default = Rule$3$1;
Container$3$1.registerRule(Rule$3$1);
let Declaration$2$1 = declaration$1;
let tokenizer2$1 = tokenize$1;
let Comment$2$1 = comment$1;
let AtRule$2$1 = atRule$1;
let Root$4$1 = root$1;
let Rule$2$1 = rule$1;
const SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function findLastWithPosition$1(tokens) {
    for(let i2 = tokens.length - 1; i2 >= 0; i2--){
        let token = tokens[i2];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let Parser$1$1 = class Parser {
    atrule(token) {
        let node2 = new AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") {
            this.unnamedAtrule(node2, token);
        }
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") {
                brackets.push(type === "(" ? ")" : "]");
            } else if (type === "{" && brackets.length > 0) {
                brackets.push("}");
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
            }
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space"){
                            prev = params[--shift];
                        }
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else {
                    params.push(token);
                }
            } else {
                params.push(token);
            }
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i2, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") {
                brackets += 1;
            }
            if (type === ")") {
                brackets -= 1;
            }
            if (brackets === 0 && type === ":") {
                if (!prev) {
                    this.doubleColon(token);
                } else if (prev[0] === "word" && prev[1] === "progid") {
                    continue;
                } else {
                    return i2;
                }
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = tokenizer2$1(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new Declaration$2$1();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") {
                break;
            }
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) {
                    this.unknownWord([
                        token
                    ]);
                }
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i2; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") {
                        break;
                    }
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") {
                break;
            }
        }
        let hasWord = tokens.some((i2)=>i2[0] !== "space" && i2[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i2)=>i2[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) {
            this.checkMissedSemicolon(tokens);
        }
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else {
            this.unexpectedClose(token);
        }
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else {
                        break;
                    }
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") {
                    colon = true;
                }
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) {
                while(tokens.length){
                    token = tokens[tokens.length - 1][0];
                    if (token !== "space" && token !== "comment") break;
                    this.tokenizer.back(tokens.pop());
                }
            }
            this.decl(tokens, customProperty);
        } else {
            this.unknownWord(tokens);
        }
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) {
                clean = false;
            } else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!SAFE_COMMENT_NEIGHBOR$1[prev] && !SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") {
                        clean = false;
                    } else {
                        value += token[1];
                    }
                } else {
                    clean = false;
                }
            } else {
                value += token[1];
            }
        }
        if (!clean) {
            let raw = tokens.reduce((all, i2)=>all + i2[1], "");
            node2.raws[prop] = {
                raw,
                value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i2 = from; i2 < tokens.length; i2++){
            result2 += tokens[i2][1];
        }
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    constructor(input2){
        this.input = input2;
        this.root = new Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
};
var parser$1 = Parser$1$1;
let Container$2$1 = container$1;
let Parser2$1 = parser$1;
let Input$2$1 = input$1;
function parse$3$1(css, opts) {
    let input2 = new Input$2$1(css, opts);
    let parser2 = new Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        if (false) {}
        throw e2;
    }
    return parser2.root;
}
var parse_1$1 = parse$3$1;
parse$3$1.default = parse$3$1;
Container$2$1.registerParse(parse$3$1);
let { isClean: isClean$3, my: my$3 } = symbols$1;
let MapGenerator$1$1 = mapGenerator$1;
let stringify$2$1 = stringify_1$1;
let Container$1$1 = container$1;
let Document$2$1 = document$1$1;
let warnOnce$1$1 = (/* unused pure expression or super */ null && (warnOnce$2$1));
let Result$2$1 = result$1;
let parse$2$1 = parse_1$1;
let Root$3$1 = root$1;
const TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const CHILDREN$1 = 0;
function isPromise$1(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function getEvents$1(node2) {
    let key = false;
    let type = TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") {
        key = node2.prop.toLowerCase();
    } else if (node2.type === "atrule") {
        key = node2.name.toLowerCase();
    }
    if (key && node2.append) {
        return [
            type,
            type + "-" + key,
            CHILDREN$1,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (key) {
        return [
            type,
            type + "-" + key,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (node2.append) {
        return [
            type,
            CHILDREN$1,
            type + "Exit"
        ];
    } else {
        return [
            type,
            type + "Exit"
        ];
    }
}
function toStack$1(node2) {
    let events;
    if (node2.type === "document") {
        events = [
            "Document",
            CHILDREN$1,
            "DocumentExit"
        ];
    } else if (node2.type === "root") {
        events = [
            "Root",
            CHILDREN$1,
            "RootExit"
        ];
    } else {
        events = getEvents$1(node2);
    }
    return {
        eventIndex: 0,
        events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function cleanMarks$1(node2) {
    node2[isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach((i2)=>cleanMarks$1(i2));
    return node2;
}
let postcss$2$1 = {};
let LazyResult$2$1 = class LazyResult {
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) {
            this.processing = this.runAsync();
        }
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) {
                if (false) {}
            }
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin22, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for (let plugin22 of this.plugins){
            if (typeof plugin22 === "object") {
                for(let event in plugin22){
                    if (!PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) {
                        throw new Error(`Unknown event ${event} in ${plugin22.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                    }
                    if (!NOT_VISITORS$1[event]) {
                        if (typeof plugin22[event] === "object") {
                            for(let filter in plugin22[event]){
                                if (filter === "*") {
                                    add(plugin22, event, plugin22[event][filter]);
                                } else {
                                    add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                                }
                            }
                        } else if (typeof plugin22[event] === "function") {
                            add(plugin22, event, plugin22[event]);
                        }
                    }
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    runAsync() {
        var _this = this;
        return _async_to_generator(function*() {
            _this.plugin = 0;
            for(let i2 = 0; i2 < _this.plugins.length; i2++){
                let plugin22 = _this.plugins[i2];
                let promise = _this.runOnRoot(plugin22);
                if (isPromise$1(promise)) {
                    try {
                        yield promise;
                    } catch (error) {
                        throw _this.handleError(error);
                    }
                }
            }
            _this.prepareVisitors();
            if (_this.hasListener) {
                let root2 = _this.result.root;
                while(!root2[isClean$3]){
                    root2[isClean$3] = true;
                    let stack = [
                        toStack$1(root2)
                    ];
                    while(stack.length > 0){
                        let promise = _this.visitTick(stack);
                        if (isPromise$1(promise)) {
                            try {
                                yield promise;
                            } catch (e2) {
                                let node2 = stack[stack.length - 1].node;
                                throw _this.handleError(e2, node2);
                            }
                        }
                    }
                }
                if (_this.listeners.OnceExit) {
                    for (let [plugin22, visitor] of _this.listeners.OnceExit){
                        _this.result.lastPlugin = plugin22;
                        try {
                            if (root2.type === "document") {
                                let roots = root2.nodes.map((subRoot)=>visitor(subRoot, _this.helpers));
                                yield Promise.all(roots);
                            } else {
                                yield visitor(root2, _this.helpers);
                            }
                        } catch (e2) {
                            throw _this.handleError(e2);
                        }
                    }
                }
            }
            _this.processed = true;
            return _this.stringify();
        })();
    }
    runOnRoot(plugin22) {
        this.result.lastPlugin = plugin22;
        try {
            if (typeof plugin22 === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin22.Once(root2, this.helpers));
                    if (isPromise$1(roots[0])) {
                        return Promise.all(roots);
                    }
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") {
                return plugin22(this.result.root, this.result);
            }
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new MapGenerator$1$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) {
            throw this.getAsyncError();
        }
        for (let plugin22 of this.plugins){
            let promise = this.runOnRoot(plugin22);
            if (isPromise$1(promise)) {
                throw this.getAsyncError();
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[isClean$3]){
                root2[isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") {
                    for (let subRoot of root2.nodes){
                        this.visitSync(this.listeners.OnceExit, subRoot);
                    }
                } else {
                    this.visitSync(this.listeners.OnceExit, root2);
                }
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin22, visitor] of visitors){
            this.result.lastPlugin = plugin22;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
                return true;
            }
            if (isPromise$1(promise)) {
                throw this.getAsyncError();
            }
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin22, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[isClean$3]) {
                    child[isClean$3] = true;
                    stack.push(toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[isClean$3] = true;
        let events = getEvents$1(node2);
        for (let event of events){
            if (event === CHILDREN$1) {
                if (node2.nodes) {
                    node2.each((child)=>{
                        if (!child[isClean$3]) this.walkSync(child);
                    });
                }
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
            root2 = cleanMarks$1(css);
        } else if (css instanceof LazyResult || css instanceof Result$2$1) {
            root2 = cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[my$3]) {
                Container$1$1.rebuild(root2);
            }
        }
        this.result = new Result$2$1(processor2, root2, opts);
        this.helpers = _extends({}, postcss$2$1, {
            postcss: postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map((plugin22)=>{
            if (typeof plugin22 === "object" && plugin22.prepare) {
                return _extends({}, plugin22, plugin22.prepare(this.result));
            } else {
                return plugin22;
            }
        });
    }
};
LazyResult$2$1.registerPostcss = (dependant)=>{
    postcss$2$1 = dependant;
};
var lazyResult$1 = LazyResult$2$1;
LazyResult$2$1.default = LazyResult$2$1;
Root$3$1.registerLazyResult(LazyResult$2$1);
Document$2$1.registerLazyResult(LazyResult$2$1);
let MapGenerator2$1 = mapGenerator$1;
let stringify$1$1 = stringify_1$1;
let warnOnce2$1 = (/* unused pure expression or super */ null && (warnOnce$2$1));
let parse$1$1 = parse_1$1;
const Result$1$1 = result$1;
let NoWorkResult$1$1 = class NoWorkResult {
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) {
            return this._root;
        }
        let root2;
        let parser2 = parse$1$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) {
            throw this.error;
        } else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = stringify$1$1;
        this.result = new Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) {
                this.result.css = generatedCSS;
            }
            if (generatedMap) {
                this.result.map = generatedMap;
            }
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
};
var noWorkResult$1 = NoWorkResult$1$1;
NoWorkResult$1$1.default = NoWorkResult$1$1;
let NoWorkResult2$1 = noWorkResult$1;
let LazyResult$1$1 = lazyResult$1;
let Document$1$1 = document$1$1;
let Root$2$1 = root$1;
let Processor$1$1 = class Processor {
    normalize(plugins) {
        let normalized = [];
        for (let i2 of plugins){
            if (i2.postcss === true) {
                i2 = i2();
            } else if (i2.postcss) {
                i2 = i2.postcss;
            }
            if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
                normalized = normalized.concat(i2.plugins);
            } else if (typeof i2 === "object" && i2.postcssPlugin) {
                normalized.push(i2);
            } else if (typeof i2 === "function") {
                normalized.push(i2);
            } else if (typeof i2 === "object" && (i2.parse || i2.stringify)) {
                if (false) {}
            } else {
                throw new Error(i2 + " is not a PostCSS plugin");
            }
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
            return new NoWorkResult2$1(this, css, opts);
        } else {
            return new LazyResult$1$1(this, css, opts);
        }
    }
    use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    }
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
};
var processor$1 = Processor$1$1;
Processor$1$1.default = Processor$1$1;
Root$2$1.registerProcessor(Processor$1$1);
Document$1$1.registerProcessor(Processor$1$1);
let Declaration$1$1 = declaration$1;
let PreviousMap2$1 = previousMap$1;
let Comment$1$1 = comment$1;
let AtRule$1$1 = atRule$1;
let Input$1$1 = input$1;
let Root$1$1 = root$1;
let Rule$1$1 = rule$1;
function fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n2)=>fromJSON$1$1(n2));
    let { inputs: ownInputs } = json, defaults = _object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = _extends({}, input2, {
                __proto__: Input$1$1.prototype
            });
            if (inputHydrated.map) {
                inputHydrated.map = _extends({}, inputHydrated.map, {
                    __proto__: PreviousMap2$1.prototype
                });
            }
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) {
        defaults.nodes = json.nodes.map((n2)=>fromJSON$1$1(n2, inputs));
    }
    if (defaults.source) {
        let _defaults_source = defaults.source, { inputId } = _defaults_source, source = _object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) {
            defaults.source.input = inputs[inputId];
        }
    }
    if (defaults.type === "root") {
        return new Root$1$1(defaults);
    } else if (defaults.type === "decl") {
        return new Declaration$1$1(defaults);
    } else if (defaults.type === "rule") {
        return new Rule$1$1(defaults);
    } else if (defaults.type === "comment") {
        return new Comment$1$1(defaults);
    } else if (defaults.type === "atrule") {
        return new AtRule$1$1(defaults);
    } else {
        throw new Error("Unknown node type: " + json.type);
    }
}
var fromJSON_1$1 = fromJSON$1$1;
fromJSON$1$1.default = fromJSON$1$1;
let CssSyntaxError2$1 = cssSyntaxError$1;
let Declaration2$1 = declaration$1;
let LazyResult2$1 = lazyResult$1;
let Container2$1 = container$1;
let Processor2$1 = processor$1;
let stringify$5 = stringify_1$1;
let fromJSON$2 = fromJSON_1$1;
let Document22 = document$1$1;
let Warning2$1 = warning$1;
let Comment2$1 = comment$1;
let AtRule2$1 = atRule$1;
let Result2$1 = result$1;
let Input2$1 = input$1;
let parse$5 = parse_1$1;
let list$3 = list_1$1;
let Rule2$1 = rule$1;
let Root2$1 = root$1;
let Node2$1 = node$1;
function postcss$3(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) {
        plugins = plugins[0];
    }
    return new Processor2$1(plugins);
}
postcss$3.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
            if ( true && "C.UTF-8".startsWith("cn")) {
                console.warn(name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226");
            }
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new Processor2$1().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
postcss$3.stringify = stringify$5;
postcss$3.parse = parse$5;
postcss$3.fromJSON = fromJSON$2;
postcss$3.list = list$3;
postcss$3.comment = (defaults)=>new Comment2$1(defaults);
postcss$3.atRule = (defaults)=>new AtRule2$1(defaults);
postcss$3.decl = (defaults)=>new Declaration2$1(defaults);
postcss$3.rule = (defaults)=>new Rule2$1(defaults);
postcss$3.root = (defaults)=>new Root2$1(defaults);
postcss$3.document = (defaults)=>new Document22(defaults);
postcss$3.CssSyntaxError = CssSyntaxError2$1;
postcss$3.Declaration = Declaration2$1;
postcss$3.Container = Container2$1;
postcss$3.Processor = Processor2$1;
postcss$3.Document = Document22;
postcss$3.Comment = Comment2$1;
postcss$3.Warning = Warning2$1;
postcss$3.AtRule = AtRule2$1;
postcss$3.Result = Result2$1;
postcss$3.Input = Input2$1;
postcss$3.Rule = Rule2$1;
postcss$3.Root = Root2$1;
postcss$3.Node = Node2$1;
LazyResult2$1.registerPostcss(postcss$3);
var postcss_1$1 = postcss$3;
postcss$3.default = postcss$3;
const postcss$1$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(postcss_1$1);
postcss$1$1.stringify;
postcss$1$1.fromJSON;
postcss$1$1.plugin;
postcss$1$1.parse;
postcss$1$1.list;
postcss$1$1.document;
postcss$1$1.comment;
postcss$1$1.atRule;
postcss$1$1.rule;
postcss$1$1.decl;
postcss$1$1.root;
postcss$1$1.CssSyntaxError;
postcss$1$1.Declaration;
postcss$1$1.Container;
postcss$1$1.Processor;
postcss$1$1.Document;
postcss$1$1.Comment;
postcss$1$1.Warning;
postcss$1$1.AtRule;
postcss$1$1.Result;
postcss$1$1.Input;
postcss$1$1.Rule;
postcss$1$1.Root;
postcss$1$1.Node;
const tagMap = {
    script: "noscript",
    // camel case svg element tag names
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
function getTagName(n2) {
    let tagName = tagMap[n2.tagName] ? tagMap[n2.tagName] : n2.tagName;
    if (tagName === "link" && n2.attributes._cssText) {
        tagName = "style";
    }
    return tagName;
}
function adaptCssForReplay(cssText, cache) {
    const cachedStyle = cache == null ? void 0 : cache.stylesWithHoverClass.get(cssText);
    if (cachedStyle) return cachedStyle;
    let result2 = cssText;
    try {
        const ast = postcss$1$1([
            mediaSelectorPlugin,
            pseudoClassPlugin
        ]).process(cssText);
        result2 = ast.css;
    } catch (error) {
        console.warn("Failed to adapt css for replay", error);
    }
    cache == null ? void 0 : cache.stylesWithHoverClass.set(cssText, result2);
    return result2;
}
function createCache() {
    const stylesWithHoverClass = /* @__PURE__ */ new Map();
    return {
        stylesWithHoverClass
    };
}
function buildNode(n2, options) {
    var _a2;
    const { doc, hackCss, cache } = options;
    switch(n2.type){
        case NodeType$2.Document:
            return doc.implementation.createDocument(null, "", null);
        case NodeType$2.DocumentType:
            return doc.implementation.createDocumentType(n2.name || "html", n2.publicId, n2.systemId);
        case NodeType$2.Element:
            {
                const tagName = getTagName(n2);
                let node2;
                if (n2.isSVG) {
                    node2 = doc.createElementNS("http://www.w3.org/2000/svg", tagName);
                } else {
                    if (// If the tag name is a custom element name
                    n2.isCustom && // If the browser supports custom elements
                    ((_a2 = doc.defaultView) == null ? void 0 : _a2.customElements) && // If the custom element hasn't been defined yet
                    !doc.defaultView.customElements.get(n2.tagName)) doc.defaultView.customElements.define(n2.tagName, class extends doc.defaultView.HTMLElement {
                    });
                    node2 = doc.createElement(tagName);
                }
                const specialAttributes = {};
                for(const name in n2.attributes){
                    if (!Object.prototype.hasOwnProperty.call(n2.attributes, name)) {
                        continue;
                    }
                    let value = n2.attributes[name];
                    if (tagName === "option" && name === "selected" && value === false) {
                        continue;
                    }
                    if (value === null) {
                        continue;
                    }
                    if (value === true) value = "";
                    if (name.startsWith("rr_")) {
                        specialAttributes[name] = value;
                        continue;
                    }
                    const isTextarea = tagName === "textarea" && name === "value";
                    const isRemoteOrDynamicCss = tagName === "style" && name === "_cssText";
                    if (isRemoteOrDynamicCss && hackCss && typeof value === "string") {
                        value = adaptCssForReplay(value, cache);
                    }
                    if ((isTextarea || isRemoteOrDynamicCss) && typeof value === "string") {
                        node2.appendChild(doc.createTextNode(value));
                        n2.childNodes = [];
                        continue;
                    }
                    try {
                        if (n2.isSVG && name === "xlink:href") {
                            node2.setAttributeNS("http://www.w3.org/1999/xlink", name, value.toString());
                        } else if (name === "onload" || name === "onclick" || name.substring(0, 7) === "onmouse") {
                            node2.setAttribute("_" + name, value.toString());
                        } else if (tagName === "meta" && n2.attributes["http-equiv"] === "Content-Security-Policy" && name === "content") {
                            node2.setAttribute("csp-content", value.toString());
                            continue;
                        } else if (tagName === "link" && (n2.attributes.rel === "preload" || n2.attributes.rel === "modulepreload") && n2.attributes.as === "script") {} else if (tagName === "link" && n2.attributes.rel === "prefetch" && typeof n2.attributes.href === "string" && n2.attributes.href.endsWith(".js")) {} else if (tagName === "img" && n2.attributes.srcset && n2.attributes.rr_dataURL) {
                            node2.setAttribute("rrweb-original-srcset", n2.attributes.srcset);
                        } else {
                            node2.setAttribute(name, value.toString());
                        }
                    } catch (error) {}
                }
                for(const name in specialAttributes){
                    const value = specialAttributes[name];
                    if (tagName === "canvas" && name === "rr_dataURL") {
                        const image = doc.createElement("img");
                        image.onload = ()=>{
                            const ctx = node2.getContext("2d");
                            if (ctx) {
                                ctx.drawImage(image, 0, 0, image.width, image.height);
                            }
                        };
                        image.src = value.toString();
                        if (node2.RRNodeType) node2.rr_dataURL = value.toString();
                    } else if (tagName === "img" && name === "rr_dataURL") {
                        const image = node2;
                        if (!image.currentSrc.startsWith("data:")) {
                            image.setAttribute("rrweb-original-src", n2.attributes.src);
                            image.src = value.toString();
                        }
                    }
                    if (name === "rr_width") {
                        node2.style.width = value.toString();
                    } else if (name === "rr_height") {
                        node2.style.height = value.toString();
                    } else if (name === "rr_mediaCurrentTime" && typeof value === "number") {
                        node2.currentTime = value;
                    } else if (name === "rr_mediaState") {
                        switch(value){
                            case "played":
                                node2.play().catch((e2)=>console.warn("media playback error", e2));
                                break;
                            case "paused":
                                node2.pause();
                                break;
                        }
                    } else if (name === "rr_mediaPlaybackRate" && typeof value === "number") {
                        node2.playbackRate = value;
                    } else if (name === "rr_mediaMuted" && typeof value === "boolean") {
                        node2.muted = value;
                    } else if (name === "rr_mediaLoop" && typeof value === "boolean") {
                        node2.loop = value;
                    } else if (name === "rr_mediaVolume" && typeof value === "number") {
                        node2.volume = value;
                    } else if (name === "rr_open_mode") {
                        node2.setAttribute("rr_open_mode", value);
                    }
                }
                if (n2.isShadowHost) {
                    if (!node2.shadowRoot) {
                        node2.attachShadow({
                            mode: "open"
                        });
                    } else {
                        while(node2.shadowRoot.firstChild){
                            node2.shadowRoot.removeChild(node2.shadowRoot.firstChild);
                        }
                    }
                }
                return node2;
            }
        case NodeType$2.Text:
            return doc.createTextNode(n2.isStyle && hackCss ? adaptCssForReplay(n2.textContent, cache) : n2.textContent);
        case NodeType$2.CDATA:
            return doc.createCDATASection(n2.textContent);
        case NodeType$2.Comment:
            return doc.createComment(n2.textContent);
        default:
            return null;
    }
}
function buildNodeWithSN(n2, options) {
    const { doc, mirror: mirror2, skipChild = false, hackCss = true, afterAppend, cache } = options;
    if (mirror2.has(n2.id)) {
        const nodeInMirror = mirror2.getNode(n2.id);
        const meta = mirror2.getMeta(nodeInMirror);
        if (isNodeMetaEqual(meta, n2)) return mirror2.getNode(n2.id);
    }
    let node2 = buildNode(n2, {
        doc,
        hackCss,
        cache
    });
    if (!node2) {
        return null;
    }
    if (n2.rootId && mirror2.getNode(n2.rootId) !== doc) {
        mirror2.replace(n2.rootId, doc);
    }
    if (n2.type === NodeType$2.Document) {
        doc.close();
        doc.open();
        if (n2.compatMode === "BackCompat" && n2.childNodes && n2.childNodes[0].type !== NodeType$2.DocumentType) {
            if (n2.childNodes[0].type === NodeType$2.Element && "xmlns" in n2.childNodes[0].attributes && n2.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml") {
                doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
            } else {
                doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
            }
        }
        node2 = doc;
    }
    mirror2.add(node2, n2);
    if ((n2.type === NodeType$2.Document || n2.type === NodeType$2.Element) && !skipChild) {
        for (const childN of n2.childNodes){
            const childNode = buildNodeWithSN(childN, {
                doc,
                mirror: mirror2,
                skipChild: false,
                hackCss,
                afterAppend,
                cache
            });
            if (!childNode) {
                console.warn("Failed to rebuild", childN);
                continue;
            }
            if (childN.isShadow && isElement(node2) && node2.shadowRoot) {
                node2.shadowRoot.appendChild(childNode);
            } else if (n2.type === NodeType$2.Document && childN.type == NodeType$2.Element) {
                const htmlElement = childNode;
                let body = null;
                htmlElement.childNodes.forEach((child)=>{
                    if (child.nodeName === "BODY") body = child;
                });
                if (body) {
                    htmlElement.removeChild(body);
                    node2.appendChild(childNode);
                    htmlElement.appendChild(body);
                } else {
                    node2.appendChild(childNode);
                }
            } else {
                node2.appendChild(childNode);
            }
            if (afterAppend) {
                afterAppend(childNode, childN.id);
            }
        }
    }
    return node2;
}
function visit(mirror2, onVisit) {
    function walk(node2) {
        onVisit(node2);
    }
    for (const id of mirror2.getIds()){
        if (mirror2.has(id)) {
            walk(mirror2.getNode(id));
        }
    }
}
function handleScroll(node2, mirror2) {
    const n2 = mirror2.getMeta(node2);
    if ((n2 == null ? void 0 : n2.type) !== NodeType$2.Element) {
        return;
    }
    const el = node2;
    for(const name in n2.attributes){
        if (!(Object.prototype.hasOwnProperty.call(n2.attributes, name) && name.startsWith("rr_"))) {
            continue;
        }
        const value = n2.attributes[name];
        if (name === "rr_scrollLeft") {
            el.scrollLeft = value;
        }
        if (name === "rr_scrollTop") {
            el.scrollTop = value;
        }
    }
}
function rebuild(n2, options) {
    const { doc, onVisit, hackCss = true, afterAppend, cache, mirror: mirror2 = new Mirror() } = options;
    const node2 = buildNodeWithSN(n2, {
        doc,
        mirror: mirror2,
        skipChild: false,
        hackCss,
        afterAppend,
        cache
    });
    visit(mirror2, (visitedNode)=>{
        if (onVisit) {
            onVisit(visitedNode);
        }
        handleScroll(visitedNode, mirror2);
    });
    return node2;
}
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value)=>key in obj ? __defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField2 = (obj, key, value)=>__defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
var __defProp22 = Object.defineProperty;
var __defNormalProp22 = (obj, key, value)=>key in obj ? __defProp22(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField22 = (obj, key, value)=>__defNormalProp22(obj, typeof key !== "symbol" ? key + "" : key, value);
var NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})(NodeType$1 || {});
let Mirror$1 = class Mirror2 {
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) {
            n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
        }
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
    constructor(){
        __publicField22(this, "idNodeMap", /* @__PURE__ */ new Map());
        __publicField22(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
};
function createMirror$1() {
    return new Mirror$1();
}
function getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if (this instanceof a22) {
                return Reflect.construct(f2, arguments, this.constructor);
            }
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n2[k];
            }
        });
    });
    return a2;
}
var picocolors_browser = {
    exports: {}
};
var x = String;
var create = function() {
    return {
        isColorSupported: false,
        reset: x,
        bold: x,
        dim: x,
        italic: x,
        underline: x,
        inverse: x,
        hidden: x,
        strikethrough: x,
        black: x,
        red: x,
        green: x,
        yellow: x,
        blue: x,
        magenta: x,
        cyan: x,
        white: x,
        gray: x,
        bgBlack: x,
        bgRed: x,
        bgGreen: x,
        bgYellow: x,
        bgBlue: x,
        bgMagenta: x,
        bgCyan: x,
        bgWhite: x
    };
};
picocolors_browser.exports = create();
picocolors_browser.exports.createColors = create;
var picocolors_browserExports = picocolors_browser.exports;
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: __viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
let pico = picocolors_browserExports;
let terminalHighlight$1 = require$$2;
let CssSyntaxError$3 = class CssSyntaxError2 extends Error {
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") {
            this.message += ":" + this.line + ":" + this.column;
        }
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = pico.isColorSupported;
        if (terminalHighlight$1) {
            if (color) css = terminalHighlight$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold, gray, red } = pico.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else {
            mark = aside = (str)=>str;
        }
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) {
            code = "\n\n" + code + "\n";
        }
        return this.name + ": " + this.message + code;
    }
    constructor(message, line, column, source, file, plugin22){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) {
            this.file = file;
        }
        if (source) {
            this.source = source;
        }
        if (plugin22) {
            this.plugin = plugin22;
        }
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CssSyntaxError2);
        }
    }
};
var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;
var symbols = {};
symbols.isClean = Symbol("isClean");
symbols.my = Symbol("my");
const DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let Stringifier$2 = class Stringifier2 {
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") {
            name += node2.raws.afterName;
        } else if (params) {
            name += " ";
        }
        if (node2.nodes) {
            this.block(node2, name + params);
        } else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (node2.type === "comment") {
            value = this.raw(node2, null, "beforeComment");
        } else if (detect === "before") {
            value = this.raw(node2, null, "beforeRule");
        } else {
            value = this.raw(node2, null, "beforeClose");
        }
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) {
                for(let step = 0; step < depth; step++)value += indent;
            }
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else {
            after = this.raw(node2, "after", "emptyBody");
        }
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i2 = 0; i2 < node2.nodes.length; i2++){
            let child = node2.nodes[i2];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) {
            string += node2.raws.important || " !important";
        }
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) {
                return "";
            }
            if (parent && parent.type === "document") {
                return "";
            }
        }
        if (!parent) return DEFAULT_RAW[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") {
            return root2.rawCache[detect];
        }
        if (detect === "before" || detect === "after") {
            return this.beforeAfter(node2, detect);
        } else {
            let method = "raw" + capitalize(detect);
            if (this[method]) {
                value = this[method](root2, node2);
            } else {
                root2.walk((i2)=>{
                    value = i2.raws[own];
                    if (typeof value !== "undefined") return false;
                });
            }
        }
        if (typeof value === "undefined") value = DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeRule");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i2)=>{
            let p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    let parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) {
            return raw.raw;
        }
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) {
            this.builder(node2.raws.ownSemicolon, node2, "end");
        }
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) {
            throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        }
        this[node2.type](node2, semicolon);
    }
    constructor(builder){
        this.builder = builder;
    }
};
var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;
let Stringifier$1 = stringifier;
function stringify$4(node2, builder) {
    let str = new Stringifier$1(builder);
    str.stringify(node2);
}
var stringify_1 = stringify$4;
stringify$4.default = stringify$4;
let { isClean: isClean$2, my: my$2 } = symbols;
let CssSyntaxError$2 = cssSyntaxError;
let Stringifier22 = stringifier;
let stringify$3 = stringify_1;
function cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
            continue;
        }
        if (i2 === "proxyCache") continue;
        let value = obj[i2];
        let type = typeof value;
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") {
            cloned[i2] = value;
        } else if (Array.isArray(value)) {
            cloned[i2] = value.map((j)=>cloneNode(j, cloned));
        } else {
            if (type === "object" && value !== null) value = cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
let Node$4 = class Node3 {
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides){
            this[name] = overrides[name];
        }
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = cloneNode(this);
        for(let name in overrides){
            cloned[name] = overrides[name];
        }
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end, start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new CssSyntaxError$2(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    markDirty() {
        if (this[isClean$2]) {
            this[isClean$2] = false;
            let next = this;
            while(next = next.parent){
                next[isClean$2] = false;
            }
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) {
            pos = this.positionInside(opts.index, stringRepresentation);
        } else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i2 = 0; i2 < index2; i2++){
            if (string[i2] === "\n") {
                column = 1;
                line += 1;
            } else {
                column += 1;
            }
        }
        return {
            column,
            line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) {
                start = {
                    column: opts.start.column,
                    line: opts.start.line
                };
            } else if (opts.index) {
                start = this.positionInside(opts.index);
            }
            if (opts.end) {
                end = {
                    column: opts.end.column,
                    line: opts.end.line
                };
            } else if (typeof opts.endIndex === "number") {
                end = this.positionInside(opts.endIndex);
            } else if (opts.index) {
                end = this.positionInside(opts.index + 1);
            }
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) {
            end = {
                column: start.column + 1,
                line: start.line
            };
        }
        return {
            end,
            start
        };
    }
    raw(prop, defaultType) {
        let str = new Stringifier22();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) {
                    foundSelf = true;
                } else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else {
                    this.parent.insertBefore(bookmark, node2);
                }
            }
            if (!foundSelf) {
                this.remove();
            }
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document"){
            result2 = result2.parent;
        }
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) {
                continue;
            }
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) {
                fixed[name] = value.map((i2)=>{
                    if (typeof i2 === "object" && i2.toJSON) {
                        return i2.toJSON(null, inputs);
                    } else {
                        return i2;
                    }
                });
            } else if (typeof value === "object" && value.toJSON) {
                fixed[name] = value.toJSON(null, inputs);
            } else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId,
                    start: value.start
                };
            } else {
                fixed[name] = value;
            }
        }
        if (emitInputs) {
            fixed.inputs = [
                ...inputs.keys()
            ].map((input2)=>input2.toJSON());
        }
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) {
            this.proxyCache = new Proxy(this, this.getProxyProcessor());
        }
        return this.proxyCache;
    }
    toString(stringifier2 = stringify$3) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i2)=>{
            result2 += i2;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
    constructor(defaults = {}){
        this.raws = {};
        this[isClean$2] = false;
        this[my$2] = true;
        for(let name in defaults){
            if (name === "nodes") {
                this.nodes = [];
                for (let node2 of defaults[name]){
                    if (typeof node2.clone === "function") {
                        this.append(node2.clone());
                    } else {
                        this.append(node2);
                    }
                }
            } else {
                this[name] = defaults[name];
            }
        }
    }
};
var node = Node$4;
Node$4.default = Node$4;
let Node$3 = node;
let Declaration$4 = class Declaration2 extends Node$3 {
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
            defaults = _extends({}, defaults, {
                value: String(defaults.value)
            });
        }
        super(defaults);
        this.type = "decl";
    }
};
var declaration = Declaration$4;
Declaration$4.default = Declaration$4;
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i2 = size;
        while(i2--){
            id += alphabet[Math.random() * alphabet.length | 0];
        }
        return id;
    };
};
let nanoid$1 = (size = 21)=>{
    let id = "";
    let i2 = size;
    while(i2--){
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
var nonSecure = {
    nanoid: nanoid$1,
    customAlphabet
};
let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = require$$2;
let { existsSync, readFileSync } = require$$2;
let { dirname: dirname$1, join } = require$$2;
function fromBase64(str) {
    if (Buffer) {
        return Buffer.from(str, "base64").toString();
    } else {
        return window.atob(str);
    }
}
let PreviousMap$2 = class PreviousMap2 {
    consumer() {
        if (!this.consumerCache) {
            this.consumerCache = new SourceMapConsumer$2(this.text);
        }
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) {
            return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        }
        if (baseCharsetUri.test(text) || baseUri.test(text)) {
            return fromBase64(text.substr(RegExp.lastMatch.length));
        }
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) {
            this.annotation = this.getAnnotationURL(css.substring(start, end));
        }
    }
    loadFile(path) {
        this.root = dirname$1(path);
        if (existsSync(path)) {
            this.mapFile = path;
            return readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") {
                return prev;
            } else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) {
                        throw new Error("Unable to load previous source map: " + prevPath.toString());
                    }
                    return map;
                }
            } else if (prev instanceof SourceMapConsumer$2) {
                return SourceMapGenerator$2.fromSourceMap(prev).toString();
            } else if (prev instanceof SourceMapGenerator$2) {
                return prev.toString();
            } else if (this.isMap(prev)) {
                return JSON.stringify(prev);
            } else {
                throw new Error("Unsupported previous source map format: " + prev.toString());
            }
        } else if (this.inline) {
            return this.decodeInline(this.annotation);
        } else if (this.annotation) {
            let map = this.annotation;
            if (file) map = join(dirname$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) {
            this.mapFile = opts.from;
        }
        if (this.mapFile) this.root = dirname$1(this.mapFile);
        if (text) this.text = text;
    }
};
var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;
let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = require$$2;
let { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$2;
let { isAbsolute, resolve: resolve$1 } = require$$2;
let { nanoid } = nonSecure;
let terminalHighlight = require$$2;
let CssSyntaxError$1 = cssSyntaxError;
let PreviousMap$1 = previousMap;
let fromOffsetCache = Symbol("fromOffsetCache");
let sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
let pathAvailable$1 = Boolean(resolve$1 && isAbsolute);
let Input$4 = class Input2 {
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) {
            result2 = new CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
                column: origin.column,
                line: origin.line
            }, origin.endLine === void 0 ? origin.column : {
                column: origin.endColumn,
                line: origin.endLine
            }, origin.source, origin.file, opts.plugin);
        } else {
            result2 = new CssSyntaxError$1(message, endLine === void 0 ? line : {
                column,
                line
            }, endLine === void 0 ? column : {
                column: endColumn,
                line: endLine
            }, this.css, this.file, opts.plugin);
        }
        result2.input = {
            column,
            endColumn,
            endLine,
            line,
            source: this.css
        };
        if (this.file) {
            if (pathToFileURL$1) {
                result2.input.url = pathToFileURL$1(this.file).toString();
            }
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[fromOffsetCache] = lineToIndex;
        } else {
            lineToIndex = this[fromOffsetCache];
        }
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) {
            min = lineToIndex.length - 1;
        } else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) {
                    max = mid - 1;
                } else if (offset >= lineToIndex[mid + 1]) {
                    min = mid + 1;
                } else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) {
            return file;
        }
        return resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column,
            line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") {
            to = consumer.originalPositionFor({
                column: endColumn,
                line: endLine
            });
        }
        let fromUrl;
        if (isAbsolute(from.source)) {
            fromUrl = pathToFileURL$1(from.source);
        } else {
            fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile));
        }
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if (fileURLToPath) {
                result2.file = fileURLToPath(fromUrl);
            } else {
                throw new Error(`file: protocol is not available in this PostCSS build`);
            }
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ]){
            if (this[name] != null) {
                json[name] = this[name];
            }
        }
        if (this.map) {
            json.map = _extends({}, this.map);
            if (json.map.consumerCache) {
                json.map.consumerCache = void 0;
            }
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
            throw new Error(`PostCSS received ${css} instead of CSS string`);
        }
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else {
            this.hasBOM = false;
        }
        if (opts.from) {
            if (!pathAvailable$1 || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
                this.file = opts.from;
            } else {
                this.file = resolve$1(opts.from);
            }
        }
        if (pathAvailable$1 && sourceMapAvailable$1) {
            let map = new PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) {
            this.id = "<input css " + nanoid(6) + ">";
        }
        if (this.map) this.map.file = this.from;
    }
};
var input = Input$4;
Input$4.default = Input$4;
if (terminalHighlight && terminalHighlight.registerInput) {
    terminalHighlight.registerInput(Input$4);
}
let { SourceMapConsumer, SourceMapGenerator } = require$$2;
let { dirname, relative, resolve, sep } = require$$2;
let { pathToFileURL } = require$$2;
let Input$3 = input;
let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(dirname && resolve && relative && sep);
let MapGenerator$2 = class MapGenerator2 {
    addAnnotation() {
        let content;
        if (this.isInline()) {
            content = "data:application/json;base64," + this.toBase64(this.map.toString());
        } else if (typeof this.mapOpts.annotation === "string") {
            content = this.mapOpts.annotation;
        } else if (typeof this.mapOpts.annotation === "function") {
            content = this.mapOpts.annotation(this.opts.to, this.root);
        } else {
            content = this.outputFile() + ".map";
        }
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new SourceMapConsumer(prev.text);
                if (map.sourcesContent) {
                    map.sourcesContent = null;
                }
            } else {
                map = prev.consumer();
            }
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) {
                    this.root.removeChild(i2);
                }
            }
        } else if (this.css) {
            this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
        }
    }
    generate() {
        this.clearAnnotation();
        if (pathAvailable && sourceMapAvailable && this.isMap()) {
            return this.generateMap();
        } else {
            let result2 = "";
            this.stringify(this.root, (i2)=>{
                result2 += i2;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) {
            this.generateString();
        } else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) {
            return [
                this.css
            ];
        } else {
            return [
                this.css,
                this.map
            ];
        }
    }
    generateString() {
        this.css = "";
        this.map = new SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else {
                column += str.length;
            }
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) {
            return true;
        }
        if (typeof this.mapOpts.annotation !== "undefined") {
            return this.mapOpts.annotation;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.annotation);
        }
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") {
            return this.mapOpts.inline;
        }
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) {
            return false;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.inline);
        }
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") {
            return !!this.opts.map;
        }
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") {
            return this.mapOpts.sourcesContent;
        }
        if (this.previous().length) {
            return this.previous().some((i2)=>i2.withContent());
        }
        return true;
    }
    outputFile() {
        if (this.opts.to) {
            return this.path(this.opts.to);
        } else if (this.opts.from) {
            return this.path(this.opts.from);
        } else {
            return "to.css";
        }
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") {
            from = dirname(resolve(from, this.mapOpts.annotation));
        }
        let path = relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) {
                this.root.walk((node2)=>{
                    if (node2.source && node2.source.input.map) {
                        let map = node2.source.input.map;
                        if (!this.previousMaps.includes(map)) {
                            this.previousMaps.push(map);
                        }
                    }
                });
            } else {
                let input2 = new Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) {
            this.root.walk((node2)=>{
                if (node2.source) {
                    let from = node2.source.input.from;
                    if (from && !already[from]) {
                        already[from] = true;
                        let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                        this.map.setSourceContent(fromUrl, node2.source.input.css);
                    }
                }
            });
        } else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) {
            return this.toUrl(this.mapOpts.from);
        } else if (this.usesFileUrls) {
            return this.toFileUrl(node2.source.input.from);
        } else {
            return this.toUrl(this.path(node2.source.input.from));
        }
    }
    toBase64(str) {
        if (Buffer) {
            return Buffer.from(str).toString("base64");
        } else {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if (pathToFileURL) {
            let fileURL = pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else {
            throw new Error("`map.absolute` option is not available in this PostCSS build");
        }
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if (sep === "\\") {
            path = path.replace(/\\/g, "/");
        }
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
};
var mapGenerator = MapGenerator$2;
let Node$2 = node;
let Comment$4 = class Comment2 extends Node$2 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var comment = Comment$4;
Comment$4.default = Comment$4;
let { isClean: isClean$1, my: my$1 } = symbols;
let Declaration$3 = declaration;
let Comment$3 = comment;
let Node$1 = node;
let parse$4, Rule$4, AtRule$4, Root$6;
function cleanSource(nodes) {
    return nodes.map((i2)=>{
        if (i2.nodes) i2.nodes = cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function markDirtyUp(node2) {
    node2[isClean$1] = false;
    if (node2.proxyOf.nodes) {
        for (let i2 of node2.proxyOf.nodes){
            markDirtyUp(i2);
        }
    }
}
let Container$7 = class Container2 extends Node$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) {
            for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
        }
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (!node2[prop]) {
                    return node2[prop];
                } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
                    return (...args)=>{
                        return node2[prop](...args.map((i2)=>{
                            if (typeof i2 === "function") {
                                return (child, index2)=>i2(child.toProxy(), index2);
                            } else {
                                return i2;
                            }
                        }));
                    };
                } else if (prop === "every" || prop === "some") {
                    return (cb)=>{
                        return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                    };
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else if (prop === "nodes") {
                    return node2.nodes.map((i2)=>i2.toProxy());
                } else if (prop === "first" || prop === "last") {
                    return node2[prop].toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") {
            nodes = cleanSource(parse$4(nodes).nodes);
        } else if (typeof nodes === "undefined") {
            nodes = [];
        } else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i2 of nodes){
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i2 of nodes){
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type) {
            nodes = [
                nodes
            ];
        } else if (nodes.prop) {
            if (typeof nodes.value === "undefined") {
                throw new Error("Value field is missed in node creation");
            } else if (typeof nodes.value !== "string") {
                nodes.value = String(nodes.value);
            }
            nodes = [
                new Declaration$3(nodes)
            ];
        } else if (nodes.selector) {
            nodes = [
                new Rule$4(nodes)
            ];
        } else if (nodes.name) {
            nodes = [
                new AtRule$4(nodes)
            ];
        } else if (nodes.text) {
            nodes = [
                new Comment$3(nodes)
            ];
        } else {
            throw new Error("Unknown node type in node creation");
        }
        let processed = nodes.map((i2)=>{
            if (!i2[my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[isClean$1]) markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") {
                    i2.raws.before = sample.raws.before.replace(/\S/g, "");
                }
            }
            i2.parent = this.proxyOf;
            return i2;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes){
                this.indexes[id] = this.indexes[id] + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) {
                this.indexes[id] = index2 - 1;
            }
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i2)=>{
            let result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) {
                result2 = child.walk(callback);
            }
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i2)=>{
                if (child.type === "atrule") {
                    return callback(child, i2);
                }
            });
        }
        if (name instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "atrule" && name.test(child.name)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "atrule" && child.name === name) {
                return callback(child, i2);
            }
        });
    }
    walkComments(callback) {
        return this.walk((child, i2)=>{
            if (child.type === "comment") {
                return callback(child, i2);
            }
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i2)=>{
                if (child.type === "decl") {
                    return callback(child, i2);
                }
            });
        }
        if (prop instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "decl" && prop.test(child.prop)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "decl" && child.prop === prop) {
                return callback(child, i2);
            }
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i2)=>{
                if (child.type === "rule") {
                    return callback(child, i2);
                }
            });
        }
        if (selector instanceof RegExp) {
            return this.walk((child, i2)=>{
                if (child.type === "rule" && selector.test(child.selector)) {
                    return callback(child, i2);
                }
            });
        }
        return this.walk((child, i2)=>{
            if (child.type === "rule" && child.selector === selector) {
                return callback(child, i2);
            }
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
Container$7.registerParse = (dependant)=>{
    parse$4 = dependant;
};
Container$7.registerRule = (dependant)=>{
    Rule$4 = dependant;
};
Container$7.registerAtRule = (dependant)=>{
    AtRule$4 = dependant;
};
Container$7.registerRoot = (dependant)=>{
    Root$6 = dependant;
};
var container = Container$7;
Container$7.default = Container$7;
Container$7.rebuild = (node2)=>{
    if (node2.type === "atrule") {
        Object.setPrototypeOf(node2, AtRule$4.prototype);
    } else if (node2.type === "rule") {
        Object.setPrototypeOf(node2, Rule$4.prototype);
    } else if (node2.type === "decl") {
        Object.setPrototypeOf(node2, Declaration$3.prototype);
    } else if (node2.type === "comment") {
        Object.setPrototypeOf(node2, Comment$3.prototype);
    } else if (node2.type === "root") {
        Object.setPrototypeOf(node2, Root$6.prototype);
    }
    node2[my$1] = true;
    if (node2.nodes) {
        node2.nodes.forEach((child)=>{
            Container$7.rebuild(child);
        });
    }
};
let Container$6 = container;
let LazyResult$4, Processor$3;
let Document$3 = class Document23 extends Container$6 {
    toResult(opts = {}) {
        let lazy = new LazyResult$4(new Processor$3(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(_extends({
            type: "document"
        }, defaults));
        if (!this.nodes) {
            this.nodes = [];
        }
    }
};
Document$3.registerLazyResult = (dependant)=>{
    LazyResult$4 = dependant;
};
Document$3.registerProcessor = (dependant)=>{
    Processor$3 = dependant;
};
var document$1 = Document$3;
Document$3.default = Document$3;
let printed = {};
var warnOnce$2 = function warnOnce2(message) {
    if (printed[message]) return;
    printed[message] = true;
    if (typeof console !== "undefined" && console.warn) {
        console.warn(message);
    }
};
let Warning$2 = class Warning2 {
    toString() {
        if (this.node) {
            return this.node.error(this.text, {
                index: this.index,
                plugin: this.plugin,
                word: this.word
            }).message;
        }
        if (this.plugin) {
            return this.plugin + ": " + this.text;
        }
        return this.text;
    }
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
};
var warning = Warning$2;
Warning$2.default = Warning$2;
let Warning$1 = warning;
let Result$3 = class Result2 {
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
                opts.plugin = this.lastPlugin.postcssPlugin;
            }
        }
        let warning2 = new Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i2)=>i2.type === "warning");
    }
    get content() {
        return this.css;
    }
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
};
var result = Result$3;
Result$3.default = Result$3;
const SINGLE_QUOTE = "'".charCodeAt(0);
const DOUBLE_QUOTE = '"'.charCodeAt(0);
const BACKSLASH = "\\".charCodeAt(0);
const SLASH = "/".charCodeAt(0);
const NEWLINE = "\n".charCodeAt(0);
const SPACE = " ".charCodeAt(0);
const FEED = "\f".charCodeAt(0);
const TAB = "	".charCodeAt(0);
const CR = "\r".charCodeAt(0);
const OPEN_SQUARE = "[".charCodeAt(0);
const CLOSE_SQUARE = "]".charCodeAt(0);
const OPEN_PARENTHESES = "(".charCodeAt(0);
const CLOSE_PARENTHESES = ")".charCodeAt(0);
const OPEN_CURLY = "{".charCodeAt(0);
const CLOSE_CURLY = "}".charCodeAt(0);
const SEMICOLON = ";".charCodeAt(0);
const ASTERISK = "*".charCodeAt(0);
const COLON = ":".charCodeAt(0);
const AT = "@".charCodeAt(0);
const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const RE_HEX_ESCAPE = /[\da-f]/i;
var tokenize = function tokenizer2(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n2, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case NEWLINE:
            case SPACE:
            case TAB:
            case CR:
            case FEED:
                {
                    next = pos;
                    do {
                        next += 1;
                        code = css.charCodeAt(next);
                    }while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED)
                    currentToken = [
                        "space",
                        css.slice(pos, next)
                    ];
                    pos = next - 1;
                    break;
                }
            case OPEN_SQUARE:
            case CLOSE_SQUARE:
            case OPEN_CURLY:
            case CLOSE_CURLY:
            case COLON:
            case SEMICOLON:
            case CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case OPEN_PARENTHESES:
                {
                    prev = buffer.length ? buffer.pop()[1] : "";
                    n2 = css.charCodeAt(pos + 1);
                    if (prev === "url" && n2 !== SINGLE_QUOTE && n2 !== DOUBLE_QUOTE && n2 !== SPACE && n2 !== NEWLINE && n2 !== TAB && n2 !== FEED && n2 !== CR) {
                        next = pos;
                        do {
                            escaped = false;
                            next = css.indexOf(")", next + 1);
                            if (next === -1) {
                                if (ignore || ignoreUnclosed) {
                                    next = pos;
                                    break;
                                } else {
                                    unclosed("bracket");
                                }
                            }
                            escapePos = next;
                            while(css.charCodeAt(escapePos - 1) === BACKSLASH){
                                escapePos -= 1;
                                escaped = !escaped;
                            }
                        }while (escaped)
                        currentToken = [
                            "brackets",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        next = css.indexOf(")", pos + 1);
                        content = css.slice(pos, next + 1);
                        if (next === -1 || RE_BAD_BRACKET.test(content)) {
                            currentToken = [
                                "(",
                                "(",
                                pos
                            ];
                        } else {
                            currentToken = [
                                "brackets",
                                content,
                                pos,
                                next
                            ];
                            pos = next;
                        }
                    }
                    break;
                }
            case SINGLE_QUOTE:
            case DOUBLE_QUOTE:
                {
                    quote = code === SINGLE_QUOTE ? "'" : '"';
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(quote, next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos + 1;
                                break;
                            } else {
                                unclosed("string");
                            }
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped)
                    currentToken = [
                        "string",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case AT:
                {
                    RE_AT_END.lastIndex = pos + 1;
                    RE_AT_END.test(css);
                    if (RE_AT_END.lastIndex === 0) {
                        next = css.length - 1;
                    } else {
                        next = RE_AT_END.lastIndex - 2;
                    }
                    currentToken = [
                        "at-word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case BACKSLASH:
                {
                    next = pos;
                    escape = true;
                    while(css.charCodeAt(next + 1) === BACKSLASH){
                        next += 1;
                        escape = !escape;
                    }
                    code = css.charCodeAt(next + 1);
                    if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
                        next += 1;
                        if (RE_HEX_ESCAPE.test(css.charAt(next))) {
                            while(RE_HEX_ESCAPE.test(css.charAt(next + 1))){
                                next += 1;
                            }
                            if (css.charCodeAt(next + 1) === SPACE) {
                                next += 1;
                            }
                        }
                    }
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            default:
                {
                    if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
                        next = css.indexOf("*/", pos + 2) + 1;
                        if (next === 0) {
                            if (ignore || ignoreUnclosed) {
                                next = css.length;
                            } else {
                                unclosed("comment");
                            }
                        }
                        currentToken = [
                            "comment",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        RE_WORD_END.lastIndex = pos + 1;
                        RE_WORD_END.test(css);
                        if (RE_WORD_END.lastIndex === 0) {
                            next = css.length - 1;
                        } else {
                            next = RE_WORD_END.lastIndex - 2;
                        }
                        currentToken = [
                            "word",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        buffer.push(currentToken);
                        pos = next;
                    }
                    break;
                }
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back,
        endOfFile,
        nextToken,
        position
    };
};
let Container$5 = container;
let AtRule$3 = class AtRule2 extends Container$5 {
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
};
var atRule = AtRule$3;
AtRule$3.default = AtRule$3;
Container$5.registerAtRule(AtRule$3);
let Container$4 = container;
let LazyResult$3, Processor$2;
let Root$5 = class Root2 extends Container$4 {
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) {
                    sample.raws.before = this.nodes[1].raws.before;
                } else {
                    delete sample.raws.before;
                }
            } else if (this.first !== sample) {
                for (let node2 of nodes){
                    node2.raws.before = sample.raws.before;
                }
            }
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) {
            this.nodes[1].raws.before = this.nodes[index2].raws.before;
        }
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new LazyResult$3(new Processor$2(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
};
Root$5.registerLazyResult = (dependant)=>{
    LazyResult$3 = dependant;
};
Root$5.registerProcessor = (dependant)=>{
    Processor$2 = dependant;
};
var root = Root$5;
Root$5.default = Root$5;
Container$4.registerRoot(Root$5);
let list$2 = {
    comma (string) {
        return list$2.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return list$2.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) {
                escape = false;
            } else if (letter === "\\") {
                escape = true;
            } else if (inQuote) {
                if (letter === prevQuote) {
                    inQuote = false;
                }
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") {
                func += 1;
            } else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else {
                current += letter;
            }
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var list_1 = list$2;
list$2.default = list$2;
let Container$3 = container;
let list$1 = list_1;
let Rule$3 = class Rule2 extends Container$3 {
    get selectors() {
        return list$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
};
var rule = Rule$3;
Rule$3.default = Rule$3;
Container$3.registerRule(Rule$3);
let Declaration$2 = declaration;
let tokenizer22 = tokenize;
let Comment$2 = comment;
let AtRule$2 = atRule;
let Root$4 = root;
let Rule$2 = rule;
const SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function findLastWithPosition(tokens) {
    for(let i2 = tokens.length - 1; i2 >= 0; i2--){
        let token = tokens[i2];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let Parser$1 = class Parser2 {
    atrule(token) {
        let node2 = new AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") {
            this.unnamedAtrule(node2, token);
        }
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") {
                brackets.push(type === "(" ? ")" : "]");
            } else if (type === "{" && brackets.length > 0) {
                brackets.push("}");
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
            }
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space"){
                            prev = params[--shift];
                        }
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else {
                    params.push(token);
                }
            } else {
                params.push(token);
            }
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i2, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") {
                brackets += 1;
            }
            if (type === ")") {
                brackets -= 1;
            }
            if (brackets === 0 && type === ":") {
                if (!prev) {
                    this.doubleColon(token);
                } else if (prev[0] === "word" && prev[1] === "progid") {
                    continue;
                } else {
                    return i2;
                }
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = tokenizer22(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new Declaration$2();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") {
                break;
            }
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) {
                    this.unknownWord([
                        token
                    ]);
                }
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i2; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") {
                        break;
                    }
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") {
                break;
            }
        }
        let hasWord = tokens.some((i2)=>i2[0] !== "space" && i2[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i2)=>i2[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) {
            this.checkMissedSemicolon(tokens);
        }
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else {
            this.unexpectedClose(token);
        }
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else {
                        break;
                    }
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") {
                    colon = true;
                }
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) {
                while(tokens.length){
                    token = tokens[tokens.length - 1][0];
                    if (token !== "space" && token !== "comment") break;
                    this.tokenizer.back(tokens.pop());
                }
            }
            this.decl(tokens, customProperty);
        } else {
            this.unknownWord(tokens);
        }
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) {
                clean = false;
            } else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") {
                        clean = false;
                    } else {
                        value += token[1];
                    }
                } else {
                    clean = false;
                }
            } else {
                value += token[1];
            }
        }
        if (!clean) {
            let raw = tokens.reduce((all, i2)=>all + i2[1], "");
            node2.raws[prop] = {
                raw,
                value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i2 = from; i2 < tokens.length; i2++){
            result2 += tokens[i2][1];
        }
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    constructor(input2){
        this.input = input2;
        this.root = new Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
};
var parser = Parser$1;
let Container$2 = container;
let Parser22 = parser;
let Input$2 = input;
function parse$3(css, opts) {
    let input2 = new Input$2(css, opts);
    let parser2 = new Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        if (false) {}
        throw e2;
    }
    return parser2.root;
}
var parse_1 = parse$3;
parse$3.default = parse$3;
Container$2.registerParse(parse$3);
let { isClean, my } = symbols;
let MapGenerator$1 = mapGenerator;
let stringify$2 = stringify_1;
let Container$1 = container;
let Document$2 = document$1;
let warnOnce$1 = (/* unused pure expression or super */ null && (warnOnce$2));
let Result$2 = result;
let parse$2 = parse_1;
let Root$3 = root;
const TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const CHILDREN = 0;
function isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function getEvents(node2) {
    let key = false;
    let type = TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") {
        key = node2.prop.toLowerCase();
    } else if (node2.type === "atrule") {
        key = node2.name.toLowerCase();
    }
    if (key && node2.append) {
        return [
            type,
            type + "-" + key,
            CHILDREN,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (key) {
        return [
            type,
            type + "-" + key,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (node2.append) {
        return [
            type,
            CHILDREN,
            type + "Exit"
        ];
    } else {
        return [
            type,
            type + "Exit"
        ];
    }
}
function toStack(node2) {
    let events;
    if (node2.type === "document") {
        events = [
            "Document",
            CHILDREN,
            "DocumentExit"
        ];
    } else if (node2.type === "root") {
        events = [
            "Root",
            CHILDREN,
            "RootExit"
        ];
    } else {
        events = getEvents(node2);
    }
    return {
        eventIndex: 0,
        events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function cleanMarks(node2) {
    node2[isClean] = false;
    if (node2.nodes) node2.nodes.forEach((i2)=>cleanMarks(i2));
    return node2;
}
let postcss$2 = {};
let LazyResult$2 = class LazyResult2 {
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) {
            this.processing = this.runAsync();
        }
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) {
                if (false) {}
            }
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin22, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for (let plugin22 of this.plugins){
            if (typeof plugin22 === "object") {
                for(let event in plugin22){
                    if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
                        throw new Error(`Unknown event ${event} in ${plugin22.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                    }
                    if (!NOT_VISITORS[event]) {
                        if (typeof plugin22[event] === "object") {
                            for(let filter in plugin22[event]){
                                if (filter === "*") {
                                    add(plugin22, event, plugin22[event][filter]);
                                } else {
                                    add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                                }
                            }
                        } else if (typeof plugin22[event] === "function") {
                            add(plugin22, event, plugin22[event]);
                        }
                    }
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    runAsync() {
        var _this = this;
        return _async_to_generator(function*() {
            _this.plugin = 0;
            for(let i2 = 0; i2 < _this.plugins.length; i2++){
                let plugin22 = _this.plugins[i2];
                let promise = _this.runOnRoot(plugin22);
                if (isPromise(promise)) {
                    try {
                        yield promise;
                    } catch (error) {
                        throw _this.handleError(error);
                    }
                }
            }
            _this.prepareVisitors();
            if (_this.hasListener) {
                let root2 = _this.result.root;
                while(!root2[isClean]){
                    root2[isClean] = true;
                    let stack = [
                        toStack(root2)
                    ];
                    while(stack.length > 0){
                        let promise = _this.visitTick(stack);
                        if (isPromise(promise)) {
                            try {
                                yield promise;
                            } catch (e2) {
                                let node2 = stack[stack.length - 1].node;
                                throw _this.handleError(e2, node2);
                            }
                        }
                    }
                }
                if (_this.listeners.OnceExit) {
                    for (let [plugin22, visitor] of _this.listeners.OnceExit){
                        _this.result.lastPlugin = plugin22;
                        try {
                            if (root2.type === "document") {
                                let roots = root2.nodes.map((subRoot)=>visitor(subRoot, _this.helpers));
                                yield Promise.all(roots);
                            } else {
                                yield visitor(root2, _this.helpers);
                            }
                        } catch (e2) {
                            throw _this.handleError(e2);
                        }
                    }
                }
            }
            _this.processed = true;
            return _this.stringify();
        })();
    }
    runOnRoot(plugin22) {
        this.result.lastPlugin = plugin22;
        try {
            if (typeof plugin22 === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin22.Once(root2, this.helpers));
                    if (isPromise(roots[0])) {
                        return Promise.all(roots);
                    }
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") {
                return plugin22(this.result.root, this.result);
            }
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new MapGenerator$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) {
            throw this.getAsyncError();
        }
        for (let plugin22 of this.plugins){
            let promise = this.runOnRoot(plugin22);
            if (isPromise(promise)) {
                throw this.getAsyncError();
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[isClean]){
                root2[isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") {
                    for (let subRoot of root2.nodes){
                        this.visitSync(this.listeners.OnceExit, subRoot);
                    }
                } else {
                    this.visitSync(this.listeners.OnceExit, root2);
                }
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin22, visitor] of visitors){
            this.result.lastPlugin = plugin22;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
                return true;
            }
            if (isPromise(promise)) {
                throw this.getAsyncError();
            }
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin22, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[isClean]) {
                    child[isClean] = true;
                    stack.push(toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[isClean] = true;
        let events = getEvents(node2);
        for (let event of events){
            if (event === CHILDREN) {
                if (node2.nodes) {
                    node2.each((child)=>{
                        if (!child[isClean]) this.walkSync(child);
                    });
                }
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
            root2 = cleanMarks(css);
        } else if (css instanceof LazyResult2 || css instanceof Result$2) {
            root2 = cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[my]) {
                Container$1.rebuild(root2);
            }
        }
        this.result = new Result$2(processor2, root2, opts);
        this.helpers = _extends({}, postcss$2, {
            postcss: postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map((plugin22)=>{
            if (typeof plugin22 === "object" && plugin22.prepare) {
                return _extends({}, plugin22, plugin22.prepare(this.result));
            } else {
                return plugin22;
            }
        });
    }
};
LazyResult$2.registerPostcss = (dependant)=>{
    postcss$2 = dependant;
};
var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;
Root$3.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);
let MapGenerator22 = mapGenerator;
let stringify$1 = stringify_1;
let warnOnce22 = (/* unused pure expression or super */ null && (warnOnce$2));
let parse$1 = parse_1;
const Result$1 = result;
let NoWorkResult$1 = class NoWorkResult2 {
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) {
            return this._root;
        }
        let root2;
        let parser2 = parse$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) {
            throw this.error;
        } else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = stringify$1;
        this.result = new Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) {
                this.result.css = generatedCSS;
            }
            if (generatedMap) {
                this.result.map = generatedMap;
            }
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
};
var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;
let NoWorkResult22 = noWorkResult;
let LazyResult$1 = lazyResult;
let Document$1 = document$1;
let Root$2 = root;
let Processor$1 = class Processor2 {
    normalize(plugins) {
        let normalized = [];
        for (let i2 of plugins){
            if (i2.postcss === true) {
                i2 = i2();
            } else if (i2.postcss) {
                i2 = i2.postcss;
            }
            if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
                normalized = normalized.concat(i2.plugins);
            } else if (typeof i2 === "object" && i2.postcssPlugin) {
                normalized.push(i2);
            } else if (typeof i2 === "function") {
                normalized.push(i2);
            } else if (typeof i2 === "object" && (i2.parse || i2.stringify)) {
                if (false) {}
            } else {
                throw new Error(i2 + " is not a PostCSS plugin");
            }
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
            return new NoWorkResult22(this, css, opts);
        } else {
            return new LazyResult$1(this, css, opts);
        }
    }
    use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    }
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
};
var processor = Processor$1;
Processor$1.default = Processor$1;
Root$2.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);
let Declaration$1 = declaration;
let PreviousMap22 = previousMap;
let Comment$1 = comment;
let AtRule$1 = atRule;
let Input$1 = input;
let Root$1 = root;
let Rule$1 = rule;
function fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n2)=>fromJSON$1(n2));
    let { inputs: ownInputs } = json, defaults = _object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = _extends({}, input2, {
                __proto__: Input$1.prototype
            });
            if (inputHydrated.map) {
                inputHydrated.map = _extends({}, inputHydrated.map, {
                    __proto__: PreviousMap22.prototype
                });
            }
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) {
        defaults.nodes = json.nodes.map((n2)=>fromJSON$1(n2, inputs));
    }
    if (defaults.source) {
        let _defaults_source = defaults.source, { inputId } = _defaults_source, source = _object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) {
            defaults.source.input = inputs[inputId];
        }
    }
    if (defaults.type === "root") {
        return new Root$1(defaults);
    } else if (defaults.type === "decl") {
        return new Declaration$1(defaults);
    } else if (defaults.type === "rule") {
        return new Rule$1(defaults);
    } else if (defaults.type === "comment") {
        return new Comment$1(defaults);
    } else if (defaults.type === "atrule") {
        return new AtRule$1(defaults);
    } else {
        throw new Error("Unknown node type: " + json.type);
    }
}
var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;
let CssSyntaxError22 = cssSyntaxError;
let Declaration22 = declaration;
let LazyResult22 = lazyResult;
let Container22 = container;
let Processor22 = processor;
let stringify = stringify_1;
let fromJSON = fromJSON_1;
let Document222 = document$1;
let Warning22 = warning;
let Comment22 = comment;
let AtRule22 = atRule;
let Result22 = result;
let Input22 = input;
let parse = parse_1;
let list = list_1;
let Rule22 = rule;
let Root22 = root;
let Node22 = node;
function postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) {
        plugins = plugins[0];
    }
    return new Processor22(plugins);
}
postcss.plugin = function plugin2(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
            if ( true && "C.UTF-8".startsWith("cn")) {
                console.warn(name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226");
            }
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new Processor22().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
postcss.stringify = stringify;
postcss.parse = parse;
postcss.fromJSON = fromJSON;
postcss.list = list;
postcss.comment = (defaults)=>new Comment22(defaults);
postcss.atRule = (defaults)=>new AtRule22(defaults);
postcss.decl = (defaults)=>new Declaration22(defaults);
postcss.rule = (defaults)=>new Rule22(defaults);
postcss.root = (defaults)=>new Root22(defaults);
postcss.document = (defaults)=>new Document222(defaults);
postcss.CssSyntaxError = CssSyntaxError22;
postcss.Declaration = Declaration22;
postcss.Container = Container22;
postcss.Processor = Processor22;
postcss.Document = Document222;
postcss.Comment = Comment22;
postcss.Warning = Warning22;
postcss.AtRule = AtRule22;
postcss.Result = Result22;
postcss.Input = Input22;
postcss.Rule = Rule22;
postcss.Root = Root22;
postcss.Node = Node22;
LazyResult22.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
const postcss$1 = /* @__PURE__ */ getDefaultExportFromCjs(postcss_1);
postcss$1.stringify;
postcss$1.fromJSON;
postcss$1.plugin;
postcss$1.parse;
postcss$1.list;
postcss$1.document;
postcss$1.comment;
postcss$1.atRule;
postcss$1.rule;
postcss$1.decl;
postcss$1.root;
postcss$1.CssSyntaxError;
postcss$1.Declaration;
postcss$1.Container;
postcss$1.Processor;
postcss$1.Document;
postcss$1.Comment;
postcss$1.Warning;
postcss$1.AtRule;
postcss$1.Result;
postcss$1.Input;
postcss$1.Rule;
postcss$1.Root;
postcss$1.Node;
function parseCSSText(cssText) {
    const res = {};
    const listDelimiter = /;(?![^(]*\))/g;
    const propertyDelimiter = /:(.+)/;
    const comment2 = /\/\*.*?\*\//g;
    cssText.replace(comment2, "").split(listDelimiter).forEach(function(item) {
        if (item) {
            const tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[camelize(tmp[0].trim())] = tmp[1].trim());
        }
    });
    return res;
}
function toCSSText(style) {
    const properties = [];
    for(const name in style){
        const value = style[name];
        if (typeof value !== "string") continue;
        const normalizedName = hyphenate(name);
        properties.push(`${normalizedName}: ${value};`);
    }
    return properties.join(" ");
}
const camelizeRE = /-([a-z])/g;
const CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
const camelize = (str)=>{
    if (CUSTOM_PROPERTY_REGEX.test(str)) return str;
    return str.replace(camelizeRE, (_, c2)=>c2 ? c2.toUpperCase() : "");
};
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = (str)=>{
    return str.replace(hyphenateRE, "-$1").toLowerCase();
};
class BaseRRNode {
    get childNodes() {
        const childNodes2 = [];
        let childIterator = this.firstChild;
        while(childIterator){
            childNodes2.push(childIterator);
            childIterator = childIterator.nextSibling;
        }
        return childNodes2;
    }
    contains(node2) {
        if (!(node2 instanceof BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appendChild(_newChild) {
        throw new Error(`RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    insertBefore(_newChild, _refChild) {
        throw new Error(`RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeChild(_node) {
        throw new Error(`RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.`);
    }
    toString() {
        return "RRNode";
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    constructor(..._args){
        __publicField2(this, "parentElement", null);
        __publicField2(this, "parentNode", null);
        __publicField2(this, "ownerDocument");
        __publicField2(this, "firstChild", null);
        __publicField2(this, "lastChild", null);
        __publicField2(this, "previousSibling", null);
        __publicField2(this, "nextSibling", null);
        __publicField2(this, "ELEMENT_NODE", 1);
        __publicField2(this, "TEXT_NODE", 3);
        __publicField2(this, "nodeType");
        __publicField2(this, "nodeName");
        __publicField2(this, "RRNodeType");
    }
}
class BaseRRDocument extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    get documentElement() {
        return this.childNodes.find((node2)=>node2.RRNodeType === NodeType$1.Element && node2.tagName === "HTML") || null;
    }
    get body() {
        var _a2;
        return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find((node2)=>node2.RRNodeType === NodeType$1.Element && node2.tagName === "BODY")) || null;
    }
    get head() {
        var _a2;
        return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find((node2)=>node2.RRNodeType === NodeType$1.Element && node2.tagName === "HEAD")) || null;
    }
    get implementation() {
        return this;
    }
    get firstElementChild() {
        return this.documentElement;
    }
    appendChild(newChild) {
        const nodeType = newChild.RRNodeType;
        if (nodeType === NodeType$1.Element || nodeType === NodeType$1.DocumentType) {
            if (this.childNodes.some((s2)=>s2.RRNodeType === nodeType)) {
                throw new Error(`RRDomException: Failed to execute 'appendChild' on 'RRNode': Only one ${nodeType === NodeType$1.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`);
            }
        }
        const child = appendChild(this, newChild);
        child.parentElement = null;
        return child;
    }
    insertBefore(newChild, refChild) {
        const nodeType = newChild.RRNodeType;
        if (nodeType === NodeType$1.Element || nodeType === NodeType$1.DocumentType) {
            if (this.childNodes.some((s2)=>s2.RRNodeType === nodeType)) {
                throw new Error(`RRDomException: Failed to execute 'insertBefore' on 'RRNode': Only one ${nodeType === NodeType$1.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`);
            }
        }
        const child = insertBefore(this, newChild, refChild);
        child.parentElement = null;
        return child;
    }
    removeChild(node2) {
        return removeChild(this, node2);
    }
    open() {
        this.firstChild = null;
        this.lastChild = null;
    }
    close() {}
    /**
   * Adhoc implementation for setting xhtml namespace in rebuilt.ts (rrweb-snapshot).
   * There are two lines used this function:
   * 1. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" ""\>')
   * 2. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" ""\>')
   */ write(content) {
        let publicId;
        if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">') publicId = "-//W3C//DTD XHTML 1.0 Transitional//EN";
        else if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">') publicId = "-//W3C//DTD HTML 4.0 Transitional//EN";
        if (publicId) {
            const doctype = this.createDocumentType("html", publicId, "");
            this.open();
            this.appendChild(doctype);
        }
    }
    createDocument(_namespace, _qualifiedName, _doctype) {
        return new BaseRRDocument();
    }
    createDocumentType(qualifiedName, publicId, systemId) {
        const doctype = new BaseRRDocumentType(qualifiedName, publicId, systemId);
        doctype.ownerDocument = this;
        return doctype;
    }
    createElement(tagName) {
        const element = new BaseRRElement(tagName);
        element.ownerDocument = this;
        return element;
    }
    createElementNS(_namespaceURI, qualifiedName) {
        return this.createElement(qualifiedName);
    }
    createTextNode(data) {
        const text = new BaseRRText(data);
        text.ownerDocument = this;
        return text;
    }
    createComment(data) {
        const comment2 = new BaseRRComment(data);
        comment2.ownerDocument = this;
        return comment2;
    }
    createCDATASection(data) {
        const CDATASection = new BaseRRCDATASection(data);
        CDATASection.ownerDocument = this;
        return CDATASection;
    }
    toString() {
        return "RRDocument";
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args){
        super(args);
        __publicField2(this, "nodeType", 9);
        __publicField2(this, "nodeName", "#document");
        __publicField2(this, "compatMode", "CSS1Compat");
        __publicField2(this, "RRNodeType", NodeType$1.Document);
        __publicField2(this, "textContent", null);
        this.ownerDocument = this;
    }
}
class BaseRRDocumentType extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    toString() {
        return "RRDocumentType";
    }
    constructor(qualifiedName, publicId, systemId){
        super();
        __publicField2(this, "nodeType", 10);
        __publicField2(this, "RRNodeType", NodeType$1.DocumentType);
        __publicField2(this, "name");
        __publicField2(this, "publicId");
        __publicField2(this, "systemId");
        __publicField2(this, "textContent", null);
        this.name = qualifiedName;
        this.publicId = publicId;
        this.systemId = systemId;
        this.nodeName = qualifiedName;
    }
}
class BaseRRElement extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    get textContent() {
        let result2 = "";
        this.childNodes.forEach((node2)=>result2 += node2.textContent);
        return result2;
    }
    set textContent(textContent2) {
        this.firstChild = null;
        this.lastChild = null;
        this.appendChild(this.ownerDocument.createTextNode(textContent2));
    }
    get classList() {
        return new ClassList(this.attributes.class, (newClassName)=>{
            this.attributes.class = newClassName;
        });
    }
    get id() {
        return this.attributes.id || "";
    }
    get className() {
        return this.attributes.class || "";
    }
    get style() {
        const style = this.attributes.style ? parseCSSText(this.attributes.style) : {};
        const hyphenateRE2 = /\B([A-Z])/g;
        style.setProperty = (name, value, priority)=>{
            if (hyphenateRE2.test(name)) return;
            const normalizedName = camelize(name);
            if (!value) delete style[normalizedName];
            else style[normalizedName] = value;
            if (priority === "important") style[normalizedName] += " !important";
            this.attributes.style = toCSSText(style);
        };
        style.removeProperty = (name)=>{
            if (hyphenateRE2.test(name)) return "";
            const normalizedName = camelize(name);
            const value = style[normalizedName] || "";
            delete style[normalizedName];
            this.attributes.style = toCSSText(style);
            return value;
        };
        return style;
    }
    getAttribute(name) {
        if (this.attributes[name] === void 0) return null;
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
    }
    setAttributeNS(_namespace, qualifiedName, value) {
        this.setAttribute(qualifiedName, value);
    }
    removeAttribute(name) {
        delete this.attributes[name];
    }
    appendChild(newChild) {
        return appendChild(this, newChild);
    }
    insertBefore(newChild, refChild) {
        return insertBefore(this, newChild, refChild);
    }
    removeChild(node2) {
        return removeChild(this, node2);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attachShadow(_init) {
        const shadowRoot2 = this.ownerDocument.createElement("SHADOWROOT");
        this.shadowRoot = shadowRoot2;
        return shadowRoot2;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatchEvent(_event) {
        return true;
    }
    toString() {
        let attributeString = "";
        for(const attribute in this.attributes){
            attributeString += `${attribute}="${this.attributes[attribute]}" `;
        }
        return `${this.tagName} ${attributeString}`;
    }
    constructor(tagName){
        super();
        __publicField2(this, "nodeType", 1);
        __publicField2(this, "RRNodeType", NodeType$1.Element);
        __publicField2(this, "tagName");
        __publicField2(this, "attributes", {});
        __publicField2(this, "shadowRoot", null);
        __publicField2(this, "scrollLeft");
        __publicField2(this, "scrollTop");
        this.tagName = tagName.toUpperCase();
        this.nodeName = tagName.toUpperCase();
    }
}
class BaseRRMediaElement extends (/* unused pure expression or super */ null && (BaseRRElement)) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attachShadow(_init) {
        throw new Error(`RRDomException: Failed to execute 'attachShadow' on 'RRElement': This RRElement does not support attachShadow`);
    }
    play() {
        this.paused = false;
    }
    pause() {
        this.paused = true;
    }
    constructor(){
        super(...arguments);
        __publicField2(this, "currentTime");
        __publicField2(this, "volume");
        __publicField2(this, "paused");
        __publicField2(this, "muted");
        __publicField2(this, "playbackRate");
        __publicField2(this, "loop");
    }
}
class BaseRRDialogElement extends (/* unused pure expression or super */ null && (BaseRRElement)) {
    get isModal() {
        return this.getAttribute("rr_open_mode") === "modal";
    }
    get open() {
        return this.getAttribute("open") !== null;
    }
    close() {
        this.removeAttribute("open");
        this.removeAttribute("rr_open_mode");
    }
    show() {
        this.setAttribute("open", "");
        this.setAttribute("rr_open_mode", "non-modal");
    }
    showModal() {
        this.setAttribute("open", "");
        this.setAttribute("rr_open_mode", "modal");
    }
    constructor(){
        super(...arguments);
        __publicField2(this, "tagName", "DIALOG");
        __publicField2(this, "nodeName", "DIALOG");
    }
}
class BaseRRText extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRText text=${JSON.stringify(this.data)}`;
    }
    constructor(data){
        super();
        __publicField2(this, "nodeType", 3);
        __publicField2(this, "nodeName", "#text");
        __publicField2(this, "RRNodeType", NodeType$1.Text);
        __publicField2(this, "data");
        this.data = data;
    }
}
class BaseRRComment extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRComment text=${JSON.stringify(this.data)}`;
    }
    constructor(data){
        super();
        __publicField2(this, "nodeType", 8);
        __publicField2(this, "nodeName", "#comment");
        __publicField2(this, "RRNodeType", NodeType$1.Comment);
        __publicField2(this, "data");
        this.data = data;
    }
}
class BaseRRCDATASection extends (/* unused pure expression or super */ null && (BaseRRNode)) {
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRCDATASection data=${JSON.stringify(this.data)}`;
    }
    constructor(data){
        super();
        __publicField2(this, "nodeName", "#cdata-section");
        __publicField2(this, "nodeType", 4);
        __publicField2(this, "RRNodeType", NodeType$1.CDATA);
        __publicField2(this, "data");
        this.data = data;
    }
}
class ClassList {
    constructor(classText, onChange){
        __publicField2(this, "onChange");
        __publicField2(this, "classes", []);
        __publicField2(this, "add", (...classNames)=>{
            for (const item of classNames){
                const className = String(item);
                if (this.classes.indexOf(className) >= 0) continue;
                this.classes.push(className);
            }
            this.onChange && this.onChange(this.classes.join(" "));
        });
        __publicField2(this, "remove", (...classNames)=>{
            this.classes = this.classes.filter((item)=>classNames.indexOf(item) === -1);
            this.onChange && this.onChange(this.classes.join(" "));
        });
        if (classText) {
            const classes = classText.trim().split(/\s+/);
            this.classes.push(...classes);
        }
        this.onChange = onChange;
    }
}
function appendChild(parent, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    if (parent.lastChild) {
        parent.lastChild.nextSibling = newChild;
        newChild.previousSibling = parent.lastChild;
    } else {
        parent.firstChild = newChild;
        newChild.previousSibling = null;
    }
    parent.lastChild = newChild;
    newChild.nextSibling = null;
    newChild.parentNode = parent;
    newChild.parentElement = parent;
    newChild.ownerDocument = parent.ownerDocument;
    return newChild;
}
function insertBefore(parent, newChild, refChild) {
    if (!refChild) return appendChild(parent, newChild);
    if (refChild.parentNode !== parent) throw new Error("Failed to execute 'insertBefore' on 'RRNode': The RRNode before which the new node is to be inserted is not a child of this RRNode.");
    if (newChild === refChild) return newChild;
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.previousSibling = refChild.previousSibling;
    refChild.previousSibling = newChild;
    newChild.nextSibling = refChild;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parent.firstChild = newChild;
    newChild.parentElement = parent;
    newChild.parentNode = parent;
    newChild.ownerDocument = parent.ownerDocument;
    return newChild;
}
function removeChild(parent, child) {
    if (child.parentNode !== parent) throw new Error("Failed to execute 'removeChild' on 'RRNode': The RRNode to be removed is not a child of this RRNode.");
    if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
    else parent.firstChild = child.nextSibling;
    if (child.nextSibling) child.nextSibling.previousSibling = child.previousSibling;
    else parent.lastChild = child.previousSibling;
    child.previousSibling = null;
    child.nextSibling = null;
    child.parentElement = null;
    child.parentNode = null;
    return child;
}
var NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["PLACEHOLDER"] = 0] = "PLACEHOLDER";
    NodeType2[NodeType2["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType2[NodeType2["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
    NodeType2[NodeType2["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType2[NodeType2["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
    NodeType2[NodeType2["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
    NodeType2[NodeType2["ENTITY_NODE"] = 6] = "ENTITY_NODE";
    NodeType2[NodeType2["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
    NodeType2[NodeType2["COMMENT_NODE"] = 8] = "COMMENT_NODE";
    NodeType2[NodeType2["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
    NodeType2[NodeType2["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
    NodeType2[NodeType2["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
    return NodeType2;
})(NodeType || {});
const NAMESPACES = {
    svg: "http://www.w3.org/2000/svg",
    "xlink:href": "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/xmlns/"
};
const SVGTagMap = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
let createdNodeSet = null;
function diff(oldTree, newTree, replayer, rrnodeMirror = newTree.mirror || newTree.ownerDocument.mirror) {
    oldTree = diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror);
    diffChildren(oldTree, newTree, replayer, rrnodeMirror);
    diffAfterUpdatingChildren(oldTree, newTree, replayer);
}
function diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror) {
    var _a2;
    if (replayer.afterAppend && !createdNodeSet) {
        createdNodeSet = /* @__PURE__ */ new WeakSet();
        setTimeout(()=>{
            createdNodeSet = null;
        }, 0);
    }
    if (!sameNodeType(oldTree, newTree)) {
        const calibratedOldTree = createOrGetNode(newTree, replayer.mirror, rrnodeMirror);
        (_a2 = oldTree.parentNode) == null ? void 0 : _a2.replaceChild(calibratedOldTree, oldTree);
        oldTree = calibratedOldTree;
    }
    switch(newTree.RRNodeType){
        case NodeType$1.Document:
            {
                if (!nodeMatching(oldTree, newTree, replayer.mirror, rrnodeMirror)) {
                    const newMeta = rrnodeMirror.getMeta(newTree);
                    if (newMeta) {
                        replayer.mirror.removeNodeFromMap(oldTree);
                        oldTree.close();
                        oldTree.open();
                        replayer.mirror.add(oldTree, newMeta);
                        createdNodeSet == null ? void 0 : createdNodeSet.add(oldTree);
                    }
                }
                break;
            }
        case NodeType$1.Element:
            {
                const oldElement = oldTree;
                const newRRElement = newTree;
                switch(newRRElement.tagName){
                    case "IFRAME":
                        {
                            const oldContentDocument = oldTree.contentDocument;
                            if (!oldContentDocument) break;
                            diff(oldContentDocument, newTree.contentDocument, replayer, rrnodeMirror);
                            break;
                        }
                }
                if (newRRElement.shadowRoot) {
                    if (!oldElement.shadowRoot) oldElement.attachShadow({
                        mode: "open"
                    });
                    diffChildren(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    oldElement.shadowRoot, newRRElement.shadowRoot, replayer, rrnodeMirror);
                }
                diffProps(oldElement, newRRElement, rrnodeMirror);
                break;
            }
    }
    return oldTree;
}
function diffAfterUpdatingChildren(oldTree, newTree, replayer) {
    var _a2;
    switch(newTree.RRNodeType){
        case NodeType$1.Document:
            {
                const scrollData = newTree.scrollData;
                scrollData && replayer.applyScroll(scrollData, true);
                break;
            }
        case NodeType$1.Element:
            {
                const oldElement = oldTree;
                const newRRElement = newTree;
                newRRElement.scrollData && replayer.applyScroll(newRRElement.scrollData, true);
                newRRElement.inputData && replayer.applyInput(newRRElement.inputData);
                switch(newRRElement.tagName){
                    case "AUDIO":
                    case "VIDEO":
                        {
                            const oldMediaElement = oldTree;
                            const newMediaRRElement = newRRElement;
                            if (newMediaRRElement.paused !== void 0) newMediaRRElement.paused ? void oldMediaElement.pause() : void oldMediaElement.play();
                            if (newMediaRRElement.muted !== void 0) oldMediaElement.muted = newMediaRRElement.muted;
                            if (newMediaRRElement.volume !== void 0) oldMediaElement.volume = newMediaRRElement.volume;
                            if (newMediaRRElement.currentTime !== void 0) oldMediaElement.currentTime = newMediaRRElement.currentTime;
                            if (newMediaRRElement.playbackRate !== void 0) oldMediaElement.playbackRate = newMediaRRElement.playbackRate;
                            if (newMediaRRElement.loop !== void 0) oldMediaElement.loop = newMediaRRElement.loop;
                            break;
                        }
                    case "CANVAS":
                        {
                            const rrCanvasElement = newTree;
                            if (rrCanvasElement.rr_dataURL !== null) {
                                const image = document.createElement("img");
                                image.onload = ()=>{
                                    const ctx = oldElement.getContext("2d");
                                    if (ctx) {
                                        ctx.drawImage(image, 0, 0, image.width, image.height);
                                    }
                                };
                                image.src = rrCanvasElement.rr_dataURL;
                            }
                            rrCanvasElement.canvasMutations.forEach((canvasMutation2)=>replayer.applyCanvas(canvasMutation2.event, canvasMutation2.mutation, oldTree));
                            break;
                        }
                    case "STYLE":
                        {
                            const styleSheet = oldElement.sheet;
                            styleSheet && newTree.rules.forEach((data)=>replayer.applyStyleSheetMutation(data, styleSheet));
                            break;
                        }
                    case "DIALOG":
                        {
                            const dialog = oldElement;
                            const rrDialog = newRRElement;
                            const wasOpen = dialog.open;
                            const wasModal = dialog.matches("dialog:modal");
                            const shouldBeOpen = rrDialog.open;
                            const shouldBeModal = rrDialog.isModal;
                            const modalChanged = wasModal !== shouldBeModal;
                            const openChanged = wasOpen !== shouldBeOpen;
                            if (modalChanged || wasOpen && openChanged) dialog.close();
                            if (shouldBeOpen && (openChanged || modalChanged)) {
                                try {
                                    if (shouldBeModal) dialog.showModal();
                                    else dialog.show();
                                } catch (e2) {
                                    console.warn(e2);
                                }
                            }
                            break;
                        }
                }
                break;
            }
        case NodeType$1.Text:
        case NodeType$1.Comment:
        case NodeType$1.CDATA:
            {
                if (oldTree.textContent !== newTree.data) oldTree.textContent = newTree.data;
                break;
            }
    }
    if (createdNodeSet == null ? void 0 : createdNodeSet.has(oldTree)) {
        createdNodeSet.delete(oldTree);
        (_a2 = replayer.afterAppend) == null ? void 0 : _a2.call(replayer, oldTree, replayer.mirror.getId(oldTree));
    }
}
function diffProps(oldTree, newTree, rrnodeMirror) {
    const oldAttributes = oldTree.attributes;
    const newAttributes = newTree.attributes;
    for(const name in newAttributes){
        const newValue = newAttributes[name];
        const sn = rrnodeMirror.getMeta(newTree);
        if ((sn == null ? void 0 : sn.isSVG) && NAMESPACES[name]) oldTree.setAttributeNS(NAMESPACES[name], name, newValue);
        else if (newTree.tagName === "CANVAS" && name === "rr_dataURL") {
            const image = document.createElement("img");
            image.src = newValue;
            image.onload = ()=>{
                const ctx = oldTree.getContext("2d");
                if (ctx) {
                    ctx.drawImage(image, 0, 0, image.width, image.height);
                }
            };
        } else if (newTree.tagName === "IFRAME" && name === "srcdoc") continue;
        else oldTree.setAttribute(name, newValue);
    }
    for (const { name } of Array.from(oldAttributes))if (!(name in newAttributes)) oldTree.removeAttribute(name);
    newTree.scrollLeft && (oldTree.scrollLeft = newTree.scrollLeft);
    newTree.scrollTop && (oldTree.scrollTop = newTree.scrollTop);
}
function diffChildren(oldTree, newTree, replayer, rrnodeMirror) {
    const oldChildren = Array.from(oldTree.childNodes);
    const newChildren = newTree.childNodes;
    if (oldChildren.length === 0 && newChildren.length === 0) return;
    let oldStartIndex = 0, oldEndIndex = oldChildren.length - 1, newStartIndex = 0, newEndIndex = newChildren.length - 1;
    let oldStartNode = oldChildren[oldStartIndex], oldEndNode = oldChildren[oldEndIndex], newStartNode = newChildren[newStartIndex], newEndNode = newChildren[newEndIndex];
    let oldIdToIndex = void 0, indexInOld = void 0;
    while(oldStartIndex <= oldEndIndex && newStartIndex <= newEndIndex){
        if (oldStartNode === void 0) {
            oldStartNode = oldChildren[++oldStartIndex];
        } else if (oldEndNode === void 0) {
            oldEndNode = oldChildren[--oldEndIndex];
        } else if (// same first node?
        nodeMatching(oldStartNode, newStartNode, replayer.mirror, rrnodeMirror)) {
            oldStartNode = oldChildren[++oldStartIndex];
            newStartNode = newChildren[++newStartIndex];
        } else if (// same last node?
        nodeMatching(oldEndNode, newEndNode, replayer.mirror, rrnodeMirror)) {
            oldEndNode = oldChildren[--oldEndIndex];
            newEndNode = newChildren[--newEndIndex];
        } else if (// is the first old node the same as the last new node?
        nodeMatching(oldStartNode, newEndNode, replayer.mirror, rrnodeMirror)) {
            try {
                oldTree.insertBefore(oldStartNode, oldEndNode.nextSibling);
            } catch (e2) {
                console.warn(e2);
            }
            oldStartNode = oldChildren[++oldStartIndex];
            newEndNode = newChildren[--newEndIndex];
        } else if (// is the last old node the same as the first new node?
        nodeMatching(oldEndNode, newStartNode, replayer.mirror, rrnodeMirror)) {
            try {
                oldTree.insertBefore(oldEndNode, oldStartNode);
            } catch (e2) {
                console.warn(e2);
            }
            oldEndNode = oldChildren[--oldEndIndex];
            newStartNode = newChildren[++newStartIndex];
        } else {
            if (!oldIdToIndex) {
                oldIdToIndex = {};
                for(let i2 = oldStartIndex; i2 <= oldEndIndex; i2++){
                    const oldChild2 = oldChildren[i2];
                    if (oldChild2 && replayer.mirror.hasNode(oldChild2)) oldIdToIndex[replayer.mirror.getId(oldChild2)] = i2;
                }
            }
            indexInOld = oldIdToIndex[rrnodeMirror.getId(newStartNode)];
            const nodeToMove = oldChildren[indexInOld];
            if (indexInOld !== void 0 && nodeToMove && nodeMatching(nodeToMove, newStartNode, replayer.mirror, rrnodeMirror)) {
                try {
                    oldTree.insertBefore(nodeToMove, oldStartNode);
                } catch (e2) {
                    console.warn(e2);
                }
                oldChildren[indexInOld] = void 0;
            } else {
                const newNode = createOrGetNode(newStartNode, replayer.mirror, rrnodeMirror);
                if (oldTree.nodeName === "#document" && oldStartNode && /**
        * Special case 1: one document isn't allowed to have two doctype nodes at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A parent document in the old tree already has a doctype node with an id e.g. #1. A new full snapshot rebuilds the replayer with a new doctype node with another id #2. According to the algorithm, the new doctype node will be inserted before the old one, which is not allowed by the Document standard.
        */ (newNode.nodeType === newNode.DOCUMENT_TYPE_NODE && oldStartNode.nodeType === oldStartNode.DOCUMENT_TYPE_NODE || /**
        * Special case 2: one document isn't allowed to have two HTMLElements at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A mounted iframe element has an automatically created HTML element. We should delete it before inserting a serialized one. Otherwise, an error 'Only one element on document allowed' will be thrown.
        */ newNode.nodeType === newNode.ELEMENT_NODE && oldStartNode.nodeType === oldStartNode.ELEMENT_NODE)) {
                    oldTree.removeChild(oldStartNode);
                    replayer.mirror.removeNodeFromMap(oldStartNode);
                    oldStartNode = oldChildren[++oldStartIndex];
                }
                try {
                    oldTree.insertBefore(newNode, oldStartNode || null);
                } catch (e2) {
                    console.warn(e2);
                }
            }
            newStartNode = newChildren[++newStartIndex];
        }
    }
    if (oldStartIndex > oldEndIndex) {
        const referenceRRNode = newChildren[newEndIndex + 1];
        let referenceNode = null;
        if (referenceRRNode) referenceNode = replayer.mirror.getNode(rrnodeMirror.getId(referenceRRNode));
        for(; newStartIndex <= newEndIndex; ++newStartIndex){
            const newNode = createOrGetNode(newChildren[newStartIndex], replayer.mirror, rrnodeMirror);
            try {
                oldTree.insertBefore(newNode, referenceNode);
            } catch (e2) {
                console.warn(e2);
            }
        }
    } else if (newStartIndex > newEndIndex) {
        for(; oldStartIndex <= oldEndIndex; oldStartIndex++){
            const node2 = oldChildren[oldStartIndex];
            if (!node2 || node2.parentNode !== oldTree) continue;
            try {
                oldTree.removeChild(node2);
                replayer.mirror.removeNodeFromMap(node2);
            } catch (e2) {
                console.warn(e2);
            }
        }
    }
    let oldChild = oldTree.firstChild;
    let newChild = newTree.firstChild;
    while(oldChild !== null && newChild !== null){
        diff(oldChild, newChild, replayer, rrnodeMirror);
        oldChild = oldChild.nextSibling;
        newChild = newChild.nextSibling;
    }
}
function createOrGetNode(rrNode, domMirror, rrnodeMirror) {
    const nodeId = rrnodeMirror.getId(rrNode);
    const sn = rrnodeMirror.getMeta(rrNode);
    let node2 = null;
    if (nodeId > -1) node2 = domMirror.getNode(nodeId);
    if (node2 !== null && sameNodeType(node2, rrNode)) return node2;
    switch(rrNode.RRNodeType){
        case NodeType$1.Document:
            node2 = new Document();
            break;
        case NodeType$1.DocumentType:
            node2 = document.implementation.createDocumentType(rrNode.name, rrNode.publicId, rrNode.systemId);
            break;
        case NodeType$1.Element:
            {
                let tagName = rrNode.tagName.toLowerCase();
                tagName = SVGTagMap[tagName] || tagName;
                if (sn && "isSVG" in sn && (sn == null ? void 0 : sn.isSVG)) {
                    node2 = document.createElementNS(NAMESPACES["svg"], tagName);
                } else node2 = document.createElement(rrNode.tagName);
                break;
            }
        case NodeType$1.Text:
            node2 = document.createTextNode(rrNode.data);
            break;
        case NodeType$1.Comment:
            node2 = document.createComment(rrNode.data);
            break;
        case NodeType$1.CDATA:
            node2 = document.createCDATASection(rrNode.data);
            break;
    }
    if (sn) domMirror.add(node2, _extends({}, sn));
    try {
        createdNodeSet == null ? void 0 : createdNodeSet.add(node2);
    } catch (e2) {}
    return node2;
}
function sameNodeType(node1, node2) {
    if (node1.nodeType !== node2.nodeType) return false;
    return node1.nodeType !== node1.ELEMENT_NODE || node1.tagName.toUpperCase() === node2.tagName;
}
function nodeMatching(node1, node2, domMirror, rrdomMirror) {
    const node1Id = domMirror.getId(node1);
    const node2Id = rrdomMirror.getId(node2);
    if (node1Id === -1 || node1Id !== node2Id) return false;
    return sameNodeType(node1, node2);
}
class RRDocument extends (/* unused pure expression or super */ null && (BaseRRDocument)) {
    /**
   * Every time the id is used, it will minus 1 automatically to avoid collisions.
   */ get unserializedId() {
        return this._unserializedId--;
    }
    createDocument(_namespace, _qualifiedName, _doctype) {
        return new RRDocument();
    }
    createDocumentType(qualifiedName, publicId, systemId) {
        const documentTypeNode = new RRDocumentType(qualifiedName, publicId, systemId);
        documentTypeNode.ownerDocument = this;
        return documentTypeNode;
    }
    createElement(tagName) {
        const upperTagName = tagName.toUpperCase();
        let element;
        switch(upperTagName){
            case "AUDIO":
            case "VIDEO":
                element = new RRMediaElement(upperTagName);
                break;
            case "IFRAME":
                element = new RRIFrameElement(upperTagName, this.mirror);
                break;
            case "CANVAS":
                element = new RRCanvasElement(upperTagName);
                break;
            case "STYLE":
                element = new RRStyleElement(upperTagName);
                break;
            case "DIALOG":
                element = new RRDialogElement(upperTagName);
                break;
            default:
                element = new RRElement(upperTagName);
                break;
        }
        element.ownerDocument = this;
        return element;
    }
    createComment(data) {
        const commentNode = new RRComment(data);
        commentNode.ownerDocument = this;
        return commentNode;
    }
    createCDATASection(data) {
        const sectionNode = new RRCDATASection(data);
        sectionNode.ownerDocument = this;
        return sectionNode;
    }
    createTextNode(data) {
        const textNode = new RRText(data);
        textNode.ownerDocument = this;
        return textNode;
    }
    destroyTree() {
        this.firstChild = null;
        this.lastChild = null;
        this.mirror.reset();
    }
    open() {
        super.open();
        this._unserializedId = this.UNSERIALIZED_STARTING_ID;
    }
    constructor(mirror2){
        super();
        __publicField2(this, "UNSERIALIZED_STARTING_ID", -2);
        __publicField2(this, "_unserializedId", this.UNSERIALIZED_STARTING_ID);
        __publicField2(this, "mirror", createMirror());
        __publicField2(this, "scrollData", null);
        if (mirror2) {
            this.mirror = mirror2;
        }
    }
}
const RRDocumentType = (/* unused pure expression or super */ null && (BaseRRDocumentType));
class RRElement extends (/* unused pure expression or super */ null && (BaseRRElement)) {
    constructor(){
        super(...arguments);
        __publicField2(this, "inputData", null);
        __publicField2(this, "scrollData", null);
    }
}
class RRMediaElement extends (/* unused pure expression or super */ null && (BaseRRMediaElement)) {
}
class RRDialogElement extends (/* unused pure expression or super */ null && (BaseRRDialogElement)) {
}
class RRCanvasElement extends (/* unused pure expression or super */ null && (RRElement)) {
    /**
   * This is a dummy implementation to distinguish RRCanvasElement from real HTMLCanvasElement.
   */ getContext() {
        return null;
    }
    constructor(){
        super(...arguments);
        __publicField2(this, "rr_dataURL", null);
        __publicField2(this, "canvasMutations", []);
    }
}
class RRStyleElement extends (/* unused pure expression or super */ null && (RRElement)) {
    constructor(){
        super(...arguments);
        __publicField2(this, "rules", []);
    }
}
class RRIFrameElement extends (/* unused pure expression or super */ null && (RRElement)) {
    constructor(upperTagName, mirror2){
        super(upperTagName);
        __publicField2(this, "contentDocument", new RRDocument());
        this.contentDocument.mirror = mirror2;
    }
}
const RRText = (/* unused pure expression or super */ null && (BaseRRText));
const RRComment = (/* unused pure expression or super */ null && (BaseRRComment));
const RRCDATASection = (/* unused pure expression or super */ null && (BaseRRCDATASection));
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return "FORM";
    }
    return element.tagName.toUpperCase();
}
function buildFromNode(node2, rrdom, domMirror, parentRRNode) {
    let rrNode;
    switch(node2.nodeType){
        case NodeType.DOCUMENT_NODE:
            if (parentRRNode && parentRRNode.nodeName === "IFRAME") rrNode = parentRRNode.contentDocument;
            else {
                rrNode = rrdom;
                rrNode.compatMode = node2.compatMode;
            }
            break;
        case NodeType.DOCUMENT_TYPE_NODE:
            {
                const documentType = node2;
                rrNode = rrdom.createDocumentType(documentType.name, documentType.publicId, documentType.systemId);
                break;
            }
        case NodeType.ELEMENT_NODE:
            {
                const elementNode = node2;
                const tagName = getValidTagName(elementNode);
                rrNode = rrdom.createElement(tagName);
                const rrElement = rrNode;
                for (const { name, value } of Array.from(elementNode.attributes)){
                    rrElement.attributes[name] = value;
                }
                elementNode.scrollLeft && (rrElement.scrollLeft = elementNode.scrollLeft);
                elementNode.scrollTop && (rrElement.scrollTop = elementNode.scrollTop);
                break;
            }
        case NodeType.TEXT_NODE:
            rrNode = rrdom.createTextNode(node2.textContent || "");
            break;
        case NodeType.CDATA_SECTION_NODE:
            rrNode = rrdom.createCDATASection(node2.data);
            break;
        case NodeType.COMMENT_NODE:
            rrNode = rrdom.createComment(node2.textContent || "");
            break;
        case NodeType.DOCUMENT_FRAGMENT_NODE:
            rrNode = parentRRNode.attachShadow({
                mode: "open"
            });
            break;
        default:
            return null;
    }
    let sn = domMirror.getMeta(node2);
    if (rrdom instanceof RRDocument) {
        if (!sn) {
            sn = getDefaultSN(rrNode, rrdom.unserializedId);
            domMirror.add(node2, sn);
        }
        rrdom.mirror.add(rrNode, _extends({}, sn));
    }
    return rrNode;
}
function buildFromDom(dom, domMirror = createMirror$1(), rrdom = new RRDocument()) {
    function walk2(node2, parentRRNode) {
        const rrNode = buildFromNode(node2, rrdom, domMirror, parentRRNode);
        if (rrNode === null) return;
        if (// if the parentRRNode isn't a RRIFrameElement
        (parentRRNode == null ? void 0 : parentRRNode.nodeName) !== "IFRAME" && // if node isn't a shadow root
        node2.nodeType !== NodeType.DOCUMENT_FRAGMENT_NODE) {
            parentRRNode == null ? void 0 : parentRRNode.appendChild(rrNode);
            rrNode.parentNode = parentRRNode;
            rrNode.parentElement = parentRRNode;
        }
        if (node2.nodeName === "IFRAME") {
            const iframeDoc = node2.contentDocument;
            iframeDoc && walk2(iframeDoc, rrNode);
        } else if (node2.nodeType === NodeType.DOCUMENT_NODE || node2.nodeType === NodeType.ELEMENT_NODE || node2.nodeType === NodeType.DOCUMENT_FRAGMENT_NODE) {
            if (node2.nodeType === NodeType.ELEMENT_NODE && node2.shadowRoot) walk2(node2.shadowRoot, rrNode);
            node2.childNodes.forEach((childNode)=>walk2(childNode, rrNode));
        }
    }
    walk2(dom, null);
    return rrdom;
}
function createMirror() {
    return new Mirror22();
}
class Mirror22 {
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) {
            n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
        }
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
    constructor(){
        __publicField2(this, "idNodeMap", /* @__PURE__ */ new Map());
        __publicField2(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
}
function getDefaultSN(node2, id) {
    switch(node2.RRNodeType){
        case NodeType$1.Document:
            return {
                id,
                type: node2.RRNodeType,
                childNodes: []
            };
        case NodeType$1.DocumentType:
            {
                const doctype = node2;
                return {
                    id,
                    type: node2.RRNodeType,
                    name: doctype.name,
                    publicId: doctype.publicId,
                    systemId: doctype.systemId
                };
            }
        case NodeType$1.Element:
            return {
                id,
                type: node2.RRNodeType,
                tagName: node2.tagName.toLowerCase(),
                // In rrweb data, all tagNames are lowercase.
                attributes: {},
                childNodes: []
            };
        case NodeType$1.Text:
            return {
                id,
                type: node2.RRNodeType,
                textContent: node2.textContent || ""
            };
        case NodeType$1.Comment:
            return {
                id,
                type: node2.RRNodeType,
                textContent: node2.textContent || ""
            };
        case NodeType$1.CDATA:
            return {
                id,
                type: node2.RRNodeType,
                textContent: ""
            };
    }
}
const testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const untaintedBasePrototype = {};
function getUntaintedPrototype(key) {
    if (untaintedBasePrototype[key]) return untaintedBasePrototype[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in testableAccessors ? testableAccessors[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in testableMethods ? testableMethods[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods) {
        untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
const untaintedAccessorCache = {};
function getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    const cacheKey = `${key}.${String(accessor)}`;
    if (untaintedAccessorCache[cacheKey]) return untaintedAccessorCache[cacheKey].call(instance);
    const untaintedPrototype = getUntaintedPrototype(key);
    const untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const untaintedMethodCache = {};
function getUntaintedMethod(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if (untaintedMethodCache[cacheKey]) return untaintedMethodCache[cacheKey].bind(instance);
    const untaintedPrototype = getUntaintedPrototype(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function childNodes(n2) {
    return getUntaintedAccessor("Node", n2, "childNodes");
}
function parentNode(n2) {
    return getUntaintedAccessor("Node", n2, "parentNode");
}
function parentElement(n2) {
    return getUntaintedAccessor("Node", n2, "parentElement");
}
function textContent(n2) {
    return getUntaintedAccessor("Node", n2, "textContent");
}
function contains(n2, other) {
    return getUntaintedMethod("Node", n2, "contains")(other);
}
function getRootNode(n2) {
    return getUntaintedMethod("Node", n2, "getRootNode")();
}
function host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return getUntaintedAccessor("ShadowRoot", n2, "host");
}
function styleSheets(n2) {
    return n2.styleSheets;
}
function shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return getUntaintedAccessor("Element", n2, "shadowRoot");
}
function querySelector(n2, selectors) {
    return getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function querySelectorAll(n2, selectors) {
    return getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function mutationObserverCtor() {
    return getUntaintedPrototype("MutationObserver").constructor;
}
const index = {
    childNodes,
    parentNode,
    parentElement,
    textContent,
    contains,
    getRootNode,
    host,
    styleSheets,
    shadowRoot,
    querySelector,
    querySelectorAll,
    mutationObserver: mutationObserverCtor
};
function on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let _mirror = {
    map: {},
    getId () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get (target, prop, receiver) {
            if (prop === "map") {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function throttle(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(()=>{
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) {
                original.set.call(this, value);
            }
        }
    });
    return ()=>hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return ()=>{};
        }
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e) {
        return ()=>{};
    }
}
let nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) {
    nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
}
function getWindowScroll(win) {
    var _a2, _b, _c, _d;
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node2) {
    if (!node2) {
        return null;
    }
    const el = node2.nodeType === node2.ELEMENT_NODE ? node2 : index.parentElement(node2);
    return el;
}
function isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) {
        return false;
    }
    const el = closestElementOfNode(node2);
    if (!el) {
        return false;
    }
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if (classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) {
        return true;
    }
    return mirror2.getId(n2) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror2) {
    if (isShadowRoot(target)) {
        return false;
    }
    const id = mirror2.getId(target);
    if (!mirror2.has(id)) {
        return true;
    }
    const parent = index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) {
        return false;
    }
    if (!parent) {
        return true;
    }
    return isAncestorRemoved(parent, mirror2);
}
function legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill$1(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) {
        win.NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) {
        win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    }
}
function queueToResolveTrees(queue) {
    const queueNodeMap = {};
    const putIntoMap = (m, parent)=>{
        const nodeInTree = {
            value: m,
            parent,
            children: []
        };
        queueNodeMap[m.node.id] = nodeInTree;
        return nodeInTree;
    };
    const queueNodeTrees = [];
    for (const mutation of queue){
        const { nextId, parentId } = mutation;
        if (nextId && nextId in queueNodeMap) {
            const nextInTree = queueNodeMap[nextId];
            if (nextInTree.parent) {
                const idx = nextInTree.parent.children.indexOf(nextInTree);
                nextInTree.parent.children.splice(idx, 0, putIntoMap(mutation, nextInTree.parent));
            } else {
                const idx = queueNodeTrees.indexOf(nextInTree);
                queueNodeTrees.splice(idx, 0, putIntoMap(mutation, null));
            }
            continue;
        }
        if (parentId in queueNodeMap) {
            const parentInTree = queueNodeMap[parentId];
            parentInTree.children.push(putIntoMap(mutation, parentInTree));
            continue;
        }
        queueNodeTrees.push(putIntoMap(mutation, null));
    }
    return queueNodeTrees;
}
function iterateResolveTree(tree, cb) {
    cb(tree.value);
    for(let i2 = tree.children.length - 1; i2 >= 0; i2--){
        iterateResolveTree(tree.children[i2], cb);
    }
}
function isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function getBaseDimension(node2, rootIframe) {
    var _a2, _b;
    const frameElement = (_b = (_a2 = node2.ownerDocument) == null ? void 0 : _a2.defaultView) == null ? void 0 : _b.frameElement;
    if (!frameElement || frameElement === rootIframe) {
        return {
            x: 0,
            y: 0,
            relativeScale: 1,
            absoluteScale: 1
        };
    }
    const frameDimension = frameElement.getBoundingClientRect();
    const frameBaseDimension = getBaseDimension(frameElement, rootIframe);
    const relativeScale = frameDimension.height / frameElement.clientHeight;
    return {
        x: frameDimension.x * frameBaseDimension.relativeScale + frameBaseDimension.x,
        y: frameDimension.y * frameBaseDimension.relativeScale + frameBaseDimension.y,
        relativeScale,
        absoluteScale: frameBaseDimension.absoluteScale * relativeScale
    };
}
function hasShadowRoot(n2) {
    if (!n2) return false;
    if (n2 instanceof BaseRRNode && "shadowRoot" in n2) {
        return Boolean(n2.shadowRoot);
    }
    return Boolean(index.shadowRoot(n2));
}
function getNestedRule(rules2, position) {
    const rule2 = rules2[position[0]];
    if (position.length === 1) {
        return rule2;
    } else {
        return getNestedRule(rule2.cssRules[position[1]].cssRules, position.slice(2));
    }
}
function getPositionsAndIndex(nestedIndex) {
    const positions = [
        ...nestedIndex
    ];
    const index2 = positions.pop();
    return {
        positions,
        index: index2
    };
}
function uniqueTextMutations(mutations) {
    const idSet = /* @__PURE__ */ new Set();
    const uniqueMutations = [];
    for(let i2 = mutations.length; i2--;){
        const mutation = mutations[i2];
        if (!idSet.has(mutation.id)) {
            uniqueMutations.push(mutation);
            idSet.add(mutation.id);
        }
    }
    return uniqueMutations;
}
class StyleSheetMirror {
    getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) {
            newId = this.id++;
        } else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
    constructor(){
        __publicField(this, "id", 1);
        __publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
}
function getShadowHost(n2) {
    var _a2;
    let shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && index.host(index.getRootNode(n2))) shadowHost = index.host(index.getRootNode(n2));
    return shadowHost;
}
function getRootShadowHost(n2) {
    let rootShadowHost = n2;
    let shadowHost;
    while(shadowHost = getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function shadowHostInDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    const shadowHost = getRootShadowHost(n2);
    return index.contains(doc, shadowHost);
}
function inDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    return index.contains(doc, n2) || shadowHostInDom(n2);
}
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    StyleSheetMirror,
    get _mirror () {
        return _mirror;
    },
    closestElementOfNode,
    getBaseDimension,
    getNestedRule,
    getPositionsAndIndex,
    getRootShadowHost,
    getShadowHost,
    getWindowHeight,
    getWindowScroll,
    getWindowWidth,
    hasShadowRoot,
    hookSetter,
    inDom,
    isAncestorRemoved,
    isBlocked,
    isIgnored,
    isSerialized,
    isSerializedIframe,
    isSerializedStylesheet,
    iterateResolveTree,
    legacy_isTouchEvent,
    get nowTimestamp () {
        return nowTimestamp;
    },
    on,
    patch,
    polyfill: polyfill$1,
    queueToResolveTrees,
    shadowHostInDom,
    throttle,
    uniqueTextMutations
}, Symbol.toStringTag, {
    value: "Module"
}));
var EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})(PointerTypes || {});
var CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})(CanvasContext || {});
var MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})(MediaInteractions || {});
var ReplayerEvents = /* @__PURE__ */ ((ReplayerEvents2)=>{
    ReplayerEvents2["Start"] = "start";
    ReplayerEvents2["Pause"] = "pause";
    ReplayerEvents2["Resume"] = "resume";
    ReplayerEvents2["Resize"] = "resize";
    ReplayerEvents2["Finish"] = "finish";
    ReplayerEvents2["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents2["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents2["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents2["SkipStart"] = "skip-start";
    ReplayerEvents2["SkipEnd"] = "skip-end";
    ReplayerEvents2["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents2["EventCast"] = "event-cast";
    ReplayerEvents2["CustomEvent"] = "custom-event";
    ReplayerEvents2["Flush"] = "flush";
    ReplayerEvents2["StateChange"] = "state-change";
    ReplayerEvents2["PlayBack"] = "play-back";
    ReplayerEvents2["Destroy"] = "destroy";
    return ReplayerEvents2;
})(ReplayerEvents || {});
function isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class DoubleLinkedList {
    get(position) {
        if (position >= this.length) {
            throw new Error("Position outside of list range");
        }
        let current = this.head;
        for(let index2 = 0; index2 < position; index2++){
            current = (current == null ? void 0 : current.next) || null;
        }
        return current;
    }
    addNode(n2) {
        const node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) {
                current.previous = node2;
            }
        } else if (n2.nextSibling && isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node2.previous = current;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current) {
                current.next = node2;
            }
        } else {
            if (this.head) {
                this.head.previous = node2;
            }
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) {
            this.tail = node2;
        }
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) {
            return;
        }
        if (!current.previous) {
            this.head = current.next;
            if (this.head) {
                this.head.previous = null;
            } else {
                this.tail = null;
            }
        } else {
            current.previous.next = current.next;
            if (current.next) {
                current.next.previous = current.previous;
            } else {
                this.tail = current.previous;
            }
        }
        if (n2.__ln) {
            delete n2.__ln;
        }
        this.length--;
    }
    constructor(){
        __publicField(this, "length", 0);
        __publicField(this, "head", null);
        __publicField(this, "tail", null);
    }
}
const moveKey = (id, parentId)=>`${id}@${parentId}`;
class MutationBuffer {
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
    constructor(){
        __publicField(this, "frozen", false);
        __publicField(this, "locked", false);
        __publicField(this, "texts", []);
        __publicField(this, "attributes", []);
        __publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "removes", []);
        __publicField(this, "mapRemoves", []);
        __publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ __publicField(this, "addedSet", /* @__PURE__ */ new Set());
        __publicField(this, "movedSet", /* @__PURE__ */ new Set());
        __publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        __publicField(this, "mutationCb");
        __publicField(this, "blockClass");
        __publicField(this, "blockSelector");
        __publicField(this, "maskTextClass");
        __publicField(this, "maskTextSelector");
        __publicField(this, "inlineStylesheet");
        __publicField(this, "maskInputOptions");
        __publicField(this, "maskTextFn");
        __publicField(this, "maskInputFn");
        __publicField(this, "keepIframeSrcFn");
        __publicField(this, "recordCanvas");
        __publicField(this, "inlineImages");
        __publicField(this, "slimDOMOptions");
        __publicField(this, "dataURLOptions");
        __publicField(this, "doc");
        __publicField(this, "mirror");
        __publicField(this, "iframeManager");
        __publicField(this, "stylesheetManager");
        __publicField(this, "shadowDomManager");
        __publicField(this, "canvasManager");
        __publicField(this, "processedNodeManager");
        __publicField(this, "unattachedDoc");
        __publicField(this, "processMutations", (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        });
        __publicField(this, "emit", ()=>{
            if (this.frozen || this.locked) {
                return;
            }
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = IGNORED_NODE;
                while(nextId === IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                const parent = index.parentNode(n2);
                if (!parent || !inDom(n2) || parent.tagName === "TEXTAREA") {
                    return;
                }
                const parentId = isShadowRoot(parent) ? this.mirror.getId(getShadowHost(n2)) : this.mirror.getId(parent);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) {
                    return addList.addNode(n2);
                }
                const sn = serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if (isSerializedIframe(currentN, this.mirror)) {
                            this.iframeManager.addIframe(currentN);
                        }
                        if (isSerializedStylesheet(currentN, this.mirror)) {
                            this.stylesheetManager.trackLinkElement(currentN);
                        }
                        if (hasShadowRoot(n2)) {
                            this.shadowDomManager.addShadowRoot(index.shadowRoot(n2), this.doc);
                        }
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId,
                        nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length){
                this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            }
            for (const n2 of this.movedSet){
                if (isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(index.parentNode(n2))) {
                    continue;
                }
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!isAncestorInSet(this.droppedSet, n2) && !isParentRemoved(this.removes, n2, this.mirror)) {
                    pushAdd(n2);
                } else if (isAncestorInSet(this.movedSet, n2)) {
                    pushAdd(n2);
                } else {
                    this.droppedSet.add(n2);
                }
            }
            let candidate = null;
            while(addList.length){
                let node2 = null;
                if (candidate) {
                    const parentId = this.mirror.getId(index.parentNode(candidate.value));
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) {
                        node2 = candidate;
                    }
                }
                if (!node2) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(index.parentNode(_node.value));
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                const parent = index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = index.host(parent);
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head){
                        addList.removeNode(addList.head.value);
                    }
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            const payload = {
                texts: this.texts.map((text)=>{
                    const n2 = text.node;
                    const parent = index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") {
                        this.genTextAreaValueMutation(parent);
                    }
                    return {
                        id: this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) {
                                attributes.style = attribute.styleDiff;
                            }
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
                return;
            }
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        });
        __publicField(this, "genTextAreaValueMutation", (textarea)=>{
            let item = this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                this.attributes.push(item);
                this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from(index.childNodes(textarea), (cn)=>index.textContent(cn) || "").join("");
        });
        __publicField(this, "processMutation", (m)=>{
            if (isIgnored(m.target, this.mirror, this.slimDOMOptions)) {
                return;
            }
            switch(m.type){
                case "characterData":
                    {
                        const value = index.textContent(m.target);
                        if (!isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) {
                            this.texts.push({
                                value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, true) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                                node: m.target
                            });
                        }
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = getInputType(target);
                            value = maskInputValue({
                                element: target,
                                maskInputOptions: this.maskInputOptions,
                                tagName: target.tagName,
                                type,
                                value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || value === m.oldValue) {
                            return;
                        }
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) {
                                attributeName = "rr_src";
                            } else {
                                return;
                            }
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") {
                            target.setAttribute("data-rr-is-password", "true");
                        }
                        if (!ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) {
                                    try {
                                        this.unattachedDoc = document.implementation.createHTMLDocument();
                                    } catch (e2) {
                                        this.unattachedDoc = this.doc;
                                    }
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) {
                                    old.setAttribute("style", m.oldValue);
                                }
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") {
                                            item.styleDiff[pname] = newValue;
                                        } else {
                                            item.styleDiff[pname] = [
                                                newValue,
                                                newPriority
                                            ];
                                        }
                                    } else {
                                        item._unchangedStyles[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                }
                                for (const pname of Array.from(old.style)){
                                    if (target.style.getPropertyValue(pname) === "") {
                                        item.styleDiff[pname] = false;
                                    }
                                }
                            } else if (attributeName === "open" && target.tagName === "DIALOG") {
                                if (target.matches("dialog:modal")) {
                                    item.attributes["rr_open_mode"] = "modal";
                                } else {
                                    item.attributes["rr_open_mode"] = "non-modal";
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    {
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;
                        if (m.target.tagName === "TEXTAREA") {
                            this.genTextAreaValueMutation(m.target);
                            return;
                        }
                        m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                        m.removedNodes.forEach((n2)=>{
                            const nodeId = this.mirror.getId(n2);
                            const parentId = isShadowRoot(m.target) ? this.mirror.getId(index.host(m.target)) : this.mirror.getId(m.target);
                            if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || isIgnored(n2, this.mirror, this.slimDOMOptions) || !isSerialized(n2, this.mirror)) {
                                return;
                            }
                            if (this.addedSet.has(n2)) {
                                deepDelete(this.addedSet, n2);
                                this.droppedSet.add(n2);
                            } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                            else if (isAncestorRemoved(m.target, this.mirror)) ;
                            else if (this.movedSet.has(n2) && this.movedMap[moveKey(nodeId, parentId)]) {
                                deepDelete(this.movedSet, n2);
                            } else {
                                this.removes.push({
                                    parentId,
                                    id: nodeId,
                                    isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : void 0
                                });
                            }
                            this.mapRemoves.push(n2);
                        });
                        break;
                    }
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ __publicField(this, "genAdds", (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if (isIgnored(n2, this.mirror, this.slimDOMOptions)) {
                    return;
                }
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) {
                    targetId = this.mirror.getId(target);
                }
                if (targetId && targetId !== -1) {
                    this.movedMap[moveKey(this.mirror.getId(n2), targetId)] = true;
                }
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!isBlocked(n2, this.blockClass, this.blockSelector, false)) {
                index.childNodes(n2).forEach((childN)=>this.genAdds(childN));
                if (hasShadowRoot(n2)) {
                    index.childNodes(index.shadowRoot(n2)).forEach((childN)=>{
                        this.processedNodeManager.add(childN, this);
                        this.genAdds(childN, n2);
                    });
                }
            }
        });
    }
}
function deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    index.childNodes(n2).forEach((childN)=>deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return _isParentRemoved(removes, n2, mirror2);
}
function _isParentRemoved(removes, n2, mirror2) {
    let node2 = index.parentNode(n2);
    while(node2){
        const parentId = mirror2.getId(node2);
        if (removes.some((r2)=>r2.id === parentId)) {
            return true;
        }
        node2 = index.parentNode(node2);
    }
    return false;
}
function isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return _isAncestorInSet(set, n2);
}
function _isAncestorInSet(set, n2) {
    const parent = index.parentNode(n2);
    if (!parent) {
        return false;
    }
    if (set.has(parent)) {
        return true;
    }
    return _isAncestorInSet(set, parent);
}
let errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
function unregisterErrorHandler() {
    errorHandler = void 0;
}
const callbackWrapper = (cb)=>{
    if (!errorHandler) {
        return cb;
    }
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) {
                return;
            }
            throw error;
        }
    };
    return rrwebWrapped;
};
function externalFunctionWrapper(func) {
    return (...args)=>{
        try {
            return func(...args);
        } catch (error) {
            try {
                error._external_ = true;
            } catch (e) {}
            throw error;
        }
    };
}
const mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) {
                return path[0];
            }
        } else if ("path" in event && event.path.length) {
            return event.path[0];
        }
    } catch (e) {}
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    const mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    const observer = new (mutationObserverCtor())(callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function initMoveObserver({ mousemoveCb, sampling, doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) {
        return ()=>{};
    }
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = throttle(callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = callbackWrapper(throttle(callbackWrapper((evt)=>{
        const target = getEventTarget(evt);
        const { clientX, clientY } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) {
            timeBaseline = nowTimestamp();
        }
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        on("mousemove", updatePosition, doc),
        on("touchmove", updatePosition, doc),
        on("drag", updatePosition, doc)
    ];
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initMouseInteractionObserver({ mouseInteractionCb, doc, mirror: mirror2, blockClass, blockSelector, sampling }) {
    if (sampling.mouseInteraction === false) {
        return ()=>{};
    }
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, true)) {
                return;
            }
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = PointerTypes.Pen;
                        break;
                }
                if (pointerType === PointerTypes.Touch) {
                    if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
                        thisEventKey = "TouchStart";
                    } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
                        thisEventKey = "TouchEnd";
                    }
                } else if (pointerType === PointerTypes.Pen) ;
            } else if (legacy_isTouchEvent(event)) {
                pointerType = PointerTypes.Touch;
            }
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) {
                    pointerType = null;
                }
            } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) {
                return;
            }
            const id = mirror2.getId(target);
            const { clientX, clientY } = e2;
            callbackWrapper(mouseInteractionCb)(_extends({
                type: MouseInteractions[thisEventKey],
                id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType
            }));
        };
    };
    Object.keys(MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) {
            switch(MouseInteractions[eventKey]){
                case MouseInteractions.MouseDown:
                case MouseInteractions.MouseUp:
                    eventName = eventName.replace("mouse", "pointer");
                    break;
                case MouseInteractions.TouchStart:
                case MouseInteractions.TouchEnd:
                    return;
            }
        }
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initScrollObserver({ scrollCb, doc, mirror: mirror2, blockClass, blockSelector, sampling }) {
    const updatePosition = callbackWrapper(throttle(callbackWrapper((evt)=>{
        const target = getEventTarget(evt);
        if (!target || isBlocked(target, blockClass, blockSelector, true)) {
            return;
        }
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = getWindowScroll(doc.defaultView);
            scrollCb({
                id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else {
            scrollCb({
                id,
                x: target.scrollLeft,
                y: target.scrollTop
            });
        }
    }), sampling.scroll || 100));
    return on("scroll", updatePosition, doc);
}
function initViewportResizeObserver({ viewportResizeCb }, { win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = callbackWrapper(throttle(callbackWrapper(()=>{
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return on("resize", updateDimension, win);
}
const INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const lastInputValueMap = /* @__PURE__ */ new WeakMap();
function initInputObserver({ inputCb, doc, mirror: mirror2, blockClass, blockSelector, ignoreClass, ignoreSelector, maskInputOptions, maskInputFn, sampling, userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && target.tagName;
        if (target && tagName === "OPTION") {
            target = index.parentElement(target);
        }
        if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, true)) {
            return;
        }
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) {
            return;
        }
        let text = target.value;
        let isChecked = false;
        const type = getInputType(target) || "";
        if (type === "radio" || type === "checkbox") {
            isChecked = target.checked;
        } else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) {
            text = maskInputValue({
                element: target,
                maskInputOptions,
                tagName,
                type,
                value: text,
                maskInputFn
            });
        }
        cbWithDedup(target, userTriggeredOnInput ? {
            text,
            isChecked,
            userTriggered
        } : {
            text,
            isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) {
            doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
                if (el !== target) {
                    const text2 = el.value;
                    cbWithDedup(el, userTriggeredOnInput ? {
                        text: text2,
                        isChecked: !isChecked,
                        userTriggered: false
                    } : {
                        text: text2,
                        isChecked: !isChecked
                    });
                }
            });
        }
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            callbackWrapper(inputCb)(_extends({}, v2, {
                id
            }));
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>on(eventName, callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) {
        return ()=>{
            handlers.forEach((h)=>h());
        };
    }
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        handlers.push(...hookProperties.map((p)=>hookSetter(p[0], p[1], {
                set () {
                    callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow)));
    }
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function getNestedCSSRulePositions(rule2) {
    const positions = [];
    function recurse(childRule, pos) {
        if (hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId,
        id
    };
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror: mirror2, stylesheetManager }, { win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
        return ()=>{};
    }
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule2, index2] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) {
                styleSheetRuleCb({
                    id,
                    styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: index2
                        }
                    ]
                });
            }
            return externalFunctionWrapper(()=>target.apply(thisArg, argumentsList))();
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2 = this.cssRules.length) {
        const rule2 = `${selector} { ${styleBlock} }`;
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [index2] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) {
                styleSheetRuleCb({
                    id,
                    styleId,
                    removes: [
                        {
                            index: index2
                        }
                    ]
                });
            }
            return externalFunctionWrapper(()=>target.apply(thisArg, argumentsList))();
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        replace: text
                    });
                }
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        replaceSync: text
                    });
                }
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) {
        supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    } else {
        if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) {
            supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        }
        if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) {
            supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        }
        if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) {
            supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
        }
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule2, index2] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        adds: [
                            {
                                rule: rule2,
                                index: [
                                    ...getNestedCSSRulePositions(thisArg),
                                    index2 || 0
                                ]
                            }
                        ]
                    });
                }
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [index2] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) {
                    styleSheetRuleCb({
                        id,
                        styleId,
                        removes: [
                            {
                                index: [
                                    ...getNestedCSSRulePositions(thisArg),
                                    index2
                                ]
                            }
                        ]
                    });
                }
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager }, host2) {
    var _a2, _b, _c;
    let hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId(index.host(host2));
    const patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    const originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set (sheets) {
            var _a3;
            const result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) {
                try {
                    stylesheetManager.adoptStyleSheets(sheets, hostId);
                } catch (e2) {}
            }
            return result2;
        }
    });
    return callbackWrapper(()=>{
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function initStyleDeclarationObserver({ styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes, stylesheetManager }, { win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            var _a2;
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) {
                return setProperty.apply(thisArg, [
                    property,
                    value,
                    priority
                ]);
            }
            const { id, styleId } = getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) {
                styleDeclarationCb({
                    id,
                    styleId,
                    set: {
                        property,
                        value,
                        priority
                    },
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    index: getNestedCSSRulePositions(thisArg.parentRule)
                });
            }
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            var _a2;
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) {
                return removeProperty.apply(thisArg, [
                    property
                ]);
            }
            const { id, styleId } = getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) {
                styleDeclarationCb({
                    id,
                    styleId,
                    remove: {
                        property
                    },
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    index: getNestedCSSRulePositions(thisArg.parentRule)
                });
            }
            return target.apply(thisArg, argumentsList);
        })
    });
    return callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver({ mediaInteractionCb, blockClass, blockSelector, mirror: mirror2, sampling, doc }) {
    const handler = callbackWrapper((type)=>throttle(callbackWrapper((event)=>{
            const target = getEventTarget(event);
            if (!target || isBlocked(target, blockClass, blockSelector, true)) {
                return;
            }
            const { currentTime, volume, muted, playbackRate, loop } = target;
            mediaInteractionCb({
                type,
                id: mirror2.getId(target),
                currentTime,
                volume,
                muted,
                playbackRate,
                loop
            });
        }), sampling.media || 500));
    const handlers = [
        on("play", handler(MediaInteractions.Play), doc),
        on("pause", handler(MediaInteractions.Pause), doc),
        on("seeked", handler(MediaInteractions.Seeked), doc),
        on("volumechange", handler(MediaInteractions.VolumeChange), doc),
        on("ratechange", handler(MediaInteractions.RateChange), doc)
    ];
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initFontObserver({ fontCb, doc }) {
    const win = doc.defaultView;
    if (!win) {
        return ()=>{};
    }
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family,
            buffer: typeof source !== "string",
            descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout(callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initSelectionObserver(param) {
    const { doc, mirror: mirror2, blockClass, blockSelector, selectionCb } = param;
    let collapsed = true;
    const updateSelection = callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer, startOffset, endContainer, endOffset } = range;
            const blocked = isBlocked(startContainer, blockClass, blockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset,
                end: mirror2.getId(endContainer),
                endOffset
            });
        }
        selectionCb({
            ranges
        });
    });
    updateSelection();
    return on("selectionchange", updateSelection);
}
function initCustomElementObserver({ doc, customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name
                    }
                });
            } catch (e2) {
                console.warn(`Custom element callback failed for ${name}`);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function mergeHooks(o2, hooks) {
    const { mutationCb, mousemoveCb, mouseInteractionCb, scrollCb, viewportResizeCb, inputCb, mediaInteractionCb, styleSheetRuleCb, styleDeclarationCb, canvasMutationCb, fontCb, selectionCb, customElementCb } = o2;
    o2.mutationCb = (...p)=>{
        if (hooks.mutation) {
            hooks.mutation(...p);
        }
        mutationCb(...p);
    };
    o2.mousemoveCb = (...p)=>{
        if (hooks.mousemove) {
            hooks.mousemove(...p);
        }
        mousemoveCb(...p);
    };
    o2.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) {
            hooks.mouseInteraction(...p);
        }
        mouseInteractionCb(...p);
    };
    o2.scrollCb = (...p)=>{
        if (hooks.scroll) {
            hooks.scroll(...p);
        }
        scrollCb(...p);
    };
    o2.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) {
            hooks.viewportResize(...p);
        }
        viewportResizeCb(...p);
    };
    o2.inputCb = (...p)=>{
        if (hooks.input) {
            hooks.input(...p);
        }
        inputCb(...p);
    };
    o2.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) {
            hooks.mediaInteaction(...p);
        }
        mediaInteractionCb(...p);
    };
    o2.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) {
            hooks.styleSheetRule(...p);
        }
        styleSheetRuleCb(...p);
    };
    o2.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) {
            hooks.styleDeclaration(...p);
        }
        styleDeclarationCb(...p);
    };
    o2.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) {
            hooks.canvasMutation(...p);
        }
        canvasMutationCb(...p);
    };
    o2.fontCb = (...p)=>{
        if (hooks.font) {
            hooks.font(...p);
        }
        fontCb(...p);
    };
    o2.selectionCb = (...p)=>{
        if (hooks.selection) {
            hooks.selection(...p);
        }
        selectionCb(...p);
    };
    o2.customElementCb = (...c2)=>{
        if (hooks.customElement) {
            hooks.customElement(...c2);
        }
        customElementCb(...c2);
    };
}
function initObservers(o2, hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) {
        return ()=>{};
    }
    mergeHooks(o2, hooks);
    let mutationObserver;
    if (o2.recordDOM) {
        mutationObserver = initMutationObserver(o2, o2.doc);
    }
    const mousemoveHandler = initMoveObserver(o2);
    const mouseInteractionHandler = initMouseInteractionObserver(o2);
    const scrollHandler = initScrollObserver(o2);
    const viewportResizeHandler = initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = initInputObserver(o2);
    const mediaInteractionHandler = initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) {
            fontObserver = initFontObserver(o2);
        }
    }
    const selectionObserver = initSelectionObserver(o2);
    const customElementObserver = initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin3 of o2.plugins){
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return callbackWrapper(()=>{
        mutationBuffers.forEach((b)=>b.reset());
        mutationObserver == null ? void 0 : mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class CrossOriginIframeMirror {
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
    constructor(generateIdFn){
        __publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
}
class IframeManager {
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null ? void 0 : _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null ? void 0 : _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        var _a2;
        switch(e2.type){
            case EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case EventType.Meta:
            case EventType.Load:
            case EventType.DomContentLoaded:
                {
                    return false;
                }
            case EventType.Plugin:
                {
                    return e2;
                }
            case EventType.Custom:
                {
                    this.replaceIds(e2.data.payload, iframeEl, [
                        "id",
                        "parentId",
                        "previousId",
                        "nextId"
                    ]);
                    return e2;
                }
            case EventType.IncrementalSnapshot:
                {
                    switch(e2.data.source){
                        case IncrementalSource.Mutation:
                            {
                                e2.data.adds.forEach((n2)=>{
                                    this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "nextId",
                                        "previousId"
                                    ]);
                                    this.replaceIdOnNode(n2.node, iframeEl);
                                    const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                                    rootId && this.patchRootIdOnNode(n2.node, rootId);
                                });
                                e2.data.removes.forEach((n2)=>{
                                    this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "id"
                                    ]);
                                });
                                e2.data.attributes.forEach((n2)=>{
                                    this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                e2.data.texts.forEach((n2)=>{
                                    this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            }
                        case IncrementalSource.Drag:
                        case IncrementalSource.TouchMove:
                        case IncrementalSource.MouseMove:
                            {
                                e2.data.positions.forEach((p)=>{
                                    this.replaceIds(p, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            }
                        case IncrementalSource.ViewportResize:
                            {
                                return false;
                            }
                        case IncrementalSource.MediaInteraction:
                        case IncrementalSource.MouseInteraction:
                        case IncrementalSource.Scroll:
                        case IncrementalSource.CanvasMutation:
                        case IncrementalSource.Input:
                            {
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                return e2;
                            }
                        case IncrementalSource.StyleSheetRule:
                        case IncrementalSource.StyleDeclaration:
                            {
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleId"
                                ]);
                                return e2;
                            }
                        case IncrementalSource.Font:
                            {
                                return e2;
                            }
                        case IncrementalSource.Selection:
                            {
                                e2.data.ranges.forEach((range)=>{
                                    this.replaceIds(range, iframeEl, [
                                        "start",
                                        "end"
                                    ]);
                                });
                                return e2;
                            }
                        case IncrementalSource.AdoptedStyleSheet:
                            {
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleIds"
                                ]);
                                (_a2 = e2.data.styles) == null ? void 0 : _a2.forEach((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                });
                                return e2;
                            }
                    }
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) {
                obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            } else {
                obj[key] = iframeMirror.getId(iframeEl, obj[key]);
            }
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node2, iframeEl) {
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) {
            node2.childNodes.forEach((child)=>{
                this.replaceIdOnNode(child, iframeEl);
            });
        }
    }
    patchRootIdOnNode(node2, rootId) {
        if (node2.type !== NodeType$2.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) {
            node2.childNodes.forEach((child)=>{
                this.patchRootIdOnNode(child, rootId);
            });
        }
    }
    constructor(options){
        __publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        __publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "crossOriginIframeMirror", new CrossOriginIframeMirror(genId));
        __publicField(this, "crossOriginIframeStyleMirror");
        __publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "mirror");
        __publicField(this, "mutationCb");
        __publicField(this, "wrappedEmit");
        __publicField(this, "loadListener");
        __publicField(this, "stylesheetManager");
        __publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) {
            window.addEventListener("message", this.handleMessage.bind(this));
        }
    }
}
class ShadowDomManager {
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot2, doc) {
        if (!isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        const observer = initMutationObserver(_extends({}, this.bypassOptions, {
            doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push(initScrollObserver(_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(()=>{
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, this.mirror.getId(index.host(shadowRoot2)));
            this.restoreHandlers.push(initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push(patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const sRoot = original.call(this, option);
                const shadowRootEl = index.shadowRoot(this);
                if (shadowRootEl && inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    }
    constructor(options){
        __publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        __publicField(this, "mutationCb");
        __publicField(this, "scrollCb");
        __publicField(this, "bypassOptions");
        __publicField(this, "mirror");
        __publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
}
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$1 = 0; i$1 < chars.length; i$1++){
    lookup[chars.charCodeAt(i$1)] = i$1;
}
var encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += chars[bytes[i2] >> 2];
        base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + "==";
    }
    return base64;
};
var decode = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") {
            bufferLength--;
        }
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i2 = 0; i2 < len; i2 += 4){
        encoded1 = lookup[base64.charCodeAt(i2)];
        encoded2 = lookup[base64.charCodeAt(i2 + 1)];
        encoded3 = lookup[base64.charCodeAt(i2 + 2)];
        encoded4 = lookup[base64.charCodeAt(i2 + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
const canvasVarMap = /* @__PURE__ */ new Map();
function variableListFor$1(ctx, ctor) {
    let contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx)=>{
    if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list2 = variableListFor$1(ctx, name);
    let index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) {
        return value.map((arg)=>serializeArg(arg, win, ctx));
    } else if (value === null) {
        return value;
    } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = encode(value);
        return {
            rr_type: name,
            base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src } = value;
        return {
            rr_type: name,
            src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if (isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index2 = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index2
        };
    }
    return value;
}
const serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D){
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") {
                continue;
            }
            const restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function(...args) {
                    if (!isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        setTimeout(()=>{
                            const recordArgs = serializeArgs(args, win, this);
                            cb(this.canvas, {
                                type: CanvasContext["2D"],
                                property: prop,
                                args: recordArgs
                            });
                        }, 0);
                    }
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set (v2) {
                    cb(this.canvas, {
                        type: CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!isBlocked(this, blockClass, blockSelector, true)) {
                    const ctxName = getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) {
                                contextAttributes.preserveDrawingBuffer = true;
                            }
                        } else {
                            args.splice(0, 1, {
                                preserveDrawingBuffer: true
                            });
                        }
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
        [
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) {
            continue;
        }
        try {
            if (typeof prototype[prop] !== "function") {
                continue;
            }
            const restoreHandler = patch(prototype, prop, function(original) {
                return function(...args) {
                    const result2 = original.apply(this, args);
                    saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        const recordArgs = serializeArgs(args, win, this);
                        const mutation = {
                            type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = hookSetter(prototype, prop, {
                set (v2) {
                    cb(this.canvas, {
                        type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, win));
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
const encodedJs = "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";
const decodeBase64 = (base64)=>Uint8Array.from(atob(base64), (c2)=>c2.charCodeAt(0));
const blob = typeof window !== "undefined" && window.Blob && new Blob([
    decodeBase64(encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function WorkerWrapper(options) {
    let objURL;
    try {
        objURL = blob && (window.URL || window.webkitURL).createObjectURL(blob);
        if (!objURL) throw "";
        const worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", ()=>{
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
class CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, true);
        const snapshotInProgressMap = /* @__PURE__ */ new Map();
        const worker = new WorkerWrapper();
        worker.onmessage = (e2)=>{
            const { id } = e2.data;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            const { base64, type, width, height } = e2.data;
            this.mutationCb({
                id,
                type: CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64
                                            }
                                        ],
                                        type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1e3 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = ()=>{
            const matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach((canvas)=>{
                if (!isBlocked(canvas, blockClass, blockSelector, true)) {
                    matchedCanvas.push(canvas);
                }
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this = this;
            getCanvas().forEach(/*#__PURE__*/ _async_to_generator(function*(canvas) {
                var _a2;
                const id = _this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                if (canvas.width === 0 || canvas.height === 0) return;
                snapshotInProgressMap.set(id, true);
                if ([
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) {
                        context.clear(context.COLOR_BUFFER_BIT);
                    }
                }
                const bitmap = yield createImageBitmap(canvas);
                worker.postMessage({
                    id,
                    bitmap,
                    width: canvas.width,
                    height: canvas.height,
                    dataURLOptions: options.dataURLOptions
                }, [
                    bitmap
                ]);
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, false);
        const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((_values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) {
            return;
        }
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type2 } = value, rest = _object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        const { type } = valuesWithType[0];
        this.mutationCb({
            id,
            type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
    constructor(options){
        __publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        __publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        __publicField(this, "mirror");
        __publicField(this, "mutationCb");
        __publicField(this, "resetObservers");
        __publicField(this, "frozen", false);
        __publicField(this, "locked", false);
        __publicField(this, "processMutation", (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) {
                this.pendingCanvasMutations.set(target, []);
            }
            this.pendingCanvasMutations.get(target).push(mutation);
        });
        const { sampling = "all", win, blockClass, blockSelector, recordCanvas, dataURLOptions } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions
        });
    }
}
class StylesheetManager {
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index2)=>({
                            rule: stringifyRule(r2, sheet.href),
                            index: index2
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
    constructor(options){
        __publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        __publicField(this, "mutationCb");
        __publicField(this, "adoptedStyleSheetCb");
        __publicField(this, "styleMirror", new StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
}
class ProcessedNodeManager {
    inOtherBuffer(node2, thisBuffer) {
        const buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node2, buffer) {
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
    constructor(){
        __publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        __publicField(this, "active", false);
    }
}
let wrappedEmit;
let takeFullSnapshot$1;
let canvasManager;
let recording = false;
try {
    if (Array.from([
        1
    ], (x2)=>x2 * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = ((_a = cleanFrame.contentWindow) == null ? void 0 : _a.Array.from) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const mirror = createMirror$2();
function record(options = {}) {
    const { emit, checkoutEveryNms, checkoutEveryNth, blockClass = "rr-block", blockSelector = null, ignoreClass = "rr-ignore", ignoreSelector = null, maskTextClass = "rr-mask", maskTextSelector = null, inlineStylesheet = true, maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn, maskTextFn, hooks, packFn, sampling = {}, dataURLOptions = {}, mousemoveWait, recordDOM = true, recordCanvas = false, recordCrossOriginIframes = false, recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput = false, collectFonts = false, inlineImages = false, plugins, keepIframeSrcFn = ()=>false, ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler2 } = options;
    registerErrorHandler(errorHandler2);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) {
        try {
            if (window.parent.document) {
                passEmitsToParent = false;
            }
        } catch (e2) {
            passEmitsToParent = true;
        }
    }
    if (inEmittingFrame && !emit) {
        throw new Error("emit function is required");
    }
    if (!inEmittingFrame && !passEmitsToParent) {
        return ()=>{};
    }
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) {
        sampling.mousemove = mousemoveWait;
    }
    mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    polyfill$1();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin3 of plugins || []){
            if (plugin3.eventProcessor) {
                e2 = plugin3.eventProcessor(e2);
            }
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) {
            e2 = packFn(e2);
        }
        return e2;
    };
    wrappedEmit = (r2, isCheckout)=>{
        var _a2;
        const e2 = r2;
        e2.timestamp = nowTimestamp();
        if (((_a2 = mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== EventType.FullSnapshot && !(e2.type === EventType.IncrementalSnapshot && e2.data.source === IncrementalSource.Mutation)) {
            mutationBuffers.forEach((buf)=>buf.unfreeze());
        }
        if (inEmittingFrame) {
            emit == null ? void 0 : emit(eventProcessor(e2), isCheckout);
        } else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === EventType.IncrementalSnapshot) {
            if (e2.data.source === IncrementalSource.Mutation && e2.data.isAttachIframe) {
                return;
            }
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) {
                takeFullSnapshot$1(true);
            }
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _extends({
                source: IncrementalSource.Mutation
            }, m)
        });
    };
    const wrappedScrollEmit = (p)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _extends({
                source: IncrementalSource.Scroll
            }, p)
        });
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _extends({
                source: IncrementalSource.CanvasMutation
            }, p)
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _extends({
                source: IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    const stylesheetManager = new StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = new IframeManager({
        mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager,
        recordCrossOriginIframes,
        wrappedEmit
    });
    for (const plugin3 of plugins || []){
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    const processedNodeManager = new ProcessedNodeManager();
    canvasManager = new CanvasManager({
        recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass,
        blockSelector,
        mirror,
        sampling: sampling.canvas,
        dataURLOptions
    });
    const shadowDomManager = new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass,
            blockSelector,
            maskTextClass,
            maskTextSelector,
            inlineStylesheet,
            maskInputOptions,
            dataURLOptions,
            maskTextFn,
            maskInputFn,
            recordCanvas,
            inlineImages,
            sampling,
            slimDOMOptions,
            iframeManager,
            stylesheetManager,
            canvasManager,
            keepIframeSrcFn,
            processedNodeManager
        },
        mirror
    });
    takeFullSnapshot$1 = (isCheckout = false)=>{
        if (!recordDOM) {
            return;
        }
        wrappedEmit({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        mutationBuffers.forEach((buf)=>buf.lock());
        const node2 = snapshot(document, {
            mirror,
            blockClass,
            blockSelector,
            maskTextClass,
            maskTextSelector,
            inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions,
            recordCanvas,
            inlineImages,
            onSerialize: (n2)=>{
                if (isSerializedIframe(n2, mirror)) {
                    iframeManager.addIframe(n2);
                }
                if (isSerializedStylesheet(n2, mirror)) {
                    stylesheetManager.trackLinkElement(n2);
                }
                if (hasShadowRoot(n2)) {
                    shadowDomManager.addShadowRoot(index.shadowRoot(n2), document);
                }
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn
        });
        if (!node2) {
            return console.warn("Failed to snapshot the document");
        }
        wrappedEmit({
            type: EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: getWindowScroll(window)
            }
        }, isCheckout);
        mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
    };
    try {
        const handlers = [];
        const observe = (doc)=>{
            var _a2;
            return callbackWrapper(initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source,
                            positions
                        }
                    }),
                mouseInteractionCb: (d)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.MouseInteraction
                        }, d)
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.ViewportResize
                        }, d)
                    }),
                inputCb: (v2)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.Input
                        }, v2)
                    }),
                mediaInteractionCb: (p)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.MediaInteraction
                        }, p)
                    }),
                styleSheetRuleCb: (r2)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.StyleSheetRule
                        }, r2)
                    }),
                styleDeclarationCb: (r2)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.StyleDeclaration
                        }, r2)
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.Font
                        }, p)
                    }),
                selectionCb: (p)=>{
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: (c2)=>{
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: _extends({
                            source: IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass,
                ignoreClass,
                ignoreSelector,
                maskTextClass,
                maskTextSelector,
                maskInputOptions,
                inlineStylesheet,
                sampling,
                recordDOM,
                recordCanvas,
                inlineImages,
                userTriggeredOnInput,
                collectFonts,
                doc,
                maskInputFn,
                maskTextFn,
                keepIframeSrcFn,
                blockSelector,
                slimDOMOptions,
                dataURLOptions,
                mirror,
                iframeManager,
                stylesheetManager,
                shadowDomManager,
                processedNodeManager,
                canvasManager,
                ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter((p)=>p.observer)) == null ? void 0 : _a2.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>wrappedEmit({
                                type: EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload
                                }
                            })
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot$1();
            handlers.push(observe(document));
            recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") {
            init();
        } else {
            handlers.push(on("DOMContentLoaded", ()=>{
                wrappedEmit({
                    type: EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push(on("load", ()=>{
                wrappedEmit({
                    type: EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            recording = false;
            unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
record.addCustomEvent = (tag, payload)=>{
    if (!recording) {
        throw new Error("please add custom event after start recording");
    }
    wrappedEmit({
        type: EventType.Custom,
        data: {
            tag,
            payload
        }
    });
};
record.freezePage = ()=>{
    mutationBuffers.forEach((buf)=>buf.freeze());
};
record.takeFullSnapshot = (isCheckout)=>{
    if (!recording) {
        throw new Error("please take full snapshot after start recording");
    }
    takeFullSnapshot$1(isCheckout);
};
record.mirror = mirror;
function mitt$1(n2) {
    return {
        all: n2 = n2 || /* @__PURE__ */ new Map(),
        on: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 ? i2.push(e2) : n2.set(t2, [
                e2
            ]);
        },
        off: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 && (e2 ? i2.splice(i2.indexOf(e2) >>> 0, 1) : n2.set(t2, []));
        },
        emit: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 && i2.slice().map(function(n3) {
                n3(e2);
            }), (i2 = n2.get("*")) && i2.slice().map(function(n3) {
                n3(t2, e2);
            });
        }
    };
}
const mittProxy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: mitt$1
}, Symbol.toStringTag, {
    value: "Module"
}));
function polyfill(w = window, d = document) {
    if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
        return;
    }
    const Element2 = w.HTMLElement || w.Element;
    const SCROLL_TIME = 468;
    const original = {
        scroll: w.scroll || w.scrollTo,
        scrollBy: w.scrollBy,
        elementScroll: Element2.prototype.scroll || scrollElement,
        scrollIntoView: Element2.prototype.scrollIntoView
    };
    const now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
    function isMicrosoftBrowser(userAgent) {
        const userAgentPatterns = [
            "MSIE ",
            "Trident/",
            "Edge/"
        ];
        return new RegExp(userAgentPatterns.join("|")).test(userAgent);
    }
    const ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
    function scrollElement(x2, y) {
        this.scrollLeft = x2;
        this.scrollTop = y;
    }
    function ease(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    }
    function shouldBailOut(firstArg) {
        if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === void 0 || firstArg.behavior === "auto" || firstArg.behavior === "instant") {
            return true;
        }
        if (typeof firstArg === "object" && firstArg.behavior === "smooth") {
            return false;
        }
        throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
    }
    function hasScrollableSpace(el, axis) {
        if (axis === "Y") {
            return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
        }
        if (axis === "X") {
            return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
    }
    function canOverflow(el, axis) {
        const overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
        return overflowValue === "auto" || overflowValue === "scroll";
    }
    function isScrollable(el) {
        const isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
        const isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
        return isScrollableY || isScrollableX;
    }
    function findScrollableParent(el) {
        while(el !== d.body && isScrollable(el) === false){
            el = el.parentNode || el.host;
        }
        return el;
    }
    function step(context) {
        const time = now();
        let value;
        let currentX;
        let currentY;
        let elapsed = (time - context.startTime) / SCROLL_TIME;
        elapsed = elapsed > 1 ? 1 : elapsed;
        value = ease(elapsed);
        currentX = context.startX + (context.x - context.startX) * value;
        currentY = context.startY + (context.y - context.startY) * value;
        context.method.call(context.scrollable, currentX, currentY);
        if (currentX !== context.x || currentY !== context.y) {
            w.requestAnimationFrame(step.bind(w, context));
        }
    }
    function smoothScroll(el, x2, y) {
        let scrollable;
        let startX;
        let startY;
        let method;
        const startTime = now();
        if (el === d.body) {
            scrollable = w;
            startX = w.scrollX || w.pageXOffset;
            startY = w.scrollY || w.pageYOffset;
            method = original.scroll;
        } else {
            scrollable = el;
            startX = el.scrollLeft;
            startY = el.scrollTop;
            method = scrollElement;
        }
        step({
            scrollable,
            method,
            startTime,
            startX,
            startY,
            x: x2,
            y
        });
    }
    w.scroll = w.scrollTo = function() {
        if (arguments[0] === void 0) {
            return;
        }
        if (shouldBailOut(arguments[0]) === true) {
            original.scroll.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
            arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : w.scrollY || w.pageYOffset);
            return;
        }
        smoothScroll.call(w, d.body, arguments[0].left !== void 0 ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
    };
    w.scrollBy = function() {
        if (arguments[0] === void 0) {
            return;
        }
        if (shouldBailOut(arguments[0])) {
            original.scrollBy.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0);
            return;
        }
        smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
    };
    Element2.prototype.scroll = Element2.prototype.scrollTo = function() {
        if (arguments[0] === void 0) {
            return;
        }
        if (shouldBailOut(arguments[0]) === true) {
            if (typeof arguments[0] === "number" && arguments[1] === void 0) {
                throw new SyntaxError("Value could not be converted");
            }
            original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
            arguments[0].left !== void 0 ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
            arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop);
            return;
        }
        const left = arguments[0].left;
        const top = arguments[0].top;
        smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
    };
    Element2.prototype.scrollBy = function() {
        if (arguments[0] === void 0) {
            return;
        }
        if (shouldBailOut(arguments[0]) === true) {
            original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
            return;
        }
        this.scroll({
            left: ~~arguments[0].left + this.scrollLeft,
            top: ~~arguments[0].top + this.scrollTop,
            behavior: arguments[0].behavior
        });
    };
    Element2.prototype.scrollIntoView = function() {
        if (shouldBailOut(arguments[0]) === true) {
            original.scrollIntoView.call(this, arguments[0] === void 0 ? true : arguments[0]);
            return;
        }
        const scrollableParent = findScrollableParent(this);
        const parentRects = scrollableParent.getBoundingClientRect();
        const clientRects = this.getBoundingClientRect();
        if (scrollableParent !== d.body) {
            smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
            if (w.getComputedStyle(scrollableParent).position !== "fixed") {
                w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            }
        } else {
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        }
    };
}
class Timer {
    /**
   * Add an action, possibly after the timer starts.
   */ addAction(action) {
        const rafWasActive = this.raf === true;
        if (!this.actions.length || this.actions[this.actions.length - 1].delay <= action.delay) {
            this.actions.push(action);
        } else {
            const index2 = this.findActionIndex(action);
            this.actions.splice(index2, 0, action);
        }
        if (rafWasActive) {
            this.raf = requestAnimationFrame(this.rafCheck.bind(this));
        }
    }
    start() {
        this.timeOffset = 0;
        this.lastTimestamp = performance.now();
        this.raf = requestAnimationFrame(this.rafCheck.bind(this));
    }
    rafCheck() {
        const time = performance.now();
        this.timeOffset += (time - this.lastTimestamp) * this.speed;
        this.lastTimestamp = time;
        while(this.actions.length){
            const action = this.actions[0];
            if (this.timeOffset >= action.delay) {
                this.actions.shift();
                action.doAction();
            } else {
                break;
            }
        }
        if (this.actions.length > 0) {
            this.raf = requestAnimationFrame(this.rafCheck.bind(this));
        } else {
            this.raf = true;
        }
    }
    clear() {
        if (this.raf) {
            if (this.raf !== true) {
                cancelAnimationFrame(this.raf);
            }
            this.raf = null;
        }
        this.actions.length = 0;
    }
    setSpeed(speed) {
        this.speed = speed;
    }
    isActive() {
        return this.raf !== null;
    }
    findActionIndex(action) {
        let start = 0;
        let end = this.actions.length - 1;
        while(start <= end){
            const mid = Math.floor((start + end) / 2);
            if (this.actions[mid].delay < action.delay) {
                start = mid + 1;
            } else if (this.actions[mid].delay > action.delay) {
                end = mid - 1;
            } else {
                return mid + 1;
            }
        }
        return start;
    }
    constructor(actions = [], config){
        __publicField(this, "timeOffset", 0);
        __publicField(this, "speed");
        __publicField(this, "actions");
        __publicField(this, "raf", null);
        __publicField(this, "lastTimestamp");
        this.actions = actions;
        this.speed = config.speed;
    }
}
function addDelay(event, baselineTime) {
    if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseMove && event.data.positions && event.data.positions.length) {
        const firstOffset = event.data.positions[0].timeOffset;
        const firstTimestamp = event.timestamp + firstOffset;
        event.delay = firstTimestamp - baselineTime;
        return firstTimestamp - baselineTime;
    }
    event.delay = event.timestamp - baselineTime;
    return event.delay;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function t(t2, n2) {
    var e2 = "function" == typeof Symbol && t2[Symbol.iterator];
    if (!e2) return t2;
    var r2, o2, i2 = e2.call(t2), a2 = [];
    try {
        for(; (void 0 === n2 || n2-- > 0) && !(r2 = i2.next()).done;)a2.push(r2.value);
    } catch (t3) {
        o2 = {
            error: t3
        };
    } finally{
        try {
            r2 && !r2.done && (e2 = i2.return) && e2.call(i2);
        } finally{
            if (o2) throw o2.error;
        }
    }
    return a2;
}
var n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}(n || (n = {}));
var e = {
    type: "xstate.init"
};
function r(t2) {
    return void 0 === t2 ? [] : [].concat(t2);
}
function o(t2) {
    return {
        type: "xstate.assign",
        assignment: t2
    };
}
function i(t2, n2) {
    return "string" == typeof (t2 = "string" == typeof t2 && n2 && n2[t2] ? n2[t2] : t2) ? {
        type: t2
    } : "function" == typeof t2 ? {
        type: t2.name,
        exec: t2
    } : t2;
}
function a(t2) {
    return function(n2) {
        return t2 === n2;
    };
}
function u(t2) {
    return "string" == typeof t2 ? {
        type: t2
    } : t2;
}
function c(t2, n2) {
    return {
        value: t2,
        context: n2,
        actions: [],
        changed: false,
        matches: a(t2)
    };
}
function f(t2, n2, e2) {
    var r2 = n2, o2 = false;
    return [
        t2.filter(function(t3) {
            if ("xstate.assign" === t3.type) {
                o2 = true;
                var n3 = Object.assign({}, r2);
                return "function" == typeof t3.assignment ? n3 = t3.assignment(r2, e2) : Object.keys(t3.assignment).forEach(function(o3) {
                    n3[o3] = "function" == typeof t3.assignment[o3] ? t3.assignment[o3](r2, e2) : t3.assignment[o3];
                }), r2 = n3, false;
            }
            return true;
        }),
        r2,
        o2
    ];
}
function s(n2, o2) {
    void 0 === o2 && (o2 = {});
    var s2 = t(f(r(n2.states[n2.initial].entry).map(function(t2) {
        return i(t2, o2.actions);
    }), n2.context, e), 2), l2 = s2[0], v2 = s2[1], y = {
        config: n2,
        _options: o2,
        initialState: {
            value: n2.initial,
            actions: l2,
            context: v2,
            matches: a(n2.initial)
        },
        transition: function(e2, o3) {
            var s3, l3, v3 = "string" == typeof e2 ? {
                value: e2,
                context: n2.context
            } : e2, p = v3.value, g = v3.context, d = u(o3), x2 = n2.states[p];
            if (x2.on) {
                var m = r(x2.on[d.type]);
                try {
                    for(var h = function(t2) {
                        var n3 = "function" == typeof Symbol && Symbol.iterator, e3 = n3 && t2[n3], r2 = 0;
                        if (e3) return e3.call(t2);
                        if (t2 && "number" == typeof t2.length) return {
                            next: function() {
                                return t2 && r2 >= t2.length && (t2 = void 0), {
                                    value: t2 && t2[r2++],
                                    done: !t2
                                };
                            }
                        };
                        throw new TypeError(n3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
                    }(m), b = h.next(); !b.done; b = h.next()){
                        var S = b.value;
                        if (void 0 === S) return c(p, g);
                        var w = "string" == typeof S ? {
                            target: S
                        } : S, j = w.target, E = w.actions, R = void 0 === E ? [] : E, N = w.cond, O = void 0 === N ? function() {
                            return true;
                        } : N, _ = void 0 === j, k = null != j ? j : p, T = n2.states[k];
                        if (O(g, d)) {
                            var q = t(f((_ ? r(R) : [].concat(x2.exit, R, T.entry).filter(function(t2) {
                                return t2;
                            })).map(function(t2) {
                                return i(t2, y._options.actions);
                            }), g, d), 3), z = q[0], A = q[1], B = q[2], C = null != j ? j : p;
                            return {
                                value: C,
                                context: A,
                                actions: z,
                                changed: j !== p || z.length > 0 || B,
                                matches: a(C)
                            };
                        }
                    }
                } catch (t2) {
                    s3 = {
                        error: t2
                    };
                } finally{
                    try {
                        b && !b.done && (l3 = h.return) && l3.call(h);
                    } finally{
                        if (s3) throw s3.error;
                    }
                }
            }
            return c(p, g);
        }
    };
    return y;
}
var l = function(t2, n2) {
    return t2.actions.forEach(function(e2) {
        var r2 = e2.exec;
        return r2 && r2(t2.context, n2);
    });
};
function v(t2) {
    var r2 = t2.initialState, o2 = n.NotStarted, i2 = /* @__PURE__ */ new Set(), c2 = {
        _machine: t2,
        send: function(e2) {
            o2 === n.Running && (r2 = t2.transition(r2, e2), l(r2, u(e2)), i2.forEach(function(t3) {
                return t3(r2);
            }));
        },
        subscribe: function(t3) {
            return i2.add(t3), t3(r2), {
                unsubscribe: function() {
                    return i2.delete(t3);
                }
            };
        },
        start: function(i3) {
            if (i3) {
                var u2 = "object" == typeof i3 ? i3 : {
                    context: t2.config.context,
                    value: i3
                };
                r2 = {
                    value: u2.value,
                    actions: [],
                    context: u2.context,
                    matches: a(u2.value)
                };
            }
            return o2 = n.Running, l(r2, e), c2;
        },
        stop: function() {
            return o2 = n.Stopped, i2.clear(), c2;
        },
        get state () {
            return r2;
        },
        get status () {
            return o2;
        }
    };
    return c2;
}
function discardPriorSnapshots(events, baselineTime) {
    for(let idx = events.length - 1; idx >= 0; idx--){
        const event = events[idx];
        if (event.type === EventType.Meta) {
            if (event.timestamp <= baselineTime) {
                return events.slice(idx);
            }
        }
    }
    return events;
}
function createPlayerService(context, { getCastFn, applyEventsSynchronously, emitter }) {
    const playerMachine = s({
        id: "player",
        context,
        initial: "paused",
        states: {
            playing: {
                on: {
                    PAUSE: {
                        target: "paused",
                        actions: [
                            "pause"
                        ]
                    },
                    CAST_EVENT: {
                        target: "playing",
                        actions: "castEvent"
                    },
                    END: {
                        target: "paused",
                        actions: [
                            "resetLastPlayedEvent",
                            "pause"
                        ]
                    },
                    ADD_EVENT: {
                        target: "playing",
                        actions: [
                            "addEvent"
                        ]
                    }
                }
            },
            paused: {
                on: {
                    PLAY: {
                        target: "playing",
                        actions: [
                            "recordTimeOffset",
                            "play"
                        ]
                    },
                    CAST_EVENT: {
                        target: "paused",
                        actions: "castEvent"
                    },
                    TO_LIVE: {
                        target: "live",
                        actions: [
                            "startLive"
                        ]
                    },
                    ADD_EVENT: {
                        target: "paused",
                        actions: [
                            "addEvent"
                        ]
                    }
                }
            },
            live: {
                on: {
                    ADD_EVENT: {
                        target: "live",
                        actions: [
                            "addEvent"
                        ]
                    },
                    CAST_EVENT: {
                        target: "live",
                        actions: [
                            "castEvent"
                        ]
                    }
                }
            }
        }
    }, {
        actions: {
            castEvent: o({
                lastPlayedEvent: (ctx, event)=>{
                    if (event.type === "CAST_EVENT") {
                        return event.payload.event;
                    }
                    return ctx.lastPlayedEvent;
                }
            }),
            recordTimeOffset: o((ctx, event)=>{
                let timeOffset = ctx.timeOffset;
                if ("payload" in event && "timeOffset" in event.payload) {
                    timeOffset = event.payload.timeOffset;
                }
                return _extends({}, ctx, {
                    timeOffset,
                    baselineTime: ctx.events[0].timestamp + timeOffset
                });
            }),
            play (ctx) {
                var _a2;
                const { timer, events, baselineTime, lastPlayedEvent } = ctx;
                timer.clear();
                for (const event of events){
                    addDelay(event, baselineTime);
                }
                const neededEvents = discardPriorSnapshots(events, baselineTime);
                let lastPlayedTimestamp = lastPlayedEvent == null ? void 0 : lastPlayedEvent.timestamp;
                if ((lastPlayedEvent == null ? void 0 : lastPlayedEvent.type) === EventType.IncrementalSnapshot && lastPlayedEvent.data.source === IncrementalSource.MouseMove) {
                    lastPlayedTimestamp = lastPlayedEvent.timestamp + ((_a2 = lastPlayedEvent.data.positions[0]) == null ? void 0 : _a2.timeOffset);
                }
                if (baselineTime < (lastPlayedTimestamp || 0)) {
                    emitter.emit(ReplayerEvents.PlayBack);
                }
                const syncEvents = new Array();
                for (const event of neededEvents){
                    if (lastPlayedTimestamp && lastPlayedTimestamp < baselineTime && (event.timestamp <= lastPlayedTimestamp || event === lastPlayedEvent)) {
                        continue;
                    }
                    if (event.timestamp < baselineTime) {
                        syncEvents.push(event);
                    } else {
                        const castFn = getCastFn(event, false);
                        timer.addAction({
                            doAction: ()=>{
                                castFn();
                            },
                            delay: event.delay
                        });
                    }
                }
                applyEventsSynchronously(syncEvents);
                emitter.emit(ReplayerEvents.Flush);
                timer.start();
            },
            pause (ctx) {
                ctx.timer.clear();
            },
            resetLastPlayedEvent: o((ctx)=>{
                return _extends({}, ctx, {
                    lastPlayedEvent: null
                });
            }),
            startLive: o({
                baselineTime: (ctx, event)=>{
                    ctx.timer.start();
                    if (event.type === "TO_LIVE" && event.payload.baselineTime) {
                        return event.payload.baselineTime;
                    }
                    return Date.now();
                }
            }),
            addEvent: o((ctx, machineEvent)=>{
                const { baselineTime, timer, events } = ctx;
                if (machineEvent.type === "ADD_EVENT") {
                    const { event } = machineEvent.payload;
                    addDelay(event, baselineTime);
                    let end = events.length - 1;
                    if (!events[end] || events[end].timestamp <= event.timestamp) {
                        events.push(event);
                    } else {
                        let insertionIndex = -1;
                        let start = 0;
                        while(start <= end){
                            const mid = Math.floor((start + end) / 2);
                            if (events[mid].timestamp <= event.timestamp) {
                                start = mid + 1;
                            } else {
                                end = mid - 1;
                            }
                        }
                        if (insertionIndex === -1) {
                            insertionIndex = start;
                        }
                        events.splice(insertionIndex, 0, event);
                    }
                    const isSync = event.timestamp < baselineTime;
                    const castFn = getCastFn(event, isSync);
                    if (isSync) {
                        castFn();
                    } else if (timer.isActive()) {
                        timer.addAction({
                            doAction: ()=>{
                                castFn();
                            },
                            delay: event.delay
                        });
                    }
                }
                return _extends({}, ctx, {
                    events
                });
            })
        }
    });
    return v(playerMachine);
}
function createSpeedService(context) {
    const speedMachine = s({
        id: "speed",
        context,
        initial: "normal",
        states: {
            normal: {
                on: {
                    FAST_FORWARD: {
                        target: "skipping",
                        actions: [
                            "recordSpeed",
                            "setSpeed"
                        ]
                    },
                    SET_SPEED: {
                        target: "normal",
                        actions: [
                            "setSpeed"
                        ]
                    }
                }
            },
            skipping: {
                on: {
                    BACK_TO_NORMAL: {
                        target: "normal",
                        actions: [
                            "restoreSpeed"
                        ]
                    },
                    SET_SPEED: {
                        target: "normal",
                        actions: [
                            "setSpeed"
                        ]
                    }
                }
            }
        }
    }, {
        actions: {
            setSpeed: (ctx, event)=>{
                if ("payload" in event) {
                    ctx.timer.setSpeed(event.payload.speed);
                }
            },
            recordSpeed: o({
                normalSpeed: (ctx)=>ctx.timer.speed
            }),
            restoreSpeed: (ctx)=>{
                ctx.timer.setSpeed(ctx.normalSpeed);
            }
        }
    });
    return v(speedMachine);
}
const rules = (blockClass)=>[
        `.${blockClass} { background: currentColor }`,
        "noscript { display: none !important; }"
    ];
const webGLVarMap = /* @__PURE__ */ new Map();
function variableListFor(ctx, ctor) {
    let contextMap = webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
function deserializeArg(imageMap, ctx, preload) {
    return /*#__PURE__*/ _async_to_generator(function*(arg) {
        if (arg && typeof arg === "object" && "rr_type" in arg) {
            if (preload) preload.isUnchanged = false;
            if (arg.rr_type === "ImageBitmap" && "args" in arg) {
                const args = yield deserializeArg(imageMap, ctx, preload)(arg.args);
                return yield createImageBitmap.apply(null, args);
            } else if ("index" in arg) {
                if (preload || ctx === null) return arg;
                const { rr_type: name, index: index2 } = arg;
                return variableListFor(ctx, name)[index2];
            } else if ("args" in arg) {
                const { rr_type: name, args } = arg;
                const ctor = window[name];
                return new ctor(...yield Promise.all(args.map(deserializeArg(imageMap, ctx, preload))));
            } else if ("base64" in arg) {
                return decode(arg.base64);
            } else if ("src" in arg) {
                const image = imageMap.get(arg.src);
                if (image) {
                    return image;
                } else {
                    const image2 = new Image();
                    image2.src = arg.src;
                    imageMap.set(arg.src, image2);
                    return image2;
                }
            } else if ("data" in arg && arg.rr_type === "Blob") {
                const blobContents = yield Promise.all(arg.data.map(deserializeArg(imageMap, ctx, preload)));
                const blob2 = new Blob(blobContents, {
                    type: arg.type
                });
                return blob2;
            }
        } else if (Array.isArray(arg)) {
            const result2 = yield Promise.all(arg.map(deserializeArg(imageMap, ctx, preload)));
            return result2;
        }
        return arg;
    });
}
function getContext(target, type) {
    try {
        if (type === CanvasContext.WebGL) {
            return target.getContext("webgl") || target.getContext("experimental-webgl");
        }
        return target.getContext("webgl2");
    } catch (e2) {
        return null;
    }
}
const WebGLVariableConstructorsNames = (/* unused pure expression or super */ null && ([
    "WebGLActiveInfo",
    "WebGLBuffer",
    "WebGLFramebuffer",
    "WebGLProgram",
    "WebGLRenderbuffer",
    "WebGLShader",
    "WebGLShaderPrecisionFormat",
    "WebGLTexture",
    "WebGLUniformLocation",
    "WebGLVertexArrayObject"
]));
function saveToWebGLVarMap(ctx, result2) {
    if (!(result2 == null ? void 0 : result2.constructor)) return;
    const { name } = result2.constructor;
    if (!WebGLVariableConstructorsNames.includes(name)) return;
    const variables = variableListFor(ctx, name);
    if (!variables.includes(result2)) variables.push(result2);
}
function webglMutation(_) {
    return _webglMutation.apply(this, arguments);
}
function _webglMutation() {
    _webglMutation = _async_to_generator(function*({ mutation, target, type, imageMap, errorHandler: errorHandler2 }) {
        try {
            const ctx = getContext(target, type);
            if (!ctx) return;
            if (mutation.setter) {
                ctx[mutation.property] = mutation.args[0];
                return;
            }
            const original = ctx[mutation.property];
            const args = yield Promise.all(mutation.args.map(deserializeArg(imageMap, ctx)));
            const result2 = original.apply(ctx, args);
            saveToWebGLVarMap(ctx, result2);
            const debugMode = false;
            if (debugMode) ;
        } catch (error) {
            errorHandler2(mutation, error);
        }
    });
    return _webglMutation.apply(this, arguments);
}
function canvasMutation$1(_) {
    return _canvasMutation$1.apply(this, arguments);
}
function _canvasMutation$1() {
    _canvasMutation$1 = _async_to_generator(function*({ event, mutations, target, imageMap, errorHandler: errorHandler2 }) {
        const ctx = target.getContext("2d");
        if (!ctx) {
            errorHandler2(mutations[0], new Error("Canvas context is null"));
            return;
        }
        const mutationArgsPromises = mutations.map(/*#__PURE__*/ _async_to_generator(function*(mutation) {
            return Promise.all(mutation.args.map(deserializeArg(imageMap, ctx)));
        }));
        const args = yield Promise.all(mutationArgsPromises);
        args.forEach((args2, index2)=>{
            const mutation = mutations[index2];
            try {
                if (mutation.setter) {
                    ctx[mutation.property] = mutation.args[0];
                    return;
                }
                const original = ctx[mutation.property];
                if (mutation.property === "drawImage" && typeof mutation.args[0] === "string") {
                    imageMap.get(event);
                    original.apply(ctx, mutation.args);
                } else {
                    original.apply(ctx, args2);
                }
            } catch (error) {
                errorHandler2(mutation, error);
            }
            return;
        });
    });
    return _canvasMutation$1.apply(this, arguments);
}
function canvasMutation(_) {
    return _canvasMutation.apply(this, arguments);
}
function _canvasMutation() {
    _canvasMutation = _async_to_generator(function*({ event, mutation, target, imageMap, canvasEventMap, errorHandler: errorHandler2 }) {
        try {
            const precomputedMutation = canvasEventMap.get(event) || mutation;
            const commands = "commands" in precomputedMutation ? precomputedMutation.commands : [
                precomputedMutation
            ];
            if ([
                CanvasContext.WebGL,
                CanvasContext.WebGL2
            ].includes(mutation.type)) {
                for(let i2 = 0; i2 < commands.length; i2++){
                    const command = commands[i2];
                    yield webglMutation({
                        mutation: command,
                        type: mutation.type,
                        target,
                        imageMap,
                        errorHandler: errorHandler2
                    });
                }
                return;
            }
            yield canvasMutation$1({
                event,
                mutations: commands,
                target,
                imageMap,
                errorHandler: errorHandler2
            });
        } catch (error) {
            errorHandler2(mutation, error);
        }
    });
    return _canvasMutation.apply(this, arguments);
}
class MediaManager {
    syncAllMediaElements(options = {
        pause: false
    }) {
        this.mediaMap.forEach((_mediaState, target)=>{
            this.syncTargetWithState(target);
            if (options.pause) {
                target.pause();
            }
        });
    }
    start() {
        this.syncAllMediaElements();
    }
    pause() {
        this.syncAllMediaElements({
            pause: true
        });
    }
    seekTo({ time, target, mediaState }) {
        if (mediaState.isPlaying) {
            const differenceBetweenCurrentTimeAndMediaMutationTimestamp = time - mediaState.lastInteractionTimeOffset;
            const mediaPlaybackOffset = differenceBetweenCurrentTimeAndMediaMutationTimestamp / 1e3 * mediaState.playbackRate;
            const duration = "duration" in target && target.duration;
            if (Number.isNaN(duration)) {
                this.waitForMetadata(target);
                return;
            }
            let seekToTime = mediaState.currentTimeAtLastInteraction + mediaPlaybackOffset;
            if (target.loop && // RRMediaElement doesn't have a duration property
            duration !== false) {
                seekToTime = seekToTime % duration;
            }
            target.currentTime = seekToTime;
        } else {
            target.pause();
            target.currentTime = mediaState.currentTimeAtLastInteraction;
        }
    }
    waitForMetadata(target) {
        if (this.metadataCallbackMap.has(target)) return;
        if (!("addEventListener" in target)) return;
        const onLoadedMetadata = ()=>{
            this.metadataCallbackMap.delete(target);
            const mediaState = this.mediaMap.get(target);
            if (!mediaState) return;
            this.seekTo({
                time: this.getCurrentTime(),
                target,
                mediaState
            });
        };
        this.metadataCallbackMap.set(target, onLoadedMetadata);
        target.addEventListener("loadedmetadata", onLoadedMetadata, {
            once: true
        });
    }
    getMediaStateFromMutation({ target, timeOffset, mutation }) {
        const lastState = this.mediaMap.get(target);
        const { type, playbackRate, currentTime, muted, volume, loop } = mutation;
        const isPlaying = type === MediaInteractions.Play || type !== MediaInteractions.Pause && ((lastState == null ? void 0 : lastState.isPlaying) || target.getAttribute("autoplay") !== null);
        var _ref, _ref1, _ref2, _ref3, _ref4;
        const mediaState = {
            isPlaying,
            currentTimeAtLastInteraction: (_ref = currentTime != null ? currentTime : lastState == null ? void 0 : lastState.currentTimeAtLastInteraction) != null ? _ref : 0,
            lastInteractionTimeOffset: timeOffset,
            playbackRate: (_ref1 = playbackRate != null ? playbackRate : lastState == null ? void 0 : lastState.playbackRate) != null ? _ref1 : 1,
            volume: (_ref2 = volume != null ? volume : lastState == null ? void 0 : lastState.volume) != null ? _ref2 : 1,
            muted: (_ref3 = muted != null ? muted : lastState == null ? void 0 : lastState.muted) != null ? _ref3 : target.getAttribute("muted") === null,
            loop: (_ref4 = loop != null ? loop : lastState == null ? void 0 : lastState.loop) != null ? _ref4 : target.getAttribute("loop") === null
        };
        return mediaState;
    }
    syncTargetWithState(target) {
        const mediaState = this.mediaMap.get(target);
        if (!mediaState) return;
        const { muted, loop, volume, isPlaying } = mediaState;
        const playerIsPaused = this.service.state.matches("paused");
        const playbackRate = mediaState.playbackRate * this.speedService.state.context.timer.speed;
        try {
            this.seekTo({
                time: this.getCurrentTime(),
                target,
                mediaState
            });
            if (target.volume !== volume) {
                target.volume = volume;
            }
            target.muted = muted;
            target.loop = loop;
            if (target.playbackRate !== playbackRate) {
                target.playbackRate = playbackRate;
            }
            if (isPlaying && !playerIsPaused) {
                void target.play();
            } else {
                target.pause();
            }
        } catch (error) {
            this.warn(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions
            `Failed to replay media interactions: ${error.message || error}`);
        }
    }
    addMediaElements(node2, timeOffset, mirror2) {
        if (![
            "AUDIO",
            "VIDEO"
        ].includes(node2.nodeName)) return;
        const target = node2;
        const serializedNode = mirror2.getMeta(target);
        if (!serializedNode || !("attributes" in serializedNode)) return;
        const playerIsPaused = this.service.state.matches("paused");
        const mediaAttributes = serializedNode.attributes;
        let isPlaying = false;
        if (mediaAttributes.rr_mediaState) {
            isPlaying = mediaAttributes.rr_mediaState === "played";
        } else {
            isPlaying = target.getAttribute("autoplay") !== null;
        }
        if (isPlaying && playerIsPaused) target.pause();
        let playbackRate = 1;
        if (typeof mediaAttributes.rr_mediaPlaybackRate === "number") {
            playbackRate = mediaAttributes.rr_mediaPlaybackRate;
        }
        let muted = false;
        if (typeof mediaAttributes.rr_mediaMuted === "boolean") {
            muted = mediaAttributes.rr_mediaMuted;
        } else {
            muted = target.getAttribute("muted") !== null;
        }
        let loop = false;
        if (typeof mediaAttributes.rr_mediaLoop === "boolean") {
            loop = mediaAttributes.rr_mediaLoop;
        } else {
            loop = target.getAttribute("loop") !== null;
        }
        let volume = 1;
        if (typeof mediaAttributes.rr_mediaVolume === "number") {
            volume = mediaAttributes.rr_mediaVolume;
        }
        let currentTimeAtLastInteraction = 0;
        if (typeof mediaAttributes.rr_mediaCurrentTime === "number") {
            currentTimeAtLastInteraction = mediaAttributes.rr_mediaCurrentTime;
        }
        this.mediaMap.set(target, {
            isPlaying,
            currentTimeAtLastInteraction,
            lastInteractionTimeOffset: timeOffset,
            playbackRate,
            volume,
            muted,
            loop
        });
        this.syncTargetWithState(target);
    }
    mediaMutation({ target, timeOffset, mutation }) {
        this.mediaMap.set(target, this.getMediaStateFromMutation({
            target,
            timeOffset,
            mutation
        }));
        this.syncTargetWithState(target);
    }
    isSupportedMediaElement(node2) {
        return [
            "AUDIO",
            "VIDEO"
        ].includes(node2.nodeName);
    }
    reset() {
        this.mediaMap.clear();
    }
    constructor(options){
        __publicField(this, "mediaMap", /* @__PURE__ */ new Map());
        __publicField(this, "warn");
        __publicField(this, "service");
        __publicField(this, "speedService");
        __publicField(this, "emitter");
        __publicField(this, "getCurrentTime");
        __publicField(this, "metadataCallbackMap", /* @__PURE__ */ new Map());
        this.warn = options.warn;
        this.service = options.service;
        this.speedService = options.speedService;
        this.emitter = options.emitter;
        this.getCurrentTime = options.getCurrentTime;
        this.emitter.on(ReplayerEvents.Start, this.start.bind(this));
        this.emitter.on(ReplayerEvents.SkipStart, this.start.bind(this));
        this.emitter.on(ReplayerEvents.Pause, this.pause.bind(this));
        this.emitter.on(ReplayerEvents.Finish, this.pause.bind(this));
        this.speedService.subscribe(()=>{
            this.syncAllMediaElements();
        });
    }
}
function applyDialogToTopLevel(node2, attributeMutation) {
    if (node2.nodeName !== "DIALOG" || node2 instanceof BaseRRNode) return;
    const dialog = node2;
    const oldIsOpen = dialog.open;
    const oldIsModalState = oldIsOpen && dialog.matches("dialog:modal");
    const rrOpenMode = dialog.getAttribute("rr_open_mode");
    const newIsOpen = typeof (attributeMutation == null ? void 0 : attributeMutation.attributes.open) === "string" || typeof dialog.getAttribute("open") === "string";
    const newIsModalState = rrOpenMode === "modal";
    const newIsNonModalState = rrOpenMode === "non-modal";
    const modalStateChanged = oldIsModalState && newIsNonModalState || !oldIsModalState && newIsModalState;
    if (oldIsOpen && !modalStateChanged) return;
    if (!dialog.isConnected) {
        console.warn("dialog is not attached to the dom", dialog);
        return;
    }
    if (oldIsOpen) dialog.close();
    if (!newIsOpen) return;
    if (newIsModalState) dialog.showModal();
    else dialog.show();
}
function removeDialogFromTopLevel(node2, attributeMutation) {
    if (node2.nodeName !== "DIALOG" || node2 instanceof BaseRRNode) return;
    const dialog = node2;
    if (!dialog.isConnected) {
        console.warn("dialog is not attached to the dom", dialog);
        return;
    }
    if (attributeMutation.attributes.open === null) {
        dialog.removeAttribute("open");
        dialog.removeAttribute("rr_open_mode");
    }
}
const mitt = mitt$1 || mittProxy;
const REPLAY_CONSOLE_PREFIX = "[replayer]";
const defaultMouseTailConfig = {
    duration: 500,
    lineCap: "round",
    lineWidth: 3,
    strokeStyle: "red"
};
function indicatesTouchDevice(e2) {
    return e2.type == EventType.IncrementalSnapshot && (e2.data.source == IncrementalSource.TouchMove || e2.data.source == IncrementalSource.MouseInteraction && e2.data.type == MouseInteractions.TouchStart);
}
class Replayer {
    get timer() {
        return this.service.state.context.timer;
    }
    on(event, handler) {
        this.emitter.on(event, handler);
        return this;
    }
    off(event, handler) {
        this.emitter.off(event, handler);
        return this;
    }
    setConfig(config) {
        Object.keys(config).forEach((key)=>{
            config[key];
            this.config[key] = config[key];
        });
        if (!this.config.skipInactive) {
            this.backToNormal();
        }
        if (typeof config.speed !== "undefined") {
            this.speedService.send({
                type: "SET_SPEED",
                payload: {
                    speed: config.speed
                }
            });
        }
        if (typeof config.mouseTail !== "undefined") {
            if (config.mouseTail === false) {
                if (this.mouseTail) {
                    this.mouseTail.style.display = "none";
                }
            } else {
                if (!this.mouseTail) {
                    this.mouseTail = document.createElement("canvas");
                    this.mouseTail.width = Number.parseFloat(this.iframe.width);
                    this.mouseTail.height = Number.parseFloat(this.iframe.height);
                    this.mouseTail.classList.add("replayer-mouse-tail");
                    this.wrapper.insertBefore(this.mouseTail, this.iframe);
                }
                this.mouseTail.style.display = "inherit";
            }
        }
    }
    getMetaData() {
        const firstEvent = this.service.state.context.events[0];
        const lastEvent = this.service.state.context.events[this.service.state.context.events.length - 1];
        return {
            startTime: firstEvent.timestamp,
            endTime: lastEvent.timestamp,
            totalTime: lastEvent.timestamp - firstEvent.timestamp
        };
    }
    /**
   * Get the actual time offset the player is at now compared to the first event.
   */ getCurrentTime() {
        return this.timer.timeOffset + this.getTimeOffset();
    }
    /**
   * Get the time offset the player is at now compared to the first event, but without regard for the timer.
   */ getTimeOffset() {
        const { baselineTime, events } = this.service.state.context;
        return baselineTime - events[0].timestamp;
    }
    getMirror() {
        return this.mirror;
    }
    /**
   * This API was designed to be used as play at any time offset.
   * Since we minimized the data collected from recorder, we do not
   * have the ability of undo an event.
   * So the implementation of play at any time offset will always iterate
   * all of the events, cast event before the offset synchronously
   * and cast event after the offset asynchronously with timer.
   * @param timeOffset - number
   */ play(timeOffset = 0) {
        var _a2, _b;
        if (this.service.state.matches("paused")) {
            this.service.send({
                type: "PLAY",
                payload: {
                    timeOffset
                }
            });
        } else {
            this.service.send({
                type: "PAUSE"
            });
            this.service.send({
                type: "PLAY",
                payload: {
                    timeOffset
                }
            });
        }
        (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null ? void 0 : _b.classList.remove("rrweb-paused");
        this.emitter.emit(ReplayerEvents.Start);
    }
    pause(timeOffset) {
        var _a2, _b;
        if (timeOffset === void 0 && this.service.state.matches("playing")) {
            this.service.send({
                type: "PAUSE"
            });
        }
        if (typeof timeOffset === "number") {
            this.play(timeOffset);
            this.service.send({
                type: "PAUSE"
            });
        }
        (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null ? void 0 : _b.classList.add("rrweb-paused");
        this.emitter.emit(ReplayerEvents.Pause);
    }
    resume(timeOffset = 0) {
        this.warn(`The 'resume' was deprecated in 1.0. Please use 'play' method which has the same interface.`);
        this.play(timeOffset);
        this.emitter.emit(ReplayerEvents.Resume);
    }
    /**
   * Totally destroy this replayer and please be careful that this operation is irreversible.
   * Memory occupation can be released by removing all references to this replayer.
   */ destroy() {
        this.pause();
        this.mirror.reset();
        this.styleMirror.reset();
        this.mediaManager.reset();
        this.config.root.removeChild(this.wrapper);
        this.emitter.emit(ReplayerEvents.Destroy);
    }
    startLive(baselineTime) {
        this.service.send({
            type: "TO_LIVE",
            payload: {
                baselineTime
            }
        });
    }
    addEvent(rawEvent) {
        const event = this.config.unpackFn ? this.config.unpackFn(rawEvent) : rawEvent;
        if (indicatesTouchDevice(event)) {
            this.mouse.classList.add("touch-device");
        }
        void Promise.resolve().then(()=>this.service.send({
                type: "ADD_EVENT",
                payload: {
                    event
                }
            }));
    }
    enableInteract() {
        this.iframe.setAttribute("scrolling", "auto");
        this.iframe.style.pointerEvents = "auto";
    }
    disableInteract() {
        this.iframe.setAttribute("scrolling", "no");
        this.iframe.style.pointerEvents = "none";
    }
    /**
   * Empties the replayer's cache and reclaims memory.
   * The replayer will use this cache to speed up the playback.
   */ resetCache() {
        this.cache = createCache();
    }
    setupDom() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("replayer-wrapper");
        this.config.root.appendChild(this.wrapper);
        this.mouse = document.createElement("div");
        this.mouse.classList.add("replayer-mouse");
        this.wrapper.appendChild(this.mouse);
        if (this.config.mouseTail !== false) {
            this.mouseTail = document.createElement("canvas");
            this.mouseTail.classList.add("replayer-mouse-tail");
            this.mouseTail.style.display = "inherit";
            this.wrapper.appendChild(this.mouseTail);
        }
        this.iframe = document.createElement("iframe");
        const attributes = [
            "allow-same-origin"
        ];
        if (this.config.UNSAFE_replayCanvas) {
            attributes.push("allow-scripts");
        }
        this.iframe.style.display = "none";
        this.iframe.setAttribute("sandbox", attributes.join(" "));
        this.disableInteract();
        this.wrapper.appendChild(this.iframe);
        if (this.iframe.contentWindow && this.iframe.contentDocument) {
            polyfill(this.iframe.contentWindow, this.iframe.contentDocument);
            polyfill$1(this.iframe.contentWindow);
        }
    }
    rebuildFullSnapshot(event, isSync = false) {
        if (!this.iframe.contentDocument) {
            return this.warn("Looks like your replayer has been destroyed.");
        }
        if (Object.keys(this.legacy_missingNodeRetryMap).length) {
            this.warn("Found unresolved missing node map", this.legacy_missingNodeRetryMap);
        }
        this.legacy_missingNodeRetryMap = {};
        const collectedIframes = [];
        const collectedDialogs = /* @__PURE__ */ new Set();
        const afterAppend = (builtNode, id)=>{
            if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
            this.collectIframeAndAttachDocument(collectedIframes, builtNode);
            if (this.mediaManager.isSupportedMediaElement(builtNode)) {
                const { events } = this.service.state.context;
                this.mediaManager.addMediaElements(builtNode, event.timestamp - events[0].timestamp, this.mirror);
            }
            for (const plugin3 of this.config.plugins || []){
                if (plugin3.onBuild) plugin3.onBuild(builtNode, {
                    id,
                    replayer: this
                });
            }
        };
        if (this.usingVirtualDom) {
            this.virtualDom.destroyTree();
            this.usingVirtualDom = false;
        }
        this.mirror.reset();
        rebuild(event.data.node, {
            doc: this.iframe.contentDocument,
            afterAppend,
            cache: this.cache,
            mirror: this.mirror
        });
        afterAppend(this.iframe.contentDocument, event.data.node.id);
        for (const { mutationInQueue, builtNode } of collectedIframes){
            this.attachDocumentToIframe(mutationInQueue, builtNode);
            this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
        }
        const { documentElement, head } = this.iframe.contentDocument;
        this.insertStyleRules(documentElement, head);
        collectedDialogs.forEach((d)=>applyDialogToTopLevel(d));
        if (!this.service.state.matches("playing")) {
            this.iframe.contentDocument.getElementsByTagName("html")[0].classList.add("rrweb-paused");
        }
        this.emitter.emit(ReplayerEvents.FullsnapshotRebuilded, event);
        if (!isSync) {
            this.waitForStylesheetLoad();
        }
        if (this.config.UNSAFE_replayCanvas) {
            void this.preloadAllImages();
        }
    }
    insertStyleRules(documentElement, head) {
        var _a2;
        const injectStylesRules = rules(this.config.blockClass).concat(this.config.insertStyleRules);
        if (this.config.pauseAnimation) {
            injectStylesRules.push("html.rrweb-paused *, html.rrweb-paused *:before, html.rrweb-paused *:after { animation-play-state: paused !important; }");
        }
        if (this.usingVirtualDom) {
            const styleEl = this.virtualDom.createElement("style");
            this.virtualDom.mirror.add(styleEl, getDefaultSN(styleEl, this.virtualDom.unserializedId));
            documentElement.insertBefore(styleEl, head);
            styleEl.rules.push({
                source: IncrementalSource.StyleSheetRule,
                adds: injectStylesRules.map((cssText, index2)=>({
                        rule: cssText,
                        index: index2
                    }))
            });
        } else {
            const styleEl = document.createElement("style");
            documentElement.insertBefore(styleEl, head);
            for(let idx = 0; idx < injectStylesRules.length; idx++){
                (_a2 = styleEl.sheet) == null ? void 0 : _a2.insertRule(injectStylesRules[idx], idx);
            }
        }
    }
    attachDocumentToIframe(mutation, iframeEl) {
        const mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
        const collectedIframes = [];
        const collectedDialogs = /* @__PURE__ */ new Set();
        const afterAppend = (builtNode, id)=>{
            if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
            this.collectIframeAndAttachDocument(collectedIframes, builtNode);
            const sn = mirror2.getMeta(builtNode);
            if ((sn == null ? void 0 : sn.type) === NodeType$2.Element && (sn == null ? void 0 : sn.tagName.toUpperCase()) === "HTML") {
                const { documentElement, head } = iframeEl.contentDocument;
                this.insertStyleRules(documentElement, head);
            }
            if (this.usingVirtualDom) return;
            for (const plugin3 of this.config.plugins || []){
                if (plugin3.onBuild) plugin3.onBuild(builtNode, {
                    id,
                    replayer: this
                });
            }
        };
        buildNodeWithSN(mutation.node, {
            doc: iframeEl.contentDocument,
            mirror: mirror2,
            hackCss: true,
            skipChild: false,
            afterAppend,
            cache: this.cache
        });
        afterAppend(iframeEl.contentDocument, mutation.node.id);
        for (const { mutationInQueue, builtNode } of collectedIframes){
            this.attachDocumentToIframe(mutationInQueue, builtNode);
            this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
        }
        collectedDialogs.forEach((d)=>applyDialogToTopLevel(d));
    }
    collectIframeAndAttachDocument(collected, builtNode) {
        if (isSerializedIframe(builtNode, this.mirror)) {
            const mutationInQueue = this.newDocumentQueue.find((m)=>m.parentId === this.mirror.getId(builtNode));
            if (mutationInQueue) {
                collected.push({
                    mutationInQueue,
                    builtNode
                });
            }
        }
    }
    /**
   * pause when loading style sheet, resume when loaded all timeout exceed
   */ waitForStylesheetLoad() {
        var _a2;
        const head = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.head;
        if (head) {
            const unloadSheets = /* @__PURE__ */ new Set();
            let timer;
            let beforeLoadState = this.service.state;
            const stateHandler = ()=>{
                beforeLoadState = this.service.state;
            };
            this.emitter.on(ReplayerEvents.Start, stateHandler);
            this.emitter.on(ReplayerEvents.Pause, stateHandler);
            const unsubscribe = ()=>{
                this.emitter.off(ReplayerEvents.Start, stateHandler);
                this.emitter.off(ReplayerEvents.Pause, stateHandler);
            };
            head.querySelectorAll('link[rel="stylesheet"]').forEach((css)=>{
                if (!css.sheet) {
                    unloadSheets.add(css);
                    css.addEventListener("load", ()=>{
                        unloadSheets.delete(css);
                        if (unloadSheets.size === 0 && timer !== -1) {
                            if (beforeLoadState.matches("playing")) {
                                this.play(this.getCurrentTime());
                            }
                            this.emitter.emit(ReplayerEvents.LoadStylesheetEnd);
                            if (timer) {
                                clearTimeout(timer);
                            }
                            unsubscribe();
                        }
                    });
                }
            });
            if (unloadSheets.size > 0) {
                this.service.send({
                    type: "PAUSE"
                });
                this.emitter.emit(ReplayerEvents.LoadStylesheetStart);
                timer = setTimeout(()=>{
                    if (beforeLoadState.matches("playing")) {
                        this.play(this.getCurrentTime());
                    }
                    timer = -1;
                    unsubscribe();
                }, this.config.loadTimeout);
            }
        }
    }
    /**
   * pause when there are some canvas drawImage args need to be loaded
   */ preloadAllImages() {
        var _this = this;
        return _async_to_generator(function*() {
            const promises = [];
            for (const event of _this.service.state.context.events){
                if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.CanvasMutation) {
                    promises.push(_this.deserializeAndPreloadCanvasEvents(event.data, event));
                    const commands = "commands" in event.data ? event.data.commands : [
                        event.data
                    ];
                    commands.forEach((c2)=>{
                        _this.preloadImages(c2, event);
                    });
                }
            }
            return Promise.all(promises);
        })();
    }
    preloadImages(data, event) {
        if (data.property === "drawImage" && typeof data.args[0] === "string" && !this.imageMap.has(event)) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imgd = ctx == null ? void 0 : ctx.createImageData(canvas.width, canvas.height);
            ctx == null ? void 0 : ctx.putImageData(imgd, 0, 0);
        }
    }
    deserializeAndPreloadCanvasEvents(data, event) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.canvasEventMap.has(event)) {
                const status = {
                    isUnchanged: true
                };
                if ("commands" in data) {
                    const commands = yield Promise.all(data.commands.map(/*#__PURE__*/ _async_to_generator(function*(c2) {
                        const args = yield Promise.all(c2.args.map(deserializeArg(_this.imageMap, null, status)));
                        return _extends({}, c2, {
                            args
                        });
                    })));
                    if (status.isUnchanged === false) _this.canvasEventMap.set(event, _extends({}, data, {
                        commands
                    }));
                } else {
                    const args = yield Promise.all(data.args.map(deserializeArg(_this.imageMap, null, status)));
                    if (status.isUnchanged === false) _this.canvasEventMap.set(event, _extends({}, data, {
                        args
                    }));
                }
            }
        })();
    }
    applyIncremental(e2, isSync) {
        var _a2, _b, _c;
        const { data: d } = e2;
        switch(d.source){
            case IncrementalSource.Mutation:
                {
                    try {
                        this.applyMutation(d, isSync);
                    } catch (error) {
                        this.warn(`Exception in mutation ${error.message || error}`, d);
                    }
                    break;
                }
            case IncrementalSource.Drag:
            case IncrementalSource.TouchMove:
            case IncrementalSource.MouseMove:
                if (isSync) {
                    const lastPosition = d.positions[d.positions.length - 1];
                    this.mousePos = {
                        x: lastPosition.x,
                        y: lastPosition.y,
                        id: lastPosition.id,
                        debugData: d
                    };
                } else {
                    d.positions.forEach((p)=>{
                        const action = {
                            doAction: ()=>{
                                this.moveAndHover(p.x, p.y, p.id, isSync, d);
                            },
                            delay: p.timeOffset + e2.timestamp - this.service.state.context.baselineTime
                        };
                        this.timer.addAction(action);
                    });
                    this.timer.addAction({
                        doAction () {},
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        delay: e2.delay - ((_a2 = d.positions[0]) == null ? void 0 : _a2.timeOffset)
                    });
                }
                break;
            case IncrementalSource.MouseInteraction:
                {
                    if (d.id === -1) {
                        break;
                    }
                    const event = new Event(toLowerCase(MouseInteractions[d.type]));
                    const target = this.mirror.getNode(d.id);
                    if (!target) {
                        return this.debugNodeNotFound(d, d.id);
                    }
                    this.emitter.emit(ReplayerEvents.MouseInteraction, {
                        type: d.type,
                        target
                    });
                    const { triggerFocus } = this.config;
                    switch(d.type){
                        case MouseInteractions.Blur:
                            if ("blur" in target) {
                                target.blur();
                            }
                            break;
                        case MouseInteractions.Focus:
                            if (triggerFocus && target.focus) {
                                target.focus({
                                    preventScroll: true
                                });
                            }
                            break;
                        case MouseInteractions.Click:
                        case MouseInteractions.TouchStart:
                        case MouseInteractions.TouchEnd:
                        case MouseInteractions.MouseDown:
                        case MouseInteractions.MouseUp:
                            if (isSync) {
                                if (d.type === MouseInteractions.TouchStart) {
                                    this.touchActive = true;
                                } else if (d.type === MouseInteractions.TouchEnd) {
                                    this.touchActive = false;
                                }
                                if (d.type === MouseInteractions.MouseDown) {
                                    this.lastMouseDownEvent = [
                                        target,
                                        event
                                    ];
                                } else if (d.type === MouseInteractions.MouseUp) {
                                    this.lastMouseDownEvent = null;
                                }
                                this.mousePos = {
                                    x: d.x || 0,
                                    y: d.y || 0,
                                    id: d.id,
                                    debugData: d
                                };
                            } else {
                                if (d.type === MouseInteractions.TouchStart) {
                                    this.tailPositions.length = 0;
                                }
                                this.moveAndHover(d.x || 0, d.y || 0, d.id, isSync, d);
                                if (d.type === MouseInteractions.Click) {
                                    this.mouse.classList.remove("active");
                                    void this.mouse.offsetWidth;
                                    this.mouse.classList.add("active");
                                } else if (d.type === MouseInteractions.TouchStart) {
                                    void this.mouse.offsetWidth;
                                    this.mouse.classList.add("touch-active");
                                } else if (d.type === MouseInteractions.TouchEnd) {
                                    this.mouse.classList.remove("touch-active");
                                } else {
                                    target.dispatchEvent(event);
                                }
                            }
                            break;
                        case MouseInteractions.TouchCancel:
                            if (isSync) {
                                this.touchActive = false;
                            } else {
                                this.mouse.classList.remove("touch-active");
                            }
                            break;
                        default:
                            target.dispatchEvent(event);
                    }
                    break;
                }
            case IncrementalSource.Scroll:
                {
                    if (d.id === -1) {
                        break;
                    }
                    if (this.usingVirtualDom) {
                        const target = this.virtualDom.mirror.getNode(d.id);
                        if (!target) {
                            return this.debugNodeNotFound(d, d.id);
                        }
                        target.scrollData = d;
                        break;
                    }
                    this.applyScroll(d, isSync);
                    break;
                }
            case IncrementalSource.ViewportResize:
                this.emitter.emit(ReplayerEvents.Resize, {
                    width: d.width,
                    height: d.height
                });
                break;
            case IncrementalSource.Input:
                {
                    if (d.id === -1) {
                        break;
                    }
                    if (this.usingVirtualDom) {
                        const target = this.virtualDom.mirror.getNode(d.id);
                        if (!target) {
                            return this.debugNodeNotFound(d, d.id);
                        }
                        target.inputData = d;
                        break;
                    }
                    this.applyInput(d);
                    break;
                }
            case IncrementalSource.MediaInteraction:
                {
                    const target = this.usingVirtualDom ? this.virtualDom.mirror.getNode(d.id) : this.mirror.getNode(d.id);
                    if (!target) {
                        return this.debugNodeNotFound(d, d.id);
                    }
                    const mediaEl = target;
                    const { events } = this.service.state.context;
                    this.mediaManager.mediaMutation({
                        target: mediaEl,
                        timeOffset: e2.timestamp - events[0].timestamp,
                        mutation: d
                    });
                    break;
                }
            case IncrementalSource.StyleSheetRule:
            case IncrementalSource.StyleDeclaration:
                {
                    if (this.usingVirtualDom) {
                        if (d.styleId) this.constructedStyleMutations.push(d);
                        else if (d.id) (_b = this.virtualDom.mirror.getNode(d.id)) == null ? void 0 : _b.rules.push(d);
                    } else this.applyStyleSheetMutation(d);
                    break;
                }
            case IncrementalSource.CanvasMutation:
                {
                    if (!this.config.UNSAFE_replayCanvas) {
                        return;
                    }
                    if (this.usingVirtualDom) {
                        const target = this.virtualDom.mirror.getNode(d.id);
                        if (!target) {
                            return this.debugNodeNotFound(d, d.id);
                        }
                        target.canvasMutations.push({
                            event: e2,
                            mutation: d
                        });
                    } else {
                        const target = this.mirror.getNode(d.id);
                        if (!target) {
                            return this.debugNodeNotFound(d, d.id);
                        }
                        void canvasMutation({
                            event: e2,
                            mutation: d,
                            target,
                            imageMap: this.imageMap,
                            canvasEventMap: this.canvasEventMap,
                            errorHandler: this.warnCanvasMutationFailed.bind(this)
                        });
                    }
                    break;
                }
            case IncrementalSource.Font:
                {
                    try {
                        const fontFace = new FontFace(d.family, d.buffer ? new Uint8Array(JSON.parse(d.fontSource)) : d.fontSource, d.descriptors);
                        (_c = this.iframe.contentDocument) == null ? void 0 : _c.fonts.add(fontFace);
                    } catch (error) {
                        this.warn(error);
                    }
                    break;
                }
            case IncrementalSource.Selection:
                {
                    if (isSync) {
                        this.lastSelectionData = d;
                        break;
                    }
                    this.applySelection(d);
                    break;
                }
            case IncrementalSource.AdoptedStyleSheet:
                {
                    if (this.usingVirtualDom) this.adoptedStyleSheets.push(d);
                    else this.applyAdoptedStyleSheet(d);
                    break;
                }
        }
    }
    /**
   * Apply the mutation to the virtual dom or the real dom.
   * @param d - The mutation data.
   * @param isSync - Whether the mutation should be applied synchronously (while fast-forwarding).
   */ applyMutation(d, isSync) {
        if (this.config.useVirtualDom && !this.usingVirtualDom && isSync) {
            this.usingVirtualDom = true;
            buildFromDom(this.iframe.contentDocument, this.mirror, this.virtualDom);
            if (Object.keys(this.legacy_missingNodeRetryMap).length) {
                for(const key in this.legacy_missingNodeRetryMap){
                    try {
                        const value = this.legacy_missingNodeRetryMap[key];
                        const virtualNode = buildFromNode(value.node, this.virtualDom, this.mirror);
                        if (virtualNode) value.node = virtualNode;
                    } catch (error) {
                        this.warn(error);
                    }
                }
            }
        }
        const mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
        d.removes = d.removes.filter((mutation)=>{
            if (!mirror2.getNode(mutation.id)) {
                this.warnNodeNotFound(d, mutation.id);
                return false;
            }
            return true;
        });
        d.removes.forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) {
                return;
            }
            let parent = mirror2.getNode(mutation.parentId);
            if (!parent) {
                return this.warnNodeNotFound(d, mutation.parentId);
            }
            if (mutation.isShadow && hasShadowRoot(parent)) {
                parent = parent.shadowRoot;
            }
            mirror2.removeNodeFromMap(target);
            if (parent) try {
                parent.removeChild(target);
                if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_a2 = parent.rules) == null ? void 0 : _a2.length) > 0) parent.rules = [];
            } catch (error) {
                if (error instanceof DOMException) {
                    this.warn("parent could not remove child in mutation", parent, target, d);
                } else {
                    throw error;
                }
            }
        });
        const legacy_missingNodeMap = _extends({}, this.legacy_missingNodeRetryMap);
        const queue = [];
        const nextNotInDOM = (mutation)=>{
            let next = null;
            if (mutation.nextId) {
                next = mirror2.getNode(mutation.nextId);
            }
            if (mutation.nextId !== null && mutation.nextId !== void 0 && mutation.nextId !== -1 && !next) {
                return true;
            }
            return false;
        };
        const appendNode = (mutation)=>{
            var _a2, _b;
            if (!this.iframe.contentDocument) {
                return this.warn("Looks like your replayer has been destroyed.");
            }
            let parent = mirror2.getNode(mutation.parentId);
            if (!parent) {
                if (mutation.node.type === NodeType$2.Document) {
                    return this.newDocumentQueue.push(mutation);
                }
                return queue.push(mutation);
            }
            if (mutation.node.isShadow) {
                if (!hasShadowRoot(parent)) {
                    parent.attachShadow({
                        mode: "open"
                    });
                    parent = parent.shadowRoot;
                } else parent = parent.shadowRoot;
            }
            let previous = null;
            let next = null;
            if (mutation.previousId) {
                previous = mirror2.getNode(mutation.previousId);
            }
            if (mutation.nextId) {
                next = mirror2.getNode(mutation.nextId);
            }
            if (nextNotInDOM(mutation)) {
                return queue.push(mutation);
            }
            if (mutation.node.rootId && !mirror2.getNode(mutation.node.rootId)) {
                return;
            }
            const targetDoc = mutation.node.rootId ? mirror2.getNode(mutation.node.rootId) : this.usingVirtualDom ? this.virtualDom : this.iframe.contentDocument;
            if (isSerializedIframe(parent, mirror2)) {
                this.attachDocumentToIframe(mutation, parent);
                return;
            }
            const afterAppend = (node2, id)=>{
                if (this.usingVirtualDom) return;
                applyDialogToTopLevel(node2);
                for (const plugin3 of this.config.plugins || []){
                    if (plugin3.onBuild) plugin3.onBuild(node2, {
                        id,
                        replayer: this
                    });
                }
            };
            const target = buildNodeWithSN(mutation.node, {
                doc: targetDoc,
                // can be Document or RRDocument
                mirror: mirror2,
                // can be this.mirror or virtualDom.mirror
                skipChild: true,
                hackCss: true,
                cache: this.cache,
                /**
         * caveat: `afterAppend` only gets called on child nodes of target
         * we have to call it again below when this target was added to the DOM
         */ afterAppend
            });
            if (mutation.previousId === -1 || mutation.nextId === -1) {
                legacy_missingNodeMap[mutation.node.id] = {
                    node: target,
                    mutation
                };
                return;
            }
            const parentSn = mirror2.getMeta(parent);
            if (parentSn && parentSn.type === NodeType$2.Element && mutation.node.type === NodeType$2.Text) {
                const prospectiveSiblings = Array.isArray(parent.childNodes) ? parent.childNodes : Array.from(parent.childNodes);
                if (parentSn.tagName === "textarea") {
                    for (const c2 of prospectiveSiblings){
                        if (c2.nodeType === parent.TEXT_NODE) {
                            parent.removeChild(c2);
                        }
                    }
                } else if (parentSn.tagName === "style" && prospectiveSiblings.length === 1) {
                    for (const cssText of prospectiveSiblings){
                        if (cssText.nodeType === parent.TEXT_NODE && !mirror2.hasNode(cssText)) {
                            target.textContent = cssText.textContent;
                            parent.removeChild(cssText);
                        }
                    }
                }
            } else if ((parentSn == null ? void 0 : parentSn.type) === NodeType$2.Document) {
                const parentDoc = parent;
                if (mutation.node.type === NodeType$2.DocumentType && ((_a2 = parentDoc.childNodes[0]) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_TYPE_NODE) parentDoc.removeChild(parentDoc.childNodes[0]);
                if (target.nodeName === "HTML" && parentDoc.documentElement) parentDoc.removeChild(parentDoc.documentElement);
            }
            if (previous && previous.nextSibling && previous.nextSibling.parentNode) {
                parent.insertBefore(target, previous.nextSibling);
            } else if (next && next.parentNode) {
                parent.contains(next) ? parent.insertBefore(target, next) : parent.insertBefore(target, null);
            } else {
                parent.appendChild(target);
            }
            afterAppend(target, mutation.node.id);
            if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_b = parent.rules) == null ? void 0 : _b.length) > 0) parent.rules = [];
            if (isSerializedIframe(target, this.mirror)) {
                const targetId = this.mirror.getId(target);
                const mutationInQueue = this.newDocumentQueue.find((m)=>m.parentId === targetId);
                if (mutationInQueue) {
                    this.attachDocumentToIframe(mutationInQueue, target);
                    this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
                }
            }
            if (mutation.previousId || mutation.nextId) {
                this.legacy_resolveMissingNode(legacy_missingNodeMap, parent, target, mutation);
            }
        };
        d.adds.forEach((mutation)=>{
            appendNode(mutation);
        });
        const startTime = Date.now();
        while(queue.length){
            const resolveTrees = queueToResolveTrees(queue);
            queue.length = 0;
            if (Date.now() - startTime > 500) {
                this.warn("Timeout in the loop, please check the resolve tree data:", resolveTrees);
                break;
            }
            for (const tree of resolveTrees){
                const parent = mirror2.getNode(tree.value.parentId);
                if (!parent) {
                    this.debug("Drop resolve tree since there is no parent for the root node.", tree);
                } else {
                    iterateResolveTree(tree, (mutation)=>{
                        appendNode(mutation);
                    });
                }
            }
        }
        if (Object.keys(legacy_missingNodeMap).length) {
            Object.assign(this.legacy_missingNodeRetryMap, legacy_missingNodeMap);
        }
        uniqueTextMutations(d.texts).forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) {
                if (d.removes.find((r2)=>r2.id === mutation.id)) {
                    return;
                }
                return this.warnNodeNotFound(d, mutation.id);
            }
            target.textContent = mutation.value;
            if (this.usingVirtualDom) {
                const parent = target.parentNode;
                if (((_a2 = parent == null ? void 0 : parent.rules) == null ? void 0 : _a2.length) > 0) parent.rules = [];
            }
        });
        d.attributes.forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) {
                if (d.removes.find((r2)=>r2.id === mutation.id)) {
                    return;
                }
                return this.warnNodeNotFound(d, mutation.id);
            }
            for(const attributeName in mutation.attributes){
                if (typeof attributeName === "string") {
                    const value = mutation.attributes[attributeName];
                    if (value === null) {
                        target.removeAttribute(attributeName);
                        if (attributeName === "open") removeDialogFromTopLevel(target, mutation);
                    } else if (typeof value === "string") {
                        try {
                            if (attributeName === "_cssText" && (target.nodeName === "LINK" || target.nodeName === "STYLE")) {
                                try {
                                    const newSn = mirror2.getMeta(target);
                                    Object.assign(newSn.attributes, mutation.attributes);
                                    const newNode = buildNodeWithSN(newSn, {
                                        doc: target.ownerDocument,
                                        // can be Document or RRDocument
                                        mirror: mirror2,
                                        skipChild: true,
                                        hackCss: true,
                                        cache: this.cache
                                    });
                                    const siblingNode = target.nextSibling;
                                    const parentNode2 = target.parentNode;
                                    if (newNode && parentNode2) {
                                        parentNode2.removeChild(target);
                                        parentNode2.insertBefore(newNode, siblingNode);
                                        mirror2.replace(mutation.id, newNode);
                                        break;
                                    }
                                } catch (e2) {}
                            }
                            if (attributeName === "value" && target.nodeName === "TEXTAREA") {
                                const textarea = target;
                                textarea.childNodes.forEach((c2)=>textarea.removeChild(c2));
                                const tn = (_a2 = target.ownerDocument) == null ? void 0 : _a2.createTextNode(value);
                                if (tn) {
                                    textarea.appendChild(tn);
                                }
                            } else {
                                target.setAttribute(attributeName, value);
                            }
                            if (attributeName === "rr_open_mode" && target.nodeName === "DIALOG") {
                                applyDialogToTopLevel(target, mutation);
                            }
                        } catch (error) {
                            this.warn("An error occurred may due to the checkout feature.", error);
                        }
                    } else if (attributeName === "style") {
                        const styleValues = value;
                        const targetEl = target;
                        for(const s2 in styleValues){
                            if (styleValues[s2] === false) {
                                targetEl.style.removeProperty(s2);
                            } else if (styleValues[s2] instanceof Array) {
                                const svp = styleValues[s2];
                                targetEl.style.setProperty(s2, svp[0], svp[1]);
                            } else {
                                const svs = styleValues[s2];
                                targetEl.style.setProperty(s2, svs);
                            }
                        }
                    }
                }
            }
        });
    }
    /**
   * Apply the scroll data on real elements.
   * If the replayer is in sync mode, smooth scroll behavior should be disabled.
   * @param d - the scroll data
   * @param isSync - whether the replayer is in sync mode(fast-forward)
   */ applyScroll(d, isSync) {
        var _a2, _b;
        const target = this.mirror.getNode(d.id);
        if (!target) {
            return this.debugNodeNotFound(d, d.id);
        }
        const sn = this.mirror.getMeta(target);
        if (target === this.iframe.contentDocument) {
            (_a2 = this.iframe.contentWindow) == null ? void 0 : _a2.scrollTo({
                top: d.y,
                left: d.x,
                behavior: isSync ? "auto" : "smooth"
            });
        } else if ((sn == null ? void 0 : sn.type) === NodeType$2.Document) {
            (_b = target.defaultView) == null ? void 0 : _b.scrollTo({
                top: d.y,
                left: d.x,
                behavior: isSync ? "auto" : "smooth"
            });
        } else {
            try {
                target.scrollTo({
                    top: d.y,
                    left: d.x,
                    behavior: isSync ? "auto" : "smooth"
                });
            } catch (error) {}
        }
    }
    applyInput(d) {
        const target = this.mirror.getNode(d.id);
        if (!target) {
            return this.debugNodeNotFound(d, d.id);
        }
        try {
            target.checked = d.isChecked;
            target.value = d.text;
        } catch (error) {}
    }
    applySelection(d) {
        try {
            const selectionSet = /* @__PURE__ */ new Set();
            const ranges = d.ranges.map(({ start, startOffset, end, endOffset })=>{
                const startContainer = this.mirror.getNode(start);
                const endContainer = this.mirror.getNode(end);
                if (!startContainer || !endContainer) return;
                const result2 = new Range();
                result2.setStart(startContainer, startOffset);
                result2.setEnd(endContainer, endOffset);
                const doc = startContainer.ownerDocument;
                const selection = doc == null ? void 0 : doc.getSelection();
                selection && selectionSet.add(selection);
                return {
                    range: result2,
                    selection
                };
            });
            selectionSet.forEach((s2)=>s2.removeAllRanges());
            ranges.forEach((r2)=>{
                var _a2;
                return r2 && ((_a2 = r2.selection) == null ? void 0 : _a2.addRange(r2.range));
            });
        } catch (error) {}
    }
    applyStyleSheetMutation(data) {
        var _a2;
        let styleSheet = null;
        if (data.styleId) styleSheet = this.styleMirror.getStyle(data.styleId);
        else if (data.id) styleSheet = ((_a2 = this.mirror.getNode(data.id)) == null ? void 0 : _a2.sheet) || null;
        if (!styleSheet) return;
        if (data.source === IncrementalSource.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);
        else if (data.source === IncrementalSource.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
    }
    applyStyleSheetRule(data, styleSheet) {
        var _a2, _b, _c, _d;
        (_a2 = data.adds) == null ? void 0 : _a2.forEach(({ rule: rule2, index: nestedIndex })=>{
            try {
                if (Array.isArray(nestedIndex)) {
                    const { positions, index: index2 } = getPositionsAndIndex(nestedIndex);
                    const nestedRule = getNestedRule(styleSheet.cssRules, positions);
                    nestedRule.insertRule(rule2, index2);
                } else {
                    const index2 = nestedIndex === void 0 ? void 0 : Math.min(nestedIndex, styleSheet.cssRules.length);
                    styleSheet == null ? void 0 : styleSheet.insertRule(rule2, index2);
                }
            } catch (e2) {}
        });
        (_b = data.removes) == null ? void 0 : _b.forEach(({ index: nestedIndex })=>{
            try {
                if (Array.isArray(nestedIndex)) {
                    const { positions, index: index2 } = getPositionsAndIndex(nestedIndex);
                    const nestedRule = getNestedRule(styleSheet.cssRules, positions);
                    nestedRule.deleteRule(index2 || 0);
                } else {
                    styleSheet == null ? void 0 : styleSheet.deleteRule(nestedIndex);
                }
            } catch (e2) {}
        });
        if (data.replace) try {
            void ((_c = styleSheet.replace) == null ? void 0 : _c.call(styleSheet, data.replace));
        } catch (e2) {}
        if (data.replaceSync) try {
            (_d = styleSheet.replaceSync) == null ? void 0 : _d.call(styleSheet, data.replaceSync);
        } catch (e2) {}
    }
    applyStyleDeclaration(data, styleSheet) {
        if (data.set) {
            const rule2 = getNestedRule(styleSheet.rules, data.index);
            rule2.style.setProperty(data.set.property, data.set.value, data.set.priority);
        }
        if (data.remove) {
            const rule2 = getNestedRule(styleSheet.rules, data.index);
            rule2.style.removeProperty(data.remove.property);
        }
    }
    applyAdoptedStyleSheet(data) {
        var _a2;
        const targetHost = this.mirror.getNode(data.id);
        if (!targetHost) return;
        (_a2 = data.styles) == null ? void 0 : _a2.forEach((style)=>{
            var _a3;
            let newStyleSheet = null;
            let hostWindow = null;
            if (hasShadowRoot(targetHost)) hostWindow = ((_a3 = targetHost.ownerDocument) == null ? void 0 : _a3.defaultView) || null;
            else if (targetHost.nodeName === "#document") hostWindow = targetHost.defaultView;
            if (!hostWindow) return;
            try {
                newStyleSheet = new hostWindow.CSSStyleSheet();
                this.styleMirror.add(newStyleSheet, style.styleId);
                this.applyStyleSheetRule({
                    source: IncrementalSource.StyleSheetRule,
                    adds: style.rules
                }, newStyleSheet);
            } catch (e2) {}
        });
        const MAX_RETRY_TIME = 10;
        let count = 0;
        const adoptStyleSheets = (targetHost2, styleIds)=>{
            const stylesToAdopt = styleIds.map((styleId)=>this.styleMirror.getStyle(styleId)).filter((style)=>style !== null);
            if (hasShadowRoot(targetHost2)) targetHost2.shadowRoot.adoptedStyleSheets = stylesToAdopt;
            else if (targetHost2.nodeName === "#document") targetHost2.adoptedStyleSheets = stylesToAdopt;
            if (stylesToAdopt.length !== styleIds.length && count < MAX_RETRY_TIME) {
                setTimeout(()=>adoptStyleSheets(targetHost2, styleIds), 0 + 100 * count);
                count++;
            }
        };
        adoptStyleSheets(targetHost, data.styleIds);
    }
    legacy_resolveMissingNode(map, parent, target, targetMutation) {
        const { previousId, nextId } = targetMutation;
        const previousInMap = previousId && map[previousId];
        const nextInMap = nextId && map[nextId];
        if (previousInMap) {
            const { node: node2, mutation } = previousInMap;
            parent.insertBefore(node2, target);
            delete map[mutation.node.id];
            delete this.legacy_missingNodeRetryMap[mutation.node.id];
            if (mutation.previousId || mutation.nextId) {
                this.legacy_resolveMissingNode(map, parent, node2, mutation);
            }
        }
        if (nextInMap) {
            const { node: node2, mutation } = nextInMap;
            parent.insertBefore(node2, target.nextSibling);
            delete map[mutation.node.id];
            delete this.legacy_missingNodeRetryMap[mutation.node.id];
            if (mutation.previousId || mutation.nextId) {
                this.legacy_resolveMissingNode(map, parent, node2, mutation);
            }
        }
    }
    moveAndHover(x2, y, id, isSync, debugData) {
        const target = this.mirror.getNode(id);
        if (!target) {
            return this.debugNodeNotFound(debugData, id);
        }
        const base = getBaseDimension(target, this.iframe);
        const _x = x2 * base.absoluteScale + base.x;
        const _y = y * base.absoluteScale + base.y;
        this.mouse.style.left = `${_x}px`;
        this.mouse.style.top = `${_y}px`;
        if (!isSync) {
            this.drawMouseTail({
                x: _x,
                y: _y
            });
        }
        this.hoverElements(target);
    }
    drawMouseTail(position) {
        if (!this.mouseTail) {
            return;
        }
        const { lineCap, lineWidth, strokeStyle, duration } = this.config.mouseTail === true ? defaultMouseTailConfig : Object.assign({}, defaultMouseTailConfig, this.config.mouseTail);
        const draw = ()=>{
            if (!this.mouseTail) {
                return;
            }
            const ctx = this.mouseTail.getContext("2d");
            if (!ctx || !this.tailPositions.length) {
                return;
            }
            ctx.clearRect(0, 0, this.mouseTail.width, this.mouseTail.height);
            ctx.beginPath();
            ctx.lineWidth = lineWidth;
            ctx.lineCap = lineCap;
            ctx.strokeStyle = strokeStyle;
            ctx.moveTo(this.tailPositions[0].x, this.tailPositions[0].y);
            this.tailPositions.forEach((p)=>ctx.lineTo(p.x, p.y));
            ctx.stroke();
        };
        this.tailPositions.push(position);
        draw();
        setTimeout(()=>{
            this.tailPositions = this.tailPositions.filter((p)=>p !== position);
            draw();
        }, duration / this.speedService.state.context.timer.speed);
    }
    hoverElements(el) {
        var _a2;
        (_a2 = this.lastHoveredRootNode || this.iframe.contentDocument) == null ? void 0 : _a2.querySelectorAll(".\\:hover").forEach((hoveredEl)=>{
            hoveredEl.classList.remove(":hover");
        });
        this.lastHoveredRootNode = el.getRootNode();
        let currentEl = el;
        while(currentEl){
            if (currentEl.classList) {
                currentEl.classList.add(":hover");
            }
            currentEl = currentEl.parentElement;
        }
    }
    isUserInteraction(event) {
        if (event.type !== EventType.IncrementalSnapshot) {
            return false;
        }
        return event.data.source > IncrementalSource.Mutation && event.data.source <= IncrementalSource.Input;
    }
    backToNormal() {
        this.nextUserInteractionEvent = null;
        if (this.speedService.state.matches("normal")) {
            return;
        }
        this.speedService.send({
            type: "BACK_TO_NORMAL"
        });
        this.emitter.emit(ReplayerEvents.SkipEnd, {
            speed: this.speedService.state.context.normalSpeed
        });
    }
    warnNodeNotFound(d, id) {
        this.warn(`Node with id '${id}' not found. `, d);
    }
    warnCanvasMutationFailed(d, error) {
        this.warn(`Has error on canvas update`, error, "canvas mutation:", d);
    }
    debugNodeNotFound(d, id) {
        this.debug(`Node with id '${id}' not found. `, d);
    }
    warn(...args) {
        if (!this.config.showWarning) {
            return;
        }
        this.config.logger.warn(REPLAY_CONSOLE_PREFIX, ...args);
    }
    debug(...args) {
        if (!this.config.showDebug) {
            return;
        }
        this.config.logger.log(REPLAY_CONSOLE_PREFIX, ...args);
    }
    constructor(events, config){
        __publicField(this, "wrapper");
        __publicField(this, "iframe");
        __publicField(this, "service");
        __publicField(this, "speedService");
        __publicField(this, "config");
        // In the fast-forward process, if the virtual-dom optimization is used, this flag value is true.
        __publicField(this, "usingVirtualDom", false);
        __publicField(this, "virtualDom", new RRDocument());
        __publicField(this, "mouse");
        __publicField(this, "mouseTail", null);
        __publicField(this, "tailPositions", []);
        __publicField(this, "emitter", mitt());
        __publicField(this, "nextUserInteractionEvent");
        __publicField(this, "legacy_missingNodeRetryMap", {});
        // The replayer uses the cache to speed up replay and scrubbing.
        __publicField(this, "cache", createCache());
        __publicField(this, "imageMap", /* @__PURE__ */ new Map());
        __publicField(this, "canvasEventMap", /* @__PURE__ */ new Map());
        __publicField(this, "mirror", createMirror$2());
        // Used to track StyleSheetObjects adopted on multiple document hosts.
        __publicField(this, "styleMirror", new StyleSheetMirror());
        // Used to track video & audio elements, and keep them in sync with general playback.
        __publicField(this, "mediaManager");
        __publicField(this, "firstFullSnapshot", null);
        __publicField(this, "newDocumentQueue", []);
        __publicField(this, "mousePos", null);
        __publicField(this, "touchActive", null);
        __publicField(this, "lastMouseDownEvent", null);
        // Keep the rootNode of the last hovered element. So  when hovering a new element, we can remove the last hovered element's :hover style.
        __publicField(this, "lastHoveredRootNode");
        // In the fast-forward mode, only the last selection data needs to be applied.
        __publicField(this, "lastSelectionData", null);
        // In the fast-forward mode using VirtualDom optimization, all stylesheetRule, and styleDeclaration events on constructed StyleSheets will be delayed to get applied until the flush stage.
        __publicField(this, "constructedStyleMutations", []);
        // Similar to the reason for constructedStyleMutations.
        __publicField(this, "adoptedStyleSheets", []);
        __publicField(this, "handleResize", (dimension)=>{
            this.iframe.style.display = "inherit";
            for (const el of [
                this.mouseTail,
                this.iframe
            ]){
                if (!el) {
                    continue;
                }
                el.setAttribute("width", String(dimension.width));
                el.setAttribute("height", String(dimension.height));
            }
        });
        __publicField(this, "applyEventsSynchronously", (events)=>{
            for (const event of events){
                switch(event.type){
                    case EventType.DomContentLoaded:
                    case EventType.Load:
                    case EventType.Custom:
                        continue;
                    case EventType.FullSnapshot:
                    case EventType.Meta:
                    case EventType.Plugin:
                    case EventType.IncrementalSnapshot:
                        break;
                }
                const castFn = this.getCastFn(event, true);
                castFn();
            }
        });
        __publicField(this, "getCastFn", (event, isSync = false)=>{
            let castFn;
            switch(event.type){
                case EventType.DomContentLoaded:
                case EventType.Load:
                    break;
                case EventType.Custom:
                    castFn = ()=>{
                        this.emitter.emit(ReplayerEvents.CustomEvent, event);
                    };
                    break;
                case EventType.Meta:
                    castFn = ()=>this.emitter.emit(ReplayerEvents.Resize, {
                            width: event.data.width,
                            height: event.data.height
                        });
                    break;
                case EventType.FullSnapshot:
                    castFn = ()=>{
                        var _a2;
                        if (this.firstFullSnapshot) {
                            if (this.firstFullSnapshot === event) {
                                this.firstFullSnapshot = true;
                                return;
                            }
                        } else {
                            this.firstFullSnapshot = true;
                        }
                        this.mediaManager.reset();
                        this.styleMirror.reset();
                        this.rebuildFullSnapshot(event, isSync);
                        (_a2 = this.iframe.contentWindow) == null ? void 0 : _a2.scrollTo(event.data.initialOffset);
                    };
                    break;
                case EventType.IncrementalSnapshot:
                    castFn = ()=>{
                        this.applyIncremental(event, isSync);
                        if (isSync) {
                            return;
                        }
                        if (this.config.skipInactive && !this.nextUserInteractionEvent) {
                            for (const _event of this.service.state.context.events){
                                if (_event.timestamp <= event.timestamp) {
                                    continue;
                                }
                                if (this.isUserInteraction(_event)) {
                                    if (// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    _event.delay - event.delay > this.config.inactivePeriodThreshold * this.speedService.state.context.timer.speed) {
                                        this.nextUserInteractionEvent = _event;
                                    }
                                    break;
                                }
                            }
                            if (this.nextUserInteractionEvent) {
                                const skipTime = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                this.nextUserInteractionEvent.delay - event.delay;
                                this.play(this.getCurrentTime() + skipTime);
                                this.nextUserInteractionEvent = null;
                            }
                        }
                    };
                    break;
            }
            const wrappedCastFn = ()=>{
                if (castFn) {
                    castFn();
                }
                for (const plugin3 of this.config.plugins || []){
                    if (plugin3.handler) plugin3.handler(event, isSync, {
                        replayer: this
                    });
                }
                this.service.send({
                    type: "CAST_EVENT",
                    payload: {
                        event
                    }
                });
                const last_index = this.service.state.context.events.length - 1;
                if (!this.config.liveMode && event === this.service.state.context.events[last_index]) {
                    const finish = ()=>{
                        if (last_index < this.service.state.context.events.length - 1) {
                            return;
                        }
                        this.backToNormal();
                        this.service.send("END");
                        this.emitter.emit(ReplayerEvents.Finish);
                    };
                    let finish_buffer = 50;
                    if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseMove && event.data.positions.length) {
                        finish_buffer += Math.max(0, -event.data.positions[0].timeOffset);
                    }
                    setTimeout(finish, finish_buffer);
                }
                this.emitter.emit(ReplayerEvents.EventCast, event);
            };
            return wrappedCastFn;
        });
        if (!(config == null ? void 0 : config.liveMode) && events.length < 2) {
            throw new Error("Replayer need at least 2 events.");
        }
        const defaultConfig = {
            speed: 1,
            maxSpeed: 360,
            root: document.body,
            loadTimeout: 0,
            skipInactive: false,
            inactivePeriodThreshold: 10 * 1e3,
            showWarning: true,
            showDebug: false,
            blockClass: "rr-block",
            liveMode: false,
            insertStyleRules: [],
            triggerFocus: true,
            UNSAFE_replayCanvas: false,
            pauseAnimation: true,
            mouseTail: defaultMouseTailConfig,
            useVirtualDom: true,
            // Virtual-dom optimization is enabled by default.
            logger: console
        };
        this.config = Object.assign({}, defaultConfig, config);
        this.handleResize = this.handleResize.bind(this);
        this.getCastFn = this.getCastFn.bind(this);
        this.applyEventsSynchronously = this.applyEventsSynchronously.bind(this);
        this.emitter.on(ReplayerEvents.Resize, this.handleResize);
        this.setupDom();
        for (const plugin3 of this.config.plugins || []){
            if (plugin3.getMirror) plugin3.getMirror({
                nodeMirror: this.mirror
            });
        }
        this.emitter.on(ReplayerEvents.Flush, ()=>{
            if (this.usingVirtualDom) {
                const replayerHandler = {
                    mirror: this.mirror,
                    applyCanvas: (canvasEvent, canvasMutationData, target)=>{
                        void canvasMutation({
                            event: canvasEvent,
                            mutation: canvasMutationData,
                            target,
                            imageMap: this.imageMap,
                            canvasEventMap: this.canvasEventMap,
                            errorHandler: this.warnCanvasMutationFailed.bind(this)
                        });
                    },
                    applyInput: this.applyInput.bind(this),
                    applyScroll: this.applyScroll.bind(this),
                    applyStyleSheetMutation: (data, styleSheet)=>{
                        if (data.source === IncrementalSource.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);
                        else if (data.source === IncrementalSource.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
                    },
                    afterAppend: (node2, id)=>{
                        for (const plugin3 of this.config.plugins || []){
                            if (plugin3.onBuild) plugin3.onBuild(node2, {
                                id,
                                replayer: this
                            });
                        }
                    }
                };
                if (this.iframe.contentDocument) try {
                    diff(this.iframe.contentDocument, this.virtualDom, replayerHandler, this.virtualDom.mirror);
                } catch (e2) {
                    console.warn(e2);
                }
                this.virtualDom.destroyTree();
                this.usingVirtualDom = false;
                if (Object.keys(this.legacy_missingNodeRetryMap).length) {
                    for(const key in this.legacy_missingNodeRetryMap){
                        try {
                            const value = this.legacy_missingNodeRetryMap[key];
                            const realNode = createOrGetNode(value.node, this.mirror, this.virtualDom.mirror);
                            diff(realNode, value.node, replayerHandler, this.virtualDom.mirror);
                            value.node = realNode;
                        } catch (error) {
                            this.warn(error);
                        }
                    }
                }
                this.constructedStyleMutations.forEach((data)=>{
                    this.applyStyleSheetMutation(data);
                });
                this.constructedStyleMutations = [];
                this.adoptedStyleSheets.forEach((data)=>{
                    this.applyAdoptedStyleSheet(data);
                });
                this.adoptedStyleSheets = [];
            }
            if (this.mousePos) {
                this.moveAndHover(this.mousePos.x, this.mousePos.y, this.mousePos.id, true, this.mousePos.debugData);
                this.mousePos = null;
            }
            if (this.touchActive === true) {
                this.mouse.classList.add("touch-active");
            } else if (this.touchActive === false) {
                this.mouse.classList.remove("touch-active");
            }
            this.touchActive = null;
            if (this.lastMouseDownEvent) {
                const [target, event] = this.lastMouseDownEvent;
                target.dispatchEvent(event);
            }
            this.lastMouseDownEvent = null;
            if (this.lastSelectionData) {
                this.applySelection(this.lastSelectionData);
                this.lastSelectionData = null;
            }
        });
        this.emitter.on(ReplayerEvents.PlayBack, ()=>{
            this.firstFullSnapshot = null;
            this.mirror.reset();
            this.styleMirror.reset();
            this.mediaManager.reset();
        });
        const timer = new Timer([], {
            speed: this.config.speed
        });
        this.service = createPlayerService({
            events: events.map((e2)=>{
                if (config && config.unpackFn) {
                    return config.unpackFn(e2);
                }
                return e2;
            }).sort((a1, a2)=>a1.timestamp - a2.timestamp),
            timer,
            timeOffset: 0,
            baselineTime: 0,
            lastPlayedEvent: null
        }, {
            getCastFn: this.getCastFn,
            applyEventsSynchronously: this.applyEventsSynchronously,
            emitter: this.emitter
        });
        this.service.start();
        this.service.subscribe((state)=>{
            this.emitter.emit(ReplayerEvents.StateChange, {
                player: state
            });
        });
        this.speedService = createSpeedService({
            normalSpeed: -1,
            timer
        });
        this.speedService.start();
        this.speedService.subscribe((state)=>{
            this.emitter.emit(ReplayerEvents.StateChange, {
                speed: state
            });
        });
        this.mediaManager = new MediaManager({
            warn: this.warn.bind(this),
            service: this.service,
            speedService: this.speedService,
            emitter: this.emitter,
            getCurrentTime: this.getCurrentTime.bind(this)
        });
        const firstMeta = this.service.state.context.events.find((e2)=>e2.type === EventType.Meta);
        const firstFullsnapshot = this.service.state.context.events.find((e2)=>e2.type === EventType.FullSnapshot);
        if (firstMeta) {
            const { width, height } = firstMeta.data;
            setTimeout(()=>{
                this.emitter.emit(ReplayerEvents.Resize, {
                    width,
                    height
                });
            }, 0);
        }
        if (firstFullsnapshot) {
            setTimeout(()=>{
                var _a2;
                if (this.firstFullSnapshot) {
                    return;
                }
                this.firstFullSnapshot = firstFullsnapshot;
                this.rebuildFullSnapshot(firstFullsnapshot);
                (_a2 = this.iframe.contentWindow) == null ? void 0 : _a2.scrollTo(firstFullsnapshot.data.initialOffset);
            }, 1);
        }
        if (this.service.state.context.events.find(indicatesTouchDevice)) {
            this.mouse.classList.add("touch-device");
        }
    }
}
const { addCustomEvent } = record;
const { freezePage } = record;
const { takeFullSnapshot } = record;
 //# sourceMappingURL=rrweb.js.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-core@2.5.4/node_modules/@amplitude/analytics-core/lib/esm/transports/base.js
var base = __webpack_require__(21143);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@amplitude+analytics-types@2.8.4/node_modules/@amplitude/analytics-types/lib/esm/status.js
var esm_status = __webpack_require__(91669);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-remote-config@0.5.0/node_modules/@amplitude/analytics-remote-config/lib/esm/remote-config.js



var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, remote config fetch failed';
var SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Remote config fetch rejected due to exceeded retry count';
var TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var REMOTE_CONFIG_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_STAGING = 'https://sr-client-cfg.stag2.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_EU = 'https://sr-client-cfg.eu.amplitude.com/config';
var RemoteConfigFetch = /** @class */ function() {
    function RemoteConfigFetch(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1000;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var fetchStartTime, configAPIResponse, remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fetchStartTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                this.fetchWithTimeout(sessionId)
                            ];
                        case 1:
                            configAPIResponse = _a.sent();
                            if (configAPIResponse) {
                                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                                if (remoteConfig) {
                                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                                    return [
                                        2 /*return*/ ,
                                        remoteConfig[key]
                                    ];
                                }
                            }
                            this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        this.fetchWithTimeout = function(sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var controller, timeoutId, remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            controller = new AbortController();
                            timeoutId = setTimeout(function() {
                                return controller.abort();
                            }, 5000);
                            return [
                                4 /*yield*/ ,
                                this.fetchRemoteConfig(controller.signal, sessionId)
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            clearTimeout(timeoutId);
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var urlParams, _a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
                var e_2, _c;
                var _d;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: MAX_RETRIES_EXCEEDED_MESSAGE
                                    })
                                ];
                            } else if (signal.aborted) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: TIMEOUT_MESSAGE
                                    })
                                ];
                            } else if (sessionId !== this.lastFetchedSessionId) {
                                this.lastFetchedSessionId = sessionId;
                                this.attempts = 0;
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            urlParams = new URLSearchParams({
                                api_key: this.localConfig.apiKey
                            });
                            try {
                                for(_a = (0,tslib_es6/* __values */.XA)(this.configKeys), _b = _a.next(); !_b.done; _b = _a.next()){
                                    configKey = _b.value;
                                    urlParams.append('config_keys', configKey);
                                }
                            } catch (e_2_1) {
                                e_2 = {
                                    error: e_2_1
                                };
                            } finally{
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                } finally{
                                    if (e_2) throw e_2.error;
                                }
                            }
                            if (sessionId) {
                                urlParams.set('session_id', String(sessionId));
                            }
                            options = {
                                headers: {
                                    Accept: '*/*'
                                },
                                method: 'GET'
                            };
                            serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                            this.attempts += 1;
                            return [
                                4 /*yield*/ ,
                                fetch(serverUrl, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), {
                                    signal: signal
                                }))
                            ];
                        case 2:
                            res = _e.sent();
                            if (res === null) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: UNEXPECTED_ERROR_MESSAGE
                                    })
                                ];
                            }
                            parsedStatus = new base/* BaseTransport */.d().buildStatus(res.status);
                            switch(parsedStatus){
                                case esm_status/* Status.Success */.q.Success:
                                    this.attempts = 0;
                                    return [
                                        2 /*return*/ ,
                                        this.parseAndStoreConfig(res)
                                    ];
                                case esm_status/* Status.Failed */.q.Failed:
                                    return [
                                        2 /*return*/ ,
                                        this.retryFetch(signal, sessionId)
                                    ];
                                default:
                                    return [
                                        2 /*return*/ ,
                                        this.completeRequest({
                                            err: UNEXPECTED_NETWORK_ERROR_MESSAGE
                                        })
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _e.sent();
                            knownError = e_1;
                            if (signal.aborted) {
                                return [
                                    2 /*return*/ ,
                                    this.completeRequest({
                                        err: TIMEOUT_MESSAGE
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: (_d = knownError.message) !== null && _d !== void 0 ? _d : UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.retryFetch = function(signal, sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var _this = this;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, _this.attempts * _this.retryTimeout);
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.fetchRemoteConfig(signal, sessionId)
                            ];
                    }
                });
            });
        };
        this.parseAndStoreConfig = function(res) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var remoteConfig;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                res.json()
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            this.completeRequest({
                                success: SUCCESS_REMOTE_CONFIG
                            });
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
    }
    RemoteConfigFetch.prototype.getServerUrl = function() {
        if (this.localConfig.serverZone === server_zone/* ServerZone.STAGING */.J.STAGING) {
            return REMOTE_CONFIG_SERVER_URL_STAGING;
        }
        if (this.localConfig.serverZone === server_zone/* ServerZone.EU */.J.EU) {
            return REMOTE_CONFIG_SERVER_URL_EU;
        }
        return REMOTE_CONFIG_SERVER_URL;
    };
    RemoteConfigFetch.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) {
            throw new Error(err);
        } else if (success) {
            this.localConfig.loggerProvider.log(success);
        }
    };
    return RemoteConfigFetch;
}();

var createRemoteConfigFetch = function(_a) {
    var localConfig = _a.localConfig, configKeys = _a.configKeys;
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            return [
                2 /*return*/ ,
                new RemoteConfigFetch({
                    localConfig: localConfig,
                    configKeys: configKeys
                })
            ];
        });
    });
}; //# sourceMappingURL=remote-config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+analytics-remote-config@0.5.0/node_modules/@amplitude/analytics-remote-config/lib/esm/index.js

var esm_createRemoteConfigFetch = createRemoteConfigFetch; //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-snapshot@2.0.0-alpha.26/node_modules/@amplitude/rrweb-snapshot/dist/rrweb-snapshot.js
function rrweb_snapshot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function rrweb_snapshot_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                rrweb_snapshot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                rrweb_snapshot_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function rrweb_snapshot_extends() {
    rrweb_snapshot_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return rrweb_snapshot_extends.apply(this, arguments);
}
function rrweb_snapshot_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var rrweb_snapshot_defProp = Object.defineProperty;
var rrweb_snapshot_defNormalProp = (obj, key, value)=>key in obj ? rrweb_snapshot_defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var rrweb_snapshot_publicField = (obj, key, value)=>rrweb_snapshot_defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var rrweb_snapshot_NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})(rrweb_snapshot_NodeType || {});
const rrweb_snapshot_testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const rrweb_snapshot_testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const rrweb_snapshot_untaintedBasePrototype = {};
function rrweb_snapshot_getUntaintedPrototype(key) {
    if (rrweb_snapshot_untaintedBasePrototype[key]) return rrweb_snapshot_untaintedBasePrototype[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in rrweb_snapshot_testableAccessors ? rrweb_snapshot_testableAccessors[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a, _b;
        return Boolean((_b = (_a = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in rrweb_snapshot_testableMethods ? rrweb_snapshot_testableMethods[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a;
        return typeof defaultPrototype[method] === "function" && ((_a = defaultPrototype[method]) == null ? void 0 : _a.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods) {
        rrweb_snapshot_untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return rrweb_snapshot_untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
const rrweb_snapshot_untaintedAccessorCache = {};
function rrweb_snapshot_getUntaintedAccessor(key, instance, accessor) {
    var _a;
    const cacheKey = `${key}.${String(accessor)}`;
    if (rrweb_snapshot_untaintedAccessorCache[cacheKey]) return rrweb_snapshot_untaintedAccessorCache[cacheKey].call(instance);
    const untaintedPrototype = rrweb_snapshot_getUntaintedPrototype(key);
    const untaintedAccessor = (_a = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a.get;
    if (!untaintedAccessor) return instance[accessor];
    rrweb_snapshot_untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const rrweb_snapshot_untaintedMethodCache = {};
function rrweb_snapshot_getUntaintedMethod(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if (rrweb_snapshot_untaintedMethodCache[cacheKey]) return rrweb_snapshot_untaintedMethodCache[cacheKey].bind(instance);
    const untaintedPrototype = rrweb_snapshot_getUntaintedPrototype(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    rrweb_snapshot_untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function rrweb_snapshot_childNodes(n) {
    return rrweb_snapshot_getUntaintedAccessor("Node", n, "childNodes");
}
function rrweb_snapshot_parentNode(n) {
    return rrweb_snapshot_getUntaintedAccessor("Node", n, "parentNode");
}
function rrweb_snapshot_parentElement(n) {
    return rrweb_snapshot_getUntaintedAccessor("Node", n, "parentElement");
}
function rrweb_snapshot_textContent(n) {
    return rrweb_snapshot_getUntaintedAccessor("Node", n, "textContent");
}
function rrweb_snapshot_contains(n, other) {
    return rrweb_snapshot_getUntaintedMethod("Node", n, "contains")(other);
}
function rrweb_snapshot_getRootNode(n) {
    return rrweb_snapshot_getUntaintedMethod("Node", n, "getRootNode")();
}
function rrweb_snapshot_host(n) {
    if (!n || !("host" in n)) return null;
    return rrweb_snapshot_getUntaintedAccessor("ShadowRoot", n, "host");
}
function rrweb_snapshot_styleSheets(n) {
    return n.styleSheets;
}
function rrweb_snapshot_shadowRoot(n) {
    if (!n || !("shadowRoot" in n)) return null;
    return rrweb_snapshot_getUntaintedAccessor("Element", n, "shadowRoot");
}
function rrweb_snapshot_querySelector(n, selectors) {
    return rrweb_snapshot_getUntaintedAccessor("Element", n, "querySelector")(selectors);
}
function rrweb_snapshot_querySelectorAll(n, selectors) {
    return rrweb_snapshot_getUntaintedAccessor("Element", n, "querySelectorAll")(selectors);
}
function rrweb_snapshot_mutationObserverCtor() {
    return rrweb_snapshot_getUntaintedPrototype("MutationObserver").constructor;
}
const rrweb_snapshot_index = {
    childNodes: rrweb_snapshot_childNodes,
    parentNode: rrweb_snapshot_parentNode,
    parentElement: rrweb_snapshot_parentElement,
    textContent: rrweb_snapshot_textContent,
    contains: rrweb_snapshot_contains,
    getRootNode: rrweb_snapshot_getRootNode,
    host: rrweb_snapshot_host,
    styleSheets: rrweb_snapshot_styleSheets,
    shadowRoot: rrweb_snapshot_shadowRoot,
    querySelector: rrweb_snapshot_querySelector,
    querySelectorAll: rrweb_snapshot_querySelectorAll,
    mutationObserver: rrweb_snapshot_mutationObserverCtor
};
function rrweb_snapshot_isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function rrweb_snapshot_isShadowRoot(n) {
    const hostEl = // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    n && "host" in n && "mode" in n && rrweb_snapshot_index.host(n) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && rrweb_snapshot_index.shadowRoot(hostEl) === n);
}
function rrweb_snapshot_isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function rrweb_snapshot_fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) {
        cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    }
    return cssText;
}
function rrweb_snapshot_escapeImportStatement(rule2) {
    const { cssText } = rule2;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule2.href)})`
    ];
    if (rule2.layerName === "") {
        statement.push(`layer`);
    } else if (rule2.layerName) {
        statement.push(`layer(${rule2.layerName})`);
    }
    if (rule2.supportsText) {
        statement.push(`supports(${rule2.supportsText})`);
    }
    if (rule2.media.length) {
        statement.push(rule2.media.mediaText);
    }
    return statement.join(" ") + ";";
}
function rrweb_snapshot_stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        if (!rules) {
            return null;
        }
        const stringifiedRules = Array.from(rules, (rule2)=>rrweb_snapshot_stringifyRule(rule2, s.href)).join("");
        return rrweb_snapshot_fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function rrweb_snapshot_stringifyRule(rule2, sheetHref) {
    if (rrweb_snapshot_isCSSImportRule(rule2)) {
        let importStringified;
        try {
            importStringified = // we can access the imported stylesheet rules directly
            rrweb_snapshot_stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            rrweb_snapshot_escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) {
            return rrweb_snapshot_absolutifyURLs(importStringified, rule2.styleSheet.href);
        }
        return importStringified;
    } else {
        let ruleStringified = rule2.cssText;
        if (rrweb_snapshot_isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) {
            ruleStringified = rrweb_snapshot_fixSafariColons(ruleStringified);
        }
        if (sheetHref) {
            return rrweb_snapshot_absolutifyURLs(ruleStringified, sheetHref);
        }
        return ruleStringified;
    }
}
function rrweb_snapshot_fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function rrweb_snapshot_isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function rrweb_snapshot_isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
class rrweb_snapshot_Mirror {
    getId(n) {
        var _a;
        if (!n) return -1;
        const id = (_a = this.getMeta(n)) == null ? void 0 : _a.id;
        return id != null ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) {
            n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
        }
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
    constructor(){
        rrweb_snapshot_publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        rrweb_snapshot_publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
}
function rrweb_snapshot_createMirror() {
    return new rrweb_snapshot_Mirror();
}
function rrweb_snapshot_maskInputValue({ element, maskInputOptions, tagName, type, value, maskInputFn }) {
    let text = value || "";
    const actualType = type && rrweb_snapshot_toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) {
            text = maskInputFn(text, element);
        } else {
            text = "*".repeat(text.length);
        }
    }
    return text;
}
function rrweb_snapshot_toLowerCase(str) {
    return str.toLowerCase();
}
const rrweb_snapshot_ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function rrweb_snapshot_is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x2 = 0; x2 < canvas.width; x2 += chunkSize){
        for(let y = 0; y < canvas.height; y += chunkSize){
            const getImageData = ctx.getImageData;
            const originalGetImageData = rrweb_snapshot_ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[rrweb_snapshot_ORIGINAL_ATTRIBUTE_NAME] : getImageData;
            const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
        }
    }
    return true;
}
function rrweb_snapshot_isNodeMetaEqual(a, b) {
    if (!a || !b || a.type !== b.type) return false;
    if (a.type === rrweb_snapshot_NodeType.Document) return a.compatMode === b.compatMode;
    else if (a.type === rrweb_snapshot_NodeType.DocumentType) return a.name === b.name && a.publicId === b.publicId && a.systemId === b.systemId;
    else if (a.type === rrweb_snapshot_NodeType.Comment || a.type === rrweb_snapshot_NodeType.Text || a.type === rrweb_snapshot_NodeType.CDATA) return a.textContent === b.textContent;
    else if (a.type === rrweb_snapshot_NodeType.Element) return a.tagName === b.tagName && JSON.stringify(a.attributes) === JSON.stringify(b.attributes) && a.isSVG === b.isSVG && a.needBlock === b.needBlock;
    return false;
}
function rrweb_snapshot_getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    rrweb_snapshot_toLowerCase(type) : null;
}
function rrweb_snapshot_extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function rrweb_snapshot_extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) {
        origin = url.split("/").slice(0, 3).join("/");
    } else {
        origin = url.split("/")[0];
    }
    origin = origin.split("?")[0];
    return origin;
}
const rrweb_snapshot_URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const rrweb_snapshot_URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const rrweb_snapshot_URL_WWW_MATCH = /^www\..*/i;
const rrweb_snapshot_DATA_URI = /^(data:)([^,]*),(.*)/i;
function rrweb_snapshot_absolutifyURLs(cssText, href) {
    return (cssText || "").replace(rrweb_snapshot_URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) {
            return origin;
        }
        if (rrweb_snapshot_URL_PROTOCOL_MATCH.test(filePath) || rrweb_snapshot_URL_WWW_MATCH.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (rrweb_snapshot_DATA_URI.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (filePath[0] === "/") {
            return `url(${maybeQuote}${rrweb_snapshot_extractOrigin(href) + filePath}${maybeQuote})`;
        }
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") {
                continue;
            } else if (part === "..") {
                stack.pop();
            } else {
                stack.push(part);
            }
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
let rrweb_snapshot_id = 1;
const rrweb_snapshot_tagNameRegex = (/* unused pure expression or super */ null && (new RegExp("[^a-z0-9-_:]")));
const rrweb_snapshot_IGNORED_NODE = (/* unused pure expression or super */ null && (-2));
function rrweb_snapshot_genId() {
    return rrweb_snapshot_id++;
}
function rrweb_snapshot_getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return "form";
    }
    const processedTagName = rrweb_snapshot_toLowerCase(element.tagName);
    if (rrweb_snapshot_tagNameRegex.test(processedTagName)) {
        return "div";
    }
    return processedTagName;
}
let rrweb_snapshot_canvasService;
let rrweb_snapshot_canvasCtx;
const rrweb_snapshot_SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const rrweb_snapshot_SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function rrweb_snapshot_getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") {
        return attributeValue;
    }
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters(rrweb_snapshot_SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        let url = collectCharacters(rrweb_snapshot_SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = rrweb_snapshot_absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = rrweb_snapshot_absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") {
                        inParens = true;
                    }
                } else {
                    if (c === ")") {
                        inParens = false;
                    }
                }
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const rrweb_snapshot_cachedDocument = /* @__PURE__ */ new WeakMap();
function rrweb_snapshot_absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") {
        return attributeValue;
    }
    return rrweb_snapshot_getHref(doc, attributeValue);
}
function rrweb_snapshot_isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function rrweb_snapshot_getHref(doc, customHref) {
    let a = rrweb_snapshot_cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        rrweb_snapshot_cachedDocument.set(doc, a);
    }
    if (!customHref) {
        customHref = "";
    } else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) {
        return customHref;
    }
    a.setAttribute("href", customHref);
    return a.href;
}
function rrweb_snapshot_transformAttribute(doc, tagName, name, value) {
    if (!value) {
        return value;
    }
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) {
        return rrweb_snapshot_absoluteToDoc(doc, value);
    } else if (name === "xlink:href" && value[0] !== "#") {
        return rrweb_snapshot_absoluteToDoc(doc, value);
    } else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) {
        return rrweb_snapshot_absoluteToDoc(doc, value);
    } else if (name === "srcset") {
        return rrweb_snapshot_getAbsoluteSrcsetString(doc, value);
    } else if (name === "style") {
        return rrweb_snapshot_absolutifyURLs(value, rrweb_snapshot_getHref(doc));
    } else if (tagName === "object" && name === "data") {
        return rrweb_snapshot_absoluteToDoc(doc, value);
    }
    return value;
}
function rrweb_snapshot_ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function rrweb_snapshot_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) {
                return true;
            }
        } else {
            for(let eIndex = element.classList.length; eIndex--;){
                const className = element.classList[eIndex];
                if (blockClass.test(className)) {
                    return true;
                }
            }
        }
        if (blockSelector) {
            return element.matches(blockSelector);
        }
    } catch (e) {}
    return false;
}
function rrweb_snapshot_classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return rrweb_snapshot_classMatchesRegex(rrweb_snapshot_index.parentNode(node2), regex, checkAncestors);
    }
    for(let eIndex = node2.classList.length; eIndex--;){
        const className = node2.classList[eIndex];
        if (regex.test(className)) {
            return true;
        }
    }
    if (!checkAncestors) return false;
    return rrweb_snapshot_classMatchesRegex(rrweb_snapshot_index.parentNode(node2), regex, checkAncestors);
}
function rrweb_snapshot_needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    let el;
    if (rrweb_snapshot_isElement(node2)) {
        el = node2;
        if (!rrweb_snapshot_index.childNodes(el).length) {
            return false;
        }
    } else if (rrweb_snapshot_index.parentElement(node2) === null) {
        return false;
    } else {
        el = rrweb_snapshot_index.parentElement(node2);
    }
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if (rrweb_snapshot_classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e) {}
    return false;
}
function rrweb_snapshot_onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function rrweb_snapshot_onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function rrweb_snapshot_serializeNode(n, options) {
    const { doc, mirror, blockClass, blockSelector, needsMask, inlineStylesheet, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false } = options;
    const rootId = rrweb_snapshot_getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") {
                return {
                    type: rrweb_snapshot_NodeType.Document,
                    childNodes: [],
                    compatMode: n.compatMode
                };
            } else {
                return {
                    type: rrweb_snapshot_NodeType.Document,
                    childNodes: []
                };
            }
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: rrweb_snapshot_NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId
            };
        case n.ELEMENT_NODE:
            return rrweb_snapshot_serializeElementNode(n, {
                doc,
                blockClass,
                blockSelector,
                inlineStylesheet,
                maskInputOptions,
                maskInputFn,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                keepIframeSrcFn,
                newlyAddedElement,
                rootId
            });
        case n.TEXT_NODE:
            return rrweb_snapshot_serializeTextNode(n, {
                doc,
                needsMask,
                maskTextFn,
                rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: rrweb_snapshot_NodeType.CDATA,
                textContent: "",
                rootId
            };
        case n.COMMENT_NODE:
            return {
                type: rrweb_snapshot_NodeType.Comment,
                textContent: rrweb_snapshot_index.textContent(n) || "",
                rootId
            };
        default:
            return false;
    }
}
function rrweb_snapshot_getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function rrweb_snapshot_serializeTextNode(n, options) {
    var _a;
    const { needsMask, maskTextFn, rootId } = options;
    const parent = rrweb_snapshot_index.parentNode(n);
    const parentTagName = parent && parent.tagName;
    let text = rrweb_snapshot_index.textContent(n);
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isStyle && text) {
        try {
            if (n.nextSibling || n.previousSibling) {} else if ((_a = parent.sheet) == null ? void 0 : _a.cssRules) {
                text = rrweb_snapshot_stringifyStylesheet(parent.sheet);
            }
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        text = rrweb_snapshot_absolutifyURLs(text, rrweb_snapshot_getHref(options.doc));
    }
    if (isScript) {
        text = "SCRIPT_PLACEHOLDER";
    }
    if (!isStyle && !isScript && text && needsMask) {
        text = maskTextFn ? maskTextFn(text, rrweb_snapshot_index.parentElement(n)) : text.replace(/[\S]/g, "*");
    }
    return {
        type: rrweb_snapshot_NodeType.Text,
        textContent: text || "",
        isStyle,
        rootId
    };
}
function rrweb_snapshot_serializeElementNode(n, options) {
    const { doc, blockClass, blockSelector, inlineStylesheet, maskInputOptions = {}, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false, rootId } = options;
    const needBlock = rrweb_snapshot_isBlockedElement(n, blockClass, blockSelector);
    const tagName = rrweb_snapshot_getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (!rrweb_snapshot_ignoreAttribute(tagName, attr.name, attr.value)) {
            attributes[attr.name] = rrweb_snapshot_transformAttribute(doc, tagName, rrweb_snapshot_toLowerCase(attr.name), attr.value);
        }
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) {
            cssText = rrweb_snapshot_stringifyStylesheet(stylesheet);
        }
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || rrweb_snapshot_index.textContent(n) || "").trim().length) {
        const cssText = rrweb_snapshot_stringifyStylesheet(n.sheet);
        if (cssText) {
            attributes._cssText = cssText;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        const value = n.value;
        const checked = n.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) {
            attributes.value = rrweb_snapshot_maskInputValue({
                element: n,
                type: rrweb_snapshot_getInputType(n),
                tagName,
                value,
                maskInputOptions,
                maskInputFn
            });
        } else if (checked) {
            attributes.checked = checked;
        }
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) {
            attributes.selected = true;
        } else {
            delete attributes.selected;
        }
    }
    if (tagName === "dialog" && n.open) {
        attributes.rr_open_mode = n.matches("dialog:modal") ? "modal" : "non-modal";
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!rrweb_snapshot_is2DCanvasBlank(n)) {
                attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            }
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) {
                attributes.rr_dataURL = canvasDataURL;
            }
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!rrweb_snapshot_canvasService) {
            rrweb_snapshot_canvasService = doc.createElement("canvas");
            rrweb_snapshot_canvasCtx = rrweb_snapshot_canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                rrweb_snapshot_canvasService.width = image.naturalWidth;
                rrweb_snapshot_canvasService.height = image.naturalHeight;
                rrweb_snapshot_canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = rrweb_snapshot_canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else {
                    console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
                }
            }
            if (image.crossOrigin === "anonymous") {
                priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
            }
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n.playbackRate;
        mediaAttributes.rr_mediaMuted = n.muted;
        mediaAttributes.rr_mediaLoop = n.loop;
        mediaAttributes.rr_mediaVolume = n.volume;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) {
            attributes.rr_scrollLeft = n.scrollLeft;
        }
        if (n.scrollTop) {
            attributes.rr_scrollTop = n.scrollTop;
        }
    }
    if (needBlock) {
        const { width, height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) {
            attributes.rr_src = attributes.src;
        }
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: rrweb_snapshot_NodeType.Element,
        tagName,
        attributes,
        childNodes: [],
        isSVG: rrweb_snapshot_isSVGElement(n) || void 0,
        needBlock,
        rootId,
        isCustom: isCustomElement
    };
}
function rrweb_snapshot_lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) {
        return "";
    } else {
        return maybeAttr.toLowerCase();
    }
}
function rrweb_snapshot_slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === rrweb_snapshot_NodeType.Comment) {
        return true;
    } else if (sn.type === rrweb_snapshot_NodeType.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && rrweb_snapshot_extractFileExtension(sn.attributes.href) === "js")) {
            return true;
        } else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (rrweb_snapshot_lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "application-name" || rrweb_snapshot_lowerIfExists(sn.attributes.rel) === "icon" || rrweb_snapshot_lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || rrweb_snapshot_lowerIfExists(sn.attributes.rel) === "shortcut icon"))) {
            return true;
        } else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && rrweb_snapshot_lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            } else if (slimDOMOptions.headMetaSocial && (rrweb_snapshot_lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            rrweb_snapshot_lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "pinterest")) {
                return true;
            } else if (slimDOMOptions.headMetaRobots && (rrweb_snapshot_lowerIfExists(sn.attributes.name) === "robots" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "googlebot" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "bingbot")) {
                return true;
            } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) {
                return true;
            } else if (slimDOMOptions.headMetaAuthorship && (rrweb_snapshot_lowerIfExists(sn.attributes.name) === "author" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "generator" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "framework" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "publisher" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "progid" || rrweb_snapshot_lowerIfExists(sn.attributes.property).match(/^article:/) || rrweb_snapshot_lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            } else if (slimDOMOptions.headMetaVerification && (rrweb_snapshot_lowerIfExists(sn.attributes.name) === "google-site-verification" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "yandex-verification" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "csrf-token" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "p:domain_verify" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "verify-v1" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "verification" || rrweb_snapshot_lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) {
                return true;
            }
        }
    }
    return false;
}
function rrweb_snapshot_serializeNodeWithId(n, options) {
    const { doc, mirror, blockClass, blockSelector, maskTextClass, maskTextSelector, skipChild = false, inlineStylesheet = true, maskInputOptions = {}, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5e3, onStylesheetLoad, stylesheetLoadTimeout = 5e3, keepIframeSrcFn = ()=>false, newlyAddedElement = false } = options;
    let { needsMask } = options;
    let { preserveWhiteSpace = true } = options;
    if (!needsMask) {
        const checkAncestors = needsMask === void 0;
        needsMask = rrweb_snapshot_needMaskingText(n, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = rrweb_snapshot_serializeNode(n, {
        doc,
        mirror,
        blockClass,
        blockSelector,
        needsMask,
        inlineStylesheet,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) {
        id = mirror.getId(n);
    } else if (rrweb_snapshot_slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === rrweb_snapshot_NodeType.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) {
        id = rrweb_snapshot_IGNORED_NODE;
    } else {
        id = rrweb_snapshot_genId();
    }
    const serializedNode = Object.assign(_serializedNode, {
        id
    });
    mirror.add(n, serializedNode);
    if (id === rrweb_snapshot_IGNORED_NODE) {
        return null;
    }
    if (onSerialize) {
        onSerialize(n);
    }
    let recordChild = !skipChild;
    if (serializedNode.type === rrweb_snapshot_NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRootEl = rrweb_snapshot_index.shadowRoot(n);
        if (shadowRootEl && rrweb_snapshot_isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === rrweb_snapshot_NodeType.Document || serializedNode.type === rrweb_snapshot_NodeType.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === rrweb_snapshot_NodeType.Element && serializedNode.tagName === "head") {
            preserveWhiteSpace = false;
        }
        const bypassOptions = {
            doc,
            mirror,
            blockClass,
            blockSelector,
            needsMask,
            maskTextClass,
            maskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn
        };
        if (serializedNode.type === rrweb_snapshot_NodeType.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            for (const childN of Array.from(rrweb_snapshot_index.childNodes(n))){
                const serializedChildNode = rrweb_snapshot_serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
        let shadowRootEl = null;
        if (rrweb_snapshot_isElement(n) && (shadowRootEl = rrweb_snapshot_index.shadowRoot(n))) {
            for (const childN of Array.from(rrweb_snapshot_index.childNodes(shadowRootEl))){
                const serializedChildNode = rrweb_snapshot_serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    rrweb_snapshot_isNativeShadowDom(shadowRootEl) && (serializedChildNode.isShadow = true);
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    const parent = rrweb_snapshot_index.parentNode(n);
    if (parent && rrweb_snapshot_isShadowRoot(parent) && rrweb_snapshot_isNativeShadowDom(parent)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === rrweb_snapshot_NodeType.Element && serializedNode.tagName === "iframe") {
        rrweb_snapshot_onceIframeLoaded(n, ()=>{
            const iframeDoc = n.contentDocument;
            if (iframeDoc && onIframeLoad) {
                const serializedIframeNode = rrweb_snapshot_serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    mirror,
                    blockClass,
                    blockSelector,
                    needsMask,
                    maskTextClass,
                    maskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn
                });
                if (serializedIframeNode) {
                    onIframeLoad(n, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    if (serializedNode.type === rrweb_snapshot_NodeType.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && rrweb_snapshot_extractFileExtension(serializedNode.attributes.href) === "css")) {
        rrweb_snapshot_onceStylesheetLoaded(n, ()=>{
            if (onStylesheetLoad) {
                const serializedLinkNode = rrweb_snapshot_serializeNodeWithId(n, {
                    doc,
                    mirror,
                    blockClass,
                    blockSelector,
                    needsMask,
                    maskTextClass,
                    maskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    onStylesheetLoad,
                    stylesheetLoadTimeout,
                    keepIframeSrcFn
                });
                if (serializedLinkNode) {
                    onStylesheetLoad(n, serializedLinkNode);
                }
            }
        }, stylesheetLoadTimeout);
    }
    return serializedNode;
}
function rrweb_snapshot_snapshot(n, options) {
    const { mirror = new rrweb_snapshot_Mirror(), blockClass = "rr-block", blockSelector = null, maskTextClass = "rr-mask", maskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskAllInputs = false, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, onStylesheetLoad, stylesheetLoadTimeout, keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return rrweb_snapshot_serializeNodeWithId(n, {
        doc: n,
        mirror,
        blockClass,
        blockSelector,
        maskTextClass,
        maskTextSelector,
        skipChild: false,
        inlineStylesheet,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        slimDOMOptions,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        preserveWhiteSpace,
        onSerialize,
        onIframeLoad,
        iframeLoadTimeout,
        onStylesheetLoad,
        stylesheetLoadTimeout,
        keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function visitSnapshot(node2, onVisit) {
    function walk(current) {
        onVisit(current);
        if (current.type === rrweb_snapshot_NodeType.Document || current.type === rrweb_snapshot_NodeType.Element) {
            current.childNodes.forEach(walk);
        }
    }
    walk(node2);
}
function cleanupSnapshot() {
    rrweb_snapshot_id = 1;
}
const rrweb_snapshot_MEDIA_SELECTOR = /(max|min)-device-(width|height)/;
const rrweb_snapshot_MEDIA_SELECTOR_GLOBAL = new RegExp(rrweb_snapshot_MEDIA_SELECTOR.source, "g");
const rrweb_snapshot_mediaSelectorPlugin = {
    postcssPlugin: "postcss-custom-selectors",
    prepare () {
        return {
            postcssPlugin: "postcss-custom-selectors",
            AtRule: function(atrule) {
                if (atrule.params.match(rrweb_snapshot_MEDIA_SELECTOR_GLOBAL)) {
                    atrule.params = atrule.params.replace(rrweb_snapshot_MEDIA_SELECTOR_GLOBAL, "$1-$2");
                }
            }
        };
    }
};
const rrweb_snapshot_pseudoClassPlugin = {
    postcssPlugin: "postcss-hover-classes",
    prepare: function() {
        const fixed = [];
        return {
            Rule: function(rule2) {
                if (fixed.indexOf(rule2) !== -1) {
                    return;
                }
                fixed.push(rule2);
                rule2.selectors.forEach(function(selector) {
                    if (!selector.includes(":")) {
                        return;
                    }
                    const selectorParts = selector.replace(/\n/g, " ").split(" ");
                    const pseudoedSelectorParts = [];
                    selectorParts.forEach(function(selectorPart) {
                        const pseudos = selectorPart.match(/::?([^:]+)/g);
                        if (!pseudos) {
                            pseudoedSelectorParts.push(selectorPart);
                            return;
                        }
                        const baseSelector = selectorPart.substr(0, selectorPart.length - pseudos.join("").length);
                        const classPseudos = pseudos.map(function(pseudo) {
                            const pseudoToCheck = pseudo.replace(/\(.*/g, "");
                            if (pseudoToCheck !== ":hover") {
                                return pseudo;
                            }
                            if (pseudo.match(/^::/)) {
                                return pseudo;
                            }
                            pseudo = pseudo.substr(1);
                            pseudo = pseudo.replace(/\(/g, "\\(");
                            pseudo = pseudo.replace(/\)/g, "\\)");
                            return ".\\:" + pseudo;
                        });
                        pseudoedSelectorParts.push(baseSelector + classPseudos.join(""));
                    });
                    addSelector(pseudoedSelectorParts.join(" "));
                    function addSelector(newSelector) {
                        if (newSelector && newSelector !== selector) {
                            rule2.selector += ",\n" + newSelector;
                        }
                    }
                });
            }
        };
    }
};
function rrweb_snapshot_getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function rrweb_snapshot_getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a2() {
            if (this instanceof a2) {
                return Reflect.construct(f, arguments, this.constructor);
            }
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var rrweb_snapshot_picocolors_browser = {
    exports: {}
};
var rrweb_snapshot_x = String;
var rrweb_snapshot_create = function() {
    return {
        isColorSupported: false,
        reset: rrweb_snapshot_x,
        bold: rrweb_snapshot_x,
        dim: rrweb_snapshot_x,
        italic: rrweb_snapshot_x,
        underline: rrweb_snapshot_x,
        inverse: rrweb_snapshot_x,
        hidden: rrweb_snapshot_x,
        strikethrough: rrweb_snapshot_x,
        black: rrweb_snapshot_x,
        red: rrweb_snapshot_x,
        green: rrweb_snapshot_x,
        yellow: rrweb_snapshot_x,
        blue: rrweb_snapshot_x,
        magenta: rrweb_snapshot_x,
        cyan: rrweb_snapshot_x,
        white: rrweb_snapshot_x,
        gray: rrweb_snapshot_x,
        bgBlack: rrweb_snapshot_x,
        bgRed: rrweb_snapshot_x,
        bgGreen: rrweb_snapshot_x,
        bgYellow: rrweb_snapshot_x,
        bgBlue: rrweb_snapshot_x,
        bgMagenta: rrweb_snapshot_x,
        bgCyan: rrweb_snapshot_x,
        bgWhite: rrweb_snapshot_x
    };
};
rrweb_snapshot_picocolors_browser.exports = rrweb_snapshot_create();
rrweb_snapshot_picocolors_browser.exports.createColors = rrweb_snapshot_create;
var rrweb_snapshot_picocolors_browserExports = rrweb_snapshot_picocolors_browser.exports;
const rrweb_snapshot_viteBrowserExternal = {};
const rrweb_snapshot_viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: rrweb_snapshot_viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
const rrweb_snapshot_require$$2 = /* @__PURE__ */ rrweb_snapshot_getAugmentedNamespace(rrweb_snapshot_viteBrowserExternal$1);
let rrweb_snapshot_pico = rrweb_snapshot_picocolors_browserExports;
let rrweb_snapshot_terminalHighlight$1 = rrweb_snapshot_require$$2;
let rrweb_snapshot_CssSyntaxError$3 = class CssSyntaxError extends Error {
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") {
            this.message += ":" + this.line + ":" + this.column;
        }
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = rrweb_snapshot_pico.isColorSupported;
        if (rrweb_snapshot_terminalHighlight$1) {
            if (color) css = rrweb_snapshot_terminalHighlight$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold, gray, red } = rrweb_snapshot_pico.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else {
            mark = aside = (str)=>str;
        }
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) {
            code = "\n\n" + code + "\n";
        }
        return this.name + ": " + this.message + code;
    }
    constructor(message, line, column, source, file, plugin2){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) {
            this.file = file;
        }
        if (source) {
            this.source = source;
        }
        if (plugin2) {
            this.plugin = plugin2;
        }
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CssSyntaxError);
        }
    }
};
var rrweb_snapshot_cssSyntaxError = rrweb_snapshot_CssSyntaxError$3;
rrweb_snapshot_CssSyntaxError$3.default = rrweb_snapshot_CssSyntaxError$3;
var rrweb_snapshot_symbols = {};
rrweb_snapshot_symbols.isClean = Symbol("isClean");
rrweb_snapshot_symbols.my = Symbol("my");
const rrweb_snapshot_DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function rrweb_snapshot_capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let rrweb_snapshot_Stringifier$2 = class Stringifier {
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") {
            name += node2.raws.afterName;
        } else if (params) {
            name += " ";
        }
        if (node2.nodes) {
            this.block(node2, name + params);
        } else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (node2.type === "comment") {
            value = this.raw(node2, null, "beforeComment");
        } else if (detect === "before") {
            value = this.raw(node2, null, "beforeRule");
        } else {
            value = this.raw(node2, null, "beforeClose");
        }
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) {
                for(let step = 0; step < depth; step++)value += indent;
            }
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else {
            after = this.raw(node2, "after", "emptyBody");
        }
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i = 0; i < node2.nodes.length; i++){
            let child = node2.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) {
            string += node2.raws.important || " !important";
        }
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) {
                return "";
            }
            if (parent && parent.type === "document") {
                return "";
            }
        }
        if (!parent) return rrweb_snapshot_DEFAULT_RAW[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") {
            return root2.rawCache[detect];
        }
        if (detect === "before" || detect === "after") {
            return this.beforeAfter(node2, detect);
        } else {
            let method = "raw" + rrweb_snapshot_capitalize(detect);
            if (this[method]) {
                value = this[method](root2, node2);
            } else {
                root2.walk((i)=>{
                    value = i.raws[own];
                    if (typeof value !== "undefined") return false;
                });
            }
        }
        if (typeof value === "undefined") value = rrweb_snapshot_DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeDecl");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) {
                    value = value.replace(/[^\n]+$/, "");
                }
                return false;
            }
        });
        if (typeof value === "undefined") {
            value = this.raw(node2, null, "beforeRule");
        } else if (value) {
            value = value.replace(/\S/g, "");
        }
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && (i.parent !== root2 || root2.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) {
                        value = value.replace(/[^\n]+$/, "");
                    }
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i)=>{
            let p = i.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) {
            return raw.raw;
        }
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) {
            this.builder(node2.raws.ownSemicolon, node2, "end");
        }
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) {
            throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        }
        this[node2.type](node2, semicolon);
    }
    constructor(builder){
        this.builder = builder;
    }
};
var rrweb_snapshot_stringifier = rrweb_snapshot_Stringifier$2;
rrweb_snapshot_Stringifier$2.default = rrweb_snapshot_Stringifier$2;
let rrweb_snapshot_Stringifier$1 = rrweb_snapshot_stringifier;
function rrweb_snapshot_stringify$4(node2, builder) {
    let str = new rrweb_snapshot_Stringifier$1(builder);
    str.stringify(node2);
}
var rrweb_snapshot_stringify_1 = rrweb_snapshot_stringify$4;
rrweb_snapshot_stringify$4.default = rrweb_snapshot_stringify$4;
let { isClean: rrweb_snapshot_isClean$2, my: rrweb_snapshot_my$2 } = rrweb_snapshot_symbols;
let rrweb_snapshot_CssSyntaxError$2 = rrweb_snapshot_cssSyntaxError;
let Stringifier2 = rrweb_snapshot_stringifier;
let rrweb_snapshot_stringify$3 = rrweb_snapshot_stringify_1;
function rrweb_snapshot_cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) {
            continue;
        }
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") {
            cloned[i] = value;
        } else if (Array.isArray(value)) {
            cloned[i] = value.map((j)=>rrweb_snapshot_cloneNode(j, cloned));
        } else {
            if (type === "object" && value !== null) value = rrweb_snapshot_cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
let rrweb_snapshot_Node$4 = class Node {
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides){
            this[name] = overrides[name];
        }
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = rrweb_snapshot_cloneNode(this);
        for(let name in overrides){
            cloned[name] = overrides[name];
        }
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end, start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new rrweb_snapshot_CssSyntaxError$2(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    markDirty() {
        if (this[rrweb_snapshot_isClean$2]) {
            this[rrweb_snapshot_isClean$2] = false;
            let next = this;
            while(next = next.parent){
                next[rrweb_snapshot_isClean$2] = false;
            }
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) {
            pos = this.positionInside(opts.index, stringRepresentation);
        } else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index2; i++){
            if (string[i] === "\n") {
                column = 1;
                line += 1;
            } else {
                column += 1;
            }
        }
        return {
            column,
            line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) {
                start = {
                    column: opts.start.column,
                    line: opts.start.line
                };
            } else if (opts.index) {
                start = this.positionInside(opts.index);
            }
            if (opts.end) {
                end = {
                    column: opts.end.column,
                    line: opts.end.line
                };
            } else if (typeof opts.endIndex === "number") {
                end = this.positionInside(opts.endIndex);
            } else if (opts.index) {
                end = this.positionInside(opts.index + 1);
            }
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) {
            end = {
                column: start.column + 1,
                line: start.line
            };
        }
        return {
            end,
            start
        };
    }
    raw(prop, defaultType) {
        let str = new Stringifier2();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) {
                    foundSelf = true;
                } else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else {
                    this.parent.insertBefore(bookmark, node2);
                }
            }
            if (!foundSelf) {
                this.remove();
            }
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document"){
            result2 = result2.parent;
        }
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) {
                continue;
            }
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) {
                fixed[name] = value.map((i)=>{
                    if (typeof i === "object" && i.toJSON) {
                        return i.toJSON(null, inputs);
                    } else {
                        return i;
                    }
                });
            } else if (typeof value === "object" && value.toJSON) {
                fixed[name] = value.toJSON(null, inputs);
            } else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId,
                    start: value.start
                };
            } else {
                fixed[name] = value;
            }
        }
        if (emitInputs) {
            fixed.inputs = [
                ...inputs.keys()
            ].map((input2)=>input2.toJSON());
        }
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) {
            this.proxyCache = new Proxy(this, this.getProxyProcessor());
        }
        return this.proxyCache;
    }
    toString(stringifier2 = rrweb_snapshot_stringify$3) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i)=>{
            result2 += i;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
    constructor(defaults = {}){
        this.raws = {};
        this[rrweb_snapshot_isClean$2] = false;
        this[rrweb_snapshot_my$2] = true;
        for(let name in defaults){
            if (name === "nodes") {
                this.nodes = [];
                for (let node2 of defaults[name]){
                    if (typeof node2.clone === "function") {
                        this.append(node2.clone());
                    } else {
                        this.append(node2);
                    }
                }
            } else {
                this[name] = defaults[name];
            }
        }
    }
};
var rrweb_snapshot_node = rrweb_snapshot_Node$4;
rrweb_snapshot_Node$4.default = rrweb_snapshot_Node$4;
let rrweb_snapshot_Node$3 = rrweb_snapshot_node;
let rrweb_snapshot_Declaration$4 = class Declaration extends rrweb_snapshot_Node$3 {
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
            defaults = rrweb_snapshot_extends({}, defaults, {
                value: String(defaults.value)
            });
        }
        super(defaults);
        this.type = "decl";
    }
};
var rrweb_snapshot_declaration = rrweb_snapshot_Declaration$4;
rrweb_snapshot_Declaration$4.default = rrweb_snapshot_Declaration$4;
let rrweb_snapshot_urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let rrweb_snapshot_customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--){
            id += alphabet[Math.random() * alphabet.length | 0];
        }
        return id;
    };
};
let rrweb_snapshot_nanoid$1 = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--){
        id += rrweb_snapshot_urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
var rrweb_snapshot_nonSecure = {
    nanoid: rrweb_snapshot_nanoid$1,
    customAlphabet: rrweb_snapshot_customAlphabet
};
let { SourceMapConsumer: rrweb_snapshot_SourceMapConsumer$2, SourceMapGenerator: rrweb_snapshot_SourceMapGenerator$2 } = rrweb_snapshot_require$$2;
let { existsSync: rrweb_snapshot_existsSync, readFileSync: rrweb_snapshot_readFileSync } = rrweb_snapshot_require$$2;
let { dirname: rrweb_snapshot_dirname$1, join: rrweb_snapshot_join } = rrweb_snapshot_require$$2;
function rrweb_snapshot_fromBase64(str) {
    if (Buffer) {
        return Buffer.from(str, "base64").toString();
    } else {
        return window.atob(str);
    }
}
let rrweb_snapshot_PreviousMap$2 = class PreviousMap {
    consumer() {
        if (!this.consumerCache) {
            this.consumerCache = new rrweb_snapshot_SourceMapConsumer$2(this.text);
        }
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) {
            return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        }
        if (baseCharsetUri.test(text) || baseUri.test(text)) {
            return rrweb_snapshot_fromBase64(text.substr(RegExp.lastMatch.length));
        }
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) {
            this.annotation = this.getAnnotationURL(css.substring(start, end));
        }
    }
    loadFile(path) {
        this.root = rrweb_snapshot_dirname$1(path);
        if (rrweb_snapshot_existsSync(path)) {
            this.mapFile = path;
            return rrweb_snapshot_readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") {
                return prev;
            } else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) {
                        throw new Error("Unable to load previous source map: " + prevPath.toString());
                    }
                    return map;
                }
            } else if (prev instanceof rrweb_snapshot_SourceMapConsumer$2) {
                return rrweb_snapshot_SourceMapGenerator$2.fromSourceMap(prev).toString();
            } else if (prev instanceof rrweb_snapshot_SourceMapGenerator$2) {
                return prev.toString();
            } else if (this.isMap(prev)) {
                return JSON.stringify(prev);
            } else {
                throw new Error("Unsupported previous source map format: " + prev.toString());
            }
        } else if (this.inline) {
            return this.decodeInline(this.annotation);
        } else if (this.annotation) {
            let map = this.annotation;
            if (file) map = rrweb_snapshot_join(rrweb_snapshot_dirname$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) {
            this.mapFile = opts.from;
        }
        if (this.mapFile) this.root = rrweb_snapshot_dirname$1(this.mapFile);
        if (text) this.text = text;
    }
};
var rrweb_snapshot_previousMap = rrweb_snapshot_PreviousMap$2;
rrweb_snapshot_PreviousMap$2.default = rrweb_snapshot_PreviousMap$2;
let { SourceMapConsumer: rrweb_snapshot_SourceMapConsumer$1, SourceMapGenerator: rrweb_snapshot_SourceMapGenerator$1 } = rrweb_snapshot_require$$2;
let { fileURLToPath: rrweb_snapshot_fileURLToPath, pathToFileURL: rrweb_snapshot_pathToFileURL$1 } = rrweb_snapshot_require$$2;
let { isAbsolute: rrweb_snapshot_isAbsolute, resolve: rrweb_snapshot_resolve$1 } = rrweb_snapshot_require$$2;
let { nanoid: rrweb_snapshot_nanoid } = rrweb_snapshot_nonSecure;
let rrweb_snapshot_terminalHighlight = rrweb_snapshot_require$$2;
let rrweb_snapshot_CssSyntaxError$1 = rrweb_snapshot_cssSyntaxError;
let rrweb_snapshot_PreviousMap$1 = rrweb_snapshot_previousMap;
let rrweb_snapshot_fromOffsetCache = Symbol("fromOffsetCache");
let rrweb_snapshot_sourceMapAvailable$1 = Boolean(rrweb_snapshot_SourceMapConsumer$1 && rrweb_snapshot_SourceMapGenerator$1);
let rrweb_snapshot_pathAvailable$1 = Boolean(rrweb_snapshot_resolve$1 && rrweb_snapshot_isAbsolute);
let rrweb_snapshot_Input$4 = class Input {
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) {
            result2 = new rrweb_snapshot_CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
                column: origin.column,
                line: origin.line
            }, origin.endLine === void 0 ? origin.column : {
                column: origin.endColumn,
                line: origin.endLine
            }, origin.source, origin.file, opts.plugin);
        } else {
            result2 = new rrweb_snapshot_CssSyntaxError$1(message, endLine === void 0 ? line : {
                column,
                line
            }, endLine === void 0 ? column : {
                column: endColumn,
                line: endLine
            }, this.css, this.file, opts.plugin);
        }
        result2.input = {
            column,
            endColumn,
            endLine,
            line,
            source: this.css
        };
        if (this.file) {
            if (rrweb_snapshot_pathToFileURL$1) {
                result2.input.url = rrweb_snapshot_pathToFileURL$1(this.file).toString();
            }
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[rrweb_snapshot_fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[rrweb_snapshot_fromOffsetCache] = lineToIndex;
        } else {
            lineToIndex = this[rrweb_snapshot_fromOffsetCache];
        }
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) {
            min = lineToIndex.length - 1;
        } else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) {
                    max = mid - 1;
                } else if (offset >= lineToIndex[mid + 1]) {
                    min = mid + 1;
                } else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) {
            return file;
        }
        return rrweb_snapshot_resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column,
            line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") {
            to = consumer.originalPositionFor({
                column: endColumn,
                line: endLine
            });
        }
        let fromUrl;
        if (rrweb_snapshot_isAbsolute(from.source)) {
            fromUrl = rrweb_snapshot_pathToFileURL$1(from.source);
        } else {
            fromUrl = new URL(from.source, this.map.consumer().sourceRoot || rrweb_snapshot_pathToFileURL$1(this.map.mapFile));
        }
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if (rrweb_snapshot_fileURLToPath) {
                result2.file = rrweb_snapshot_fileURLToPath(fromUrl);
            } else {
                throw new Error(`file: protocol is not available in this PostCSS build`);
            }
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ]){
            if (this[name] != null) {
                json[name] = this[name];
            }
        }
        if (this.map) {
            json.map = rrweb_snapshot_extends({}, this.map);
            if (json.map.consumerCache) {
                json.map.consumerCache = void 0;
            }
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
            throw new Error(`PostCSS received ${css} instead of CSS string`);
        }
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else {
            this.hasBOM = false;
        }
        if (opts.from) {
            if (!rrweb_snapshot_pathAvailable$1 || /^\w+:\/\//.test(opts.from) || rrweb_snapshot_isAbsolute(opts.from)) {
                this.file = opts.from;
            } else {
                this.file = rrweb_snapshot_resolve$1(opts.from);
            }
        }
        if (rrweb_snapshot_pathAvailable$1 && rrweb_snapshot_sourceMapAvailable$1) {
            let map = new rrweb_snapshot_PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) {
            this.id = "<input css " + rrweb_snapshot_nanoid(6) + ">";
        }
        if (this.map) this.map.file = this.from;
    }
};
var rrweb_snapshot_input = rrweb_snapshot_Input$4;
rrweb_snapshot_Input$4.default = rrweb_snapshot_Input$4;
if (rrweb_snapshot_terminalHighlight && rrweb_snapshot_terminalHighlight.registerInput) {
    rrweb_snapshot_terminalHighlight.registerInput(rrweb_snapshot_Input$4);
}
let { SourceMapConsumer: rrweb_snapshot_SourceMapConsumer, SourceMapGenerator: rrweb_snapshot_SourceMapGenerator } = rrweb_snapshot_require$$2;
let { dirname: rrweb_snapshot_dirname, relative: rrweb_snapshot_relative, resolve: rrweb_snapshot_resolve, sep: rrweb_snapshot_sep } = rrweb_snapshot_require$$2;
let { pathToFileURL: rrweb_snapshot_pathToFileURL } = rrweb_snapshot_require$$2;
let rrweb_snapshot_Input$3 = rrweb_snapshot_input;
let rrweb_snapshot_sourceMapAvailable = Boolean(rrweb_snapshot_SourceMapConsumer && rrweb_snapshot_SourceMapGenerator);
let rrweb_snapshot_pathAvailable = Boolean(rrweb_snapshot_dirname && rrweb_snapshot_resolve && rrweb_snapshot_relative && rrweb_snapshot_sep);
let rrweb_snapshot_MapGenerator$2 = class MapGenerator {
    addAnnotation() {
        let content;
        if (this.isInline()) {
            content = "data:application/json;base64," + this.toBase64(this.map.toString());
        } else if (typeof this.mapOpts.annotation === "string") {
            content = this.mapOpts.annotation;
        } else if (typeof this.mapOpts.annotation === "function") {
            content = this.mapOpts.annotation(this.opts.to, this.root);
        } else {
            content = this.outputFile() + ".map";
        }
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || rrweb_snapshot_dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new rrweb_snapshot_SourceMapConsumer(prev.text);
                if (map.sourcesContent) {
                    map.sourcesContent = null;
                }
            } else {
                map = prev.consumer();
            }
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node2 = this.root.nodes[i];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) {
                    this.root.removeChild(i);
                }
            }
        } else if (this.css) {
            this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
        }
    }
    generate() {
        this.clearAnnotation();
        if (rrweb_snapshot_pathAvailable && rrweb_snapshot_sourceMapAvailable && this.isMap()) {
            return this.generateMap();
        } else {
            let result2 = "";
            this.stringify(this.root, (i)=>{
                result2 += i;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) {
            this.generateString();
        } else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = rrweb_snapshot_SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new rrweb_snapshot_SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) {
            return [
                this.css
            ];
        } else {
            return [
                this.css,
                this.map
            ];
        }
    }
    generateString() {
        this.css = "";
        this.map = new rrweb_snapshot_SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else {
                column += str.length;
            }
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) {
            return true;
        }
        if (typeof this.mapOpts.annotation !== "undefined") {
            return this.mapOpts.annotation;
        }
        if (this.previous().length) {
            return this.previous().some((i)=>i.annotation);
        }
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") {
            return this.mapOpts.inline;
        }
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) {
            return false;
        }
        if (this.previous().length) {
            return this.previous().some((i)=>i.inline);
        }
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") {
            return !!this.opts.map;
        }
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") {
            return this.mapOpts.sourcesContent;
        }
        if (this.previous().length) {
            return this.previous().some((i)=>i.withContent());
        }
        return true;
    }
    outputFile() {
        if (this.opts.to) {
            return this.path(this.opts.to);
        } else if (this.opts.from) {
            return this.path(this.opts.from);
        } else {
            return "to.css";
        }
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? rrweb_snapshot_dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") {
            from = rrweb_snapshot_dirname(rrweb_snapshot_resolve(from, this.mapOpts.annotation));
        }
        let path = rrweb_snapshot_relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) {
                this.root.walk((node2)=>{
                    if (node2.source && node2.source.input.map) {
                        let map = node2.source.input.map;
                        if (!this.previousMaps.includes(map)) {
                            this.previousMaps.push(map);
                        }
                    }
                });
            } else {
                let input2 = new rrweb_snapshot_Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) {
            this.root.walk((node2)=>{
                if (node2.source) {
                    let from = node2.source.input.from;
                    if (from && !already[from]) {
                        already[from] = true;
                        let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                        this.map.setSourceContent(fromUrl, node2.source.input.css);
                    }
                }
            });
        } else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) {
            return this.toUrl(this.mapOpts.from);
        } else if (this.usesFileUrls) {
            return this.toFileUrl(node2.source.input.from);
        } else {
            return this.toUrl(this.path(node2.source.input.from));
        }
    }
    toBase64(str) {
        if (Buffer) {
            return Buffer.from(str).toString("base64");
        } else {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if (rrweb_snapshot_pathToFileURL) {
            let fileURL = rrweb_snapshot_pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else {
            throw new Error("`map.absolute` option is not available in this PostCSS build");
        }
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if (rrweb_snapshot_sep === "\\") {
            path = path.replace(/\\/g, "/");
        }
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
};
var rrweb_snapshot_mapGenerator = rrweb_snapshot_MapGenerator$2;
let rrweb_snapshot_Node$2 = rrweb_snapshot_node;
let rrweb_snapshot_Comment$4 = class Comment extends rrweb_snapshot_Node$2 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var rrweb_snapshot_comment = rrweb_snapshot_Comment$4;
rrweb_snapshot_Comment$4.default = rrweb_snapshot_Comment$4;
let { isClean: rrweb_snapshot_isClean$1, my: rrweb_snapshot_my$1 } = rrweb_snapshot_symbols;
let rrweb_snapshot_Declaration$3 = rrweb_snapshot_declaration;
let rrweb_snapshot_Comment$3 = rrweb_snapshot_comment;
let rrweb_snapshot_Node$1 = rrweb_snapshot_node;
let rrweb_snapshot_parse$4, rrweb_snapshot_Rule$4, rrweb_snapshot_AtRule$4, rrweb_snapshot_Root$6;
function rrweb_snapshot_cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = rrweb_snapshot_cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function rrweb_snapshot_markDirtyUp(node2) {
    node2[rrweb_snapshot_isClean$1] = false;
    if (node2.proxyOf.nodes) {
        for (let i of node2.proxyOf.nodes){
            rrweb_snapshot_markDirtyUp(i);
        }
    }
}
let rrweb_snapshot_Container$7 = class Container extends rrweb_snapshot_Node$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) {
            for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
        }
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") {
                    return node2;
                } else if (!node2[prop]) {
                    return node2[prop];
                } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
                    return (...args)=>{
                        return node2[prop](...args.map((i)=>{
                            if (typeof i === "function") {
                                return (child, index2)=>i(child.toProxy(), index2);
                            } else {
                                return i;
                            }
                        }));
                    };
                } else if (prop === "every" || prop === "some") {
                    return (cb)=>{
                        return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                    };
                } else if (prop === "root") {
                    return ()=>node2.root().toProxy();
                } else if (prop === "nodes") {
                    return node2.nodes.map((i)=>i.toProxy());
                } else if (prop === "first" || prop === "last") {
                    return node2[prop].toProxy();
                } else {
                    return node2[prop];
                }
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") {
                    node2.markDirty();
                }
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) {
                this.indexes[id] = index2 + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") {
            nodes = rrweb_snapshot_cleanSource(rrweb_snapshot_parse$4(nodes).nodes);
        } else if (typeof nodes === "undefined") {
            nodes = [];
        } else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes){
                if (i.parent) i.parent.removeChild(i, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes){
                if (i.parent) i.parent.removeChild(i, "ignore");
            }
        } else if (nodes.type) {
            nodes = [
                nodes
            ];
        } else if (nodes.prop) {
            if (typeof nodes.value === "undefined") {
                throw new Error("Value field is missed in node creation");
            } else if (typeof nodes.value !== "string") {
                nodes.value = String(nodes.value);
            }
            nodes = [
                new rrweb_snapshot_Declaration$3(nodes)
            ];
        } else if (nodes.selector) {
            nodes = [
                new rrweb_snapshot_Rule$4(nodes)
            ];
        } else if (nodes.name) {
            nodes = [
                new rrweb_snapshot_AtRule$4(nodes)
            ];
        } else if (nodes.text) {
            nodes = [
                new rrweb_snapshot_Comment$3(nodes)
            ];
        } else {
            throw new Error("Unknown node type in node creation");
        }
        let processed = nodes.map((i)=>{
            if (!i[rrweb_snapshot_my$1]) Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[rrweb_snapshot_isClean$1]) rrweb_snapshot_markDirtyUp(i);
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") {
                    i.raws.before = sample.raws.before.replace(/\S/g, "");
                }
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes){
                this.indexes[id] = this.indexes[id] + nodes.length;
            }
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) {
                this.indexes[id] = index2 - 1;
            }
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result2;
            try {
                result2 = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result2 !== false && child.walk) {
                result2 = child.walk(callback);
            }
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") {
                    return callback(child, i);
                }
            });
        }
        if (name instanceof RegExp) {
            return this.walk((child, i)=>{
                if (child.type === "atrule" && name.test(child.name)) {
                    return callback(child, i);
                }
            });
        }
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) {
                return callback(child, i);
            }
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") {
                return callback(child, i);
            }
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") {
                    return callback(child, i);
                }
            });
        }
        if (prop instanceof RegExp) {
            return this.walk((child, i)=>{
                if (child.type === "decl" && prop.test(child.prop)) {
                    return callback(child, i);
                }
            });
        }
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) {
                return callback(child, i);
            }
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") {
                    return callback(child, i);
                }
            });
        }
        if (selector instanceof RegExp) {
            return this.walk((child, i)=>{
                if (child.type === "rule" && selector.test(child.selector)) {
                    return callback(child, i);
                }
            });
        }
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) {
                return callback(child, i);
            }
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
rrweb_snapshot_Container$7.registerParse = (dependant)=>{
    rrweb_snapshot_parse$4 = dependant;
};
rrweb_snapshot_Container$7.registerRule = (dependant)=>{
    rrweb_snapshot_Rule$4 = dependant;
};
rrweb_snapshot_Container$7.registerAtRule = (dependant)=>{
    rrweb_snapshot_AtRule$4 = dependant;
};
rrweb_snapshot_Container$7.registerRoot = (dependant)=>{
    rrweb_snapshot_Root$6 = dependant;
};
var rrweb_snapshot_container = rrweb_snapshot_Container$7;
rrweb_snapshot_Container$7.default = rrweb_snapshot_Container$7;
rrweb_snapshot_Container$7.rebuild = (node2)=>{
    if (node2.type === "atrule") {
        Object.setPrototypeOf(node2, rrweb_snapshot_AtRule$4.prototype);
    } else if (node2.type === "rule") {
        Object.setPrototypeOf(node2, rrweb_snapshot_Rule$4.prototype);
    } else if (node2.type === "decl") {
        Object.setPrototypeOf(node2, rrweb_snapshot_Declaration$3.prototype);
    } else if (node2.type === "comment") {
        Object.setPrototypeOf(node2, rrweb_snapshot_Comment$3.prototype);
    } else if (node2.type === "root") {
        Object.setPrototypeOf(node2, rrweb_snapshot_Root$6.prototype);
    }
    node2[rrweb_snapshot_my$1] = true;
    if (node2.nodes) {
        node2.nodes.forEach((child)=>{
            rrweb_snapshot_Container$7.rebuild(child);
        });
    }
};
let rrweb_snapshot_Container$6 = rrweb_snapshot_container;
let rrweb_snapshot_LazyResult$4, rrweb_snapshot_Processor$3;
let rrweb_snapshot_Document$3 = class Document extends rrweb_snapshot_Container$6 {
    toResult(opts = {}) {
        let lazy = new rrweb_snapshot_LazyResult$4(new rrweb_snapshot_Processor$3(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(rrweb_snapshot_extends({
            type: "document"
        }, defaults));
        if (!this.nodes) {
            this.nodes = [];
        }
    }
};
rrweb_snapshot_Document$3.registerLazyResult = (dependant)=>{
    rrweb_snapshot_LazyResult$4 = dependant;
};
rrweb_snapshot_Document$3.registerProcessor = (dependant)=>{
    rrweb_snapshot_Processor$3 = dependant;
};
var rrweb_snapshot_document$1 = rrweb_snapshot_Document$3;
rrweb_snapshot_Document$3.default = rrweb_snapshot_Document$3;
let rrweb_snapshot_printed = {};
var rrweb_snapshot_warnOnce$2 = function warnOnce(message) {
    if (rrweb_snapshot_printed[message]) return;
    rrweb_snapshot_printed[message] = true;
    if (typeof console !== "undefined" && console.warn) {
        console.warn(message);
    }
};
let rrweb_snapshot_Warning$2 = class Warning {
    toString() {
        if (this.node) {
            return this.node.error(this.text, {
                index: this.index,
                plugin: this.plugin,
                word: this.word
            }).message;
        }
        if (this.plugin) {
            return this.plugin + ": " + this.text;
        }
        return this.text;
    }
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
};
var rrweb_snapshot_warning = rrweb_snapshot_Warning$2;
rrweb_snapshot_Warning$2.default = rrweb_snapshot_Warning$2;
let rrweb_snapshot_Warning$1 = rrweb_snapshot_warning;
let rrweb_snapshot_Result$3 = class Result {
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
                opts.plugin = this.lastPlugin.postcssPlugin;
            }
        }
        let warning2 = new rrweb_snapshot_Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
    get content() {
        return this.css;
    }
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
};
var rrweb_snapshot_result = rrweb_snapshot_Result$3;
rrweb_snapshot_Result$3.default = rrweb_snapshot_Result$3;
const rrweb_snapshot_SINGLE_QUOTE = "'".charCodeAt(0);
const rrweb_snapshot_DOUBLE_QUOTE = '"'.charCodeAt(0);
const rrweb_snapshot_BACKSLASH = "\\".charCodeAt(0);
const rrweb_snapshot_SLASH = "/".charCodeAt(0);
const rrweb_snapshot_NEWLINE = "\n".charCodeAt(0);
const rrweb_snapshot_SPACE = " ".charCodeAt(0);
const rrweb_snapshot_FEED = "\f".charCodeAt(0);
const rrweb_snapshot_TAB = "	".charCodeAt(0);
const rrweb_snapshot_CR = "\r".charCodeAt(0);
const rrweb_snapshot_OPEN_SQUARE = "[".charCodeAt(0);
const rrweb_snapshot_CLOSE_SQUARE = "]".charCodeAt(0);
const rrweb_snapshot_OPEN_PARENTHESES = "(".charCodeAt(0);
const rrweb_snapshot_CLOSE_PARENTHESES = ")".charCodeAt(0);
const rrweb_snapshot_OPEN_CURLY = "{".charCodeAt(0);
const rrweb_snapshot_CLOSE_CURLY = "}".charCodeAt(0);
const rrweb_snapshot_SEMICOLON = ";".charCodeAt(0);
const rrweb_snapshot_ASTERISK = "*".charCodeAt(0);
const rrweb_snapshot_COLON = ":".charCodeAt(0);
const rrweb_snapshot_AT = "@".charCodeAt(0);
const rrweb_snapshot_RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const rrweb_snapshot_RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const rrweb_snapshot_RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const rrweb_snapshot_RE_HEX_ESCAPE = /[\da-f]/i;
var rrweb_snapshot_tokenize = function tokenizer(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case rrweb_snapshot_NEWLINE:
            case rrweb_snapshot_SPACE:
            case rrweb_snapshot_TAB:
            case rrweb_snapshot_CR:
            case rrweb_snapshot_FEED:
                {
                    next = pos;
                    do {
                        next += 1;
                        code = css.charCodeAt(next);
                    }while (code === rrweb_snapshot_SPACE || code === rrweb_snapshot_NEWLINE || code === rrweb_snapshot_TAB || code === rrweb_snapshot_CR || code === rrweb_snapshot_FEED)
                    currentToken = [
                        "space",
                        css.slice(pos, next)
                    ];
                    pos = next - 1;
                    break;
                }
            case rrweb_snapshot_OPEN_SQUARE:
            case rrweb_snapshot_CLOSE_SQUARE:
            case rrweb_snapshot_OPEN_CURLY:
            case rrweb_snapshot_CLOSE_CURLY:
            case rrweb_snapshot_COLON:
            case rrweb_snapshot_SEMICOLON:
            case rrweb_snapshot_CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case rrweb_snapshot_OPEN_PARENTHESES:
                {
                    prev = buffer.length ? buffer.pop()[1] : "";
                    n = css.charCodeAt(pos + 1);
                    if (prev === "url" && n !== rrweb_snapshot_SINGLE_QUOTE && n !== rrweb_snapshot_DOUBLE_QUOTE && n !== rrweb_snapshot_SPACE && n !== rrweb_snapshot_NEWLINE && n !== rrweb_snapshot_TAB && n !== rrweb_snapshot_FEED && n !== rrweb_snapshot_CR) {
                        next = pos;
                        do {
                            escaped = false;
                            next = css.indexOf(")", next + 1);
                            if (next === -1) {
                                if (ignore || ignoreUnclosed) {
                                    next = pos;
                                    break;
                                } else {
                                    unclosed("bracket");
                                }
                            }
                            escapePos = next;
                            while(css.charCodeAt(escapePos - 1) === rrweb_snapshot_BACKSLASH){
                                escapePos -= 1;
                                escaped = !escaped;
                            }
                        }while (escaped)
                        currentToken = [
                            "brackets",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        next = css.indexOf(")", pos + 1);
                        content = css.slice(pos, next + 1);
                        if (next === -1 || rrweb_snapshot_RE_BAD_BRACKET.test(content)) {
                            currentToken = [
                                "(",
                                "(",
                                pos
                            ];
                        } else {
                            currentToken = [
                                "brackets",
                                content,
                                pos,
                                next
                            ];
                            pos = next;
                        }
                    }
                    break;
                }
            case rrweb_snapshot_SINGLE_QUOTE:
            case rrweb_snapshot_DOUBLE_QUOTE:
                {
                    quote = code === rrweb_snapshot_SINGLE_QUOTE ? "'" : '"';
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(quote, next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos + 1;
                                break;
                            } else {
                                unclosed("string");
                            }
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === rrweb_snapshot_BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped)
                    currentToken = [
                        "string",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case rrweb_snapshot_AT:
                {
                    rrweb_snapshot_RE_AT_END.lastIndex = pos + 1;
                    rrweb_snapshot_RE_AT_END.test(css);
                    if (rrweb_snapshot_RE_AT_END.lastIndex === 0) {
                        next = css.length - 1;
                    } else {
                        next = rrweb_snapshot_RE_AT_END.lastIndex - 2;
                    }
                    currentToken = [
                        "at-word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            case rrweb_snapshot_BACKSLASH:
                {
                    next = pos;
                    escape = true;
                    while(css.charCodeAt(next + 1) === rrweb_snapshot_BACKSLASH){
                        next += 1;
                        escape = !escape;
                    }
                    code = css.charCodeAt(next + 1);
                    if (escape && code !== rrweb_snapshot_SLASH && code !== rrweb_snapshot_SPACE && code !== rrweb_snapshot_NEWLINE && code !== rrweb_snapshot_TAB && code !== rrweb_snapshot_CR && code !== rrweb_snapshot_FEED) {
                        next += 1;
                        if (rrweb_snapshot_RE_HEX_ESCAPE.test(css.charAt(next))) {
                            while(rrweb_snapshot_RE_HEX_ESCAPE.test(css.charAt(next + 1))){
                                next += 1;
                            }
                            if (css.charCodeAt(next + 1) === rrweb_snapshot_SPACE) {
                                next += 1;
                            }
                        }
                    }
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                    break;
                }
            default:
                {
                    if (code === rrweb_snapshot_SLASH && css.charCodeAt(pos + 1) === rrweb_snapshot_ASTERISK) {
                        next = css.indexOf("*/", pos + 2) + 1;
                        if (next === 0) {
                            if (ignore || ignoreUnclosed) {
                                next = css.length;
                            } else {
                                unclosed("comment");
                            }
                        }
                        currentToken = [
                            "comment",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        pos = next;
                    } else {
                        rrweb_snapshot_RE_WORD_END.lastIndex = pos + 1;
                        rrweb_snapshot_RE_WORD_END.test(css);
                        if (rrweb_snapshot_RE_WORD_END.lastIndex === 0) {
                            next = css.length - 1;
                        } else {
                            next = rrweb_snapshot_RE_WORD_END.lastIndex - 2;
                        }
                        currentToken = [
                            "word",
                            css.slice(pos, next + 1),
                            pos,
                            next
                        ];
                        buffer.push(currentToken);
                        pos = next;
                    }
                    break;
                }
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back,
        endOfFile,
        nextToken,
        position
    };
};
let rrweb_snapshot_Container$5 = rrweb_snapshot_container;
let rrweb_snapshot_AtRule$3 = class AtRule extends rrweb_snapshot_Container$5 {
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
};
var rrweb_snapshot_atRule = rrweb_snapshot_AtRule$3;
rrweb_snapshot_AtRule$3.default = rrweb_snapshot_AtRule$3;
rrweb_snapshot_Container$5.registerAtRule(rrweb_snapshot_AtRule$3);
let rrweb_snapshot_Container$4 = rrweb_snapshot_container;
let rrweb_snapshot_LazyResult$3, rrweb_snapshot_Processor$2;
let rrweb_snapshot_Root$5 = class Root extends rrweb_snapshot_Container$4 {
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) {
                    sample.raws.before = this.nodes[1].raws.before;
                } else {
                    delete sample.raws.before;
                }
            } else if (this.first !== sample) {
                for (let node2 of nodes){
                    node2.raws.before = sample.raws.before;
                }
            }
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) {
            this.nodes[1].raws.before = this.nodes[index2].raws.before;
        }
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new rrweb_snapshot_LazyResult$3(new rrweb_snapshot_Processor$2(), this, opts);
        return lazy.stringify();
    }
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
};
rrweb_snapshot_Root$5.registerLazyResult = (dependant)=>{
    rrweb_snapshot_LazyResult$3 = dependant;
};
rrweb_snapshot_Root$5.registerProcessor = (dependant)=>{
    rrweb_snapshot_Processor$2 = dependant;
};
var rrweb_snapshot_root = rrweb_snapshot_Root$5;
rrweb_snapshot_Root$5.default = rrweb_snapshot_Root$5;
rrweb_snapshot_Container$4.registerRoot(rrweb_snapshot_Root$5);
let rrweb_snapshot_list$2 = {
    comma (string) {
        return rrweb_snapshot_list$2.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return rrweb_snapshot_list$2.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) {
                escape = false;
            } else if (letter === "\\") {
                escape = true;
            } else if (inQuote) {
                if (letter === prevQuote) {
                    inQuote = false;
                }
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") {
                func += 1;
            } else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else {
                current += letter;
            }
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var rrweb_snapshot_list_1 = rrweb_snapshot_list$2;
rrweb_snapshot_list$2.default = rrweb_snapshot_list$2;
let rrweb_snapshot_Container$3 = rrweb_snapshot_container;
let rrweb_snapshot_list$1 = rrweb_snapshot_list_1;
let rrweb_snapshot_Rule$3 = class Rule extends rrweb_snapshot_Container$3 {
    get selectors() {
        return rrweb_snapshot_list$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
};
var rrweb_snapshot_rule = rrweb_snapshot_Rule$3;
rrweb_snapshot_Rule$3.default = rrweb_snapshot_Rule$3;
rrweb_snapshot_Container$3.registerRule(rrweb_snapshot_Rule$3);
let rrweb_snapshot_Declaration$2 = rrweb_snapshot_declaration;
let tokenizer2 = rrweb_snapshot_tokenize;
let rrweb_snapshot_Comment$2 = rrweb_snapshot_comment;
let rrweb_snapshot_AtRule$2 = rrweb_snapshot_atRule;
let rrweb_snapshot_Root$4 = rrweb_snapshot_root;
let rrweb_snapshot_Rule$2 = rrweb_snapshot_rule;
const rrweb_snapshot_SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function rrweb_snapshot_findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let rrweb_snapshot_Parser$1 = class Parser {
    atrule(token) {
        let node2 = new rrweb_snapshot_AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") {
            this.unnamedAtrule(node2, token);
        }
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") {
                brackets.push(type === "(" ? ")" : "]");
            } else if (type === "{" && brackets.length > 0) {
                brackets.push("}");
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
            }
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space"){
                            prev = params[--shift];
                        }
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else {
                    params.push(token);
                }
            } else {
                params.push(token);
            }
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") {
                brackets += 1;
            }
            if (type === ")") {
                brackets -= 1;
            }
            if (brackets === 0 && type === ":") {
                if (!prev) {
                    this.doubleColon(token);
                } else if (prev[0] === "word" && prev[1] === "progid") {
                    continue;
                } else {
                    return i;
                }
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new rrweb_snapshot_Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = tokenizer2(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new rrweb_snapshot_Declaration$2();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || rrweb_snapshot_findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") {
                break;
            }
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) {
                    this.unknownWord([
                        token
                    ]);
                }
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") {
                        break;
                    }
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") {
                break;
            }
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) {
            this.checkMissedSemicolon(tokens);
        }
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new rrweb_snapshot_Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else {
            this.unexpectedClose(token);
        }
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) {
            this.current.raws.semicolon = this.semicolon;
        }
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else {
                        break;
                    }
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") {
                    colon = true;
                }
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) {
                while(tokens.length){
                    token = tokens[tokens.length - 1][0];
                    if (token !== "space" && token !== "comment") break;
                    this.tokenizer.back(tokens.pop());
                }
            }
            this.decl(tokens, customProperty);
        } else {
            this.unknownWord(tokens);
        }
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) {
                clean = false;
            } else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!rrweb_snapshot_SAFE_COMMENT_NEIGHBOR[prev] && !rrweb_snapshot_SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") {
                        clean = false;
                    } else {
                        value += token[1];
                    }
                } else {
                    clean = false;
                }
            } else {
                value += token[1];
            }
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node2.raws[prop] = {
                raw,
                value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new rrweb_snapshot_Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i = from; i < tokens.length; i++){
            result2 += tokens[i][1];
        }
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    constructor(input2){
        this.input = input2;
        this.root = new rrweb_snapshot_Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
};
var rrweb_snapshot_parser = rrweb_snapshot_Parser$1;
let rrweb_snapshot_Container$2 = rrweb_snapshot_container;
let Parser2 = rrweb_snapshot_parser;
let rrweb_snapshot_Input$2 = rrweb_snapshot_input;
function rrweb_snapshot_parse$3(css, opts) {
    let input2 = new rrweb_snapshot_Input$2(css, opts);
    let parser2 = new Parser2(input2);
    try {
        parser2.parse();
    } catch (e) {
        if (false) {}
        throw e;
    }
    return parser2.root;
}
var rrweb_snapshot_parse_1 = rrweb_snapshot_parse$3;
rrweb_snapshot_parse$3.default = rrweb_snapshot_parse$3;
rrweb_snapshot_Container$2.registerParse(rrweb_snapshot_parse$3);
let { isClean: rrweb_snapshot_isClean, my: rrweb_snapshot_my } = rrweb_snapshot_symbols;
let rrweb_snapshot_MapGenerator$1 = rrweb_snapshot_mapGenerator;
let rrweb_snapshot_stringify$2 = rrweb_snapshot_stringify_1;
let rrweb_snapshot_Container$1 = rrweb_snapshot_container;
let rrweb_snapshot_Document$2 = rrweb_snapshot_document$1;
let rrweb_snapshot_warnOnce$1 = (/* unused pure expression or super */ null && (rrweb_snapshot_warnOnce$2));
let rrweb_snapshot_Result$2 = rrweb_snapshot_result;
let rrweb_snapshot_parse$2 = rrweb_snapshot_parse_1;
let rrweb_snapshot_Root$3 = rrweb_snapshot_root;
const rrweb_snapshot_TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const rrweb_snapshot_PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const rrweb_snapshot_NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const rrweb_snapshot_CHILDREN = 0;
function rrweb_snapshot_isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function rrweb_snapshot_getEvents(node2) {
    let key = false;
    let type = rrweb_snapshot_TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") {
        key = node2.prop.toLowerCase();
    } else if (node2.type === "atrule") {
        key = node2.name.toLowerCase();
    }
    if (key && node2.append) {
        return [
            type,
            type + "-" + key,
            rrweb_snapshot_CHILDREN,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (key) {
        return [
            type,
            type + "-" + key,
            type + "Exit",
            type + "Exit-" + key
        ];
    } else if (node2.append) {
        return [
            type,
            rrweb_snapshot_CHILDREN,
            type + "Exit"
        ];
    } else {
        return [
            type,
            type + "Exit"
        ];
    }
}
function rrweb_snapshot_toStack(node2) {
    let events;
    if (node2.type === "document") {
        events = [
            "Document",
            rrweb_snapshot_CHILDREN,
            "DocumentExit"
        ];
    } else if (node2.type === "root") {
        events = [
            "Root",
            rrweb_snapshot_CHILDREN,
            "RootExit"
        ];
    } else {
        events = rrweb_snapshot_getEvents(node2);
    }
    return {
        eventIndex: 0,
        events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function rrweb_snapshot_cleanMarks(node2) {
    node2[rrweb_snapshot_isClean] = false;
    if (node2.nodes) node2.nodes.forEach((i)=>rrweb_snapshot_cleanMarks(i));
    return node2;
}
let rrweb_snapshot_postcss$2 = {};
let rrweb_snapshot_LazyResult$2 = class LazyResult {
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) {
            this.processing = this.runAsync();
        }
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin2 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin2.postcssPlugin;
                error.setMessage();
            } else if (plugin2.postcssVersion) {
                if (false) {}
            }
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin2, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin2,
                cb
            ]);
        };
        for (let plugin2 of this.plugins){
            if (typeof plugin2 === "object") {
                for(let event in plugin2){
                    if (!rrweb_snapshot_PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
                        throw new Error(`Unknown event ${event} in ${plugin2.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                    }
                    if (!rrweb_snapshot_NOT_VISITORS[event]) {
                        if (typeof plugin2[event] === "object") {
                            for(let filter in plugin2[event]){
                                if (filter === "*") {
                                    add(plugin2, event, plugin2[event][filter]);
                                } else {
                                    add(plugin2, event + "-" + filter.toLowerCase(), plugin2[event][filter]);
                                }
                            }
                        } else if (typeof plugin2[event] === "function") {
                            add(plugin2, event, plugin2[event]);
                        }
                    }
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    runAsync() {
        var _this = this;
        return rrweb_snapshot_async_to_generator(function*() {
            _this.plugin = 0;
            for(let i = 0; i < _this.plugins.length; i++){
                let plugin2 = _this.plugins[i];
                let promise = _this.runOnRoot(plugin2);
                if (rrweb_snapshot_isPromise(promise)) {
                    try {
                        yield promise;
                    } catch (error) {
                        throw _this.handleError(error);
                    }
                }
            }
            _this.prepareVisitors();
            if (_this.hasListener) {
                let root2 = _this.result.root;
                while(!root2[rrweb_snapshot_isClean]){
                    root2[rrweb_snapshot_isClean] = true;
                    let stack = [
                        rrweb_snapshot_toStack(root2)
                    ];
                    while(stack.length > 0){
                        let promise = _this.visitTick(stack);
                        if (rrweb_snapshot_isPromise(promise)) {
                            try {
                                yield promise;
                            } catch (e) {
                                let node2 = stack[stack.length - 1].node;
                                throw _this.handleError(e, node2);
                            }
                        }
                    }
                }
                if (_this.listeners.OnceExit) {
                    for (let [plugin2, visitor] of _this.listeners.OnceExit){
                        _this.result.lastPlugin = plugin2;
                        try {
                            if (root2.type === "document") {
                                let roots = root2.nodes.map((subRoot)=>visitor(subRoot, _this.helpers));
                                yield Promise.all(roots);
                            } else {
                                yield visitor(root2, _this.helpers);
                            }
                        } catch (e) {
                            throw _this.handleError(e);
                        }
                    }
                }
            }
            _this.processed = true;
            return _this.stringify();
        })();
    }
    runOnRoot(plugin2) {
        this.result.lastPlugin = plugin2;
        try {
            if (typeof plugin2 === "object" && plugin2.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin2.Once(root2, this.helpers));
                    if (rrweb_snapshot_isPromise(roots[0])) {
                        return Promise.all(roots);
                    }
                    return roots;
                }
                return plugin2.Once(this.result.root, this.helpers);
            } else if (typeof plugin2 === "function") {
                return plugin2(this.result.root, this.result);
            }
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = rrweb_snapshot_stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new rrweb_snapshot_MapGenerator$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) {
            throw this.getAsyncError();
        }
        for (let plugin2 of this.plugins){
            let promise = this.runOnRoot(plugin2);
            if (rrweb_snapshot_isPromise(promise)) {
                throw this.getAsyncError();
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[rrweb_snapshot_isClean]){
                root2[rrweb_snapshot_isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") {
                    for (let subRoot of root2.nodes){
                        this.visitSync(this.listeners.OnceExit, subRoot);
                    }
                } else {
                    this.visitSync(this.listeners.OnceExit, root2);
                }
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin2, visitor] of visitors){
            this.result.lastPlugin = plugin2;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e) {
                throw this.handleError(e, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
                return true;
            }
            if (rrweb_snapshot_isPromise(promise)) {
                throw this.getAsyncError();
            }
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin2, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin2;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[rrweb_snapshot_isClean]) {
                    child[rrweb_snapshot_isClean] = true;
                    stack.push(rrweb_snapshot_toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === rrweb_snapshot_CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[rrweb_snapshot_isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[rrweb_snapshot_isClean] = true;
        let events = rrweb_snapshot_getEvents(node2);
        for (let event of events){
            if (event === rrweb_snapshot_CHILDREN) {
                if (node2.nodes) {
                    node2.each((child)=>{
                        if (!child[rrweb_snapshot_isClean]) this.walkSync(child);
                    });
                }
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
            root2 = rrweb_snapshot_cleanMarks(css);
        } else if (css instanceof LazyResult || css instanceof rrweb_snapshot_Result$2) {
            root2 = rrweb_snapshot_cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = rrweb_snapshot_parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[rrweb_snapshot_my]) {
                rrweb_snapshot_Container$1.rebuild(root2);
            }
        }
        this.result = new rrweb_snapshot_Result$2(processor2, root2, opts);
        this.helpers = rrweb_snapshot_extends({}, rrweb_snapshot_postcss$2, {
            postcss: rrweb_snapshot_postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map((plugin2)=>{
            if (typeof plugin2 === "object" && plugin2.prepare) {
                return rrweb_snapshot_extends({}, plugin2, plugin2.prepare(this.result));
            } else {
                return plugin2;
            }
        });
    }
};
rrweb_snapshot_LazyResult$2.registerPostcss = (dependant)=>{
    rrweb_snapshot_postcss$2 = dependant;
};
var rrweb_snapshot_lazyResult = rrweb_snapshot_LazyResult$2;
rrweb_snapshot_LazyResult$2.default = rrweb_snapshot_LazyResult$2;
rrweb_snapshot_Root$3.registerLazyResult(rrweb_snapshot_LazyResult$2);
rrweb_snapshot_Document$2.registerLazyResult(rrweb_snapshot_LazyResult$2);
let MapGenerator2 = rrweb_snapshot_mapGenerator;
let rrweb_snapshot_stringify$1 = rrweb_snapshot_stringify_1;
let warnOnce2 = (/* unused pure expression or super */ null && (rrweb_snapshot_warnOnce$2));
let rrweb_snapshot_parse$1 = rrweb_snapshot_parse_1;
const rrweb_snapshot_Result$1 = rrweb_snapshot_result;
let rrweb_snapshot_NoWorkResult$1 = class NoWorkResult {
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        if (false) {}
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) {
            return this._root;
        }
        let root2;
        let parser2 = rrweb_snapshot_parse$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) {
            throw this.error;
        } else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = rrweb_snapshot_stringify$1;
        this.result = new rrweb_snapshot_Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new MapGenerator2(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) {
                this.result.css = generatedCSS;
            }
            if (generatedMap) {
                this.result.map = generatedMap;
            }
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
};
var rrweb_snapshot_noWorkResult = rrweb_snapshot_NoWorkResult$1;
rrweb_snapshot_NoWorkResult$1.default = rrweb_snapshot_NoWorkResult$1;
let NoWorkResult2 = rrweb_snapshot_noWorkResult;
let rrweb_snapshot_LazyResult$1 = rrweb_snapshot_lazyResult;
let rrweb_snapshot_Document$1 = rrweb_snapshot_document$1;
let rrweb_snapshot_Root$2 = rrweb_snapshot_root;
let rrweb_snapshot_Processor$1 = class Processor {
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) {
                i = i();
            } else if (i.postcss) {
                i = i.postcss;
            }
            if (typeof i === "object" && Array.isArray(i.plugins)) {
                normalized = normalized.concat(i.plugins);
            } else if (typeof i === "object" && i.postcssPlugin) {
                normalized.push(i);
            } else if (typeof i === "function") {
                normalized.push(i);
            } else if (typeof i === "object" && (i.parse || i.stringify)) {
                if (false) {}
            } else {
                throw new Error(i + " is not a PostCSS plugin");
            }
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
            return new NoWorkResult2(this, css, opts);
        } else {
            return new rrweb_snapshot_LazyResult$1(this, css, opts);
        }
    }
    use(plugin2) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin2
        ]));
        return this;
    }
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
};
var rrweb_snapshot_processor = rrweb_snapshot_Processor$1;
rrweb_snapshot_Processor$1.default = rrweb_snapshot_Processor$1;
rrweb_snapshot_Root$2.registerProcessor(rrweb_snapshot_Processor$1);
rrweb_snapshot_Document$1.registerProcessor(rrweb_snapshot_Processor$1);
let rrweb_snapshot_Declaration$1 = rrweb_snapshot_declaration;
let PreviousMap2 = rrweb_snapshot_previousMap;
let rrweb_snapshot_Comment$1 = rrweb_snapshot_comment;
let rrweb_snapshot_AtRule$1 = rrweb_snapshot_atRule;
let rrweb_snapshot_Input$1 = rrweb_snapshot_input;
let rrweb_snapshot_Root$1 = rrweb_snapshot_root;
let rrweb_snapshot_Rule$1 = rrweb_snapshot_rule;
function rrweb_snapshot_fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>rrweb_snapshot_fromJSON$1(n));
    let { inputs: ownInputs } = json, defaults = rrweb_snapshot_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = rrweb_snapshot_extends({}, input2, {
                __proto__: rrweb_snapshot_Input$1.prototype
            });
            if (inputHydrated.map) {
                inputHydrated.map = rrweb_snapshot_extends({}, inputHydrated.map, {
                    __proto__: PreviousMap2.prototype
                });
            }
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) {
        defaults.nodes = json.nodes.map((n)=>rrweb_snapshot_fromJSON$1(n, inputs));
    }
    if (defaults.source) {
        let _defaults_source = defaults.source, { inputId } = _defaults_source, source = rrweb_snapshot_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) {
            defaults.source.input = inputs[inputId];
        }
    }
    if (defaults.type === "root") {
        return new rrweb_snapshot_Root$1(defaults);
    } else if (defaults.type === "decl") {
        return new rrweb_snapshot_Declaration$1(defaults);
    } else if (defaults.type === "rule") {
        return new rrweb_snapshot_Rule$1(defaults);
    } else if (defaults.type === "comment") {
        return new rrweb_snapshot_Comment$1(defaults);
    } else if (defaults.type === "atrule") {
        return new rrweb_snapshot_AtRule$1(defaults);
    } else {
        throw new Error("Unknown node type: " + json.type);
    }
}
var rrweb_snapshot_fromJSON_1 = rrweb_snapshot_fromJSON$1;
rrweb_snapshot_fromJSON$1.default = rrweb_snapshot_fromJSON$1;
let CssSyntaxError2 = rrweb_snapshot_cssSyntaxError;
let Declaration2 = rrweb_snapshot_declaration;
let LazyResult2 = rrweb_snapshot_lazyResult;
let Container2 = rrweb_snapshot_container;
let Processor2 = rrweb_snapshot_processor;
let rrweb_snapshot_stringify = rrweb_snapshot_stringify_1;
let rrweb_snapshot_fromJSON = rrweb_snapshot_fromJSON_1;
let Document2 = rrweb_snapshot_document$1;
let Warning2 = rrweb_snapshot_warning;
let Comment2 = rrweb_snapshot_comment;
let AtRule2 = rrweb_snapshot_atRule;
let Result2 = rrweb_snapshot_result;
let Input2 = rrweb_snapshot_input;
let rrweb_snapshot_parse = rrweb_snapshot_parse_1;
let rrweb_snapshot_list = rrweb_snapshot_list_1;
let Rule2 = rrweb_snapshot_rule;
let Root2 = rrweb_snapshot_root;
let Node2 = rrweb_snapshot_node;
function rrweb_snapshot_postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) {
        plugins = plugins[0];
    }
    return new Processor2(plugins);
}
rrweb_snapshot_postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
            if ( true && "C.UTF-8".startsWith("cn")) {
                console.warn(name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226");
            }
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new Processor2().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return rrweb_snapshot_postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
rrweb_snapshot_postcss.stringify = rrweb_snapshot_stringify;
rrweb_snapshot_postcss.parse = rrweb_snapshot_parse;
rrweb_snapshot_postcss.fromJSON = rrweb_snapshot_fromJSON;
rrweb_snapshot_postcss.list = rrweb_snapshot_list;
rrweb_snapshot_postcss.comment = (defaults)=>new Comment2(defaults);
rrweb_snapshot_postcss.atRule = (defaults)=>new AtRule2(defaults);
rrweb_snapshot_postcss.decl = (defaults)=>new Declaration2(defaults);
rrweb_snapshot_postcss.rule = (defaults)=>new Rule2(defaults);
rrweb_snapshot_postcss.root = (defaults)=>new Root2(defaults);
rrweb_snapshot_postcss.document = (defaults)=>new Document2(defaults);
rrweb_snapshot_postcss.CssSyntaxError = CssSyntaxError2;
rrweb_snapshot_postcss.Declaration = Declaration2;
rrweb_snapshot_postcss.Container = Container2;
rrweb_snapshot_postcss.Processor = Processor2;
rrweb_snapshot_postcss.Document = Document2;
rrweb_snapshot_postcss.Comment = Comment2;
rrweb_snapshot_postcss.Warning = Warning2;
rrweb_snapshot_postcss.AtRule = AtRule2;
rrweb_snapshot_postcss.Result = Result2;
rrweb_snapshot_postcss.Input = Input2;
rrweb_snapshot_postcss.Rule = Rule2;
rrweb_snapshot_postcss.Root = Root2;
rrweb_snapshot_postcss.Node = Node2;
LazyResult2.registerPostcss(rrweb_snapshot_postcss);
var rrweb_snapshot_postcss_1 = rrweb_snapshot_postcss;
rrweb_snapshot_postcss.default = rrweb_snapshot_postcss;
const rrweb_snapshot_postcss$1 = /* @__PURE__ */ rrweb_snapshot_getDefaultExportFromCjs(rrweb_snapshot_postcss_1);
rrweb_snapshot_postcss$1.stringify;
rrweb_snapshot_postcss$1.fromJSON;
rrweb_snapshot_postcss$1.plugin;
rrweb_snapshot_postcss$1.parse;
rrweb_snapshot_postcss$1.list;
rrweb_snapshot_postcss$1.document;
rrweb_snapshot_postcss$1.comment;
rrweb_snapshot_postcss$1.atRule;
rrweb_snapshot_postcss$1.rule;
rrweb_snapshot_postcss$1.decl;
rrweb_snapshot_postcss$1.root;
rrweb_snapshot_postcss$1.CssSyntaxError;
rrweb_snapshot_postcss$1.Declaration;
rrweb_snapshot_postcss$1.Container;
rrweb_snapshot_postcss$1.Processor;
rrweb_snapshot_postcss$1.Document;
rrweb_snapshot_postcss$1.Comment;
rrweb_snapshot_postcss$1.Warning;
rrweb_snapshot_postcss$1.AtRule;
rrweb_snapshot_postcss$1.Result;
rrweb_snapshot_postcss$1.Input;
rrweb_snapshot_postcss$1.Rule;
rrweb_snapshot_postcss$1.Root;
rrweb_snapshot_postcss$1.Node;
const rrweb_snapshot_tagMap = {
    script: "noscript",
    // camel case svg element tag names
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
function rrweb_snapshot_getTagName(n) {
    let tagName = rrweb_snapshot_tagMap[n.tagName] ? rrweb_snapshot_tagMap[n.tagName] : n.tagName;
    if (tagName === "link" && n.attributes._cssText) {
        tagName = "style";
    }
    return tagName;
}
function rrweb_snapshot_adaptCssForReplay(cssText, cache) {
    const cachedStyle = cache == null ? void 0 : cache.stylesWithHoverClass.get(cssText);
    if (cachedStyle) return cachedStyle;
    let result2 = cssText;
    try {
        const ast = rrweb_snapshot_postcss$1([
            rrweb_snapshot_mediaSelectorPlugin,
            rrweb_snapshot_pseudoClassPlugin
        ]).process(cssText);
        result2 = ast.css;
    } catch (error) {
        console.warn("Failed to adapt css for replay", error);
    }
    cache == null ? void 0 : cache.stylesWithHoverClass.set(cssText, result2);
    return result2;
}
function rrweb_snapshot_createCache() {
    const stylesWithHoverClass = /* @__PURE__ */ new Map();
    return {
        stylesWithHoverClass
    };
}
function rrweb_snapshot_buildNode(n, options) {
    var _a;
    const { doc, hackCss, cache } = options;
    switch(n.type){
        case rrweb_snapshot_NodeType.Document:
            return doc.implementation.createDocument(null, "", null);
        case rrweb_snapshot_NodeType.DocumentType:
            return doc.implementation.createDocumentType(n.name || "html", n.publicId, n.systemId);
        case rrweb_snapshot_NodeType.Element:
            {
                const tagName = rrweb_snapshot_getTagName(n);
                let node2;
                if (n.isSVG) {
                    node2 = doc.createElementNS("http://www.w3.org/2000/svg", tagName);
                } else {
                    if (// If the tag name is a custom element name
                    n.isCustom && // If the browser supports custom elements
                    ((_a = doc.defaultView) == null ? void 0 : _a.customElements) && // If the custom element hasn't been defined yet
                    !doc.defaultView.customElements.get(n.tagName)) doc.defaultView.customElements.define(n.tagName, class extends doc.defaultView.HTMLElement {
                    });
                    node2 = doc.createElement(tagName);
                }
                const specialAttributes = {};
                for(const name in n.attributes){
                    if (!Object.prototype.hasOwnProperty.call(n.attributes, name)) {
                        continue;
                    }
                    let value = n.attributes[name];
                    if (tagName === "option" && name === "selected" && value === false) {
                        continue;
                    }
                    if (value === null) {
                        continue;
                    }
                    if (value === true) value = "";
                    if (name.startsWith("rr_")) {
                        specialAttributes[name] = value;
                        continue;
                    }
                    const isTextarea = tagName === "textarea" && name === "value";
                    const isRemoteOrDynamicCss = tagName === "style" && name === "_cssText";
                    if (isRemoteOrDynamicCss && hackCss && typeof value === "string") {
                        value = rrweb_snapshot_adaptCssForReplay(value, cache);
                    }
                    if ((isTextarea || isRemoteOrDynamicCss) && typeof value === "string") {
                        node2.appendChild(doc.createTextNode(value));
                        n.childNodes = [];
                        continue;
                    }
                    try {
                        if (n.isSVG && name === "xlink:href") {
                            node2.setAttributeNS("http://www.w3.org/1999/xlink", name, value.toString());
                        } else if (name === "onload" || name === "onclick" || name.substring(0, 7) === "onmouse") {
                            node2.setAttribute("_" + name, value.toString());
                        } else if (tagName === "meta" && n.attributes["http-equiv"] === "Content-Security-Policy" && name === "content") {
                            node2.setAttribute("csp-content", value.toString());
                            continue;
                        } else if (tagName === "link" && (n.attributes.rel === "preload" || n.attributes.rel === "modulepreload") && n.attributes.as === "script") {} else if (tagName === "link" && n.attributes.rel === "prefetch" && typeof n.attributes.href === "string" && n.attributes.href.endsWith(".js")) {} else if (tagName === "img" && n.attributes.srcset && n.attributes.rr_dataURL) {
                            node2.setAttribute("rrweb-original-srcset", n.attributes.srcset);
                        } else {
                            node2.setAttribute(name, value.toString());
                        }
                    } catch (error) {}
                }
                for(const name in specialAttributes){
                    const value = specialAttributes[name];
                    if (tagName === "canvas" && name === "rr_dataURL") {
                        const image = doc.createElement("img");
                        image.onload = ()=>{
                            const ctx = node2.getContext("2d");
                            if (ctx) {
                                ctx.drawImage(image, 0, 0, image.width, image.height);
                            }
                        };
                        image.src = value.toString();
                        if (node2.RRNodeType) node2.rr_dataURL = value.toString();
                    } else if (tagName === "img" && name === "rr_dataURL") {
                        const image = node2;
                        if (!image.currentSrc.startsWith("data:")) {
                            image.setAttribute("rrweb-original-src", n.attributes.src);
                            image.src = value.toString();
                        }
                    }
                    if (name === "rr_width") {
                        node2.style.width = value.toString();
                    } else if (name === "rr_height") {
                        node2.style.height = value.toString();
                    } else if (name === "rr_mediaCurrentTime" && typeof value === "number") {
                        node2.currentTime = value;
                    } else if (name === "rr_mediaState") {
                        switch(value){
                            case "played":
                                node2.play().catch((e)=>console.warn("media playback error", e));
                                break;
                            case "paused":
                                node2.pause();
                                break;
                        }
                    } else if (name === "rr_mediaPlaybackRate" && typeof value === "number") {
                        node2.playbackRate = value;
                    } else if (name === "rr_mediaMuted" && typeof value === "boolean") {
                        node2.muted = value;
                    } else if (name === "rr_mediaLoop" && typeof value === "boolean") {
                        node2.loop = value;
                    } else if (name === "rr_mediaVolume" && typeof value === "number") {
                        node2.volume = value;
                    } else if (name === "rr_open_mode") {
                        node2.setAttribute("rr_open_mode", value);
                    }
                }
                if (n.isShadowHost) {
                    if (!node2.shadowRoot) {
                        node2.attachShadow({
                            mode: "open"
                        });
                    } else {
                        while(node2.shadowRoot.firstChild){
                            node2.shadowRoot.removeChild(node2.shadowRoot.firstChild);
                        }
                    }
                }
                return node2;
            }
        case rrweb_snapshot_NodeType.Text:
            return doc.createTextNode(n.isStyle && hackCss ? rrweb_snapshot_adaptCssForReplay(n.textContent, cache) : n.textContent);
        case rrweb_snapshot_NodeType.CDATA:
            return doc.createCDATASection(n.textContent);
        case rrweb_snapshot_NodeType.Comment:
            return doc.createComment(n.textContent);
        default:
            return null;
    }
}
function rrweb_snapshot_buildNodeWithSN(n, options) {
    const { doc, mirror, skipChild = false, hackCss = true, afterAppend, cache } = options;
    if (mirror.has(n.id)) {
        const nodeInMirror = mirror.getNode(n.id);
        const meta = mirror.getMeta(nodeInMirror);
        if (rrweb_snapshot_isNodeMetaEqual(meta, n)) return mirror.getNode(n.id);
    }
    let node2 = rrweb_snapshot_buildNode(n, {
        doc,
        hackCss,
        cache
    });
    if (!node2) {
        return null;
    }
    if (n.rootId && mirror.getNode(n.rootId) !== doc) {
        mirror.replace(n.rootId, doc);
    }
    if (n.type === rrweb_snapshot_NodeType.Document) {
        doc.close();
        doc.open();
        if (n.compatMode === "BackCompat" && n.childNodes && n.childNodes[0].type !== rrweb_snapshot_NodeType.DocumentType) {
            if (n.childNodes[0].type === rrweb_snapshot_NodeType.Element && "xmlns" in n.childNodes[0].attributes && n.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml") {
                doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
            } else {
                doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
            }
        }
        node2 = doc;
    }
    mirror.add(node2, n);
    if ((n.type === rrweb_snapshot_NodeType.Document || n.type === rrweb_snapshot_NodeType.Element) && !skipChild) {
        for (const childN of n.childNodes){
            const childNode = rrweb_snapshot_buildNodeWithSN(childN, {
                doc,
                mirror,
                skipChild: false,
                hackCss,
                afterAppend,
                cache
            });
            if (!childNode) {
                console.warn("Failed to rebuild", childN);
                continue;
            }
            if (childN.isShadow && rrweb_snapshot_isElement(node2) && node2.shadowRoot) {
                node2.shadowRoot.appendChild(childNode);
            } else if (n.type === rrweb_snapshot_NodeType.Document && childN.type == rrweb_snapshot_NodeType.Element) {
                const htmlElement = childNode;
                let body = null;
                htmlElement.childNodes.forEach((child)=>{
                    if (child.nodeName === "BODY") body = child;
                });
                if (body) {
                    htmlElement.removeChild(body);
                    node2.appendChild(childNode);
                    htmlElement.appendChild(body);
                } else {
                    node2.appendChild(childNode);
                }
            } else {
                node2.appendChild(childNode);
            }
            if (afterAppend) {
                afterAppend(childNode, childN.id);
            }
        }
    }
    return node2;
}
function rrweb_snapshot_visit(mirror, onVisit) {
    function walk(node2) {
        onVisit(node2);
    }
    for (const id of mirror.getIds()){
        if (mirror.has(id)) {
            walk(mirror.getNode(id));
        }
    }
}
function rrweb_snapshot_handleScroll(node2, mirror) {
    const n = mirror.getMeta(node2);
    if ((n == null ? void 0 : n.type) !== rrweb_snapshot_NodeType.Element) {
        return;
    }
    const el = node2;
    for(const name in n.attributes){
        if (!(Object.prototype.hasOwnProperty.call(n.attributes, name) && name.startsWith("rr_"))) {
            continue;
        }
        const value = n.attributes[name];
        if (name === "rr_scrollLeft") {
            el.scrollLeft = value;
        }
        if (name === "rr_scrollTop") {
            el.scrollTop = value;
        }
    }
}
function rrweb_snapshot_rebuild(n, options) {
    const { doc, onVisit, hackCss = true, afterAppend, cache, mirror = new rrweb_snapshot_Mirror() } = options;
    const node2 = rrweb_snapshot_buildNodeWithSN(n, {
        doc,
        mirror,
        skipChild: false,
        hackCss,
        afterAppend,
        cache
    });
    rrweb_snapshot_visit(mirror, (visitedNode)=>{
        if (onVisit) {
            onVisit(visitedNode);
        }
        rrweb_snapshot_handleScroll(visitedNode, mirror);
    });
    return node2;
}
 //# sourceMappingURL=rrweb-snapshot.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/config/types.js
var DEFAULT_MASK_LEVEL = 'medium'; //# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/helpers.js






/**
 * Light: Subset of inputs
 * Medium: All inputs
 * Conservative: All inputs and all texts
 */ var isMaskedForLevel = function(elementType, level, element) {
    switch(level){
        case 'light':
            {
                if (elementType !== 'input') {
                    return true;
                }
                var inputType = element ? rrweb_snapshot_getInputType(element) : '';
                /* istanbul ignore if */ // TODO(lew): For some reason it's impossible to test this.
                if (!inputType) {
                    return false;
                }
                if ([
                    'password',
                    'hidden',
                    'email',
                    'tel'
                ].includes(inputType)) {
                    return true;
                }
                if (element.autocomplete.startsWith('cc-')) {
                    return true;
                }
                return false;
            }
        case 'medium':
        case 'conservative':
            return true;
        default:
            return isMaskedForLevel(elementType, DEFAULT_MASK_LEVEL, element);
    }
};
/**
 * Checks if the given element set to be masked by rrweb
 *
 * Priority is:
 *  1. [In code] Element/class based masking/unmasking <> [Config based] Selector based masking/unmasking
 *  2. Use app defaults
 */ var isMasked = function(elementType, config, element) {
    var _a, _b, _c;
    if (config === void 0) {
        config = {
            defaultMaskLevel: DEFAULT_MASK_LEVEL
        };
    }
    if (element) {
        // Element or parent is explicitly instrumented in code to mask
        if (element.closest('.' + MASK_TEXT_CLASS)) {
            return true;
        }
        // Config has override for mask
        var shouldMask = ((_a = config.maskSelector) !== null && _a !== void 0 ? _a : []).some(function(selector) {
            return element.closest(selector);
        });
        if (shouldMask) {
            return true;
        }
        // Code or config has override to unmask
        if (element.closest('.' + UNMASK_TEXT_CLASS)) {
            return false;
        }
        // Here we are probably sent an element, but we want to match if they have a
        // parent with an unmask selector.
        var shouldUnmask = ((_b = config.unmaskSelector) !== null && _b !== void 0 ? _b : []).some(function(selector) {
            return element.closest(selector);
        });
        if (shouldUnmask) {
            return false;
        }
    }
    return isMaskedForLevel(elementType, (_c = config.defaultMaskLevel) !== null && _c !== void 0 ? _c : DEFAULT_MASK_LEVEL, element);
};
var maskFn = function(elementType, config) {
    return function(text, element) {
        return isMasked(elementType, config, element) ? text.replace(/[^\s]/g, '*') : text;
    };
};
var generateHashCode = function(str) {
    var hash = 0;
    if (str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
var isSessionInSample = function(sessionId, sampleRate) {
    var hashNumber = generateHashCode(sessionId.toString());
    var absHash = Math.abs(hashNumber);
    var absHashMultiply = absHash * 31;
    var mod = absHashMultiply % 1000000;
    return mod / 1000000 < sampleRate;
};
var getCurrentUrl = function() {
    var globalScope = (0,global_scope/* getGlobalScope */.l)();
    return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) ? globalScope.location.href : '';
};
var generateSessionReplayId = function(sessionId, deviceId) {
    return "".concat(deviceId, "/").concat(sessionId);
};
var getServerUrl = function(serverZone) {
    if (serverZone === server_zone/* ServerZone.STAGING */.J.STAGING) {
        return SESSION_REPLAY_STAGING_URL;
    }
    if (serverZone === server_zone/* ServerZone.EU */.J.EU) {
        return SESSION_REPLAY_EU_URL;
    }
    return SESSION_REPLAY_SERVER_URL;
};
var getStorageSize = function() {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var globalScope, _a, usage, quota, usageDetails, totalStorageSize, percentOfQuota, e_1;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    globalScope = (0,global_scope/* getGlobalScope */.l)();
                    if (!globalScope) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        globalScope.navigator.storage.estimate()
                    ];
                case 1:
                    _a = _b.sent(), usage = _a.usage, quota = _a.quota, usageDetails = _a.usageDetails;
                    totalStorageSize = usage ? Math.round(usage / KB_SIZE) : 0;
                    percentOfQuota = usage && quota ? Math.round((usage / quota + Number.EPSILON) * 1000) / 1000 : 0;
                    return [
                        2 /*return*/ ,
                        {
                            totalStorageSize: totalStorageSize,
                            percentOfQuota: percentOfQuota,
                            usageDetails: JSON.stringify(usageDetails)
                        }
                    ];
                case 2:
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        {
                            totalStorageSize: 0,
                            percentOfQuota: 0,
                            usageDetails: ''
                        }
                    ];
            }
        });
    });
};
var getDebugConfig = function(config) {
    var debugConfig = (0,tslib_es6/* __assign */.pi)({}, config);
    var apiKey = debugConfig.apiKey;
    debugConfig.apiKey = "****".concat(apiKey.substring(apiKey.length - 4));
    return debugConfig;
}; //# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/config/joined-config.js




var removeInvalidSelectorsFromPrivacyConfig = function(privacyConfig, loggerProvider) {
    // This allows us to not search the DOM.
    var fragment = document.createDocumentFragment();
    var dropInvalidSelectors = function(selectors) {
        if (selectors === void 0) {
            selectors = [];
        }
        if (typeof selectors === 'string') {
            selectors = [
                selectors
            ];
        }
        selectors = selectors.filter(function(selector) {
            try {
                fragment.querySelector(selector);
            } catch (_a) {
                loggerProvider.warn("[session-replay-browser] omitting selector \"".concat(selector, "\" because it is invalid"));
                return false;
            }
            return true;
        });
        if (selectors.length === 0) {
            return undefined;
        }
        return selectors;
    };
    privacyConfig.blockSelector = dropInvalidSelectors(privacyConfig.blockSelector);
    privacyConfig.maskSelector = dropInvalidSelectors(privacyConfig.maskSelector);
    privacyConfig.unmaskSelector = dropInvalidSelectors(privacyConfig.unmaskSelector);
    return privacyConfig;
};
var SessionReplayJoinedConfigGenerator = /** @class */ function() {
    function SessionReplayJoinedConfigGenerator(remoteConfigFetch, localConfig) {
        this.localConfig = localConfig;
        this.remoteConfigFetch = remoteConfigFetch;
    }
    SessionReplayJoinedConfigGenerator.prototype.generateJoinedConfig = function(sessionId) {
        var _a, _b, _c;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var config, remoteConfig, samplingConfig_1, privacyConfig, _d, err_1, knownError, samplingConfig, remotePrivacyConfig, localPrivacyConfig, joinedPrivacyConfig, privacyConfigSelectorMap, selectorMap, _e, _f, _g, selector, selectorType;
            var e_1, _h;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        config = (0,tslib_es6/* __assign */.pi)({}, this.localConfig);
                        // Special case here as optOut is implemented via getter/setter
                        config.optOut = this.localConfig.optOut;
                        // We always want captureEnabled to be true, unless there's an override
                        // in the remote config.
                        config.captureEnabled = true;
                        _j.label = 1;
                    case 1:
                        _j.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_sampling_config', sessionId)
                        ];
                    case 2:
                        samplingConfig_1 = _j.sent();
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_privacy_config', sessionId)
                        ];
                    case 3:
                        privacyConfig = _j.sent();
                        // This is intentionally forced to only be set through the remote config.
                        _d = config;
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_interaction_config', sessionId)
                        ];
                    case 4:
                        // This is intentionally forced to only be set through the remote config.
                        _d.interactionConfig = _j.sent();
                        if (samplingConfig_1 || privacyConfig) {
                            remoteConfig = {};
                            if (samplingConfig_1) {
                                remoteConfig.sr_sampling_config = samplingConfig_1;
                            }
                            if (privacyConfig) {
                                remoteConfig.sr_privacy_config = privacyConfig;
                            }
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _j.sent();
                        knownError = err_1;
                        this.localConfig.loggerProvider.warn(knownError.message);
                        config.captureEnabled = false;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        if (!remoteConfig) {
                            return [
                                2 /*return*/ ,
                                config
                            ];
                        }
                        samplingConfig = remoteConfig.sr_sampling_config, remotePrivacyConfig = remoteConfig.sr_privacy_config;
                        if (samplingConfig && Object.keys(samplingConfig).length > 0) {
                            if (Object.prototype.hasOwnProperty.call(samplingConfig, 'capture_enabled')) {
                                config.captureEnabled = samplingConfig.capture_enabled;
                            } else {
                                config.captureEnabled = false;
                            }
                            if (Object.prototype.hasOwnProperty.call(samplingConfig, 'sample_rate')) {
                                config.sampleRate = samplingConfig.sample_rate;
                            }
                        } else {
                            // If config API response was valid (ie 200), but no config returned, assume that
                            // customer has not yet set up config, and use sample rate from SDK options,
                            // allowing for immediate replay capture
                            config.captureEnabled = true;
                            this.localConfig.loggerProvider.debug('Remote config successfully fetched, but no values set for project, Session Replay capture enabled.');
                        }
                        // Remote config join acts somewhat like a left join between the remote and the local
                        // config. That is, remote config has precedence over local values as with sampling.
                        // However, non conflicting values will be added to the lists.
                        // Here's an example to illustrate:
                        //
                        // Remote config:   {'.selector1': 'MASK',   '.selector2': 'UNMASK'}
                        // Local config:    {'.selector1': 'UNMASK',                         '.selector3': 'MASK'}
                        //
                        // Resolved config: {'.selector1': 'MASK',   '.selector2': 'UNMASK', '.selector3': 'MASK'}
                        // config.privacyConfig = {
                        //   ...(config.privacyConfig ?? {}),
                        //   ...remotePrivacyConfig,
                        // };
                        if (remotePrivacyConfig) {
                            localPrivacyConfig = (_a = config.privacyConfig) !== null && _a !== void 0 ? _a : {};
                            joinedPrivacyConfig = {
                                defaultMaskLevel: (_c = (_b = remotePrivacyConfig.defaultMaskLevel) !== null && _b !== void 0 ? _b : localPrivacyConfig.defaultMaskLevel) !== null && _c !== void 0 ? _c : 'medium',
                                blockSelector: [],
                                maskSelector: [],
                                unmaskSelector: []
                            };
                            privacyConfigSelectorMap = function(privacyConfig) {
                                var e_2, _a, e_3, _b, e_4, _c;
                                var _d, _e, _f;
                                var selectorMap = {};
                                if (typeof privacyConfig.blockSelector === 'string') {
                                    privacyConfig.blockSelector = [
                                        privacyConfig.blockSelector
                                    ];
                                }
                                try {
                                    for(var _g = (0,tslib_es6/* __values */.XA)((_d = privacyConfig.blockSelector) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var selector = _h.value;
                                        selectorMap[selector] = 'block';
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                try {
                                    for(var _j = (0,tslib_es6/* __values */.XA)((_e = privacyConfig.maskSelector) !== null && _e !== void 0 ? _e : []), _k = _j.next(); !_k.done; _k = _j.next()){
                                        var selector = _k.value;
                                        selectorMap[selector] = 'mask';
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                try {
                                    for(var _l = (0,tslib_es6/* __values */.XA)((_f = privacyConfig.unmaskSelector) !== null && _f !== void 0 ? _f : []), _m = _l.next(); !_m.done; _m = _l.next()){
                                        var selector = _m.value;
                                        selectorMap[selector] = 'unmask';
                                    }
                                } catch (e_4_1) {
                                    e_4 = {
                                        error: e_4_1
                                    };
                                } finally{
                                    try {
                                        if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                                    } finally{
                                        if (e_4) throw e_4.error;
                                    }
                                }
                                return selectorMap;
                            };
                            selectorMap = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, privacyConfigSelectorMap(localPrivacyConfig)), privacyConfigSelectorMap(remotePrivacyConfig));
                            try {
                                for(_e = (0,tslib_es6/* __values */.XA)(Object.entries(selectorMap)), _f = _e.next(); !_f.done; _f = _e.next()){
                                    _g = (0,tslib_es6/* __read */.CR)(_f.value, 2), selector = _g[0], selectorType = _g[1];
                                    if (selectorType === 'mask') {
                                        joinedPrivacyConfig.maskSelector.push(selector);
                                    } else if (selectorType === 'block') {
                                        joinedPrivacyConfig.blockSelector.push(selector);
                                    } else if (selectorType === 'unmask') {
                                        joinedPrivacyConfig.unmaskSelector.push(selector);
                                    }
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                            config.privacyConfig = removeInvalidSelectorsFromPrivacyConfig(joinedPrivacyConfig, this.localConfig.loggerProvider);
                        }
                        this.localConfig.loggerProvider.debug(JSON.stringify({
                            name: 'session replay joined config',
                            config: getDebugConfig(config)
                        }, null, 2));
                        return [
                            2 /*return*/ ,
                            config
                        ];
                }
            });
        });
    };
    return SessionReplayJoinedConfigGenerator;
}();

var createSessionReplayJoinedConfigGenerator = function(apiKey, options) {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var localConfig, remoteConfigFetch;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
            switch(_a.label){
                case 0:
                    localConfig = new SessionReplayLocalConfig(apiKey, options);
                    return [
                        4 /*yield*/ ,
                        esm_createRemoteConfigFetch({
                            localConfig: localConfig,
                            configKeys: [
                                'sessionReplay'
                            ]
                        })
                    ];
                case 1:
                    remoteConfigFetch = _a.sent();
                    return [
                        2 /*return*/ ,
                        new SessionReplayJoinedConfigGenerator(remoteConfigFetch, localConfig)
                    ];
            }
        });
    });
}; //# sourceMappingURL=joined-config.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/messages.js
var messages_UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var messages_UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, event batch rejected';
var messages_MAX_RETRIES_EXCEEDED_MESSAGE = 'Session replay event batch rejected due to exceeded retry count';
var STORAGE_FAILURE = 'Failed to store session replay events in IndexedDB';
var MISSING_DEVICE_ID_MESSAGE = 'Session replay event batch not sent due to missing device ID';
var MISSING_API_KEY_MESSAGE = 'Session replay event batch not sent due to missing api key'; //# sourceMappingURL=messages.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/version.js
// Autogenerated by `yarn version-file`. DO NOT EDIT
var VERSION = '1.17.0'; //# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/track-destination.js







var SessionReplayTrackDestination = /** @class */ function() {
    function SessionReplayTrackDestination(_a) {
        var loggerProvider = _a.loggerProvider, payloadBatcher = _a.payloadBatcher;
        this.storageKey = '';
        this.retryTimeout = 1000;
        this.scheduled = null;
        this.queue = [];
        this.loggerProvider = loggerProvider;
        this.payloadBatcher = payloadBatcher ? payloadBatcher : function(payload) {
            return payload;
        };
    }
    SessionReplayTrackDestination.prototype.sendEventsList = function(destinationData) {
        this.addToQueue((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, destinationData), {
            attempts: 0,
            timeout: 0
        }));
    };
    SessionReplayTrackDestination.prototype.addToQueue = function() {
        var _this = this;
        var list = [];
        for(var _i = 0; _i < arguments.length; _i++){
            list[_i] = arguments[_i];
        }
        var tryable = list.filter(function(context) {
            if (context.attempts < (context.flushMaxRetries || 0)) {
                context.attempts += 1;
                return true;
            }
            _this.completeRequest({
                context: context,
                err: messages_MAX_RETRIES_EXCEEDED_MESSAGE
            });
            return false;
        });
        tryable.forEach(function(context) {
            _this.queue = _this.queue.concat(context);
            if (context.timeout === 0) {
                _this.schedule(0);
                return;
            }
            setTimeout(function() {
                context.timeout = 0;
                _this.schedule(0);
            }, context.timeout);
        });
    };
    SessionReplayTrackDestination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.scheduled) return;
        this.scheduled = setTimeout(function() {
            void _this.flush(true).then(function() {
                if (_this.queue.length > 0) {
                    _this.schedule(timeout);
                }
            });
        }, timeout);
    };
    SessionReplayTrackDestination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) {
            useRetry = false;
        }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var list, later;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        this.queue = later;
                        if (this.scheduled) {
                            clearTimeout(this.scheduled);
                            this.scheduled = null;
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(list.map(function(context) {
                                return _this.send(context, useRetry);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayTrackDestination.prototype.send = function(context, useRetry) {
        var _a, _b;
        if (useRetry === void 0) {
            useRetry = true;
        }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var apiKey, deviceId, url, version, sampleRate, urlParams, sessionReplayLibrary, payload, options, server_url, res, responseBody, e_1;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        apiKey = context.apiKey;
                        if (!apiKey) {
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    context: context,
                                    err: MISSING_API_KEY_MESSAGE
                                })
                            ];
                        }
                        deviceId = context.deviceId;
                        if (!deviceId) {
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    context: context,
                                    err: MISSING_DEVICE_ID_MESSAGE
                                })
                            ];
                        }
                        url = getCurrentUrl();
                        version = VERSION;
                        sampleRate = context.sampleRate;
                        urlParams = new URLSearchParams({
                            device_id: deviceId,
                            session_id: "".concat(context.sessionId),
                            type: "".concat(context.type)
                        });
                        sessionReplayLibrary = "".concat(((_a = context.version) === null || _a === void 0 ? void 0 : _a.type) || 'standalone', "/").concat(((_b = context.version) === null || _b === void 0 ? void 0 : _b.version) || version);
                        payload = this.payloadBatcher({
                            version: 1,
                            events: context.events
                        });
                        if (payload.events.length === 0) {
                            this.completeRequest({
                                context: context
                            });
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*',
                                Authorization: "Bearer ".concat(apiKey),
                                'X-Client-Version': version,
                                'X-Client-Library': sessionReplayLibrary,
                                'X-Client-Url': url,
                                'X-Client-Sample-Rate': "".concat(sampleRate)
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        server_url = "".concat(getServerUrl(context.serverZone), "?").concat(urlParams.toString());
                        return [
                            4 /*yield*/ ,
                            fetch(server_url, options)
                        ];
                    case 2:
                        res = _c.sent();
                        if (res === null) {
                            this.completeRequest({
                                context: context,
                                err: messages_UNEXPECTED_ERROR_MESSAGE
                            });
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            responseBody = '';
                            try {
                                responseBody = JSON.stringify(res.body, null, 2);
                            } catch (_d) {
                            // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
                            }
                            this.completeRequest({
                                context: context,
                                success: "".concat(res.status, ": ").concat(responseBody)
                            });
                        } else {
                            this.handleReponse(res.status, context);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        this.completeRequest({
                            context: context,
                            err: e_1
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayTrackDestination.prototype.handleReponse = function(status, context) {
        var parsedStatus = new base/* BaseTransport */.d().buildStatus(status);
        switch(parsedStatus){
            case esm_status/* Status.Success */.q.Success:
                this.handleSuccessResponse(context);
                break;
            case esm_status/* Status.Failed */.q.Failed:
                this.handleOtherResponse(context);
                break;
            default:
                this.completeRequest({
                    context: context,
                    err: messages_UNEXPECTED_NETWORK_ERROR_MESSAGE
                });
        }
    };
    SessionReplayTrackDestination.prototype.handleSuccessResponse = function(context) {
        var sizeOfEventsList = Math.round(new Blob(context.events).size / KB_SIZE);
        this.completeRequest({
            context: context,
            success: "Session replay event batch tracked successfully for session id ".concat(context.sessionId, ", size of events: ").concat(sizeOfEventsList, " KB")
        });
    };
    SessionReplayTrackDestination.prototype.handleOtherResponse = function(context) {
        this.addToQueue((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), {
            timeout: context.attempts * this.retryTimeout
        }));
    };
    SessionReplayTrackDestination.prototype.completeRequest = function(_a) {
        var context = _a.context, err = _a.err, success = _a.success;
        void context.onComplete();
        if (err) {
            this.loggerProvider.warn(err);
        } else if (success) {
            this.loggerProvider.log(success);
        }
    };
    return SessionReplayTrackDestination;
}();
 //# sourceMappingURL=track-destination.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/idb@8.0.0/node_modules/idb/build/index.js
function _async_generator(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) {
                back = back.next = request;
            } else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof _await_value;
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) {
            resume(front.key, front.arg);
        } else {
            back = null;
        }
    }
    this._invoke = send;
    if (typeof gen.return !== "function") {
        this.return = undefined;
    }
}
if (typeof Symbol === "function" && Symbol.asyncIterator) {
    _async_generator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
}
_async_generator.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
_async_generator.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
_async_generator.prototype.return = function(arg) {
    return this._invoke("return", arg);
};
function build_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function build_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                build_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                build_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _await_async_generator(value) {
    return new _await_value(value);
}
function _await_value(value) {
    this.wrapped = value;
}
function build_extends() {
    build_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return build_extends.apply(this, arguments);
}
function _wrap_async_generator(fn) {
    return function() {
        return new _async_generator(fn.apply(this, arguments));
    };
}
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const transactionDoneMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function(...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap(this.request);
        };
    }
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function') return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event)=>{
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
            event.oldVersion, event.newVersion, event));
    }
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
        }
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
            event.oldVersion, event));
    }
    return wrap(request).then(()=>undefined);
}
const readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = /*#__PURE__*/ build_async_to_generator(function*(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (yield Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    });
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps)=>build_extends({}, oldTraps, {
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const methodMap = {};
const advanceResults = new WeakMap();
const ittrProxiedCursorToOriginalProxy = new WeakMap();
const cursorIteratorTraps = {
    get (target, prop) {
        if (!advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = methodMap[prop];
        if (!cachedFunc) {
            cachedFunc = methodMap[prop] = function(...args) {
                advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
            };
        }
        return cachedFunc;
    }
};
function iterate() {
    return _iterate.apply(this, arguments);
}
function _iterate() {
    _iterate = _wrap_async_generator(function*(...args) {
        // tslint:disable-next-line:no-this-assignment
        let cursor = this;
        if (!(cursor instanceof IDBCursor)) {
            cursor = yield _await_async_generator(cursor.openCursor(...args));
        }
        if (!cursor) return;
        cursor = cursor;
        const proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
        ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
        // Map this double-proxy back to the original, so other cursor methods work.
        reverseTransformCache.set(proxiedCursor, unwrap(cursor));
        while(cursor){
            yield proxiedCursor;
            // If one of the advancing methods was not called, call continue().
            cursor = yield _await_async_generator(advanceResults.get(proxiedCursor) || cursor.continue());
            advanceResults.delete(proxiedCursor);
        }
    });
    return _iterate.apply(this, arguments);
}
function isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
replaceTraps((oldTraps)=>build_extends({}, oldTraps, {
        get (target, prop, receiver) {
            if (isIteratorProp(target, prop)) return iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/base-events-store.js

var BaseEventsStore = /** @class */ function() {
    function BaseEventsStore(args) {
        var _this = this;
        var _a, _b, _c;
        this.minInterval = MIN_INTERVAL;
        this.maxInterval = MAX_INTERVAL;
        this.maxPersistedEventsSize = MAX_EVENT_LIST_SIZE_IN_BYTES;
        this.interval = this.minInterval;
        this._timeAtLastSplit = Date.now(); // Initialize this so we have a point of comparison when events are recorded
        /**
         * Determines whether to send the events list to the backend and start a new
         * empty events list, based on the size of the list as well as the last time sent
         * @param nextEventString
         * @returns boolean
         */ this.shouldSplitEventsList = function(events, nextEventString) {
            var sizeOfNextEvent = new Blob([
                nextEventString
            ]).size;
            var sizeOfEventsList = new Blob(events).size;
            if (sizeOfEventsList + sizeOfNextEvent >= _this.maxPersistedEventsSize) {
                return true;
            }
            if (Date.now() - _this.timeAtLastSplit > _this.interval && events.length) {
                _this.interval = Math.min(_this.maxInterval, _this.interval + _this.minInterval);
                _this._timeAtLastSplit = Date.now();
                return true;
            }
            return false;
        };
        this.loggerProvider = args.loggerProvider;
        this.minInterval = (_a = args.minInterval) !== null && _a !== void 0 ? _a : this.minInterval;
        this.maxInterval = (_b = args.maxInterval) !== null && _b !== void 0 ? _b : this.maxInterval;
        this.maxPersistedEventsSize = (_c = args.maxPersistedEventsSize) !== null && _c !== void 0 ? _c : this.maxPersistedEventsSize;
    }
    Object.defineProperty(BaseEventsStore.prototype, "timeAtLastSplit", {
        get: function() {
            return this._timeAtLastSplit;
        },
        enumerable: false,
        configurable: true
    });
    return BaseEventsStore;
}();
 //# sourceMappingURL=base-events-store.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/legacy-idb-types.js
var RecordingStatus;
(function(RecordingStatus) {
    RecordingStatus["RECORDING"] = "recording";
    RecordingStatus["SENT"] = "sent";
})(RecordingStatus || (RecordingStatus = {})); //# sourceMappingURL=legacy-idb-types.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/events-idb-store.js







var currentSequenceKey = 'sessionCurrentSequence';
var sequencesToSendKey = 'sequencesToSend';
var remoteConfigKey = 'remoteConfig';
var keyValDatabaseExists = function() {
    var globalScope = (0,global_scope/* getGlobalScope */.l)();
    return new Promise(function(resolve, reject) {
        if (!globalScope) {
            return reject(new Error('Global scope not found'));
        }
        if (!globalScope.indexedDB) {
            return reject(new Error('Session Replay: cannot find indexedDB'));
        }
        try {
            var request_1 = globalScope.indexedDB.open('keyval-store');
            request_1.onupgradeneeded = function() {
                if (request_1.result.version === 1) {
                    request_1.result.close();
                    request_1.transaction && request_1.transaction.abort();
                    globalScope.indexedDB.deleteDatabase('keyval-store');
                    resolve();
                }
            };
            request_1.onsuccess = function() {
                resolve(request_1.result);
            };
        } catch (e) {
            reject(e);
        }
    });
};
var batchPromiseAll = function(promiseBatch) {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        var chunkSize, batch;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(promiseBatch.length > 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    chunkSize = 10;
                    batch = promiseBatch.splice(0, chunkSize);
                    return [
                        4 /*yield*/ ,
                        Promise.all(batch)
                    ];
                case 1:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var defineObjectStores = function(db) {
    var sequencesStore;
    var currentSequenceStore;
    if (!db.objectStoreNames.contains(currentSequenceKey)) {
        currentSequenceStore = db.createObjectStore(currentSequenceKey, {
            keyPath: 'sessionId'
        });
    }
    if (!db.objectStoreNames.contains(sequencesToSendKey)) {
        sequencesStore = db.createObjectStore(sequencesToSendKey, {
            keyPath: 'sequenceId',
            autoIncrement: true
        });
        sequencesStore.createIndex('sessionId', 'sessionId');
    }
    return {
        sequencesStore: sequencesStore,
        currentSequenceStore: currentSequenceStore
    };
};
var createStore = function(dbName) {
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        openDB(dbName, 1, {
                            upgrade: defineObjectStores
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};
var SessionReplayEventsIDBStore = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(SessionReplayEventsIDBStore, _super);
    function SessionReplayEventsIDBStore(args) {
        var _this = _super.call(this, args) || this;
        _this.getSequencesToSend = function() {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var sequences, cursor, _a, sessionId, events, e_1;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            sequences = [];
                            return [
                                4 /*yield*/ ,
                                this.db.transaction('sequencesToSend').store.openCursor()
                            ];
                        case 1:
                            cursor = _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!cursor) return [
                                3 /*break*/ ,
                                4
                            ];
                            _a = cursor.value, sessionId = _a.sessionId, events = _a.events;
                            sequences.push({
                                events: events,
                                sequenceId: cursor.key,
                                sessionId: sessionId
                            });
                            return [
                                4 /*yield*/ ,
                                cursor.continue()
                            ];
                        case 3:
                            cursor = _b.sent();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 4:
                            return [
                                2 /*return*/ ,
                                sequences
                            ];
                        case 5:
                            e_1 = _b.sent();
                            this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_1));
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.storeCurrentSequence = function(sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var currentSequenceData, sequenceId, e_2;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.get(currentSequenceKey, sessionId)
                            ];
                        case 1:
                            currentSequenceData = _a.sent();
                            if (!currentSequenceData) {
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                this.db.put(sequencesToSendKey, {
                                    sessionId: sessionId,
                                    events: currentSequenceData.events
                                })
                            ];
                        case 2:
                            sequenceId = _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.db.put(currentSequenceKey, {
                                    sessionId: sessionId,
                                    events: []
                                })
                            ];
                        case 3:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, currentSequenceData), {
                                    sessionId: sessionId,
                                    sequenceId: sequenceId
                                })
                            ];
                        case 4:
                            e_2 = _a.sent();
                            this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_2));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.addEventToCurrentSequence = function(sessionId, event) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var tx, sequenceEvents, eventsToSend, updatedEvents, sequenceId, e_3;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                10,
                                ,
                                11
                            ]);
                            tx = this.db.transaction(currentSequenceKey, 'readwrite');
                            return [
                                4 /*yield*/ ,
                                tx.store.get(sessionId)
                            ];
                        case 1:
                            sequenceEvents = _a.sent();
                            if (!!sequenceEvents) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: [
                                        event
                                    ]
                                })
                            ];
                        case 2:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 3:
                            eventsToSend = void 0;
                            if (!this.shouldSplitEventsList(sequenceEvents.events, event)) return [
                                3 /*break*/ ,
                                5
                            ];
                            eventsToSend = sequenceEvents.events;
                            // set store to empty array
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: [
                                        event
                                    ]
                                })
                            ];
                        case 4:
                            // set store to empty array
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 5:
                            updatedEvents = sequenceEvents.events.concat(event);
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: updatedEvents
                                })
                            ];
                        case 6:
                            _a.sent();
                            _a.label = 7;
                        case 7:
                            return [
                                4 /*yield*/ ,
                                tx.done
                            ];
                        case 8:
                            _a.sent();
                            if (!eventsToSend) {
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                this.storeSendingEvents(sessionId, eventsToSend)
                            ];
                        case 9:
                            sequenceId = _a.sent();
                            if (!sequenceId) {
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                {
                                    events: eventsToSend,
                                    sessionId: sessionId,
                                    sequenceId: sequenceId
                                }
                            ];
                        case 10:
                            e_3 = _a.sent();
                            this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_3));
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 11:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.storeSendingEvents = function(sessionId, events) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var sequenceId, e_4;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.put(sequencesToSendKey, {
                                    sessionId: sessionId,
                                    events: events
                                })
                            ];
                        case 1:
                            sequenceId = _a.sent();
                            return [
                                2 /*return*/ ,
                                sequenceId
                            ];
                        case 2:
                            e_4 = _a.sent();
                            this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_4));
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.cleanUpSessionEventsStore = function(_sessionId, sequenceId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var e_5;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!sequenceId) {
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.delete(sequencesToSendKey, sequenceId)
                            ];
                        case 2:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_5 = _a.sent();
                            this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_5));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.transitionFromKeyValStore = function(sessionId) {
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var keyValDb, transitionCurrentSessionSequences_1, storageKey, getAllRequest_1, transitionPromise, globalScope, e_6, e_7;
                var _this = this;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                keyValDatabaseExists()
                            ];
                        case 1:
                            keyValDb = _a.sent();
                            if (!keyValDb) {
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            transitionCurrentSessionSequences_1 = function(numericSessionId, sessionStore) {
                                return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                                    var currentSessionSequences, promisesToBatch;
                                    var _this = this;
                                    return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                currentSessionSequences = sessionStore.sessionSequences;
                                                promisesToBatch = [];
                                                Object.keys(currentSessionSequences).forEach(function(sequenceId) {
                                                    var numericSequenceId = parseInt(sequenceId, 10);
                                                    var sequence = currentSessionSequences[numericSequenceId];
                                                    if (numericSequenceId === sessionStore.currentSequenceId) {
                                                        var eventAddPromises = sequence.events.map(function(event) {
                                                            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                                                                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        this.addEventToCurrentSequence(numericSessionId, event)
                                                                    ];
                                                                });
                                                            });
                                                        });
                                                        promisesToBatch.concat(eventAddPromises);
                                                    } else if (sequence.status !== RecordingStatus.SENT) {
                                                        promisesToBatch.push(_this.storeSendingEvents(numericSessionId, sequence.events));
                                                    }
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    batchPromiseAll(promisesToBatch)
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            };
                            storageKey = "".concat(constants/* STORAGE_PREFIX */.f1, "_").concat(this.apiKey.substring(0, 10));
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            getAllRequest_1 = keyValDb.transaction('keyval').objectStore('keyval').getAll(storageKey);
                            transitionPromise = new Promise(function(resolve) {
                                getAllRequest_1.onsuccess = function(e) {
                                    return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                                        var storedReplaySessionContextList, storedReplaySessionContexts, promisesToBatch_1;
                                        var _this = this;
                                        return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    storedReplaySessionContextList = e && e.target.result;
                                                    storedReplaySessionContexts = storedReplaySessionContextList && storedReplaySessionContextList[0];
                                                    if (!storedReplaySessionContexts) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    promisesToBatch_1 = [];
                                                    Object.keys(storedReplaySessionContexts).forEach(function(storedSessionId) {
                                                        var numericSessionId = parseInt(storedSessionId, 10);
                                                        var oldSessionStore = storedReplaySessionContexts[numericSessionId];
                                                        if (sessionId === numericSessionId) {
                                                            promisesToBatch_1.push(transitionCurrentSessionSequences_1(numericSessionId, oldSessionStore));
                                                        } else {
                                                            var oldSessionSequences_1 = oldSessionStore.sessionSequences;
                                                            Object.keys(oldSessionSequences_1).forEach(function(sequenceId) {
                                                                var numericSequenceId = parseInt(sequenceId, 10);
                                                                if (oldSessionSequences_1[numericSequenceId].status !== RecordingStatus.SENT) {
                                                                    promisesToBatch_1.push(_this.storeSendingEvents(numericSessionId, oldSessionSequences_1[numericSequenceId].events));
                                                                }
                                                            });
                                                        }
                                                    });
                                                    return [
                                                        4 /*yield*/ ,
                                                        batchPromiseAll(promisesToBatch_1)
                                                    ];
                                                case 1:
                                                    _a.sent();
                                                    _a.label = 2;
                                                case 2:
                                                    resolve();
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                            });
                            return [
                                4 /*yield*/ ,
                                transitionPromise
                            ];
                        case 3:
                            _a.sent();
                            globalScope = (0,global_scope/* getGlobalScope */.l)();
                            if (globalScope) {
                                globalScope.indexedDB.deleteDatabase('keyval-store');
                            }
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_6 = _a.sent();
                            this.loggerProvider.warn("Failed to transition session replay events from keyval to new store: ".concat(e_6));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            e_7 = _a.sent();
                            this.loggerProvider.warn("Failed to access keyval store: ".concat(e_7, ". For more information, visit: https://www.docs.developers.amplitude.com/session-replay/sdks/standalone/#indexeddb-best-practices"));
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.apiKey = args.apiKey;
        _this.db = args.db;
        return _this;
    }
    SessionReplayEventsIDBStore.new = function(type, args, sessionId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var dbSuffix, dbName, db, eventsIDBStore, e_8;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        dbSuffix = type === 'replay' ? '' : "_".concat(type);
                        dbName = "".concat(args.apiKey.substring(0, 10), "_amp_session_replay_events").concat(dbSuffix);
                        return [
                            4 /*yield*/ ,
                            createStore(dbName)
                        ];
                    case 1:
                        db = _a.sent();
                        eventsIDBStore = new SessionReplayEventsIDBStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, args), {
                            db: db
                        }));
                        return [
                            4 /*yield*/ ,
                            eventsIDBStore.transitionFromKeyValStore(sessionId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            eventsIDBStore
                        ];
                    case 3:
                        e_8 = _a.sent();
                        args.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_8));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayEventsIDBStore.prototype.getCurrentSequenceEvents = function(sessionId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var events, allEvents, _a, _b, events, e_9_1;
            var e_9, _c;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!sessionId) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.db.get('sessionCurrentSequence', sessionId)
                        ];
                    case 1:
                        events = _d.sent();
                        if (!events) {
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        return [
                            2 /*return*/ ,
                            [
                                events
                            ]
                        ];
                    case 2:
                        allEvents = [];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            8,
                            9,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.db.getAll('sessionCurrentSequence')
                        ];
                    case 4:
                        _a = tslib_es6/* __values.apply */.XA.apply(void 0, [
                            _d.sent()
                        ]), _b = _a.next();
                        _d.label = 5;
                    case 5:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        events = _b.value;
                        allEvents.push(events);
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_9_1 = _d.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            allEvents
                        ];
                }
            });
        });
    };
    return SessionReplayEventsIDBStore;
}(BaseEventsStore);
 //# sourceMappingURL=events-idb-store.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/events-memory-store.js


var InMemoryEventsStore = /** @class */ function(_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryEventsStore, _super);
    function InMemoryEventsStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.finalizedSequences = {};
        _this.sequences = {};
        _this.sequenceId = 0;
        return _this;
    }
    InMemoryEventsStore.prototype.resetCurrentSequence = function(sessionId) {
        this.sequences[sessionId] = [];
    };
    InMemoryEventsStore.prototype.addSequence = function(sessionId) {
        var sequenceId = this.sequenceId++;
        var events = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(this.sequences[sessionId]), false);
        this.finalizedSequences[sequenceId] = {
            sessionId: sessionId,
            events: events
        };
        this.resetCurrentSequence(sessionId);
        return {
            sequenceId: sequenceId,
            events: events,
            sessionId: sessionId
        };
    };
    InMemoryEventsStore.prototype.getSequencesToSend = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Object.entries(this.finalizedSequences).map(function(_a) {
                        var _b = (0,tslib_es6/* __read */.CR)(_a, 2), sequenceId = _b[0], _c = _b[1], sessionId = _c.sessionId, events = _c.events;
                        return {
                            sequenceId: Number(sequenceId),
                            sessionId: sessionId,
                            events: events
                        };
                    })
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.storeCurrentSequence = function(sessionId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (!this.sequences[sessionId]) {
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                }
                return [
                    2 /*return*/ ,
                    this.addSequence(sessionId)
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.addEventToCurrentSequence = function(sessionId, event) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var sequenceReturn;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (!this.sequences[sessionId]) {
                    this.resetCurrentSequence(sessionId);
                }
                if (this.shouldSplitEventsList(this.sequences[sessionId], event)) {
                    sequenceReturn = this.addSequence(sessionId);
                }
                this.sequences[sessionId].push(event);
                return [
                    2 /*return*/ ,
                    sequenceReturn
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.storeSendingEvents = function(sessionId, events) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                this.finalizedSequences[this.sequenceId] = {
                    sessionId: sessionId,
                    events: events
                };
                return [
                    2 /*return*/ ,
                    this.sequenceId++
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.cleanUpSessionEventsStore = function(_sessionId, sequenceId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                if (sequenceId !== undefined) {
                    delete this.finalizedSequences[sequenceId];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return InMemoryEventsStore;
}(BaseEventsStore);
 //# sourceMappingURL=events-memory-store.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/events-manager.js





var createEventsManager = function(_a) {
    var config = _a.config, sessionId = _a.sessionId, minInterval = _a.minInterval, maxInterval = _a.maxInterval, type = _a.type, payloadBatcher = _a.payloadBatcher, storeType = _a.storeType;
    return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
        function flush(useRetry) {
            if (useRetry === void 0) {
                useRetry = false;
            }
            return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        trackDestination.flush(useRetry)
                    ];
                });
            });
        }
        var trackDestination, getMemoryStore, getIdbStoreOrFallback, store, _b, sendEventsList, sendCurrentSequenceEvents, sendStoredEvents, addEvent;
        return (0,tslib_es6/* __generator */.Jh)(this, function(_c) {
            switch(_c.label){
                case 0:
                    trackDestination = new SessionReplayTrackDestination({
                        loggerProvider: config.loggerProvider,
                        payloadBatcher: payloadBatcher
                    });
                    getMemoryStore = function() {
                        return new InMemoryEventsStore({
                            loggerProvider: config.loggerProvider,
                            maxInterval: maxInterval,
                            minInterval: minInterval
                        });
                    };
                    getIdbStoreOrFallback = function() {
                        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                            var store;
                            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            SessionReplayEventsIDBStore["new"](type, {
                                                loggerProvider: config.loggerProvider,
                                                minInterval: minInterval,
                                                maxInterval: maxInterval,
                                                apiKey: config.apiKey
                                            }, sessionId)
                                        ];
                                    case 1:
                                        store = _a.sent();
                                        config.loggerProvider.log('Failed to initialize idb store, falling back to memory store.');
                                        return [
                                            2 /*return*/ ,
                                            store !== null && store !== void 0 ? store : getMemoryStore()
                                        ];
                                }
                            });
                        });
                    };
                    if (!(storeType === 'idb')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        getIdbStoreOrFallback()
                    ];
                case 1:
                    _b = _c.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    _b = getMemoryStore();
                    _c.label = 3;
                case 3:
                    store = _b;
                    sendEventsList = function(_a) {
                        var events = _a.events, sessionId = _a.sessionId, deviceId = _a.deviceId, sequenceId = _a.sequenceId;
                        if (config.debugMode) {
                            getStorageSize().then(function(_a) {
                                var totalStorageSize = _a.totalStorageSize, percentOfQuota = _a.percentOfQuota, usageDetails = _a.usageDetails;
                                config.loggerProvider.debug("Total storage size: ".concat(totalStorageSize, " KB, percentage of quota: ").concat(percentOfQuota, "%, usage details: ").concat(usageDetails));
                            }).catch(function() {
                            // swallow error
                            });
                        }
                        trackDestination.sendEventsList({
                            events: events,
                            sessionId: sessionId,
                            flushMaxRetries: config.flushMaxRetries,
                            apiKey: config.apiKey,
                            deviceId: deviceId,
                            sampleRate: config.sampleRate,
                            serverZone: config.serverZone,
                            version: config.version,
                            type: type,
                            onComplete: function() {
                                return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                                    return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    store.cleanUpSessionEventsStore(sessionId, sequenceId)
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }
                        });
                    };
                    sendCurrentSequenceEvents = function(_a) {
                        var sessionId = _a.sessionId, deviceId = _a.deviceId;
                        store.storeCurrentSequence(sessionId).then(function(currentSequence) {
                            if (currentSequence) {
                                sendEventsList({
                                    sequenceId: currentSequence.sequenceId,
                                    events: currentSequence.events,
                                    sessionId: currentSequence.sessionId,
                                    deviceId: deviceId
                                });
                            }
                        }).catch(function(e) {
                            config.loggerProvider.warn('Failed to get current sequence of session replay events for session:', e);
                        });
                    };
                    sendStoredEvents = function(_a) {
                        var deviceId = _a.deviceId;
                        return (0,tslib_es6/* __awaiter */.mG)(void 0, void 0, void 0, function() {
                            var sequencesToSend;
                            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            store.getSequencesToSend()
                                        ];
                                    case 1:
                                        sequencesToSend = _b.sent();
                                        sequencesToSend && sequencesToSend.forEach(function(sequence) {
                                            sendEventsList({
                                                sequenceId: sequence.sequenceId,
                                                events: sequence.events,
                                                sessionId: sequence.sessionId,
                                                deviceId: deviceId
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    addEvent = function(_a) {
                        var event = _a.event, sessionId = _a.sessionId, deviceId = _a.deviceId;
                        store.addEventToCurrentSequence(sessionId, event.data).then(function(sequenceToSend) {
                            return sequenceToSend && sendEventsList({
                                sequenceId: sequenceToSend.sequenceId,
                                events: sequenceToSend.events,
                                sessionId: sequenceToSend.sessionId,
                                deviceId: deviceId
                            });
                        }).catch(function(e) {
                            config.loggerProvider.warn('Failed to add event to session replay capture:', e);
                        });
                    };
                    return [
                        2 /*return*/ ,
                        {
                            sendCurrentSequenceEvents: sendCurrentSequenceEvents,
                            addEvent: addEvent,
                            sendStoredEvents: sendStoredEvents,
                            flush: flush
                        }
                    ];
            }
        });
    });
}; //# sourceMappingURL=events-manager.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/multi-manager.js

/**
 * "Registers" events managers internally. When an event is added this class routes the event to the correct
 * manager. For all send or flush methods this will invoke the event for all registered managers.
 */ var MultiEventManager = /** @class */ function() {
    function MultiEventManager() {
        var managers = [];
        for(var _i = 0; _i < arguments.length; _i++){
            managers[_i] = arguments[_i];
        }
        var managersMap = new Map();
        managers.forEach(function(t) {
            managersMap.set(t.name, t.manager);
        });
        this.managers = managersMap;
    }
    MultiEventManager.prototype.sendStoredEvents = function(opts) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var promises;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        promises = [];
                        this.managers.forEach(function(manager) {
                            promises.push(manager.sendStoredEvents(opts));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MultiEventManager.prototype.addEvent = function(_a) {
        var _b;
        var sessionId = _a.sessionId, event = _a.event, deviceId = _a.deviceId;
        (_b = this.managers.get(event.type)) === null || _b === void 0 ? void 0 : _b.addEvent({
            sessionId: sessionId,
            event: event,
            deviceId: deviceId
        });
    };
    MultiEventManager.prototype.sendCurrentSequenceEvents = function(_a) {
        var sessionId = _a.sessionId, deviceId = _a.deviceId;
        this.managers.forEach(function(manager) {
            manager.sendCurrentSequenceEvents({
                sessionId: sessionId,
                deviceId: deviceId
            });
        });
    };
    MultiEventManager.prototype.flush = function(useRetry) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var promises;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        promises = [];
                        this.managers.forEach(function(manager) {
                            promises.push(manager.flush(useRetry));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return MultiEventManager;
}();
 //# sourceMappingURL=multi-manager.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-types@2.0.0-alpha.26/node_modules/@amplitude/rrweb-types/dist/rrweb-types.js
var rrweb_types_EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})(rrweb_types_EventType || {});
var rrweb_types_IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})(rrweb_types_IncrementalSource || {});
var rrweb_types_MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})(rrweb_types_MouseInteractions || {});
var rrweb_types_PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})(rrweb_types_PointerTypes || {});
var rrweb_types_CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})(rrweb_types_CanvasContext || {});
var rrweb_types_MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})(rrweb_types_MediaInteractions || {});
var rrweb_types_ReplayerEvents = /* @__PURE__ */ ((ReplayerEvents2)=>{
    ReplayerEvents2["Start"] = "start";
    ReplayerEvents2["Pause"] = "pause";
    ReplayerEvents2["Resume"] = "resume";
    ReplayerEvents2["Resize"] = "resize";
    ReplayerEvents2["Finish"] = "finish";
    ReplayerEvents2["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents2["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents2["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents2["SkipStart"] = "skip-start";
    ReplayerEvents2["SkipEnd"] = "skip-end";
    ReplayerEvents2["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents2["EventCast"] = "event-cast";
    ReplayerEvents2["CustomEvent"] = "custom-event";
    ReplayerEvents2["Flush"] = "flush";
    ReplayerEvents2["StateChange"] = "state-change";
    ReplayerEvents2["PlayBack"] = "play-back";
    ReplayerEvents2["Destroy"] = "destroy";
    return ReplayerEvents2;
})(rrweb_types_ReplayerEvents || {});
 //# sourceMappingURL=rrweb-types.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/libs/finder.js
/* istanbul ignore file */ 
var finder_config;
var rootDocument;
var start;
function finder(input, options) {
    start = new Date();
    if (input.nodeType !== Node.ELEMENT_NODE) {
        throw new Error("Can't generate CSS selector for non-element node type.");
    }
    if ('html' === input.tagName.toLowerCase()) {
        return 'html';
    }
    var defaults = {
        root: document.body,
        idName: function(_name) {
            return true;
        },
        className: function(_name) {
            return true;
        },
        tagName: function(_name) {
            return true;
        },
        attr: function(_name, _value) {
            return false;
        },
        seedMinLength: 1,
        optimizedMinLength: 2,
        threshold: 1000,
        maxNumberOfTries: 10000,
        timeoutMs: undefined
    };
    finder_config = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaults), options);
    rootDocument = findRootDocument(finder_config.root, defaults);
    var path = bottomUpSearch(input, 'all', function() {
        return bottomUpSearch(input, 'two', function() {
            return bottomUpSearch(input, 'one', function() {
                return bottomUpSearch(input, 'none');
            });
        });
    });
    if (path) {
        var optimized = sort(optimize(path, input));
        if (optimized.length > 0) {
            path = optimized[0];
        }
        return selector(path);
    } else {
        throw new Error("Selector was not found.");
    }
}
function findRootDocument(rootNode, defaults) {
    if (rootNode.nodeType === Node.DOCUMENT_NODE) {
        return rootNode;
    }
    if (rootNode === defaults.root) {
        return rootNode.ownerDocument;
    }
    return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
    var path = null;
    var stack = [];
    var current = input;
    var i = 0;
    var _loop_1 = function() {
        var e_1, _a;
        var elapsedTime = new Date().getTime() - start.getTime();
        if (finder_config.timeoutMs !== undefined && elapsedTime > finder_config.timeoutMs) {
            throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
        }
        var level = maybe(id(current)) || maybe.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(attr(current)), false)) || maybe.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(classNames(current)), false)) || maybe(tagName(current)) || [
            any()
        ];
        var nth = finder_index(current);
        if (limit == 'all') {
            if (nth) {
                level = level.concat(level.filter(dispensableNth).map(function(node) {
                    return nthChild(node, nth);
                }));
            }
        } else if (limit == 'two') {
            level = level.slice(0, 1);
            if (nth) {
                level = level.concat(level.filter(dispensableNth).map(function(node) {
                    return nthChild(node, nth);
                }));
            }
        } else if (limit == 'one') {
            var _b = (0,tslib_es6/* __read */.CR)(level = level.slice(0, 1), 1), node = _b[0];
            if (nth && dispensableNth(node)) {
                level = [
                    nthChild(node, nth)
                ];
            }
        } else if (limit == 'none') {
            level = [
                any()
            ];
            if (nth) {
                level = [
                    nthChild(level[0], nth)
                ];
            }
        }
        try {
            for(var level_1 = (e_1 = void 0, (0,tslib_es6/* __values */.XA)(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()){
                var node = level_1_1.value;
                node.level = i;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        stack.push(level);
        if (stack.length >= finder_config.seedMinLength) {
            path = findUniquePath(stack, fallback);
            if (path) {
                return "break";
            }
        }
        current = current.parentElement;
        i++;
    };
    while(current){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    if (!path) {
        path = findUniquePath(stack, fallback);
    }
    if (!path && fallback) {
        return fallback();
    }
    return path;
}
function findUniquePath(stack, fallback) {
    var e_2, _a;
    var paths = sort(combinations(stack));
    if (paths.length > finder_config.threshold) {
        return fallback ? fallback() : null;
    }
    try {
        for(var paths_1 = (0,tslib_es6/* __values */.XA)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var candidate = paths_1_1.value;
            if (unique(candidate)) {
                return candidate;
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return null;
}
function selector(path) {
    var node = path[0];
    var query = node.name;
    for(var i = 1; i < path.length; i++){
        var level = path[i].level || 0;
        if (node.level === level - 1) {
            query = "".concat(path[i].name, " > ").concat(query);
        } else {
            query = "".concat(path[i].name, " ").concat(query);
        }
        node = path[i];
    }
    return query;
}
function penalty(path) {
    return path.map(function(node) {
        return node.penalty;
    }).reduce(function(acc, i) {
        return acc + i;
    }, 0);
}
function unique(path) {
    var css = selector(path);
    switch(rootDocument.querySelectorAll(css).length){
        case 0:
            throw new Error("Can't select any node with this selector: ".concat(css));
        case 1:
            return true;
        default:
            return false;
    }
}
function id(input) {
    var elementId = input.getAttribute('id');
    if (elementId && finder_config.idName(elementId)) {
        return {
            name: '#' + CSS.escape(elementId),
            penalty: 0
        };
    }
    return null;
}
function attr(input) {
    var attrs = Array.from(input.attributes).filter(function(attr) {
        return finder_config.attr(attr.name, attr.value);
    });
    return attrs.map(function(attr) {
        return {
            name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
            penalty: 0.5
        };
    });
}
function classNames(input) {
    var names = Array.from(input.classList).filter(finder_config.className);
    return names.map(function(name) {
        return {
            name: '.' + CSS.escape(name),
            penalty: 1
        };
    });
}
function tagName(input) {
    var name = input.tagName.toLowerCase();
    if (finder_config.tagName(name)) {
        return {
            name: name,
            penalty: 2
        };
    }
    return null;
}
function any() {
    return {
        name: '*',
        penalty: 3
    };
}
function finder_index(input) {
    var parent = input.parentNode;
    if (!parent) {
        return null;
    }
    var child = parent.firstChild;
    if (!child) {
        return null;
    }
    var i = 0;
    while(child){
        if (child.nodeType === Node.ELEMENT_NODE) {
            i++;
        }
        if (child === input) {
            break;
        }
        child = child.nextSibling;
    }
    return i;
}
function nthChild(node, i) {
    return {
        name: node.name + ":nth-child(".concat(i, ")"),
        penalty: node.penalty + 1
    };
}
function dispensableNth(node) {
    return node.name !== 'html' && !node.name.startsWith('#');
}
function maybe() {
    var level = [];
    for(var _i = 0; _i < arguments.length; _i++){
        level[_i] = arguments[_i];
    }
    var list = level.filter(notEmpty);
    if (list.length > 0) {
        return list;
    }
    return null;
}
function notEmpty(value) {
    return value !== null && value !== undefined;
}
function combinations(stack, path) {
    var _a, _b, node, e_3_1;
    var e_3, _c;
    if (path === void 0) {
        path = [];
    }
    return (0,tslib_es6/* __generator */.Jh)(this, function(_d) {
        switch(_d.label){
            case 0:
                if (!(stack.length > 0)) return [
                    3 /*break*/ ,
                    9
                ];
                _d.label = 1;
            case 1:
                _d.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _a = (0,tslib_es6/* __values */.XA)(stack[0]), _b = _a.next();
                _d.label = 2;
            case 2:
                if (!!_b.done) return [
                    3 /*break*/ ,
                    5
                ];
                node = _b.value;
                return [
                    5 /*yield**/ ,
                    (0,tslib_es6/* __values */.XA)(combinations(stack.slice(1, stack.length), path.concat(node)))
                ];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4:
                _b = _a.next();
                return [
                    3 /*break*/ ,
                    2
                ];
            case 5:
                return [
                    3 /*break*/ ,
                    8
                ];
            case 6:
                e_3_1 = _d.sent();
                e_3 = {
                    error: e_3_1
                };
                return [
                    3 /*break*/ ,
                    8
                ];
            case 7:
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                } finally{
                    if (e_3) throw e_3.error;
                }
                return [
                    7 /*endfinally*/ 
                ];
            case 8:
                return [
                    3 /*break*/ ,
                    11
                ];
            case 9:
                return [
                    4 /*yield*/ ,
                    path
                ];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function sort(paths) {
    return (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(paths), false).sort(function(a, b) {
        return penalty(a) - penalty(b);
    });
}
function optimize(path, input, scope) {
    var i, newPath, newPathKey;
    if (scope === void 0) {
        scope = {
            counter: 0,
            visited: new Map()
        };
    }
    return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
        switch(_a.label){
            case 0:
                if (!(path.length > 2 && path.length > finder_config.optimizedMinLength)) return [
                    3 /*break*/ ,
                    5
                ];
                i = 1;
                _a.label = 1;
            case 1:
                if (!(i < path.length - 1)) return [
                    3 /*break*/ ,
                    5
                ];
                if (scope.counter > finder_config.maxNumberOfTries) {
                    return [
                        2 /*return*/ 
                    ]; // Okay At least I tried!
                }
                scope.counter += 1;
                newPath = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(path), false);
                newPath.splice(i, 1);
                newPathKey = selector(newPath);
                if (scope.visited.has(newPathKey)) {
                    return [
                        2 /*return*/ 
                    ];
                }
                if (!(unique(newPath) && same(newPath, input))) return [
                    3 /*break*/ ,
                    4
                ];
                return [
                    4 /*yield*/ ,
                    newPath
                ];
            case 2:
                _a.sent();
                scope.visited.set(newPathKey, true);
                return [
                    5 /*yield**/ ,
                    (0,tslib_es6/* __values */.XA)(optimize(newPath, input, scope))
                ];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [
                    3 /*break*/ ,
                    1
                ];
            case 5:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function same(path, input) {
    return rootDocument.querySelector(selector(path)) === input;
} //# sourceMappingURL=finder.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/hooks/click.js





var HOUR_IN_MILLISECONDS = 3600000;
var clickNonBatcher = function(_a) {
    var version = _a.version, events = _a.events;
    var clickEvents = [];
    events.forEach(function(evt) {
        var record = JSON.parse(evt);
        record.count = 1;
        if (record.type === 'click') {
            clickEvents.push(record);
        }
    });
    return {
        version: version,
        events: clickEvents
    };
};
var clickBatcher = function(_a) {
    var version = _a.version, events = _a.events;
    var clickEvents = [];
    events.forEach(function(evt) {
        var record = JSON.parse(evt);
        if (record.type === 'click') {
            clickEvents.push(record);
        }
    });
    var reduced = clickEvents.reduce(function(prev, curr) {
        var x = curr.x, y = curr.y, selector = curr.selector, timestamp = curr.timestamp;
        // round down to nearest hour.
        var hour = timestamp - timestamp % HOUR_IN_MILLISECONDS;
        var k = "".concat(x, ":").concat(y, ":").concat(selector !== null && selector !== void 0 ? selector : '', ":").concat(hour);
        if (!prev[k]) {
            prev[k] = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, curr), {
                timestamp: hour,
                count: 1
            });
        } else {
            prev[k].count += 1;
        }
        return prev;
    }, {});
    return {
        version: version,
        events: Object.values(reduced)
    };
};
var clickHook = function(_a) {
    var eventsManager = _a.eventsManager, sessionId = _a.sessionId, deviceIdFn = _a.deviceIdFn;
    return function(e) {
        if (e.type !== rrweb_types_MouseInteractions.Click) {
            return;
        }
        var globalScope = (0,global_scope/* getGlobalScope */.l)();
        if (!globalScope) {
            return;
        }
        var location = globalScope.location, innerHeight = globalScope.innerHeight, innerWidth = globalScope.innerWidth;
        // it only makes sense to send events if a pageUrl exists
        if (!location) {
            return;
        }
        var x = e.x, y = e.y;
        if (x === undefined || y === undefined) {
            return;
        }
        var node = record.mirror.getNode(e.id);
        var selector;
        if (node) {
            selector = finder(node);
        }
        var _a = utils.getWindowScroll(globalScope), scrollX = _a.left, scrollY = _a.top;
        var event = {
            x: x + scrollX,
            y: y + scrollY,
            selector: selector,
            viewportHeight: innerHeight,
            viewportWidth: innerWidth,
            pageUrl: location.href,
            timestamp: Date.now(),
            type: 'click'
        };
        var deviceId = deviceIdFn();
        if (deviceId) {
            eventsManager.addEvent({
                sessionId: sessionId,
                event: {
                    type: 'interaction',
                    data: JSON.stringify(event)
                },
                deviceId: deviceId
            });
        }
    };
}; //# sourceMappingURL=click.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/beacon-transport.js


/**
 * For very small payloads it's preferable to use the [Beacon API](https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API).
 * While it doesn't provide 100% guarantees on sends, it greatly helps with overall reliability and page load performance. As
 * the Beacon API has a potential to fail due to size constraints we want to fall back to XHR if need be. This is mostly to
 * be used with 'pagehide' or 'beforeunload' events.
 *
 * Note there are only 3 CORS safelisted Content-Types you can send:
 *
 * - application/x-www-form-urlencoded
 * - multipart/form-data
 * - text/plain
 *
 * If we do not send one of these, some browsers like Chrome may not send this at all. Also we incur the overhead of a preflight
 * request. In our case we will add no additional content-type header. If you are trying to ping a server that requires this
 * header, you may want to use the regular fetch API or a different mechanism.
 */ var BeaconTransport = /** @class */ function() {
    function BeaconTransport(context, config) {
        var globalScope = (0,global_scope/* getGlobalScope */.l)();
        if (globalScope && globalScope.navigator && typeof globalScope.navigator.sendBeacon === 'function') {
            this.sendBeacon = function(pageUrl, payload) {
                try {
                    if (globalScope.navigator.sendBeacon(pageUrl, JSON.stringify(payload))) {
                        return true;
                    }
                } catch (e) {
                // not logging error, since it would be hard to view and just adds overhead.
                }
                return false;
            };
        } else {
            this.sendBeacon = function() {
                return false;
            };
        }
        this.sendXhr = function(pageUrl, payload) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', pageUrl, true);
            xhr.setRequestHeader('Accept', '*/*');
            xhr.send(JSON.stringify(payload));
            return true;
        };
        this.basePageUrl = getServerUrl(config.serverZone);
        this.apiKey = config.apiKey;
        this.context = context;
    }
    BeaconTransport.prototype.send = function(deviceId, payload) {
        var _a = this.context, sessionId = _a.sessionId, type = _a.type;
        var urlParams = new URLSearchParams({
            device_id: deviceId,
            session_id: String(sessionId),
            type: String(type),
            api_key: this.apiKey
        });
        var pageUrl = "".concat(this.basePageUrl, "?").concat(urlParams.toString());
        // ideally send using the beacon API, but there is a chance it may fail, possibly due to a payload
        // size limit. in this case, try best effort to send using xhr.
        this.sendBeacon(pageUrl, payload) || this.sendXhr(pageUrl, payload);
    };
    return BeaconTransport;
}();
 //# sourceMappingURL=beacon-transport.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/hooks/scroll.js



var scroll_getWindowHeight = utils.getWindowHeight, scroll_getWindowWidth = utils.getWindowWidth;
/**
 * This is intended to watch and update max scroll activity when loaded for a particular page.
 * A new instance should be created if the page URL changes, since by default it does not reset
 * it's max scroll state. It is intended to send very few and very small events utilizing the
 * Beacon API.
 * @see {@link BeaconTransport} for more details on Beacon API usage.
 */ var ScrollWatcher = /** @class */ function() {
    function ScrollWatcher(transport) {
        var _this = this;
        this.timestamp = Date.now();
        this.hook = function(e) {
            _this.update(e);
        };
        this.send = function(deviceIdFn) {
            return function(_) {
                var deviceId = deviceIdFn();
                var globalScope = (0,global_scope/* getGlobalScope */.l)();
                if (globalScope && deviceId) {
                    _this.transport.send(deviceId, {
                        version: 1,
                        events: [
                            {
                                maxScrollX: _this._maxScrollX,
                                maxScrollY: _this._maxScrollY,
                                maxScrollWidth: _this._maxScrollWidth,
                                maxScrollHeight: _this._maxScrollHeight,
                                viewportHeight: scroll_getWindowHeight(),
                                viewportWidth: scroll_getWindowWidth(),
                                pageUrl: globalScope.location.href,
                                timestamp: _this.timestamp,
                                type: 'scroll'
                            }
                        ]
                    });
                }
            };
        };
        this._maxScrollX = 0;
        this._maxScrollY = 0;
        this._maxScrollWidth = scroll_getWindowWidth();
        this._maxScrollHeight = scroll_getWindowHeight();
        this.transport = transport;
    }
    ScrollWatcher.default = function(context, config) {
        return new ScrollWatcher(new BeaconTransport(context, config));
    };
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollX", {
        get: function() {
            return this._maxScrollX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollY", {
        get: function() {
            return this._maxScrollY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollWidth", {
        get: function() {
            return this._maxScrollWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollHeight", {
        get: function() {
            return this._maxScrollHeight;
        },
        enumerable: false,
        configurable: true
    });
    ScrollWatcher.prototype.update = function(e) {
        var now = Date.now();
        if (e.x > this._maxScrollX) {
            var width = scroll_getWindowWidth();
            this._maxScrollX = e.x;
            var maxScrollWidth = e.x + width;
            if (maxScrollWidth > this._maxScrollWidth) {
                this._maxScrollWidth = maxScrollWidth;
            }
            this.timestamp = now;
        }
        if (e.y > this._maxScrollY) {
            var height = scroll_getWindowHeight();
            this._maxScrollY = e.y;
            var maxScrollHeight = e.y + height;
            if (maxScrollHeight > this._maxScrollHeight) {
                this._maxScrollHeight = maxScrollHeight;
            }
            this.timestamp = now;
        }
    };
    return ScrollWatcher;
}();
 //# sourceMappingURL=scroll.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/identifiers.js

var SessionIdentifiers = /** @class */ function() {
    function SessionIdentifiers(_a) {
        var sessionId = _a.sessionId, deviceId = _a.deviceId;
        this.deviceId = deviceId;
        this.sessionId = sessionId;
        if (sessionId && deviceId) {
            this.sessionReplayId = generateSessionReplayId(sessionId, deviceId);
        }
    }
    return SessionIdentifiers;
}();
 //# sourceMappingURL=identifiers.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-packer@2.0.0-alpha.26/node_modules/@amplitude/rrweb-packer/dist/base-BrE4jft0.js
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i){
        b[i] = start += 1 << eb[i - 1];
    }
    var r = new u32(b[30]);
    for(var i = 1; i < 30; ++i){
        for(var j = b[i]; j < b[i + 1]; ++j){
            r[j] = j - b[i] << 5 | i;
        }
    }
    return [
        b,
        r
    ];
};
var base_BrE4jft0_a = freb(fleb, 2), fl = base_BrE4jft0_a[0], revfl = base_BrE4jft0_a[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
var rev = new u16(32768);
for(var base_BrE4jft0_i = 0; base_BrE4jft0_i < 32768; ++base_BrE4jft0_i){
    var base_BrE4jft0_x = (base_BrE4jft0_i & 43690) >>> 1 | (base_BrE4jft0_i & 21845) << 1;
    base_BrE4jft0_x = (base_BrE4jft0_x & 52428) >>> 2 | (base_BrE4jft0_x & 13107) << 2;
    base_BrE4jft0_x = (base_BrE4jft0_x & 61680) >>> 4 | (base_BrE4jft0_x & 3855) << 4;
    rev[base_BrE4jft0_i] = ((base_BrE4jft0_x & 65280) >>> 8 | (base_BrE4jft0_x & 255) << 8) >>> 1;
}
var hMap = function(cd, mb, r) {
    var s = cd.length;
    var i = 0;
    var l = new u16(mb);
    for(; i < s; ++i)++l[cd[i] - 1];
    var le = new u16(mb);
    for(i = 0; i < mb; ++i){
        le[i] = le[i - 1] + l[i - 1] << 1;
    }
    var co;
    if (r) {
        co = new u16(1 << mb);
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i){
            if (cd[i]) {
                var sv = i << 4 | cd[i];
                var r_1 = mb - cd[i];
                var v = le[cd[i] - 1]++ << r_1;
                for(var m = v | (1 << r_1) - 1; v <= m; ++v){
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
var flt = new u8(288);
for(var base_BrE4jft0_i = 0; base_BrE4jft0_i < 144; ++base_BrE4jft0_i)flt[base_BrE4jft0_i] = 8;
for(var base_BrE4jft0_i = 144; base_BrE4jft0_i < 256; ++base_BrE4jft0_i)flt[base_BrE4jft0_i] = 9;
for(var base_BrE4jft0_i = 256; base_BrE4jft0_i < 280; ++base_BrE4jft0_i)flt[base_BrE4jft0_i] = 7;
for(var base_BrE4jft0_i = 280; base_BrE4jft0_i < 288; ++base_BrE4jft0_i)flt[base_BrE4jft0_i] = 8;
var fdt = new u8(32);
for(var base_BrE4jft0_i = 0; base_BrE4jft0_i < 32; ++base_BrE4jft0_i)fdt[base_BrE4jft0_i] = 5;
var flm = /* @__PURE__ */ hMap(flt, 9, 0), flrm = /* @__PURE__ */ (/* unused pure expression or super */ null && (hMap(flt, 9, 1)));
var fdm = /* @__PURE__ */ hMap(fdt, 5, 0), fdrm = /* @__PURE__ */ (/* unused pure expression or super */ null && (hMap(fdt, 5, 1)));
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i){
        if (a[i] > m) m = a[i];
    }
    return m;
};
var bits = function(d, p, m) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
};
var bits16 = function(d, p) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
};
var shft = function(p) {
    return (p / 8 >> 0) + (p & 7 && 1);
};
var slc = function(v, s, e) {
    if (e == null || e > v.length) e = v.length;
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var inflt = function(dat, buf, st) {
    var sl = dat.length;
    var noBuf = !buf || st;
    var noSt = !st || st.i;
    if (!st) st = {};
    if (!buf) buf = new u8(sl * 3);
    var cbuf = function(l2) {
        var bl = buf.length;
        if (l2 > bl) {
            var nbuf = new u8(Math.max(bl * 2, l2));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    var tbts = sl * 8;
    do {
        if (!lm) {
            st.f = final = bits(dat, pos, 1);
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                }
                if (noBuf) cbuf(bt + l);
                buf.set(dat.subarray(s, t), bt);
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                var ldt = new u8(tl);
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i){
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    pos += r & 15;
                    var s = r >>> 4;
                    if (s < 16) {
                        ldt[i++] = s;
                    } else {
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                lbt = max(lt);
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        }
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            } else {
                var add = sym - 254;
                if (sym > 264) {
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final)
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
var hTree = function(d, mb) {
    var t = [];
    for(var i = 0; i < d.length; ++i){
        if (d[i]) t.push({
            s: i,
            f: d[i]
        });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        new u8(0),
        0
    ];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l,
        r
    };
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l,
            r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i){
        if (t2[i].s > maxSym) maxSym = t2[i].s;
    }
    var tr = new u16(maxSym + 1);
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        var i = 0, dt = 0;
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new u8(tr),
        mbt
    ];
};
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
var lc = function(c) {
    var s = c.length;
    while(s && !c[--s]);
    var cl = new u16(++s);
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i){
        if (c[i] == cln && i != s) ++cls;
        else {
            if (!cln && cls > 2) {
                for(; cls > 138; cls -= 138)w(32754);
                if (cls > 2) {
                    w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                    cls = 0;
                }
            } else if (cls > 3) {
                w(cln), --cls;
                for(; cls > 6; cls -= 6)w(8304);
                if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
            }
            while(cls--)w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
var wfblk = function(out, pos, dat) {
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a2 = hTree(lf, 15), dlt = _a2[0], mlb = _a2[1];
    var _b2 = hTree(df, 15), ddt = _b2[0], mdb = _b2[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for(var i = 0; i < li; ++i){
        if (syms[i] > 255) {
            var len = syms[i] >>> 18 & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
        } else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
var deo = /* @__PURE__ */ new u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
var dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7e3)) + post);
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for(var i = 0; i <= s; i += 65535){
            var e = i + 65535;
            if (e < s) {
                pos = wfblk(w, pos, dat.subarray(i, e));
            } else {
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    } else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i2) {
            return (dat[i2] ^ dat[i2 + 1] << bs1_1 ^ dat[i2 + 2] << bs2_1) & msk_1;
        };
        var syms = new u32(25e3);
        var lf = new u16(288), df = new u16(32);
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            var hv = hsh(i);
            var imod = i & 32767;
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            if (wi <= i) {
                var rem = s - i;
                if ((lc_1 > 7e3 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                if (nl > maxn) break;
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                if (d) {
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 5552, l);
                for(; i < e; ++i)n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function() {
            return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
        }
    };
};
var dopt = function(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
var zlh = function(c, o) {
    var lv = o.level, fl2 = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl2 << 6 | (fl2 ? 32 - 2 * fl2 : 1);
};
var zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function zlibSync(data, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
function base_BrE4jft0_unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
function base_BrE4jft0_strToU8(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != "undefined") return new TextEncoder().encode(str);
    var ar = new u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1023 << 10) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);
        else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function base_BrE4jft0_strFromU8(dat, latin1) {
    var r = "";
    if (!latin1 && typeof TextDecoder != "undefined") return new TextDecoder().decode(dat);
    for(var i = 0; i < dat.length;){
        var c = dat[i++];
        if (c < 128 || latin1) r += String.fromCharCode(c);
        else if (c < 224) r += String.fromCharCode((c & 31) << 6 | dat[i++] & 63);
        else if (c < 240) r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63);
        else c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
    }
    return r;
}
const base_BrE4jft0_MARK = "v1";
 //# sourceMappingURL=base-BrE4jft0.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-packer@2.0.0-alpha.26/node_modules/@amplitude/rrweb-packer/dist/pack.js
function pack_extends() {
    pack_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return pack_extends.apply(this, arguments);
}

const pack = (event)=>{
    const _e = pack_extends({}, event, {
        v: base_BrE4jft0_MARK
    });
    return base_BrE4jft0_strFromU8(zlibSync(base_BrE4jft0_strToU8(JSON.stringify(_e))), true);
};
 //# sourceMappingURL=pack.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-packer@2.0.0-alpha.26/node_modules/@amplitude/rrweb-packer/dist/unpack.js

const unpack = (raw)=>{
    if (typeof raw !== "string") {
        return raw;
    }
    try {
        const e = JSON.parse(raw);
        if (e.timestamp) {
            return e;
        }
    } catch (error) {}
    try {
        const e = JSON.parse(strFromU8(unzlibSync(strToU8(raw, true))));
        if (e.v === MARK) {
            return e;
        }
        throw new Error(`These events were packed with packer ${e.v} which is incompatible with current packer ${MARK}.`);
    } catch (error) {
        console.error(error);
        throw new Error("Unknown data format.");
    }
};
 //# sourceMappingURL=unpack.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+rrweb-packer@2.0.0-alpha.26/node_modules/@amplitude/rrweb-packer/dist/packer.js


 //# sourceMappingURL=packer.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/events/event-compressor.js


var DEFAULT_TIMEOUT = 2000;
var EventCompressor = /** @class */ function() {
    function EventCompressor(eventsManager, config, deviceId) {
        var _this = this;
        var _a;
        this.taskQueue = [];
        this.isProcessing = false;
        this.compressEvent = function(event) {
            var packedEvent = pack(event);
            return JSON.stringify(packedEvent);
        };
        this.addCompressedEvent = function(event, sessionId) {
            var compressedEvent = _this.compressEvent(event);
            if (_this.eventsManager && _this.deviceId) {
                _this.eventsManager.addEvent({
                    event: {
                        type: 'replay',
                        data: compressedEvent
                    },
                    sessionId: sessionId,
                    deviceId: _this.deviceId
                });
            }
        };
        var globalScope = (0,global_scope/* getGlobalScope */.l)();
        this.canUseIdleCallback = globalScope && 'requestIdleCallback' in globalScope;
        this.eventsManager = eventsManager;
        this.config = config;
        this.deviceId = deviceId;
        this.timeout = ((_a = config.performanceConfig) === null || _a === void 0 ? void 0 : _a.timeout) || DEFAULT_TIMEOUT;
    }
    // Schedule processing during idle time
    EventCompressor.prototype.scheduleIdleProcessing = function() {
        var _this = this;
        if (!this.isProcessing) {
            this.isProcessing = true;
            requestIdleCallback(function(idleDeadline) {
                _this.processQueue(idleDeadline);
            }, {
                timeout: this.timeout
            });
        }
    };
    // Add an event to the task queue if idle callback is supported or compress the event directly
    EventCompressor.prototype.enqueueEvent = function(event, sessionId) {
        var _a;
        if (this.canUseIdleCallback && ((_a = this.config.performanceConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
            this.config.loggerProvider.debug('Enqueuing event for processing during idle time.');
            this.taskQueue.push({
                event: event,
                sessionId: sessionId
            });
            this.scheduleIdleProcessing();
        } else {
            this.config.loggerProvider.debug('Processing event without idle callback.');
            this.addCompressedEvent(event, sessionId);
        }
    };
    // Process the task queue during idle time
    EventCompressor.prototype.processQueue = function(idleDeadline) {
        var _this = this;
        // Process tasks while there's idle time or until the max number of tasks is reached
        while(this.taskQueue.length > 0 && (idleDeadline.timeRemaining() > 0 || idleDeadline.didTimeout)){
            var task = this.taskQueue.shift();
            if (task) {
                var event_1 = task.event, sessionId = task.sessionId;
                this.addCompressedEvent(event_1, sessionId);
            }
        }
        // If there are still tasks in the queue, schedule the next idle callback
        if (this.taskQueue.length > 0) {
            requestIdleCallback(function(idleDeadline) {
                _this.processQueue(idleDeadline);
            }, {
                timeout: this.timeout
            });
        } else {
            this.isProcessing = false;
        }
    };
    return EventCompressor;
}();
 //# sourceMappingURL=event-compressor.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/session-replay.js














var SessionReplay = /** @class */ function() {
    function SessionReplay() {
        var _this = this;
        this.name = '@amplitude/session-replay-browser';
        this.recordCancelCallback = null;
        this.eventCount = 0;
        // Visible for testing
        this.pageLeaveFns = [];
        this.teardownEventListeners = function(teardown) {
            var globalScope = (0,global_scope/* getGlobalScope */.l)();
            if (globalScope) {
                globalScope.removeEventListener('blur', _this.blurListener);
                globalScope.removeEventListener('focus', _this.focusListener);
                !teardown && globalScope.addEventListener('blur', _this.blurListener);
                !teardown && globalScope.addEventListener('focus', _this.focusListener);
                // prefer pagehide to unload events, this is the standard going forward. it is not
                // 100% reliable, but is bfcache-compatible.
                if (globalScope.self && 'onpagehide' in globalScope.self) {
                    globalScope.removeEventListener('pagehide', _this.pageLeaveListener);
                    !teardown && globalScope.addEventListener('pagehide', _this.pageLeaveListener);
                } else {
                    // this has performance implications, but is the only way we can reliably send events
                    // in browser that don't support pagehide.
                    globalScope.removeEventListener('beforeunload', _this.pageLeaveListener);
                    !teardown && globalScope.addEventListener('beforeunload', _this.pageLeaveListener);
                }
            }
        };
        this.blurListener = function() {
            _this.sendEvents();
        };
        this.focusListener = function() {
            // Restart recording on focus to ensure that when user
            // switches tabs, we take a full snapshot
            _this.recordEvents();
        };
        /**
         * This is an instance member so that if init is called multiple times
         * it doesn't add another listener to the page leave event. This is to
         * prevent duplicate listener actions from firing.
         */ this.pageLeaveListener = function(e) {
            _this.pageLeaveFns.forEach(function(fn) {
                fn(e);
            });
        };
        this.addCustomRRWebEvent = function(eventName, eventData, addStorageInfo) {
            if (eventData === void 0) {
                eventData = {};
            }
            if (addStorageInfo === void 0) {
                addStorageInfo = true;
            }
            return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function() {
                var debugInfo, config, storageSizeData, e_1;
                return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            debugInfo = undefined;
                            config = this.config;
                            if (!config) return [
                                3 /*break*/ ,
                                2
                            ];
                            debugInfo = {
                                config: getDebugConfig(config),
                                version: VERSION
                            };
                            if (!addStorageInfo) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                getStorageSize()
                            ];
                        case 1:
                            storageSizeData = _a.sent();
                            debugInfo = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, storageSizeData), debugInfo);
                            _a.label = 2;
                        case 2:
                            // Check first to ensure we are recording
                            if (this.recordCancelCallback) {
                                record.addCustomEvent(eventName, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, eventData), debugInfo));
                            } else {
                                this.loggerProvider.debug("Not able to add custom replay capture event ".concat(eventName, " due to no ongoing recording."));
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _a.sent();
                            this.loggerProvider.debug('Error while adding custom replay capture event: ', e_1);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.stopRecordingEvents = function() {
            try {
                _this.loggerProvider.log('Session Replay capture stopping.');
                _this.recordCancelCallback && _this.recordCancelCallback();
                _this.recordCancelCallback = null;
            } catch (error) {
                var typedError = error;
                _this.loggerProvider.warn("Error occurred while stopping replay capture: ".concat(typedError.toString()));
            }
        };
        this.loggerProvider = new logger/* Logger */.Y();
    }
    SessionReplay.prototype.init = function(apiKey, options) {
        return (0,return_wrapper/* returnWrapper */.S)(this._init(apiKey, options));
    };
    SessionReplay.prototype._init = function(apiKey, options) {
        var _a, _b, _c, _d;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var _e, _f, scrollWatcher, managers, storeType, rrwebEventManager, error_1, typedError, payloadBatcher, interactionEventManager, error_2, typedError;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        this.loggerProvider = options.loggerProvider || new logger/* Logger */.Y();
                        Object.prototype.hasOwnProperty.call(options, 'logLevel') && this.loggerProvider.enable(options.logLevel);
                        this.identifiers = new SessionIdentifiers({
                            sessionId: options.sessionId,
                            deviceId: options.deviceId
                        });
                        _e = this;
                        return [
                            4 /*yield*/ ,
                            createSessionReplayJoinedConfigGenerator(apiKey, options)
                        ];
                    case 1:
                        _e.joinedConfigGenerator = _g.sent();
                        _f = this;
                        return [
                            4 /*yield*/ ,
                            this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)
                        ];
                    case 2:
                        _f.config = _g.sent();
                        if (options.sessionId && ((_a = this.config.interactionConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
                            scrollWatcher = ScrollWatcher["default"]({
                                sessionId: options.sessionId,
                                type: 'interaction'
                            }, this.config);
                            this.pageLeaveFns = [
                                scrollWatcher.send(this.getDeviceId.bind(this)).bind(scrollWatcher)
                            ];
                            this.scrollHook = scrollWatcher.hook.bind(scrollWatcher);
                        }
                        managers = [];
                        storeType = this.config.storeType;
                        if (storeType === 'idb' && !((_b = (0,global_scope/* getGlobalScope */.l)()) === null || _b === void 0 ? void 0 : _b.indexedDB)) {
                            storeType = 'memory';
                            this.loggerProvider.warn('Could not use preferred indexedDB storage, reverting to in memory option.');
                        }
                        this.loggerProvider.log("Using ".concat(storeType, " for event storage."));
                        _g.label = 3;
                    case 3:
                        _g.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            createEventsManager({
                                config: this.config,
                                sessionId: this.identifiers.sessionId,
                                type: 'replay',
                                storeType: storeType
                            })
                        ];
                    case 4:
                        rrwebEventManager = _g.sent();
                        managers.push({
                            name: 'replay',
                            manager: rrwebEventManager
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        error_1 = _g.sent();
                        typedError = error_1;
                        this.loggerProvider.warn("Error occurred while creating replay events manager: ".concat(typedError.toString()));
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        if (!((_c = this.config.interactionConfig) === null || _c === void 0 ? void 0 : _c.enabled)) return [
                            3 /*break*/ ,
                            10
                        ];
                        payloadBatcher = this.config.interactionConfig.batch ? clickBatcher : clickNonBatcher;
                        _g.label = 7;
                    case 7:
                        _g.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            createEventsManager({
                                config: this.config,
                                sessionId: this.identifiers.sessionId,
                                type: 'interaction',
                                minInterval: (_d = this.config.interactionConfig.trackEveryNms) !== null && _d !== void 0 ? _d : INTERACTION_MIN_INTERVAL,
                                maxInterval: INTERACTION_MAX_INTERVAL,
                                payloadBatcher: payloadBatcher,
                                storeType: storeType
                            })
                        ];
                    case 8:
                        interactionEventManager = _g.sent();
                        managers.push({
                            name: 'interaction',
                            manager: interactionEventManager
                        });
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        error_2 = _g.sent();
                        typedError = error_2;
                        this.loggerProvider.warn("Error occurred while creating interaction events manager: ".concat(typedError.toString()));
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.eventsManager = new (MultiEventManager.bind.apply(MultiEventManager, (0,tslib_es6/* __spreadArray */.ev)([
                            void 0
                        ], (0,tslib_es6/* __read */.CR)(managers), false)))();
                        this.eventCompressor = new EventCompressor(this.eventsManager, this.config, this.getDeviceId());
                        this.loggerProvider.log('Installing @amplitude/session-replay-browser.');
                        this.teardownEventListeners(false);
                        this.initialize(true);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.setSessionId = function(sessionId, deviceId) {
        return (0,return_wrapper/* returnWrapper */.S)(this.asyncSetSessionId(sessionId, deviceId));
    };
    SessionReplay.prototype.asyncSetSessionId = function(sessionId, deviceId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var previousSessionId, deviceIdForReplayId, _a;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        previousSessionId = this.identifiers && this.identifiers.sessionId;
                        if (previousSessionId) {
                            this.sendEvents(previousSessionId);
                        }
                        deviceIdForReplayId = deviceId || this.getDeviceId();
                        this.identifiers = new SessionIdentifiers({
                            sessionId: sessionId,
                            deviceId: deviceIdForReplayId
                        });
                        if (!(this.joinedConfigGenerator && previousSessionId)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)
                        ];
                    case 1:
                        _a.config = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.recordEvents();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.getSessionReplayProperties = function() {
        var _a;
        var config = this.config;
        var identifiers = this.identifiers;
        if (!config || !identifiers) {
            this.loggerProvider.warn('Session replay init has not been called, cannot get session replay properties.');
            return {};
        }
        var shouldRecord = this.getShouldRecord();
        var eventProperties = {};
        if (shouldRecord) {
            eventProperties = (_a = {}, _a[DEFAULT_SESSION_REPLAY_PROPERTY] = identifiers.sessionReplayId ? identifiers.sessionReplayId : null, _a);
            if (config.debugMode) {
                eventProperties[SESSION_REPLAY_DEBUG_PROPERTY] = JSON.stringify({
                    appHash: generateHashCode(config.apiKey).toString()
                });
            }
        }
        void this.addCustomRRWebEvent(CustomRRwebEvent.GET_SR_PROPS, {
            shouldRecord: shouldRecord,
            eventProperties: eventProperties
        }, this.eventCount === 10);
        if (this.eventCount === 10) {
            this.eventCount = 0;
        }
        this.eventCount++;
        return eventProperties;
    };
    SessionReplay.prototype.sendEvents = function(sessionId) {
        var _a;
        var sessionIdToSend = sessionId || ((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId);
        var deviceId = this.getDeviceId();
        this.eventsManager && sessionIdToSend && deviceId && this.eventsManager.sendCurrentSequenceEvents({
            sessionId: sessionIdToSend,
            deviceId: deviceId
        });
    };
    SessionReplay.prototype.initialize = function(shouldSendStoredEvents) {
        var _a;
        if (shouldSendStoredEvents === void 0) {
            shouldSendStoredEvents = false;
        }
        if (!((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId)) {
            this.loggerProvider.log("Session is not being recorded due to lack of session id.");
            return;
        }
        var deviceId = this.getDeviceId();
        if (!deviceId) {
            this.loggerProvider.log("Session is not being recorded due to lack of device id.");
            return;
        }
        this.eventsManager && shouldSendStoredEvents && this.eventsManager.sendStoredEvents({
            deviceId: deviceId
        });
        this.recordEvents();
    };
    SessionReplay.prototype.shouldOptOut = function() {
        var _a, _b;
        var identityStoreOptOut;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
            var identityStore = (0,analytics_connector/* getAnalyticsConnector */.bM)(this.config.instanceName).identityStore;
            identityStoreOptOut = identityStore.getIdentity().optOut;
        }
        return identityStoreOptOut !== undefined ? identityStoreOptOut : (_b = this.config) === null || _b === void 0 ? void 0 : _b.optOut;
    };
    SessionReplay.prototype.getShouldRecord = function() {
        if (!this.identifiers || !this.config || !this.identifiers.sessionId) {
            this.loggerProvider.warn("Session is not being recorded due to lack of config, please call sessionReplay.init.");
            return false;
        }
        if (!this.config.captureEnabled) {
            this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured due to capture being disabled for project or because the remote config could not be fetched."));
            return false;
        }
        if (this.shouldOptOut()) {
            this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to optOut config."));
            return false;
        }
        var isInSample = isSessionInSample(this.identifiers.sessionId, this.config.sampleRate);
        if (!isInSample) {
            this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to sample rate."));
        }
        return isInSample;
    };
    SessionReplay.prototype.getBlockSelectors = function() {
        var _a, _b, _c;
        // For some reason, this defaults to empty array ([]) if undefined in the compiled script.
        // Empty arrays cause errors when being evaluated in Safari.
        // Force the selector to be undefined if it's an empty array.
        var blockSelector = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.blockSelector) !== null && _c !== void 0 ? _c : [];
        if (blockSelector.length === 0) {
            return undefined;
        }
        return blockSelector;
    };
    SessionReplay.prototype.getMaskTextSelectors = function() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.defaultMaskLevel) === 'conservative') {
            return '*';
        }
        var maskSelector = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.privacyConfig) === null || _d === void 0 ? void 0 : _d.maskSelector;
        if (!maskSelector) {
            return;
        }
        return maskSelector;
    };
    SessionReplay.prototype.recordEvents = function() {
        var _this = this;
        var _a;
        var config = this.config;
        var shouldRecord = this.getShouldRecord();
        var sessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
        if (!shouldRecord || !sessionId || !config) {
            return;
        }
        this.stopRecordingEvents();
        var privacyConfig = config.privacyConfig;
        this.loggerProvider.log("Session Replay capture beginning for ".concat(sessionId, "."));
        this.recordCancelCallback = record({
            emit: function(event) {
                if (_this.shouldOptOut()) {
                    _this.loggerProvider.log("Opting session ".concat(sessionId, " out of recording due to optOut config."));
                    _this.stopRecordingEvents();
                    _this.sendEvents();
                    return;
                }
                if (_this.eventCompressor) {
                    // Schedule processing during idle time if the browser supports requestIdleCallback
                    _this.eventCompressor.enqueueEvent(event, sessionId);
                }
            },
            inlineStylesheet: config.shouldInlineStylesheet,
            hooks: {
                mouseInteraction: this.eventsManager && clickHook({
                    eventsManager: this.eventsManager,
                    sessionId: sessionId,
                    deviceIdFn: this.getDeviceId.bind(this)
                }),
                scroll: this.scrollHook
            },
            maskAllInputs: true,
            maskTextClass: MASK_TEXT_CLASS,
            blockClass: BLOCK_CLASS,
            // rrweb only exposes string type through its types, but arrays are also be supported. #class, ['#class', 'id']
            blockSelector: this.getBlockSelectors(),
            maskInputFn: maskFn('input', privacyConfig),
            maskTextFn: maskFn('text', privacyConfig),
            // rrweb only exposes string type through its types, but arrays are also be supported. since rrweb uses .matches() which supports arrays.
            maskTextSelector: this.getMaskTextSelectors(),
            recordCanvas: false,
            errorHandler: function(error) {
                var typedError = error;
                // styled-components relies on this error being thrown and bubbled up, rrweb is otherwise suppressing it
                if (typedError.message.includes('insertRule') && typedError.message.includes('CSSStyleSheet')) {
                    throw typedError;
                }
                // rrweb does monkey patching on certain window functions such as CSSStyleSheet.proptype.insertRule,
                // and errors from external clients calling these functions can get suppressed. Styled components depend
                // on these errors being re-thrown.
                if (typedError._external_) {
                    throw typedError;
                }
                _this.loggerProvider.warn('Error while capturing replay: ', typedError.toString());
                // Return true so that we don't clutter user's consoles with internal rrweb errors
                return true;
            }
        });
        void this.addCustomRRWebEvent(CustomRRwebEvent.DEBUG_INFO);
    };
    SessionReplay.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    SessionReplay.prototype.getSessionId = function() {
        var _a;
        return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    SessionReplay.prototype.flush = function(useRetry) {
        var _a;
        if (useRetry === void 0) {
            useRetry = false;
        }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    (_a = this.eventsManager) === null || _a === void 0 ? void 0 : _a.flush(useRetry)
                ];
            });
        });
    };
    SessionReplay.prototype.shutdown = function() {
        this.teardownEventListeners(true);
        this.stopRecordingEvents();
        this.sendEvents();
    };
    return SessionReplay;
}();
 //# sourceMappingURL=session-replay.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/session-replay-factory.js



var getLogConfig = function(sessionReplay) {
    return function() {
        var config = sessionReplay.config;
        var _a = config || getDefaultConfig(), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var createInstance = function() {
    var sessionReplay = new SessionReplay();
    return {
        init: (0,debug/* debugWrapper */.w_)(sessionReplay.init.bind(sessionReplay), 'init', getLogConfig(sessionReplay)),
        setSessionId: (0,debug/* debugWrapper */.w_)(sessionReplay.setSessionId.bind(sessionReplay), 'setSessionId', getLogConfig(sessionReplay)),
        getSessionId: (0,debug/* debugWrapper */.w_)(sessionReplay.getSessionId.bind(sessionReplay), 'getSessionId', getLogConfig(sessionReplay)),
        getSessionReplayProperties: (0,debug/* debugWrapper */.w_)(sessionReplay.getSessionReplayProperties.bind(sessionReplay), 'getSessionReplayProperties', getLogConfig(sessionReplay)),
        flush: (0,debug/* debugWrapper */.w_)(sessionReplay.flush.bind(sessionReplay), 'flush', getLogConfig(sessionReplay)),
        shutdown: (0,debug/* debugWrapper */.w_)(sessionReplay.shutdown.bind(sessionReplay), 'shutdown', getLogConfig(sessionReplay))
    };
};
/* harmony default export */ const session_replay_factory = (createInstance()); //# sourceMappingURL=session-replay-factory.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+session-replay-browser@1.17.0/node_modules/@amplitude/session-replay-browser/lib/esm/index.js

var init = session_replay_factory.init, setSessionId = session_replay_factory.setSessionId, getSessionId = session_replay_factory.getSessionId, getSessionReplayProperties = session_replay_factory.getSessionReplayProperties, flush = session_replay_factory.flush, shutdown = session_replay_factory.shutdown; //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-session-replay-browser@1.10.0/node_modules/@amplitude/plugin-session-replay-browser/lib/esm/version.js
// Autogenerated by `yarn version-file`. DO NOT EDIT
var version_VERSION = '1.10.0'; //# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@amplitude+plugin-session-replay-browser@1.10.0/node_modules/@amplitude/plugin-session-replay-browser/lib/esm/session-replay.js



var SessionReplayPlugin = /** @class */ function() {
    function SessionReplayPlugin(options) {
        this.name = '@amplitude/plugin-session-replay-browser';
        this.type = 'enrichment';
        this.options = (0,tslib_es6/* __assign */.pi)({}, options);
        // The user did not explicitly configure forceSessionTracking to false, default to true.
        if (this.options.forceSessionTracking !== false) {
            this.options.forceSessionTracking = true;
        }
    }
    SessionReplayPlugin.prototype.setup = function(config) {
        var _a, _b, _c, _d;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var error_1;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        config.loggerProvider.log("Installing @amplitude/plugin-session-replay, version ".concat(version_VERSION, "."));
                        this.config = config;
                        if (this.options.forceSessionTracking) {
                            if (typeof config.defaultTracking === 'boolean') {
                                if (config.defaultTracking === false) {
                                    config.defaultTracking = {
                                        pageViews: false,
                                        formInteractions: false,
                                        fileDownloads: false,
                                        sessions: true
                                    };
                                }
                            } else {
                                config.defaultTracking = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, config.defaultTracking), {
                                    sessions: true
                                });
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            init(config.apiKey, {
                                instanceName: this.config.instanceName,
                                deviceId: this.config.deviceId,
                                optOut: this.config.optOut,
                                sessionId: this.options.customSessionId ? undefined : this.config.sessionId,
                                loggerProvider: this.config.loggerProvider,
                                logLevel: this.config.logLevel,
                                flushMaxRetries: this.config.flushMaxRetries,
                                serverZone: this.config.serverZone,
                                sampleRate: this.options.sampleRate,
                                privacyConfig: {
                                    blockSelector: (_a = this.options.privacyConfig) === null || _a === void 0 ? void 0 : _a.blockSelector,
                                    maskSelector: (_b = this.options.privacyConfig) === null || _b === void 0 ? void 0 : _b.maskSelector,
                                    unmaskSelector: (_c = this.options.privacyConfig) === null || _c === void 0 ? void 0 : _c.unmaskSelector,
                                    defaultMaskLevel: (_d = this.options.privacyConfig) === null || _d === void 0 ? void 0 : _d.defaultMaskLevel
                                },
                                debugMode: this.options.debugMode,
                                configEndpointUrl: this.options.configEndpointUrl,
                                shouldInlineStylesheet: this.options.shouldInlineStylesheet,
                                version: {
                                    type: 'plugin',
                                    version: version_VERSION
                                },
                                performanceConfig: this.options.performanceConfig,
                                storeType: this.options.storeType
                            }).promise
                        ];
                    case 1:
                        _e.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _e.sent();
                        config.loggerProvider.error("Session Replay: Failed to initialize due to ".concat(error_1.message));
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayPlugin.prototype.execute = function(event) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            var sessionId, sessionRecordingProperties, sessionId, sessionRecordingProperties, error_2;
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            8,
                            ,
                            9
                        ]);
                        if (!this.options.customSessionId) return [
                            3 /*break*/ ,
                            4
                        ];
                        sessionId = this.options.customSessionId(event);
                        if (!sessionId) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!(sessionId !== getSessionId())) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            setSessionId(sessionId).promise
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        sessionRecordingProperties = getSessionReplayProperties();
                        event.event_properties = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.event_properties), sessionRecordingProperties);
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        sessionId = this.config.sessionId;
                        if (!(sessionId && sessionId !== getSessionId())) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            setSessionId(sessionId).promise
                        ];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        // Treating config.sessionId as source of truth, if the event's session id doesn't match, the
                        // event is not of the current session (offline/late events). In that case, don't tag the events
                        if (sessionId && sessionId === event.session_id) {
                            sessionRecordingProperties = getSessionReplayProperties();
                            event.event_properties = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.event_properties), sessionRecordingProperties);
                        }
                        _a.label = 7;
                    case 7:
                        return [
                            2 /*return*/ ,
                            Promise.resolve(event)
                        ];
                    case 8:
                        error_2 = _a.sent();
                        this.config.loggerProvider.error("Session Replay: Failed to enrich event due to ".concat(error_2.message));
                        return [
                            2 /*return*/ ,
                            Promise.resolve(event)
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayPlugin.prototype.teardown = function() {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function() {
            return (0,tslib_es6/* __generator */.Jh)(this, function(_a) {
                try {
                    shutdown();
                    // the following are initialized in setup() which will always be called first
                    // here we reset them to null to prevent memory leaks
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    this.config = null;
                } catch (error) {
                    this.config.loggerProvider.error("Session Replay: teardown failed due to ".concat(error.message));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SessionReplayPlugin.prototype.getSessionReplayProperties = function() {
        return getSessionReplayProperties();
    };
    return SessionReplayPlugin;
}();

var sessionReplayPlugin = function(options) {
    return new SessionReplayPlugin(options);
}; //# sourceMappingURL=session-replay.js.map


/***/ }),

/***/ 80187:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": () => (/* binding */ __extends),
/* harmony export */   "pi": () => (/* binding */ __assign),
/* harmony export */   "_T": () => (/* binding */ __rest),
/* harmony export */   "mG": () => (/* binding */ __awaiter),
/* harmony export */   "Jh": () => (/* binding */ __generator),
/* harmony export */   "XA": () => (/* binding */ __values),
/* harmony export */   "CR": () => (/* binding */ __read),
/* harmony export */   "ev": () => (/* binding */ __spreadArray),
/* harmony export */   "qq": () => (/* binding */ __await),
/* harmony export */   "FC": () => (/* binding */ __asyncGenerator),
/* harmony export */   "KL": () => (/* binding */ __asyncValues)
/* harmony export */ });
/* unused harmony exports __decorate, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __spread, __spreadArrays, __asyncDelegator, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++){
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
/** @deprecated */ function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
/** @deprecated */ function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for(var i = 0, l = from.length, ar; i < l; i++){
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", {
            value: raw
        });
    } else {
        cooked.raw = raw;
    }
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) {
        env.stack.push({
            async: true
        });
    }
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
});


/***/ })

}]);